var Cl = Object.defineProperty;
var xl = (t, r, e) => r in t ? Cl(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e;
var d = (t, r, e) => xl(t, typeof r != "symbol" ? r + "" : r, e);
let Ra = class extends Error {
  constructor(r) {
    super(r), this.name = "AbortError";
  }
};
function Il(...t) {
  if (t.length > 0) {
    const r = String(t[0]);
    r.includes(":error") ? console.error(...t) : r.includes(":warning") ? console.warn(...t) : r.includes(":info") ? console.info(...t) : r.includes(":verbose") ? console.debug(...t) : console.debug(...t);
  }
}
function ri(t) {
  var r, e;
  return (e = (r = globalThis.process) == null ? void 0 : r.env) == null ? void 0 : e[t];
}
const Nn = ri("DEBUG");
let ai, ha = [], fa = [];
const wr = [];
Nn && za(Nn);
const yt = Object.assign((t) => ni(t), {
  enable: za,
  enabled: Ma,
  disable: Bl,
  log: Il
});
function za(t) {
  ai = t, ha = [], fa = [];
  const r = t.split(",").map((e) => e.trim());
  for (const e of r)
    e.startsWith("-") ? fa.push(e.substring(1)) : ha.push(e);
  for (const e of wr)
    e.enabled = Ma(e.namespace);
}
function Ma(t) {
  if (t.endsWith("*"))
    return !0;
  for (const r of fa)
    if (Cn(t, r))
      return !1;
  for (const r of ha)
    if (Cn(t, r))
      return !0;
  return !1;
}
function Cn(t, r) {
  if (r.indexOf("*") === -1)
    return t === r;
  let e = r;
  if (r.indexOf("**") !== -1) {
    const y = [];
    let A = "";
    for (const g of r)
      g === "*" && A === "*" || (A = g, y.push(g));
    e = y.join("");
  }
  let a = 0, n = 0;
  const i = e.length, s = t.length;
  let o = -1, m = -1;
  for (; a < s && n < i; )
    if (e[n] === "*") {
      if (o = n, n++, n === i)
        return !0;
      for (; t[a] !== e[n]; )
        if (a++, a === s)
          return !1;
      m = a, a++, n++;
      continue;
    } else if (e[n] === t[a])
      n++, a++;
    else if (o >= 0) {
      if (n = o + 1, a = m + 1, a === s)
        return !1;
      for (; t[a] !== e[n]; )
        if (a++, a === s)
          return !1;
      m = a, a++, n++;
      continue;
    } else
      return !1;
  const c = a === t.length, l = n === e.length, u = n === e.length - 1 && e[n] === "*";
  return c && (l || u);
}
function Bl() {
  const t = ai || "";
  return za(""), t;
}
function ni(t) {
  const r = Object.assign(e, {
    enabled: Ma(t),
    destroy: bl,
    log: yt.log,
    namespace: t,
    extend: El
  });
  function e(...a) {
    r.enabled && (a.length > 0 && (a[0] = `${t} ${a[0]}`), r.log(...a));
  }
  return wr.push(r), r;
}
function bl() {
  const t = wr.indexOf(this);
  return t >= 0 ? (wr.splice(t, 1), !0) : !1;
}
function El(t) {
  const r = ni(`${this.namespace}:${t}`);
  return r.log = this.log, r;
}
const Aa = ["verbose", "info", "warning", "error"], xn = {
  verbose: 400,
  info: 300,
  warning: 200,
  error: 100
};
function In(t, r) {
  r.log = (...e) => {
    t.log(...e);
  };
}
function Bn(t) {
  return Aa.includes(t);
}
function ii(t) {
  const r = /* @__PURE__ */ new Set(), e = ri(t.logLevelEnvVarName);
  let a;
  const n = yt(t.namespace);
  n.log = (...l) => {
    yt.log(...l);
  };
  function i(l) {
    if (l && !Bn(l))
      throw new Error(`Unknown log level '${l}'. Acceptable values: ${Aa.join(",")}`);
    a = l;
    const u = [];
    for (const y of r)
      s(y) && u.push(y.namespace);
    yt.enable(u.join(","));
  }
  e && (Bn(e) ? i(e) : console.error(`${t.logLevelEnvVarName} set to unknown log level '${e}'; logging is not enabled. Acceptable values: ${Aa.join(", ")}.`));
  function s(l) {
    return !!(a && xn[l.level] <= xn[a]);
  }
  function o(l, u) {
    const y = Object.assign(l.extend(u), {
      level: u
    });
    if (In(l, y), s(y)) {
      const A = yt.disable();
      yt.enable(A + "," + y.namespace);
    }
    return r.add(y), y;
  }
  function m() {
    return a;
  }
  function c(l) {
    const u = n.extend(l);
    return In(n, u), {
      error: o(u, "error"),
      warning: o(u, "warning"),
      info: o(u, "info"),
      verbose: o(u, "verbose")
    };
  }
  return {
    setLogLevel: i,
    getLogLevel: m,
    createClientLogger: c,
    logger: n
  };
}
const Pl = ii({
  logLevelEnvVarName: "TYPESPEC_RUNTIME_LOG_LEVEL",
  namespace: "typeSpecRuntime"
});
function si(t) {
  return Pl.createClientLogger(t);
}
function Nr(t) {
  return t.toLowerCase();
}
function wl(t) {
  return String(t).trim().replace(/[\r\n]/g, "");
}
function* Sl(t) {
  for (const r of t.values())
    yield [r.name, r.value];
}
class Rl {
  constructor(r) {
    d(this, "_headersMap");
    if (this._headersMap = /* @__PURE__ */ new Map(), r)
      for (const e of Object.keys(r))
        this.set(e, r[e]);
  }
  /**
   * Set a header in this collection with the provided name and value. The name is
   * case-insensitive.
   * @param name - The name of the header to set. This value is case-insensitive.
   * @param value - The value of the header to set.
   */
  set(r, e) {
    this._headersMap.set(Nr(r), { name: r, value: wl(e) });
  }
  /**
   * Get the header value for the provided header name, or undefined if no header exists in this
   * collection with the provided name.
   * @param name - The name of the header. This value is case-insensitive.
   */
  get(r) {
    var e;
    return (e = this._headersMap.get(Nr(r))) == null ? void 0 : e.value;
  }
  /**
   * Get whether or not this header collection contains a header entry for the provided header name.
   * @param name - The name of the header to set. This value is case-insensitive.
   */
  has(r) {
    return this._headersMap.has(Nr(r));
  }
  /**
   * Remove the header with the provided headerName.
   * @param name - The name of the header to remove.
   */
  delete(r) {
    this._headersMap.delete(Nr(r));
  }
  /**
   * Get the JSON object representation of this HTTP header collection.
   */
  toJSON(r = {}) {
    const e = {};
    if (r.preserveCase)
      for (const a of this._headersMap.values())
        e[a.name] = a.value;
    else
      for (const [a, n] of this._headersMap)
        e[a] = n.value;
    return e;
  }
  /**
   * Get the string representation of this HTTP header collection.
   */
  toString() {
    return JSON.stringify(this.toJSON({ preserveCase: !0 }));
  }
  /**
   * Iterate over tuples of header [name, value] pairs.
   */
  [Symbol.iterator]() {
    return Sl(this._headersMap);
  }
}
function rr(t) {
  return new Rl(t);
}
function zl() {
  let t = "";
  for (let r = 0; r < 32; r++) {
    const e = Math.floor(Math.random() * 16);
    r === 12 ? t += "4" : r === 16 ? t += (e & 3 | 8).toString(16) : t += e.toString(16), (r === 7 || r === 11 || r === 15 || r === 19) && (t += "-");
  }
  return t;
}
var ti;
const Ml = typeof ((ti = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : ti.randomUUID) == "function" ? globalThis.crypto.randomUUID.bind(globalThis.crypto) : zl;
function Da() {
  return Ml();
}
class Dl {
  constructor(r) {
    d(this, "url");
    d(this, "method");
    d(this, "headers");
    d(this, "timeout");
    d(this, "withCredentials");
    d(this, "body");
    d(this, "multipartBody");
    d(this, "formData");
    d(this, "streamResponseStatusCodes");
    d(this, "enableBrowserStreams");
    d(this, "proxySettings");
    d(this, "disableKeepAlive");
    d(this, "abortSignal");
    d(this, "requestId");
    d(this, "allowInsecureConnection");
    d(this, "onUploadProgress");
    d(this, "onDownloadProgress");
    d(this, "requestOverrides");
    d(this, "authSchemes");
    this.url = r.url, this.body = r.body, this.headers = r.headers ?? rr(), this.method = r.method ?? "GET", this.timeout = r.timeout ?? 0, this.multipartBody = r.multipartBody, this.formData = r.formData, this.disableKeepAlive = r.disableKeepAlive ?? !1, this.proxySettings = r.proxySettings, this.streamResponseStatusCodes = r.streamResponseStatusCodes, this.withCredentials = r.withCredentials ?? !1, this.abortSignal = r.abortSignal, this.onUploadProgress = r.onUploadProgress, this.onDownloadProgress = r.onDownloadProgress, this.requestId = r.requestId || Da(), this.allowInsecureConnection = r.allowInsecureConnection ?? !1, this.enableBrowserStreams = r.enableBrowserStreams ?? !1, this.requestOverrides = r.requestOverrides, this.authSchemes = r.authSchemes;
  }
}
function Ql(t) {
  return new Dl(t);
}
const bn = /* @__PURE__ */ new Set(["Deserialize", "Serialize", "Retry", "Sign"]);
class Sr {
  constructor(r) {
    d(this, "_policies", []);
    d(this, "_orderedPolicies");
    this._policies = (r == null ? void 0 : r.slice(0)) ?? [], this._orderedPolicies = void 0;
  }
  addPolicy(r, e = {}) {
    if (e.phase && e.afterPhase)
      throw new Error("Policies inside a phase cannot specify afterPhase.");
    if (e.phase && !bn.has(e.phase))
      throw new Error(`Invalid phase name: ${e.phase}`);
    if (e.afterPhase && !bn.has(e.afterPhase))
      throw new Error(`Invalid afterPhase name: ${e.afterPhase}`);
    this._policies.push({
      policy: r,
      options: e
    }), this._orderedPolicies = void 0;
  }
  removePolicy(r) {
    const e = [];
    return this._policies = this._policies.filter((a) => r.name && a.policy.name === r.name || r.phase && a.options.phase === r.phase ? (e.push(a.policy), !1) : !0), this._orderedPolicies = void 0, e;
  }
  sendRequest(r, e) {
    return this.getOrderedPolicies().reduceRight((i, s) => (o) => s.sendRequest(o, i), (i) => r.sendRequest(i))(e);
  }
  getOrderedPolicies() {
    return this._orderedPolicies || (this._orderedPolicies = this.orderPolicies()), this._orderedPolicies;
  }
  clone() {
    return new Sr(this._policies);
  }
  static create() {
    return new Sr();
  }
  orderPolicies() {
    const r = [], e = /* @__PURE__ */ new Map();
    function a(g) {
      return {
        name: g,
        policies: /* @__PURE__ */ new Set(),
        hasRun: !1,
        hasAfterPolicies: !1
      };
    }
    const n = a("Serialize"), i = a("None"), s = a("Deserialize"), o = a("Retry"), m = a("Sign"), c = [n, i, s, o, m];
    function l(g) {
      return g === "Retry" ? o : g === "Serialize" ? n : g === "Deserialize" ? s : g === "Sign" ? m : i;
    }
    for (const g of this._policies) {
      const C = g.policy, R = g.options, D = C.name;
      if (e.has(D))
        throw new Error("Duplicate policy names not allowed in pipeline");
      const T = {
        policy: C,
        dependsOn: /* @__PURE__ */ new Set(),
        dependants: /* @__PURE__ */ new Set()
      };
      R.afterPhase && (T.afterPhase = l(R.afterPhase), T.afterPhase.hasAfterPolicies = !0), e.set(D, T), l(R.phase).policies.add(T);
    }
    for (const g of this._policies) {
      const { policy: C, options: R } = g, D = C.name, T = e.get(D);
      if (!T)
        throw new Error(`Missing node for policy ${D}`);
      if (R.afterPolicies)
        for (const v of R.afterPolicies) {
          const f = e.get(v);
          f && (T.dependsOn.add(f), f.dependants.add(T));
        }
      if (R.beforePolicies)
        for (const v of R.beforePolicies) {
          const f = e.get(v);
          f && (f.dependsOn.add(T), T.dependants.add(f));
        }
    }
    function u(g) {
      g.hasRun = !0;
      for (const C of g.policies)
        if (!(C.afterPhase && (!C.afterPhase.hasRun || C.afterPhase.policies.size)) && C.dependsOn.size === 0) {
          r.push(C.policy);
          for (const R of C.dependants)
            R.dependsOn.delete(C);
          e.delete(C.policy.name), g.policies.delete(C);
        }
    }
    function y() {
      for (const g of c) {
        if (u(g), g.policies.size > 0 && g !== i) {
          i.hasRun || u(i);
          return;
        }
        g.hasAfterPolicies && u(i);
      }
    }
    let A = 0;
    for (; e.size > 0; ) {
      A++;
      const g = r.length;
      if (y(), r.length <= g && A > 1)
        throw new Error("Cannot satisfy policy dependencies due to requirements cycle.");
    }
    return r;
  }
}
function Tl() {
  return Sr.create();
}
function Pr(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t) && !(t instanceof RegExp) && !(t instanceof Date);
}
function Qa(t) {
  if (Pr(t)) {
    const r = typeof t.name == "string", e = typeof t.message == "string";
    return r && e;
  }
  return !1;
}
const vl = Symbol(), ia = "REDACTED", Hl = [
  "x-ms-client-request-id",
  "x-ms-return-client-request-id",
  "x-ms-useragent",
  "x-ms-correlation-request-id",
  "x-ms-request-id",
  "client-request-id",
  "ms-cv",
  "return-client-request-id",
  "traceparent",
  "Access-Control-Allow-Credentials",
  "Access-Control-Allow-Headers",
  "Access-Control-Allow-Methods",
  "Access-Control-Allow-Origin",
  "Access-Control-Expose-Headers",
  "Access-Control-Max-Age",
  "Access-Control-Request-Headers",
  "Access-Control-Request-Method",
  "Origin",
  "Accept",
  "Accept-Encoding",
  "Cache-Control",
  "Connection",
  "Content-Length",
  "Content-Type",
  "Date",
  "ETag",
  "Expires",
  "If-Match",
  "If-Modified-Since",
  "If-None-Match",
  "If-Unmodified-Since",
  "Last-Modified",
  "Pragma",
  "Request-Id",
  "Retry-After",
  "Server",
  "Transfer-Encoding",
  "User-Agent",
  "WWW-Authenticate"
], kl = ["api-version"];
class Ta {
  constructor({ additionalAllowedHeaderNames: r = [], additionalAllowedQueryParameters: e = [] } = {}) {
    d(this, "allowedHeaderNames");
    d(this, "allowedQueryParameters");
    r = Hl.concat(r), e = kl.concat(e), this.allowedHeaderNames = new Set(r.map((a) => a.toLowerCase())), this.allowedQueryParameters = new Set(e.map((a) => a.toLowerCase()));
  }
  /**
   * Sanitizes an object for logging.
   * @param obj - The object to sanitize
   * @returns - The sanitized object as a string
   */
  sanitize(r) {
    const e = /* @__PURE__ */ new Set();
    return JSON.stringify(r, (a, n) => {
      if (n instanceof Error)
        return {
          ...n,
          name: n.name,
          message: n.message
        };
      if (a === "headers" && Pr(n))
        return this.sanitizeHeaders(n);
      if (a === "url" && typeof n == "string")
        return this.sanitizeUrl(n);
      if (a === "query" && Pr(n))
        return this.sanitizeQuery(n);
      if (a === "body")
        return;
      if (a === "response")
        return;
      if (a === "operationSpec")
        return;
      if (Array.isArray(n) || Pr(n)) {
        if (e.has(n))
          return "[Circular]";
        e.add(n);
      }
      return n;
    }, 2);
  }
  /**
   * Sanitizes a URL for logging.
   * @param value - The URL to sanitize
   * @returns - The sanitized URL as a string
   */
  sanitizeUrl(r) {
    if (typeof r != "string" || r === null || r === "")
      return r;
    const e = new URL(r);
    if (!e.search)
      return r;
    for (const [a] of e.searchParams)
      this.allowedQueryParameters.has(a.toLowerCase()) || e.searchParams.set(a, ia);
    return e.toString();
  }
  sanitizeHeaders(r) {
    const e = {};
    for (const a of Object.keys(r))
      this.allowedHeaderNames.has(a.toLowerCase()) ? e[a] = r[a] : e[a] = ia;
    return e;
  }
  sanitizeQuery(r) {
    if (typeof r != "object" || r === null)
      return r;
    const e = {};
    for (const a of Object.keys(r))
      this.allowedQueryParameters.has(a.toLowerCase()) ? e[a] = r[a] : e[a] = ia;
    return e;
  }
}
const Ll = new Ta();
var Fe;
let Rr = (Fe = class extends Error {
  constructor(e, a = {}) {
    var i;
    super(e);
    /**
     * The code of the error itself (use statics on RestError if possible.)
     */
    d(this, "code");
    /**
     * The HTTP status code of the request (if applicable.)
     */
    d(this, "statusCode");
    /**
     * The request that was made.
     * This property is non-enumerable.
     */
    d(this, "request");
    /**
     * The response received (if any.)
     * This property is non-enumerable.
     */
    d(this, "response");
    /**
     * Bonus property set by the throw site.
     */
    d(this, "details");
    this.name = "RestError", this.code = a.code, this.statusCode = a.statusCode, Object.defineProperty(this, "request", { value: a.request, enumerable: !1 }), Object.defineProperty(this, "response", { value: a.response, enumerable: !1 });
    const n = (i = this.request) != null && i.agent ? {
      maxFreeSockets: this.request.agent.maxFreeSockets,
      maxSockets: this.request.agent.maxSockets
    } : void 0;
    Object.defineProperty(this, vl, {
      value: () => `RestError: ${this.message} 
 ${Ll.sanitize({
        ...this,
        request: { ...this.request, agent: n },
        response: this.response
      })}`,
      enumerable: !1
    }), Object.setPrototypeOf(this, Fe.prototype);
  }
}, /**
 * Something went wrong when making the request.
 * This means the actual request failed for some reason,
 * such as a DNS issue or the connection being lost.
 */
d(Fe, "REQUEST_SEND_ERROR", "REQUEST_SEND_ERROR"), /**
 * This means that parsing the response from the server failed.
 * It may have been malformed.
 */
d(Fe, "PARSE_ERROR", "PARSE_ERROR"), Fe);
function oi(t) {
  return t instanceof Rr ? !0 : Qa(t) && t.name === "RestError";
}
function Ul(t) {
  return new TextDecoder().decode(t);
}
function ql(t) {
  return new TextEncoder().encode(t);
}
function Ol(t, r) {
  switch (r) {
    case "utf-8":
      return _l(t);
    case "base64":
      return mi(t);
    case "base64url":
      return Fl(t);
    case "hex":
      return Gl(t);
  }
}
function Oe(t, r) {
  switch (r) {
    case "utf-8":
      return Yl(t);
    case "base64":
      return ci(t);
    case "base64url":
      return Kl(t);
    case "hex":
      return Jl(t);
  }
}
function mi(t) {
  return btoa([...t].map((r) => String.fromCharCode(r)).join(""));
}
function Fl(t) {
  return mi(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function _l(t) {
  return Ul(t);
}
function Gl(t) {
  return [...t].map((r) => r.toString(16).padStart(2, "0")).join("");
}
function Yl(t) {
  return ql(t);
}
function ci(t) {
  return new Uint8Array([...atob(t)].map((r) => r.charCodeAt(0)));
}
function Kl(t) {
  const r = t.replace(/-/g, "+").replace(/_/g, "/");
  return ci(r);
}
const En = new Set("0123456789abcdefABCDEF");
function Jl(t) {
  const r = new Uint8Array(t.length / 2);
  for (let e = 0; e < t.length / 2; ++e) {
    const a = t[2 * e], n = t[2 * e + 1];
    if (!En.has(a) || !En.has(n))
      return r.slice(0, e);
    r[e] = parseInt(`${a}${n}`, 16);
  }
  return r;
}
function Xl(t) {
  return t != null && typeof t == "object" && "pipe" in t && typeof t.pipe == "function" && "read" in t && typeof t.read == "function";
}
function va(t) {
  return t instanceof ReadableStream;
}
function Wl(t) {
  return t instanceof Blob;
}
function jl(t) {
  if (t.buffer instanceof ArrayBuffer && t.byteOffset === 0 && t.byteLength === t.buffer.byteLength)
    return t.buffer;
  const r = new ArrayBuffer(t.byteLength), e = new Uint8Array(r), a = new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  return e.set(a), e.buffer;
}
function Zl(t) {
  return (typeof Blob == "function" || typeof Blob == "object") && t instanceof Blob;
}
class Vl {
  /**
   * Makes a request over an underlying transport layer and returns the response.
   * @param request - The request to be made.
   */
  async sendRequest(r) {
    if (new URL(r.url).protocol !== "https:" && !r.allowInsecureConnection)
      throw new Error(`Cannot connect to ${r.url} while allowInsecureConnection is false.`);
    if (r.proxySettings)
      throw new Error("HTTP proxy is not supported in browser environment");
    try {
      return await $l(r);
    } catch (n) {
      throw rd(n, r);
    }
  }
}
async function $l(t) {
  const { abortController: r, abortControllerCleanup: e } = td(t);
  try {
    const a = ad(t.headers), { streaming: n, body: i } = id(t), s = {
      body: i,
      method: t.method,
      headers: a,
      signal: r.signal,
      // Cloudflare doesn't implement the full Fetch API spec
      // because of some of it doesn't make sense in the edge.
      // See https://github.com/cloudflare/workerd/issues/902
      ..."credentials" in Request.prototype ? { credentials: t.withCredentials ? "include" : "same-origin" } : {},
      ..."cache" in Request.prototype ? { cache: "no-store" } : {}
    };
    n && (s.duplex = "half");
    const o = await fetch(t.url, {
      ...s,
      ...t.requestOverrides
    });
    return Zl(t.body) && t.onUploadProgress && t.onUploadProgress({ loadedBytes: t.body.size }), ed(o, t, e);
  } catch (a) {
    throw e == null || e(), a;
  }
}
async function ed(t, r, e) {
  var s, o;
  const a = nd(t), n = {
    request: r,
    headers: a,
    status: t.status
  }, i = va(t.body) ? li(t.body, {
    onProgress: r.onDownloadProgress,
    onEnd: e
  }) : t.body;
  if (
    // Value of POSITIVE_INFINITY in streamResponseStatusCodes is considered as any status code
    (s = r.streamResponseStatusCodes) != null && s.has(Number.POSITIVE_INFINITY) || (o = r.streamResponseStatusCodes) != null && o.has(n.status)
  )
    if (r.enableBrowserStreams)
      n.browserStreamBody = i ?? void 0;
    else {
      const m = new Response(i);
      n.blobBody = m.blob(), e == null || e();
    }
  else {
    const m = new Response(i);
    n.bodyAsText = await m.text(), e == null || e();
  }
  return n;
}
function td(t) {
  const r = new AbortController();
  let e, a;
  if (t.abortSignal) {
    if (t.abortSignal.aborted)
      throw new Ra("The operation was aborted. Request has already been canceled.");
    a = (n) => {
      n.type === "abort" && r.abort();
    }, t.abortSignal.addEventListener("abort", a), e = () => {
      var n;
      a && ((n = t.abortSignal) == null || n.removeEventListener("abort", a));
    };
  }
  return t.timeout > 0 && setTimeout(() => {
    r.abort();
  }, t.timeout), { abortController: r, abortControllerCleanup: e };
}
function rd(t, r) {
  return t && (t == null ? void 0 : t.name) === "AbortError" ? t : new Rr(`Error sending request: ${t.message}`, {
    code: (t == null ? void 0 : t.code) ?? Rr.REQUEST_SEND_ERROR,
    request: r
  });
}
function ad(t) {
  const r = new Headers();
  for (const [e, a] of t)
    r.append(e, a);
  return r;
}
function nd(t) {
  const r = rr();
  for (const [e, a] of t.headers)
    r.set(e, a);
  return r;
}
function id(t) {
  const r = typeof t.body == "function" ? t.body() : t.body;
  if (Xl(r))
    throw new Error("Node streams are not supported in browser environment.");
  return va(r) ? {
    streaming: !0,
    body: li(r, { onProgress: t.onUploadProgress })
  } : typeof r == "object" && r && "buffer" in r ? { streaming: !1, body: jl(r) } : r === void 0 ? { streaming: !1 } : { streaming: !1, body: r };
}
function li(t, r = {}) {
  let e = 0;
  const { onProgress: a, onEnd: n } = r;
  if (od(t))
    return t.pipeThrough(new TransformStream({
      transform(i, s) {
        if (i === null) {
          s.terminate();
          return;
        }
        s.enqueue(i), e += i.length, a && a({ loadedBytes: e });
      },
      flush() {
        n == null || n();
      }
    }));
  {
    const i = t.getReader();
    return new ReadableStream({
      async pull(s) {
        const { done: o, value: m } = await i.read();
        if (o || !m) {
          n == null || n(), s.close(), i.releaseLock();
          return;
        }
        e += (m == null ? void 0 : m.length) ?? 0, s.enqueue(m), a && a({ loadedBytes: e });
      },
      cancel(s) {
        return n == null || n(), i.cancel(s);
      }
    });
  }
}
function sd() {
  return new Vl();
}
function od(t) {
  return t.pipeThrough !== void 0 && self.TransformStream !== void 0;
}
function md() {
  return sd();
}
const cd = si("ts-http-runtime"), ld = "logPolicy";
function dd(t = {}) {
  const r = t.logger ?? cd.info, e = new Ta({
    additionalAllowedHeaderNames: t.additionalAllowedHeaderNames,
    additionalAllowedQueryParameters: t.additionalAllowedQueryParameters
  });
  return {
    name: ld,
    async sendRequest(a, n) {
      if (!r.enabled)
        return n(a);
      r(`Request: ${e.sanitize(a)}`);
      const i = await n(a);
      return r(`Response status code: ${i.status}`), r(`Headers: ${e.sanitize(i.headers)}`), i;
    }
  };
}
const Na = 3;
function pd(t, r) {
  return t = Math.ceil(t), r = Math.floor(r), Math.floor(Math.random() * (r - t + 1)) + t;
}
function ud(t, r) {
  const e = r.retryDelayInMs * Math.pow(2, t), a = Math.min(r.maxRetryDelayInMs, e);
  return { retryAfterInMs: a / 2 + pd(0, a / 2) };
}
const gd = "The operation was aborted.";
function yd(t, r, e) {
  return new Promise((a, n) => {
    let i, s;
    const o = () => n(new Ra(e != null && e.abortErrorMsg ? e == null ? void 0 : e.abortErrorMsg : gd)), m = () => {
      e != null && e.abortSignal && s && e.abortSignal.removeEventListener("abort", s);
    };
    if (s = () => (i && clearTimeout(i), m(), o()), e != null && e.abortSignal && e.abortSignal.aborted)
      return o();
    i = setTimeout(() => {
      m(), a(r);
    }, t), e != null && e.abortSignal && e.abortSignal.addEventListener("abort", s);
  });
}
function hd(t, r) {
  const e = t.headers.get(r);
  if (!e)
    return;
  const a = Number(e);
  if (!Number.isNaN(a))
    return a;
}
const Ca = "Retry-After", fd = ["retry-after-ms", "x-ms-retry-after-ms", Ca];
function di(t) {
  if (t && [429, 503].includes(t.status))
    try {
      for (const n of fd) {
        const i = hd(t, n);
        if (i === 0 || i)
          return i * (n === Ca ? 1e3 : 1);
      }
      const r = t.headers.get(Ca);
      if (!r)
        return;
      const a = Date.parse(r) - Date.now();
      return Number.isFinite(a) ? Math.max(0, a) : void 0;
    } catch {
      return;
    }
}
function Ad(t) {
  return Number.isFinite(di(t));
}
function Nd() {
  return {
    name: "throttlingRetryStrategy",
    retry({ response: t }) {
      const r = di(t);
      return Number.isFinite(r) ? {
        retryAfterInMs: r
      } : { skipStrategy: !0 };
    }
  };
}
const Cd = 1e3, xd = 1e3 * 64;
function Id(t = {}) {
  const r = t.retryDelayInMs ?? Cd, e = t.maxRetryDelayInMs ?? xd;
  return {
    name: "exponentialRetryStrategy",
    retry({ retryCount: a, response: n, responseError: i }) {
      const s = bd(i), o = s && t.ignoreSystemErrors, m = Bd(n), c = m && t.ignoreHttpStatusCodes;
      return n && (Ad(n) || !m) || c || o ? { skipStrategy: !0 } : i && !s && !m ? { errorToThrow: i } : ud(a, {
        retryDelayInMs: r,
        maxRetryDelayInMs: e
      });
    }
  };
}
function Bd(t) {
  return !!(t && t.status !== void 0 && (t.status >= 500 || t.status === 408) && t.status !== 501 && t.status !== 505);
}
function bd(t) {
  return t ? t.code === "ETIMEDOUT" || t.code === "ESOCKETTIMEDOUT" || t.code === "ECONNREFUSED" || t.code === "ECONNRESET" || t.code === "ENOENT" || t.code === "ENOTFOUND" : !1;
}
const Ed = si("ts-http-runtime retryPolicy"), Pd = "retryPolicy";
function wd(t, r = { maxRetries: Na }) {
  const e = r.logger || Ed;
  return {
    name: Pd,
    async sendRequest(a, n) {
      var m;
      let i, s, o = -1;
      e: for (; ; ) {
        o += 1, i = void 0, s = void 0;
        try {
          e.info(`Retry ${o}: Attempting to send request`, a.requestId), i = await n(a), e.info(`Retry ${o}: Received a response from request`, a.requestId);
        } catch (c) {
          if (e.error(`Retry ${o}: Received an error from request`, a.requestId), !oi(c))
            throw c;
          s = c, i = c.response;
        }
        if ((m = a.abortSignal) != null && m.aborted)
          throw e.error(`Retry ${o}: Request aborted.`), new Ra();
        if (o >= (r.maxRetries ?? Na)) {
          if (e.info(`Retry ${o}: Maximum retries reached. Returning the last received response, or throwing the last received error.`), s)
            throw s;
          if (i)
            return i;
          throw new Error("Maximum retries reached with no response or error to throw");
        }
        e.info(`Retry ${o}: Processing ${t.length} retry strategies.`);
        t: for (const c of t) {
          const l = c.logger || e;
          l.info(`Retry ${o}: Processing retry strategy ${c.name}.`);
          const u = c.retry({
            retryCount: o,
            response: i,
            responseError: s
          });
          if (u.skipStrategy) {
            l.info(`Retry ${o}: Skipped.`);
            continue t;
          }
          const { errorToThrow: y, retryAfterInMs: A, redirectTo: g } = u;
          if (y)
            throw l.error(`Retry ${o}: Retry strategy ${c.name} throws error:`, y), y;
          if (A || A === 0) {
            l.info(`Retry ${o}: Retry strategy ${c.name} retries after ${A}`), await yd(A, void 0, { abortSignal: a.abortSignal });
            continue e;
          }
          if (g) {
            l.info(`Retry ${o}: Retry strategy ${c.name} redirects to ${g}`), a.url = g;
            continue e;
          }
        }
        if (s)
          throw e.info("None of the retry strategies could work with the received error. Throwing it."), s;
        if (i)
          return e.info("None of the retry strategies could work with the received response. Returning it."), i;
      }
    }
  };
}
const Sd = "defaultRetryPolicy";
function Rd(t = {}) {
  return {
    name: Sd,
    sendRequest: wd([Nd(), Id(t)], {
      maxRetries: t.maxRetries ?? Na
    }).sendRequest
  };
}
const zd = "formDataPolicy";
function Md() {
  return {
    name: zd,
    async sendRequest(t, r) {
      if (t.body, t.formData) {
        const e = t.headers.get("Content-Type");
        e && e.indexOf("application/x-www-form-urlencoded") !== -1 ? t.body = Dd(t.formData) : await Qd(t.formData, t), t.formData = void 0;
      }
      return r(t);
    }
  };
}
function Dd(t) {
  const r = new URLSearchParams();
  for (const [e, a] of Object.entries(t))
    if (Array.isArray(a))
      for (const n of a)
        r.append(e, n.toString());
    else
      r.append(e, a.toString());
  return r.toString();
}
async function Qd(t, r) {
  const e = r.headers.get("Content-Type");
  if (e && !e.startsWith("multipart/form-data"))
    return;
  r.headers.set("Content-Type", e ?? "multipart/form-data");
  const a = [];
  for (const [n, i] of Object.entries(t))
    for (const s of Array.isArray(i) ? i : [i])
      if (typeof s == "string")
        a.push({
          headers: rr({
            "Content-Disposition": `form-data; name="${n}"`
          }),
          body: Oe(s, "utf-8")
        });
      else {
        if (s == null || typeof s != "object")
          throw new Error(`Unexpected value for key ${n}: ${s}. Value should be serialized to string first.`);
        {
          const o = s.name || "blob", m = rr();
          m.set("Content-Disposition", `form-data; name="${n}"; filename="${o}"`), m.set("Content-Type", s.type || "application/octet-stream"), a.push({
            headers: m,
            body: s
          });
        }
      }
  r.multipartBody = { parts: a };
}
function Td(t) {
  return new Response(t).blob();
}
async function vd(t) {
  if (t instanceof Blob || t instanceof Uint8Array)
    return t;
  if (va(t))
    return Td(t);
  throw new Error("Unsupported source type. Only Blob, Uint8Array, and ReadableStream are supported in browser.");
}
function Hd(t) {
  return "resize" in t.buffer ? t : t.map((r) => r);
}
async function kd(t) {
  const r = [];
  for (const e of t) {
    const a = await vd(typeof e == "function" ? e() : e);
    a instanceof Blob ? r.push(a) : r.push(new Blob([Hd(a)]));
  }
  return new Blob(r);
}
function Ld() {
  return `----AzSDKFormBoundary${Da()}`;
}
function Ud(t) {
  let r = "";
  for (const [e, a] of t)
    r += `${e}: ${a}\r
`;
  return r;
}
function qd(t) {
  return t instanceof Uint8Array ? t.byteLength : Wl(t) ? t.size === -1 ? void 0 : t.size : void 0;
}
function Od(t) {
  let r = 0;
  for (const e of t) {
    const a = qd(e);
    if (a === void 0)
      return;
    r += a;
  }
  return r;
}
async function Fd(t, r, e) {
  const a = [
    Oe(`--${e}`, "utf-8"),
    ...r.flatMap((i) => [
      Oe(`\r
`, "utf-8"),
      Oe(Ud(i.headers), "utf-8"),
      Oe(`\r
`, "utf-8"),
      i.body,
      Oe(`\r
--${e}`, "utf-8")
    ]),
    Oe(`--\r
\r
`, "utf-8")
  ], n = Od(a);
  n && t.headers.set("Content-Length", n), t.body = await kd(a);
}
const pi = "multipartPolicy", _d = 70, Gd = new Set("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'()+,-./:=?");
function Yd(t) {
  if (t.length > _d)
    throw new Error(`Multipart boundary "${t}" exceeds maximum length of 70 characters`);
  if (Array.from(t).some((r) => !Gd.has(r)))
    throw new Error(`Multipart boundary "${t}" contains invalid characters`);
}
function Kd() {
  return {
    name: pi,
    async sendRequest(t, r) {
      if (!t.multipartBody)
        return r(t);
      if (t.body)
        throw new Error("multipartBody and regular body cannot be set at the same time");
      let e = t.multipartBody.boundary;
      const a = t.headers.get("Content-Type") ?? "multipart/mixed", n = a.match(/^(multipart\/[^ ;]+)(?:; *boundary=(.+))?$/);
      if (!n)
        throw new Error(`Got multipart request body, but content-type header was not multipart: ${a}`);
      const [, i, s] = n;
      if (s && e && s !== e)
        throw new Error(`Multipart boundary was specified as ${s} in the header, but got ${e} in the request body`);
      return e ?? (e = s), e ? Yd(e) : e = Ld(), t.headers.set("Content-Type", `${i}; boundary=${e}`), await Fd(t, t.multipartBody.parts, e), t.multipartBody = void 0, r(t);
    }
  };
}
function ui() {
  return Tl();
}
const Jd = ii({
  logLevelEnvVarName: "AZURE_LOG_LEVEL",
  namespace: "azure"
});
function Hr(t) {
  return Jd.createClientLogger(t);
}
const Bt = Hr("core-rest-pipeline"), Xd = "decompressResponsePolicy", Wd = "redirectPolicy";
function jd(t = {}) {
  return dd({
    logger: Bt.info,
    ...t
  });
}
const Zd = Wd;
function Vd() {
  return "x-ms-useragent";
}
function $d(t) {
  const r = [
    { name: "Firefox", regex: /Firefox\/([\d.]+)/ },
    { name: "Safari", regex: /Version\/([\d.]+).*Safari/ }
  ];
  for (const e of r) {
    const a = t.match(e.regex);
    if (a)
      return { brand: e.name, version: a[1] };
  }
}
function ep(t) {
  const r = ["Google Chrome", "Microsoft Edge", "Opera", "Brave", "Chromium"];
  for (const e of r) {
    const a = t.find((n) => n.brand === e);
    if (a)
      return a;
  }
}
async function tp(t) {
  const r = globalThis.navigator;
  let e = "unknown";
  if (r != null && r.userAgentData) {
    const a = await r.userAgentData.getHighEntropyValues([
      "architecture",
      "platformVersion"
    ]);
    e = `${a.platform} ${a.platformVersion}; ${a.architecture}`;
    const n = ep(r.userAgentData.brands);
    n && t.set(n.brand, `${n.version} (${e})`);
  } else if (r != null && r.platform) {
    e = r.platform;
    const a = $d(r.userAgent);
    a && t.set(a.brand, `${a.version} (${e})`);
  } else typeof EdgeRuntime == "string" && t.set("EdgeRuntime", `${EdgeRuntime} (${e})`);
}
const gi = "1.24.0";
function rp(t) {
  const r = [];
  for (const [e, a] of t) {
    const n = a ? `${e}/${a}` : e;
    r.push(n);
  }
  return r.join(" ");
}
function ap() {
  return Vd();
}
async function yi(t) {
  const r = /* @__PURE__ */ new Map();
  r.set("core-rest-pipeline", gi), await tp(r);
  const e = rp(r);
  return t ? `${t} ${e}` : e;
}
const Pn = ap(), np = "userAgentPolicy";
function ip(t = {}) {
  const r = yi(t.userAgentPrefix);
  return {
    name: np,
    async sendRequest(e, a) {
      return e.headers.has(Pn) || e.headers.set(Pn, await r), a(e);
    }
  };
}
const hi = Symbol("rawContent");
function fi(t) {
  return typeof t[hi] == "function";
}
function sp(t) {
  return fi(t) ? t[hi]() : t;
}
const Ai = pi;
function op() {
  const t = Kd();
  return {
    name: Ai,
    sendRequest: async (r, e) => {
      if (r.multipartBody)
        for (const a of r.multipartBody.parts)
          fi(a.body) && (a.body = sp(a.body));
      return t.sendRequest(r, e);
    }
  };
}
const mp = Xd;
function cp(t = {}) {
  return Rd(t);
}
function lp() {
  return Md();
}
class Ha extends Error {
  constructor(r) {
    super(r), this.name = "AbortError";
  }
}
function dp(t, r) {
  const { cleanupBeforeAbort: e, abortSignal: a, abortErrorMsg: n } = r ?? {};
  return new Promise((i, s) => {
    function o() {
      s(new Ha(n ?? "The operation was aborted."));
    }
    function m() {
      a == null || a.removeEventListener("abort", c);
    }
    function c() {
      e == null || e(), m(), o();
    }
    if (a != null && a.aborted)
      return o();
    try {
      t((l) => {
        m(), i(l);
      }, (l) => {
        m(), s(l);
      });
    } catch (l) {
      s(l);
    }
    a == null || a.addEventListener("abort", c);
  });
}
const pp = "The delay was aborted.";
function Ni(t, r) {
  let e;
  const { abortSignal: a, abortErrorMsg: n } = {};
  return dp((i) => {
    e = setTimeout(i, t);
  }, {
    cleanupBeforeAbort: () => clearTimeout(e),
    abortSignal: a,
    abortErrorMsg: n ?? pp
  });
}
function lr(t) {
  if (Qa(t))
    return t.message;
  {
    let r;
    try {
      typeof t == "object" && t ? r = JSON.stringify(t) : r = String(t);
    } catch {
      r = "[unable to stringify input]";
    }
    return `Unknown error ${r}`;
  }
}
function up(t) {
  return Qa(t);
}
function zr() {
  return Da();
}
function gp(t, r) {
  return Ol(t, r);
}
function yp(t, r) {
  return Oe(t, r);
}
const hp = "setClientRequestIdPolicy";
function fp(t = "x-ms-client-request-id") {
  return {
    name: hp,
    async sendRequest(r, e) {
      return r.headers.has(t) || r.headers.set(t, r.requestId), e(r);
    }
  };
}
const jt = {
  span: Symbol.for("@azure/core-tracing span"),
  namespace: Symbol.for("@azure/core-tracing namespace")
};
function Ap(t = {}) {
  let r = new Zt(t.parentContext);
  return t.span && (r = r.setValue(jt.span, t.span)), t.namespace && (r = r.setValue(jt.namespace, t.namespace)), r;
}
class Zt {
  constructor(r) {
    d(this, "_contextMap");
    this._contextMap = r instanceof Zt ? new Map(r._contextMap) : /* @__PURE__ */ new Map();
  }
  setValue(r, e) {
    const a = new Zt(this);
    return a._contextMap.set(r, e), a;
  }
  getValue(r) {
    return this._contextMap.get(r);
  }
  deleteValue(r) {
    const e = new Zt(this);
    return e._contextMap.delete(r), e;
  }
}
const sa = {
  instrumenterImplementation: void 0
};
function Np() {
  return {
    end: () => {
    },
    isRecording: () => !1,
    recordException: () => {
    },
    setAttribute: () => {
    },
    setStatus: () => {
    },
    addEvent: () => {
    }
  };
}
function Cp() {
  return {
    createRequestHeaders: () => ({}),
    parseTraceparentHeader: () => {
    },
    startSpan: (t, r) => ({
      span: Np(),
      tracingContext: Ap({ parentContext: r.tracingContext })
    }),
    withContext(t, r, ...e) {
      return r(...e);
    }
  };
}
function Cr() {
  return sa.instrumenterImplementation || (sa.instrumenterImplementation = Cp()), sa.instrumenterImplementation;
}
function Ci(t) {
  const { namespace: r, packageName: e, packageVersion: a } = t;
  function n(c, l, u) {
    var R;
    const y = Cr().startSpan(c, {
      ...u,
      packageName: e,
      packageVersion: a,
      tracingContext: (R = l == null ? void 0 : l.tracingOptions) == null ? void 0 : R.tracingContext
    });
    let A = y.tracingContext;
    const g = y.span;
    A.getValue(jt.namespace) || (A = A.setValue(jt.namespace, r)), g.setAttribute("az.namespace", A.getValue(jt.namespace));
    const C = Object.assign({}, l, {
      tracingOptions: { ...l == null ? void 0 : l.tracingOptions, tracingContext: A }
    });
    return {
      span: g,
      updatedOptions: C
    };
  }
  async function i(c, l, u, y) {
    const { span: A, updatedOptions: g } = n(c, l, y);
    try {
      const C = await s(g.tracingOptions.tracingContext, () => Promise.resolve(u(g, A)));
      return A.setStatus({ status: "success" }), C;
    } catch (C) {
      throw A.setStatus({ status: "error", error: C }), C;
    } finally {
      A.end();
    }
  }
  function s(c, l, ...u) {
    return Cr().withContext(c, l, ...u);
  }
  function o(c) {
    return Cr().parseTraceparentHeader(c);
  }
  function m(c) {
    return Cr().createRequestHeaders(c);
  }
  return {
    startSpan: n,
    withSpan: i,
    withContext: s,
    parseTraceparentHeader: o,
    createRequestHeaders: m
  };
}
const ar = Rr;
function ka(t) {
  return oi(t);
}
const xp = "tracingPolicy";
function Ip(t = {}) {
  const r = yi(t.userAgentPrefix), e = new Ta({
    additionalAllowedQueryParameters: t.additionalAllowedQueryParameters
  }), a = Bp();
  return {
    name: xp,
    async sendRequest(n, i) {
      if (!a)
        return i(n);
      const s = await r, o = {
        "http.url": e.sanitizeUrl(n.url),
        "http.method": n.method,
        "http.user_agent": s,
        requestId: n.requestId
      };
      s && (o["http.user_agent"] = s);
      const { span: m, tracingContext: c } = bp(a, n, o) ?? {};
      if (!m || !c)
        return i(n);
      try {
        const l = await a.withContext(c, i, n);
        return Pp(m, l), l;
      } catch (l) {
        throw Ep(m, l), l;
      }
    }
  };
}
function Bp() {
  try {
    return Ci({
      namespace: "",
      packageName: "@azure/core-rest-pipeline",
      packageVersion: gi
    });
  } catch (t) {
    Bt.warning(`Error when creating the TracingClient: ${lr(t)}`);
    return;
  }
}
function bp(t, r, e) {
  try {
    const { span: a, updatedOptions: n } = t.startSpan(`HTTP ${r.method}`, { tracingOptions: r.tracingOptions }, {
      spanKind: "client",
      spanAttributes: e
    });
    if (!a.isRecording()) {
      a.end();
      return;
    }
    const i = t.createRequestHeaders(n.tracingOptions.tracingContext);
    for (const [s, o] of Object.entries(i))
      r.headers.set(s, o);
    return { span: a, tracingContext: n.tracingOptions.tracingContext };
  } catch (a) {
    Bt.warning(`Skipping creating a tracing span due to an error: ${lr(a)}`);
    return;
  }
}
function Ep(t, r) {
  try {
    t.setStatus({
      status: "error",
      error: up(r) ? r : void 0
    }), ka(r) && r.statusCode && t.setAttribute("http.status_code", r.statusCode), t.end();
  } catch (e) {
    Bt.warning(`Skipping tracing span processing due to an error: ${lr(e)}`);
  }
}
function Pp(t, r) {
  try {
    t.setAttribute("http.status_code", r.status);
    const e = r.headers.get("x-ms-request-id");
    e && t.setAttribute("serviceRequestId", e), r.status >= 400 && t.setStatus({
      status: "error"
    }), t.end();
  } catch (e) {
    Bt.warning(`Skipping tracing span processing due to an error: ${lr(e)}`);
  }
}
function xi(t) {
  if (t instanceof AbortSignal)
    return { abortSignal: t };
  if (t.aborted)
    return {
      abortSignal: AbortSignal.abort("reason" in t ? t.reason : void 0)
    };
  const r = new AbortController();
  let e = !0;
  function a() {
    e && (t.removeEventListener("abort", n), e = !1);
  }
  function n() {
    r.abort("reason" in t ? t.reason : void 0), a();
  }
  return t.addEventListener("abort", n), { abortSignal: r.signal, cleanup: a };
}
const wp = "wrapAbortSignalLikePolicy";
function Sp() {
  return {
    name: wp,
    sendRequest: async (t, r) => {
      if (!t.abortSignal)
        return r(t);
      const { abortSignal: e, cleanup: a } = xi(t.abortSignal);
      t.abortSignal = e;
      try {
        return await r(t);
      } finally {
        a == null || a();
      }
    }
  };
}
function Rp(t) {
  var e;
  const r = ui();
  return r.addPolicy(Sp()), r.addPolicy(lp(), { beforePolicies: [Ai] }), r.addPolicy(ip(t.userAgentOptions)), r.addPolicy(fp((e = t.telemetryOptions) == null ? void 0 : e.clientRequestIdHeaderName)), r.addPolicy(op(), { afterPhase: "Deserialize" }), r.addPolicy(cp(t.retryOptions), { phase: "Retry" }), r.addPolicy(Ip({ ...t.userAgentOptions, ...t.loggingOptions }), {
    afterPhase: "Retry"
  }), r.addPolicy(jd(t.loggingOptions), { afterPhase: "Sign" }), r;
}
function Ii() {
  const t = md();
  return {
    async sendRequest(r) {
      const { abortSignal: e, cleanup: a } = r.abortSignal ? xi(r.abortSignal) : {};
      try {
        return r.abortSignal = e, await t.sendRequest(r);
      } finally {
        a == null || a();
      }
    }
  };
}
function kr(t) {
  return rr(t);
}
function Bi(t) {
  return Ql(t);
}
const zp = {
  forcedRefreshWindowInMs: 1e3,
  // Force waiting for a refresh 1s before the token expires
  retryIntervalInMs: 3e3,
  // Allow refresh attempts every 3s
  refreshWindowInMs: 1e3 * 60 * 2
  // Start refreshing 2m before expiry
};
async function Mp(t, r, e) {
  async function a() {
    if (Date.now() < e)
      try {
        return await t();
      } catch {
        return null;
      }
    else {
      const i = await t();
      if (i === null)
        throw new Error("Failed to refresh access token.");
      return i;
    }
  }
  let n = await a();
  for (; n === null; )
    await Ni(r), n = await a();
  return n;
}
function Dp(t, r) {
  let e = null, a = null, n;
  const i = {
    ...zp,
    ...r
  }, s = {
    /**
     * Produces true if a refresh job is currently in progress.
     */
    get isRefreshing() {
      return e !== null;
    },
    /**
     * Produces true if the cycler SHOULD refresh (we are within the refresh
     * window and not already refreshing)
     */
    get shouldRefresh() {
      return a === null ? !0 : s.isRefreshing ? !1 : a.refreshAfterTimestamp && a.refreshAfterTimestamp < Date.now() ? !0 : a.expiresOnTimestamp - i.refreshWindowInMs < Date.now();
    },
    /**
     * Produces true if the cycler MUST refresh (null or nearly-expired
     * token).
     */
    get mustRefresh() {
      return a === null || a.expiresOnTimestamp - i.forcedRefreshWindowInMs < Date.now();
    }
  };
  function o(m, c) {
    return s.isRefreshing || (e = Mp(
      () => t.getToken(m, c),
      i.retryIntervalInMs,
      // If we don't have a token, then we should timeout immediately
      (a == null ? void 0 : a.expiresOnTimestamp) ?? Date.now()
    ).then((u) => (e = null, a = u, n = c.tenantId, a)).catch((u) => {
      throw e = null, a = null, n = void 0, u;
    })), e;
  }
  return async (m, c) => {
    const l = !!c.claims, u = n !== c.tenantId;
    return l && (a = null), u || l || s.mustRefresh ? o(m, c) : (s.shouldRefresh && o(m, c), a);
  };
}
const Qp = "bearerTokenAuthenticationPolicy";
async function xr(t, r) {
  try {
    return [await r(t), void 0];
  } catch (e) {
    if (ka(e) && e.response)
      return [e.response, e];
    throw e;
  }
}
async function Tp(t) {
  const { scopes: r, getAccessToken: e, request: a } = t, n = {
    abortSignal: a.abortSignal,
    tracingOptions: a.tracingOptions,
    enableCae: !0
  }, i = await e(r, n);
  i && t.request.headers.set("Authorization", `Bearer ${i.token}`);
}
function wn(t) {
  return t.status === 401 && t.headers.has("WWW-Authenticate");
}
async function Sn(t, r) {
  const { scopes: e } = t, a = await t.getAccessToken(e, {
    enableCae: !0,
    claims: r
  });
  return a ? (t.request.headers.set("Authorization", `${a.tokenType ?? "Bearer"} ${a.token}`), !0) : !1;
}
function La(t) {
  var o, m;
  const { credential: r, scopes: e, challengeCallbacks: a } = t, n = t.logger || Bt, i = {
    authorizeRequest: ((o = a == null ? void 0 : a.authorizeRequest) == null ? void 0 : o.bind(a)) ?? Tp,
    authorizeRequestOnChallenge: (m = a == null ? void 0 : a.authorizeRequestOnChallenge) == null ? void 0 : m.bind(a)
  }, s = r ? Dp(
    r
    /* , options */
  ) : () => Promise.resolve(null);
  return {
    name: Qp,
    /**
     * If there's no challenge parameter:
     * - It will try to retrieve the token using the cache, or the credential's getToken.
     * - Then it will try the next policy with or without the retrieved token.
     *
     * It uses the challenge parameters to:
     * - Skip a first attempt to get the token from the credential if there's no cached token,
     *   since it expects the token to be retrievable only after the challenge.
     * - Prepare the outgoing request if the `prepareRequest` method has been provided.
     * - Send an initial request to receive the challenge if it fails.
     * - Process a challenge if the response contains it.
     * - Retrieve a token with the challenge information, then re-send the request.
     */
    async sendRequest(c, l) {
      if (!c.url.toLowerCase().startsWith("https://"))
        throw new Error("Bearer token authentication is not permitted for non-TLS protected (non-https) URLs.");
      await i.authorizeRequest({
        scopes: Array.isArray(e) ? e : [e],
        request: c,
        getAccessToken: s,
        logger: n
      });
      let u, y, A;
      if ([u, y] = await xr(c, l), wn(u)) {
        let g = Rn(u.headers.get("WWW-Authenticate"));
        if (g) {
          let C;
          try {
            C = atob(g);
          } catch {
            return n.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${g}`), u;
          }
          A = await Sn({
            scopes: Array.isArray(e) ? e : [e],
            response: u,
            request: c,
            getAccessToken: s,
            logger: n
          }, C), A && ([u, y] = await xr(c, l));
        } else if (i.authorizeRequestOnChallenge && (A = await i.authorizeRequestOnChallenge({
          scopes: Array.isArray(e) ? e : [e],
          request: c,
          response: u,
          getAccessToken: s,
          logger: n
        }), A && ([u, y] = await xr(c, l)), wn(u) && (g = Rn(u.headers.get("WWW-Authenticate") ?? ""), g))) {
          let C;
          try {
            C = atob(g);
          } catch {
            return n.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${g}`), u;
          }
          A = await Sn({
            scopes: Array.isArray(e) ? e : [e],
            response: u,
            request: c,
            getAccessToken: s,
            logger: n
          }, C), A && ([u, y] = await xr(c, l));
        }
      }
      if (y)
        throw y;
      return u;
    }
  };
}
function vp(t) {
  const r = /(\w+)\s+((?:\w+=(?:"[^"]*"|[^,]*),?\s*)+)/g, e = /(\w+)="([^"]*)"/g, a = [];
  let n;
  for (; (n = r.exec(t)) !== null; ) {
    const i = n[1], s = n[2], o = {};
    let m;
    for (; (m = e.exec(s)) !== null; )
      o[m[1]] = m[2];
    a.push({ scheme: i, params: o });
  }
  return a;
}
function Rn(t) {
  var e;
  return t ? (e = vp(t).find((a) => a.scheme === "Bearer" && a.params.claims && a.params.error === "insufficient_claims")) == null ? void 0 : e.params.claims : void 0;
}
function Ie(t) {
  const r = t;
  return r && typeof r.getToken == "function" && (r.signRequest === void 0 || r.getToken.length > 0);
}
const bi = "DisableKeepAlivePolicy";
function Hp() {
  return {
    name: bi,
    async sendRequest(t, r) {
      return t.disableKeepAlive = !0, r(t);
    }
  };
}
function kp(t) {
  return t.getOrderedPolicies().some((r) => r.name === bi);
}
function Ei(t) {
  return gp(t, "base64");
}
function Pi(t) {
  return yp(t, "base64");
}
const oe = "$", nr = "_";
function Lp(t, r) {
  return r !== "Composite" && r !== "Dictionary" && (typeof t == "string" || typeof t == "number" || typeof t == "boolean" || (r == null ? void 0 : r.match(/^(Date|DateTime|DateTimeRfc1123|UnixTime|ByteArray|Base64Url)$/i)) !== null || t === void 0 || t === null);
}
const Up = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function qp(t) {
  return Up.test(t);
}
const Op = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
function Fp(t) {
  return Op.test(t);
}
function _p(t) {
  const r = {
    ...t.headers,
    ...t.body
  };
  return t.hasNullableType && Object.getOwnPropertyNames(r).length === 0 ? t.shouldWrapBody ? { body: null } : null : t.shouldWrapBody ? {
    ...t.headers,
    body: t.body
  } : r;
}
function zn(t, r) {
  var m;
  const e = t.parsedHeaders;
  if (t.request.method === "HEAD")
    return {
      ...e,
      body: t.parsedBody
    };
  const a = r && r.bodyMapper, n = !!(a != null && a.nullable), i = a == null ? void 0 : a.type.name;
  if (i === "Stream")
    return {
      ...e,
      blobBody: t.blobBody,
      readableStreamBody: t.readableStreamBody
    };
  const s = i === "Composite" && a.type.modelProperties || {}, o = Object.keys(s).some((c) => s[c].serializedName === "");
  if (i === "Sequence" || o) {
    const c = t.parsedBody ?? [];
    for (const l of Object.keys(s))
      s[l].serializedName && (c[l] = (m = t.parsedBody) == null ? void 0 : m[l]);
    if (e)
      for (const l of Object.keys(e))
        c[l] = e[l];
    return n && !t.parsedBody && !e && Object.getOwnPropertyNames(s).length === 0 ? null : c;
  }
  return _p({
    body: t.parsedBody,
    headers: e,
    hasNullableType: n,
    shouldWrapBody: Lp(t.parsedBody, i)
  });
}
class Gp {
  constructor(r = {}, e = !1) {
    d(this, "modelMappers");
    d(this, "isXML");
    this.modelMappers = r, this.isXML = e;
  }
  /**
   * @deprecated Removing the constraints validation on client side.
   */
  validateConstraints(r, e, a) {
    const n = (i, s) => {
      throw new Error(`"${a}" with value "${e}" should satisfy the constraint "${i}": ${s}.`);
    };
    if (r.constraints && e !== void 0 && e !== null) {
      const { ExclusiveMaximum: i, ExclusiveMinimum: s, InclusiveMaximum: o, InclusiveMinimum: m, MaxItems: c, MaxLength: l, MinItems: u, MinLength: y, MultipleOf: A, Pattern: g, UniqueItems: C } = r.constraints;
      if (i !== void 0 && e >= i && n("ExclusiveMaximum", i), s !== void 0 && e <= s && n("ExclusiveMinimum", s), o !== void 0 && e > o && n("InclusiveMaximum", o), m !== void 0 && e < m && n("InclusiveMinimum", m), c !== void 0 && e.length > c && n("MaxItems", c), l !== void 0 && e.length > l && n("MaxLength", l), u !== void 0 && e.length < u && n("MinItems", u), y !== void 0 && e.length < y && n("MinLength", y), A !== void 0 && e % A !== 0 && n("MultipleOf", A), g) {
        const R = typeof g == "string" ? new RegExp(g) : g;
        (typeof e != "string" || e.match(R) === null) && n("Pattern", g);
      }
      C && e.some((R, D, T) => T.indexOf(R) !== D) && n("UniqueItems", C);
    }
  }
  /**
   * Serialize the given object based on its metadata defined in the mapper
   *
   * @param mapper - The mapper which defines the metadata of the serializable object
   *
   * @param object - A valid Javascript object to be serialized
   *
   * @param objectName - Name of the serialized object
   *
   * @param options - additional options to serialization
   *
   * @returns A valid serialized Javascript object
   */
  serialize(r, e, a, n = { xml: {} }) {
    const i = {
      xml: {
        rootName: n.xml.rootName ?? "",
        includeRoot: n.xml.includeRoot ?? !1,
        xmlCharKey: n.xml.xmlCharKey ?? nr
      }
    };
    let s = {};
    const o = r.type.name;
    a || (a = r.serializedName), o.match(/^Sequence$/i) !== null && (s = []), r.isConstant && (e = r.defaultValue);
    const { required: m, nullable: c } = r;
    if (m && c && e === void 0)
      throw new Error(`${a} cannot be undefined.`);
    if (m && !c && e == null)
      throw new Error(`${a} cannot be null or undefined.`);
    if (!m && c === !1 && e === null)
      throw new Error(`${a} cannot be null.`);
    return e == null || o.match(/^any$/i) !== null ? s = e : o.match(/^(Number|String|Boolean|Object|Stream|Uuid)$/i) !== null ? s = jp(o, a, e) : o.match(/^Enum$/i) !== null ? s = Zp(a, r.type.allowedValues, e) : o.match(/^(Date|DateTime|TimeSpan|DateTimeRfc1123|UnixTime)$/i) !== null ? s = eu(o, e, a) : o.match(/^ByteArray$/i) !== null ? s = Vp(a, e) : o.match(/^Base64Url$/i) !== null ? s = $p(a, e) : o.match(/^Sequence$/i) !== null ? s = tu(this, r, e, a, !!this.isXML, i) : o.match(/^Dictionary$/i) !== null ? s = ru(this, r, e, a, !!this.isXML, i) : o.match(/^Composite$/i) !== null && (s = nu(this, r, e, a, !!this.isXML, i)), s;
  }
  /**
   * Deserialize the given object based on its metadata defined in the mapper
   *
   * @param mapper - The mapper which defines the metadata of the serializable object
   *
   * @param responseBody - A valid Javascript entity to be deserialized
   *
   * @param objectName - Name of the deserialized object
   *
   * @param options - Controls behavior of XML parser and builder.
   *
   * @returns A valid deserialized Javascript object
   */
  deserialize(r, e, a, n = { xml: {} }) {
    const i = {
      xml: {
        rootName: n.xml.rootName ?? "",
        includeRoot: n.xml.includeRoot ?? !1,
        xmlCharKey: n.xml.xmlCharKey ?? nr
      },
      ignoreUnknownProperties: n.ignoreUnknownProperties ?? !1
    };
    if (e == null)
      return this.isXML && r.type.name === "Sequence" && !r.xmlIsWrapped && (e = []), r.defaultValue !== void 0 && (e = r.defaultValue), e;
    let s;
    const o = r.type.name;
    if (a || (a = r.serializedName), o.match(/^Composite$/i) !== null)
      s = su(this, r, e, a, i);
    else {
      if (this.isXML) {
        const m = i.xml.xmlCharKey;
        e[oe] !== void 0 && e[m] !== void 0 && (e = e[m]);
      }
      o.match(/^Number$/i) !== null ? (s = parseFloat(e), isNaN(s) && (s = e)) : o.match(/^Boolean$/i) !== null ? e === "true" ? s = !0 : e === "false" ? s = !1 : s = e : o.match(/^(String|Enum|Object|Stream|Uuid|TimeSpan|any)$/i) !== null ? s = e : o.match(/^(Date|DateTime|DateTimeRfc1123)$/i) !== null ? s = new Date(e) : o.match(/^UnixTime$/i) !== null ? s = Wp(e) : o.match(/^ByteArray$/i) !== null ? s = Pi(e) : o.match(/^Base64Url$/i) !== null ? s = Jp(e) : o.match(/^Sequence$/i) !== null ? s = mu(this, r, e, a, i) : o.match(/^Dictionary$/i) !== null && (s = ou(this, r, e, a, i));
    }
    return r.isConstant && (s = r.defaultValue), s;
  }
}
function bt(t = {}, r = !1) {
  return new Gp(t, r);
}
function Yp(t, r) {
  let e = t.length;
  for (; e - 1 >= 0 && t[e - 1] === r; )
    --e;
  return t.substr(0, e);
}
function Kp(t) {
  if (!t)
    return;
  if (!(t instanceof Uint8Array))
    throw new Error("Please provide an input of type Uint8Array for converting to Base64Url.");
  const r = Ei(t);
  return Yp(r, "=").replace(/\+/g, "-").replace(/\//g, "_");
}
function Jp(t) {
  if (t) {
    if (t && typeof t.valueOf() != "string")
      throw new Error("Please provide an input of type string for converting to Uint8Array");
    return t = t.replace(/-/g, "+").replace(/_/g, "/"), Pi(t);
  }
}
function xa(t) {
  const r = [];
  let e = "";
  if (t) {
    const a = t.split(".");
    for (const n of a)
      n.charAt(n.length - 1) === "\\" ? e += n.substr(0, n.length - 1) + "." : (e += n, r.push(e), e = "");
  }
  return r;
}
function Xp(t) {
  if (t)
    return typeof t.valueOf() == "string" && (t = new Date(t)), Math.floor(t.getTime() / 1e3);
}
function Wp(t) {
  if (t)
    return new Date(t * 1e3);
}
function jp(t, r, e) {
  if (e != null) {
    if (t.match(/^Number$/i) !== null) {
      if (typeof e != "number")
        throw new Error(`${r} with value ${e} must be of type number.`);
    } else if (t.match(/^String$/i) !== null) {
      if (typeof e.valueOf() != "string")
        throw new Error(`${r} with value "${e}" must be of type string.`);
    } else if (t.match(/^Uuid$/i) !== null) {
      if (!(typeof e.valueOf() == "string" && Fp(e)))
        throw new Error(`${r} with value "${e}" must be of type string and a valid uuid.`);
    } else if (t.match(/^Boolean$/i) !== null) {
      if (typeof e != "boolean")
        throw new Error(`${r} with value ${e} must be of type boolean.`);
    } else if (t.match(/^Stream$/i) !== null) {
      const a = typeof e;
      if (a !== "string" && typeof e.pipe != "function" && // NodeJS.ReadableStream
      typeof e.tee != "function" && // browser ReadableStream
      !(e instanceof ArrayBuffer) && !ArrayBuffer.isView(e) && // File objects count as a type of Blob, so we want to use instanceof explicitly
      !((typeof Blob == "function" || typeof Blob == "object") && e instanceof Blob) && a !== "function")
        throw new Error(`${r} must be a string, Blob, ArrayBuffer, ArrayBufferView, ReadableStream, or () => ReadableStream.`);
    }
  }
  return e;
}
function Zp(t, r, e) {
  if (!r)
    throw new Error(`Please provide a set of allowedValues to validate ${t} as an Enum Type.`);
  if (!r.some((n) => typeof n.valueOf() == "string" ? n.toLowerCase() === e.toLowerCase() : n === e))
    throw new Error(`${e} is not a valid value for ${t}. The valid values are: ${JSON.stringify(r)}.`);
  return e;
}
function Vp(t, r) {
  if (r != null) {
    if (!(r instanceof Uint8Array))
      throw new Error(`${t} must be of type Uint8Array.`);
    r = Ei(r);
  }
  return r;
}
function $p(t, r) {
  if (r != null) {
    if (!(r instanceof Uint8Array))
      throw new Error(`${t} must be of type Uint8Array.`);
    r = Kp(r);
  }
  return r;
}
function eu(t, r, e) {
  if (r != null) {
    if (t.match(/^Date$/i) !== null) {
      if (!(r instanceof Date || typeof r.valueOf() == "string" && !isNaN(Date.parse(r))))
        throw new Error(`${e} must be an instanceof Date or a string in ISO8601 format.`);
      r = r instanceof Date ? r.toISOString().substring(0, 10) : new Date(r).toISOString().substring(0, 10);
    } else if (t.match(/^DateTime$/i) !== null) {
      if (!(r instanceof Date || typeof r.valueOf() == "string" && !isNaN(Date.parse(r))))
        throw new Error(`${e} must be an instanceof Date or a string in ISO8601 format.`);
      r = r instanceof Date ? r.toISOString() : new Date(r).toISOString();
    } else if (t.match(/^DateTimeRfc1123$/i) !== null) {
      if (!(r instanceof Date || typeof r.valueOf() == "string" && !isNaN(Date.parse(r))))
        throw new Error(`${e} must be an instanceof Date or a string in RFC-1123 format.`);
      r = r instanceof Date ? r.toUTCString() : new Date(r).toUTCString();
    } else if (t.match(/^UnixTime$/i) !== null) {
      if (!(r instanceof Date || typeof r.valueOf() == "string" && !isNaN(Date.parse(r))))
        throw new Error(`${e} must be an instanceof Date or a string in RFC-1123/ISO8601 format for it to be serialized in UnixTime/Epoch format.`);
      r = Xp(r);
    } else if (t.match(/^TimeSpan$/i) !== null && !qp(r))
      throw new Error(`${e} must be a string in ISO 8601 format. Instead was "${r}".`);
  }
  return r;
}
function tu(t, r, e, a, n, i) {
  if (!Array.isArray(e))
    throw new Error(`${a} must be of type Array.`);
  let s = r.type.element;
  if (!s || typeof s != "object")
    throw new Error(`"element" metadata for an Array must be defined in the mapper and it must be of type "object" in ${a}.`);
  s.type.name === "Composite" && s.type.className && (s = t.modelMappers[s.type.className] ?? s);
  const o = [];
  for (let m = 0; m < e.length; m++) {
    const c = t.serialize(s, e[m], a, i);
    if (n && s.xmlNamespace) {
      const l = s.xmlNamespacePrefix ? `xmlns:${s.xmlNamespacePrefix}` : "xmlns";
      s.type.name === "Composite" ? (o[m] = { ...c }, o[m][oe] = { [l]: s.xmlNamespace }) : (o[m] = {}, o[m][i.xml.xmlCharKey] = c, o[m][oe] = { [l]: s.xmlNamespace });
    } else
      o[m] = c;
  }
  return o;
}
function ru(t, r, e, a, n, i) {
  if (typeof e != "object")
    throw new Error(`${a} must be of type object.`);
  const s = r.type.value;
  if (!s || typeof s != "object")
    throw new Error(`"value" metadata for a Dictionary must be defined in the mapper and it must of type "object" in ${a}.`);
  const o = {};
  for (const m of Object.keys(e)) {
    const c = t.serialize(s, e[m], a, i);
    o[m] = Ri(s, c, n, i);
  }
  if (n && r.xmlNamespace) {
    const m = r.xmlNamespacePrefix ? `xmlns:${r.xmlNamespacePrefix}` : "xmlns", c = o;
    return c[oe] = { [m]: r.xmlNamespace }, c;
  }
  return o;
}
function au(t, r, e) {
  const a = r.type.additionalProperties;
  if (!a && r.type.className) {
    const n = wi(t, r, e);
    return n == null ? void 0 : n.type.additionalProperties;
  }
  return a;
}
function wi(t, r, e) {
  const a = r.type.className;
  if (!a)
    throw new Error(`Class name for model "${e}" is not provided in the mapper "${JSON.stringify(r, void 0, 2)}".`);
  return t.modelMappers[a];
}
function Si(t, r, e) {
  let a = r.type.modelProperties;
  if (!a) {
    const n = wi(t, r, e);
    if (!n)
      throw new Error(`mapper() cannot be null or undefined for model "${r.type.className}".`);
    if (a = n == null ? void 0 : n.type.modelProperties, !a)
      throw new Error(`modelProperties cannot be null or undefined in the mapper "${JSON.stringify(n)}" of type "${r.type.className}" for object "${e}".`);
  }
  return a;
}
function nu(t, r, e, a, n, i) {
  if (Mr(t, r) && (r = zi(t, r, e, "clientName")), e != null) {
    const s = {}, o = Si(t, r, a);
    for (const c of Object.keys(o)) {
      const l = o[c];
      if (l.readOnly)
        continue;
      let u, y = s;
      if (t.isXML)
        l.xmlIsWrapped ? u = l.xmlName : u = l.xmlElementName || l.xmlName;
      else {
        const A = xa(l.serializedName);
        u = A.pop();
        for (const g of A) {
          const C = y[g];
          C == null && (e[c] !== void 0 && e[c] !== null || l.defaultValue !== void 0) && (y[g] = {}), y = y[g];
        }
      }
      if (y != null) {
        if (n && r.xmlNamespace) {
          const D = r.xmlNamespacePrefix ? `xmlns:${r.xmlNamespacePrefix}` : "xmlns";
          y[oe] = {
            ...y[oe],
            [D]: r.xmlNamespace
          };
        }
        const A = l.serializedName !== "" ? a + "." + l.serializedName : a;
        let g = e[c];
        const C = Mr(t, r);
        C && C.clientName === c && g == null && (g = r.serializedName);
        const R = t.serialize(l, g, A, i);
        if (R !== void 0 && u !== void 0 && u !== null) {
          const D = Ri(l, R, n, i);
          n && l.xmlIsAttribute ? (y[oe] = y[oe] || {}, y[oe][u] = R) : n && l.xmlIsWrapped ? y[u] = { [l.xmlElementName]: D } : y[u] = D;
        }
      }
    }
    const m = au(t, r, a);
    if (m) {
      const c = Object.keys(o);
      for (const l of Object.keys(e))
        c.every((y) => y !== l) && Object.defineProperty(s, l, {
          value: t.serialize(m, e[l], a + '["' + l + '"]', i),
          enumerable: !0,
          configurable: !0,
          writable: !0
        });
    }
    return s;
  }
  return e;
}
function Ri(t, r, e, a) {
  if (!e || !t.xmlNamespace)
    return r;
  const i = { [t.xmlNamespacePrefix ? `xmlns:${t.xmlNamespacePrefix}` : "xmlns"]: t.xmlNamespace };
  if (["Composite"].includes(t.type.name)) {
    if (r[oe])
      return r;
    {
      const o = { ...r };
      return o[oe] = i, o;
    }
  }
  const s = {};
  return s[a.xml.xmlCharKey] = r, s[oe] = i, s;
}
function iu(t, r) {
  return [oe, r.xml.xmlCharKey].includes(t);
}
function su(t, r, e, a, n) {
  const i = n.xml.xmlCharKey ?? nr;
  Mr(t, r) && (r = zi(t, r, e, "serializedName"));
  const s = Si(t, r, a);
  let o = {};
  const m = [];
  for (const l of Object.keys(s)) {
    const u = s[l], y = xa(s[l].serializedName);
    m.push(y[0]);
    const { serializedName: A, xmlName: g, xmlElementName: C } = u;
    let R = a;
    A !== "" && A !== void 0 && (R = a + "." + A);
    const D = u.headerCollectionPrefix;
    if (D) {
      const T = {};
      for (const v of Object.keys(e))
        v.startsWith(D) && (T[v.substring(D.length)] = t.deserialize(u.type.value, e[v], R, n)), m.push(v);
      o[l] = T;
    } else if (t.isXML)
      if (u.xmlIsAttribute && e[oe])
        o[l] = t.deserialize(u, e[oe][g], R, n);
      else if (u.xmlIsMsText)
        e[i] !== void 0 ? o[l] = e[i] : typeof e == "string" && (o[l] = e);
      else {
        const T = C || g || A;
        if (u.xmlIsWrapped) {
          const v = e[g], f = (v == null ? void 0 : v[C]) ?? [];
          Object.defineProperty(o, l, {
            value: t.deserialize(u, f, R, n),
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), m.push(g);
        } else {
          const v = e[T];
          o[l] = t.deserialize(u, v, R, n), m.push(T);
        }
      }
    else {
      let T, v = e, f = 0;
      for (const z of y) {
        if (!v)
          break;
        f++, v = v[z];
      }
      v === null && f < y.length && (v = void 0), T = v;
      const N = r.type.polymorphicDiscriminator;
      N && l === N.clientName && T == null && (T = r.serializedName);
      let h;
      if (Array.isArray(e[l]) && s[l].serializedName === "") {
        T = e[l];
        const z = t.deserialize(u, T, R, n);
        for (const [Q, _] of Object.entries(o))
          Object.prototype.hasOwnProperty.call(z, Q) || (z[Q] = _);
        o = z;
      } else (T !== void 0 || u.defaultValue !== void 0) && (h = t.deserialize(u, T, R, n), o[l] = h);
    }
  }
  const c = r.type.additionalProperties;
  if (c) {
    const l = (u) => {
      for (const y of Object.keys(s))
        if (xa(s[y].serializedName)[0] === u)
          return !1;
      return !0;
    };
    for (const u of Object.keys(e))
      if (l(u)) {
        const y = t.deserialize(c, e[u], a + '["' + u + '"]', n);
        Object.defineProperty(o, u, {
          value: y,
          enumerable: !0,
          configurable: !0,
          writable: !0
        });
      }
  } else if (e && !n.ignoreUnknownProperties)
    for (const l of Object.keys(e))
      o[l] === void 0 && !m.includes(l) && !iu(l, n) && Object.defineProperty(o, l, {
        value: e[l],
        enumerable: !0,
        configurable: !0,
        writable: !0
      });
  return o;
}
function ou(t, r, e, a, n) {
  const i = r.type.value;
  if (!i || typeof i != "object")
    throw new Error(`"value" metadata for a Dictionary must be defined in the mapper and it must of type "object" in ${a}`);
  if (e) {
    const s = {};
    for (const o of Object.keys(e))
      s[o] = t.deserialize(i, e[o], a, n);
    return s;
  }
  return e;
}
function mu(t, r, e, a, n) {
  let i = r.type.element;
  if (!i || typeof i != "object")
    throw new Error(`"element" metadata for an Array must be defined in the mapper and it must be of type "object" in ${a}`);
  if (e) {
    Array.isArray(e) || (e = [e]), i.type.name === "Composite" && i.type.className && (i = t.modelMappers[i.type.className] ?? i);
    const s = [];
    for (let o = 0; o < e.length; o++)
      s[o] = t.deserialize(i, e[o], `${a}[${o}]`, n);
    return s;
  }
  return e;
}
function cu(t, r, e) {
  const a = [e];
  for (; a.length; ) {
    const n = a.shift(), i = r === n ? r : n + "." + r;
    if (Object.prototype.hasOwnProperty.call(t, i))
      return t[i];
    for (const [s, o] of Object.entries(t))
      s.startsWith(n + ".") && o.type.uberParent === n && o.type.className && a.push(o.type.className);
  }
}
function zi(t, r, e, a) {
  const n = Mr(t, r);
  if (n) {
    let i = n[a];
    if (i) {
      a === "serializedName" && (i = i.replace(/\\/gi, ""));
      const s = e[i], o = r.type.uberParent ?? r.type.className;
      if (typeof s == "string" && o) {
        const m = cu(t.modelMappers.discriminators, s, o);
        m && (r = m);
      }
    }
  }
  return r;
}
function Mr(t, r) {
  return r.type.polymorphicDiscriminator || Mn(t, r.type.uberParent) || Mn(t, r.type.className);
}
function Mn(t, r) {
  return r && t.modelMappers[r] && t.modelMappers[r].type.polymorphicDiscriminator;
}
const ft = {
  Base64Url: "Base64Url",
  Boolean: "Boolean",
  ByteArray: "ByteArray",
  Composite: "Composite",
  Date: "Date",
  DateTime: "DateTime",
  DateTimeRfc1123: "DateTimeRfc1123",
  Dictionary: "Dictionary",
  Enum: "Enum",
  Number: "Number",
  Object: "Object",
  Sequence: "Sequence",
  String: "String",
  Stream: "Stream",
  TimeSpan: "TimeSpan",
  UnixTime: "UnixTime"
}, Dn = {
  operationRequestMap: /* @__PURE__ */ new WeakMap()
};
function Ct(t, r, e) {
  let a = r.parameterPath;
  const n = r.mapper;
  let i;
  if (typeof a == "string" && (a = [a]), Array.isArray(a)) {
    if (a.length > 0)
      if (n.isConstant)
        i = n.defaultValue;
      else {
        let s = Qn(t, a);
        !s.propertyFound && e && (s = Qn(e, a));
        let o = !1;
        s.propertyFound || (o = n.required || a[0] === "options" && a.length === 2), i = o ? n.defaultValue : s.propertyValue;
      }
  } else {
    n.required && (i = {});
    for (const [s, o] of Object.entries(a)) {
      const m = n.type.modelProperties[s], c = Ct(t, {
        parameterPath: o,
        mapper: m
      }, e);
      c !== void 0 && (i || (i = {}), Object.defineProperty(i, s, {
        value: c,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }));
    }
  }
  return i;
}
function Qn(t, r) {
  const e = { propertyFound: !1 };
  let a = 0;
  for (; a < r.length; ++a) {
    const n = r[a];
    if (t && n in t)
      t = t[n];
    else
      break;
  }
  return a === r.length && (e.propertyValue = t, e.propertyFound = !0), e;
}
const Mi = Symbol.for("@azure/core-client original request");
function lu(t) {
  return Mi in t;
}
function Et(t) {
  if (lu(t))
    return Et(t[Mi]);
  let r = Dn.operationRequestMap.get(t);
  return r || (r = {}, Dn.operationRequestMap.set(t, r)), r;
}
const du = ["application/json", "text/json"], pu = ["application/xml", "application/atom+xml"], uu = "deserializationPolicy";
function gu(t = {}) {
  var s, o;
  const r = ((s = t.expectedContentTypes) == null ? void 0 : s.json) ?? du, e = ((o = t.expectedContentTypes) == null ? void 0 : o.xml) ?? pu, a = t.parseXML, n = t.serializerOptions, i = {
    xml: {
      rootName: (n == null ? void 0 : n.xml.rootName) ?? "",
      includeRoot: (n == null ? void 0 : n.xml.includeRoot) ?? !1,
      xmlCharKey: (n == null ? void 0 : n.xml.xmlCharKey) ?? nr
    }
  };
  return {
    name: uu,
    async sendRequest(m, c) {
      const l = await c(m);
      return fu(r, e, l, i, a);
    }
  };
}
function yu(t) {
  let r;
  const e = t.request, a = Et(e), n = a == null ? void 0 : a.operationSpec;
  return n && (a != null && a.operationResponseGetter ? r = a == null ? void 0 : a.operationResponseGetter(n, t) : r = n.responses[t.status]), r;
}
function hu(t) {
  const r = t.request, e = Et(r), a = e == null ? void 0 : e.shouldDeserialize;
  let n;
  return a === void 0 ? n = !0 : typeof a == "boolean" ? n = a : n = a(t), n;
}
async function fu(t, r, e, a, n) {
  const i = await Cu(t, r, e, a, n);
  if (!hu(i))
    return i;
  const s = Et(i.request), o = s == null ? void 0 : s.operationSpec;
  if (!o || !o.responses)
    return i;
  const m = yu(i), { error: c, shouldReturnResponse: l } = Nu(i, o, m, a);
  if (c)
    throw c;
  if (l)
    return i;
  if (m) {
    if (m.bodyMapper) {
      let u = i.parsedBody;
      o.isXML && m.bodyMapper.type.name === ft.Sequence && (u = typeof u == "object" ? u[m.bodyMapper.xmlElementName] : []);
      try {
        i.parsedBody = o.serializer.deserialize(m.bodyMapper, u, "operationRes.parsedBody", a);
      } catch (y) {
        throw new ar(`Error ${y} occurred in deserializing the responseBody - ${i.bodyAsText}`, {
          statusCode: i.status,
          request: i.request,
          response: i
        });
      }
    } else o.httpMethod === "HEAD" && (i.parsedBody = e.status >= 200 && e.status < 300);
    m.headersMapper && (i.parsedHeaders = o.serializer.deserialize(m.headersMapper, i.headers.toJSON(), "operationRes.parsedHeaders", { xml: {}, ignoreUnknownProperties: !0 }));
  }
  return i;
}
function Au(t) {
  const r = Object.keys(t.responses);
  return r.length === 0 || r.length === 1 && r[0] === "default";
}
function Nu(t, r, e, a) {
  var u, y, A, g, C;
  const n = 200 <= t.status && t.status < 300;
  if (Au(r) ? n : !!e)
    if (e) {
      if (!e.isError)
        return { error: null, shouldReturnResponse: !1 };
    } else
      return { error: null, shouldReturnResponse: !1 };
  const s = e ?? r.responses.default, o = (u = t.request.streamResponseStatusCodes) != null && u.has(t.status) ? `Unexpected status code: ${t.status}` : t.bodyAsText, m = new ar(o, {
    statusCode: t.status,
    request: t.request,
    response: t
  });
  if (!s && !((A = (y = t.parsedBody) == null ? void 0 : y.error) != null && A.code && ((C = (g = t.parsedBody) == null ? void 0 : g.error) != null && C.message)))
    throw m;
  const c = s == null ? void 0 : s.bodyMapper, l = s == null ? void 0 : s.headersMapper;
  try {
    if (t.parsedBody) {
      const R = t.parsedBody;
      let D;
      if (c) {
        let v = R;
        if (r.isXML && c.type.name === ft.Sequence) {
          v = [];
          const f = c.xmlElementName;
          typeof R == "object" && f && (v = R[f]);
        }
        D = r.serializer.deserialize(c, v, "error.response.parsedBody", a);
      }
      const T = R.error || D || R;
      m.code = T.code, T.message && (m.message = T.message), c && (m.response.parsedBody = D);
    }
    t.headers && l && (m.response.parsedHeaders = r.serializer.deserialize(l, t.headers.toJSON(), "operationRes.parsedHeaders"));
  } catch (R) {
    m.message = `Error "${R.message}" occurred in deserializing the responseBody - "${t.bodyAsText}" for the default response.`;
  }
  return { error: m, shouldReturnResponse: !1 };
}
async function Cu(t, r, e, a, n) {
  var i;
  if (!((i = e.request.streamResponseStatusCodes) != null && i.has(e.status)) && e.bodyAsText) {
    const s = e.bodyAsText, o = e.headers.get("Content-Type") || "", m = o ? o.split(";").map((c) => c.toLowerCase()) : [];
    try {
      if (m.length === 0 || m.some((c) => t.indexOf(c) !== -1))
        return e.parsedBody = JSON.parse(s), e;
      if (m.some((c) => r.indexOf(c) !== -1)) {
        if (!n)
          throw new Error("Parsing XML not supported.");
        const c = await n(s, a.xml);
        return e.parsedBody = c, e;
      }
    } catch (c) {
      const l = `Error "${c}" occurred while parsing the response body - ${e.bodyAsText}.`, u = c.code || ar.PARSE_ERROR;
      throw new ar(l, {
        code: u,
        statusCode: e.status,
        request: e.request,
        response: e
      });
    }
  }
  return e;
}
function xu(t) {
  const r = /* @__PURE__ */ new Set();
  for (const [e, a] of Object.entries(t.responses))
    a.bodyMapper && a.bodyMapper.type.name === ft.Stream && r.add(Number(e));
  return r;
}
function _e(t) {
  const { parameterPath: r, mapper: e } = t;
  let a;
  return typeof r == "string" ? a = r : Array.isArray(r) ? a = r.join(".") : a = e.serializedName, a;
}
const Iu = "serializationPolicy";
function Di(t = {}) {
  const r = t.stringifyXML;
  return {
    name: Iu,
    sendRequest(e, a) {
      const n = Et(e), i = n == null ? void 0 : n.operationSpec, s = n == null ? void 0 : n.operationArguments;
      return i && s && (Bu(e, s, i), bu(e, s, i, r)), a(e);
    }
  };
}
function Bu(t, r, e) {
  var n, i;
  if (e.headerParameters)
    for (const s of e.headerParameters) {
      let o = Ct(r, s);
      if (o != null || s.mapper.required) {
        o = e.serializer.serialize(s.mapper, o, _e(s));
        const m = s.mapper.headerCollectionPrefix;
        if (m)
          for (const c of Object.keys(o))
            t.headers.set(m + c, o[c]);
        else
          t.headers.set(s.mapper.serializedName || _e(s), o);
      }
    }
  const a = (i = (n = r.options) == null ? void 0 : n.requestOptions) == null ? void 0 : i.customHeaders;
  if (a)
    for (const s of Object.keys(a))
      t.headers.set(s, a[s]);
}
function bu(t, r, e, a = function() {
  throw new Error("XML serialization unsupported!");
}) {
  var o, m;
  const n = (o = r.options) == null ? void 0 : o.serializerOptions, i = {
    xml: {
      rootName: (n == null ? void 0 : n.xml.rootName) ?? "",
      includeRoot: (n == null ? void 0 : n.xml.includeRoot) ?? !1,
      xmlCharKey: (n == null ? void 0 : n.xml.xmlCharKey) ?? nr
    }
  }, s = i.xml.xmlCharKey;
  if (e.requestBody && e.requestBody.mapper) {
    t.body = Ct(r, e.requestBody);
    const c = e.requestBody.mapper, { required: l, serializedName: u, xmlName: y, xmlElementName: A, xmlNamespace: g, xmlNamespacePrefix: C, nullable: R } = c, D = c.type.name;
    try {
      if (t.body !== void 0 && t.body !== null || R && t.body === null || l) {
        const T = _e(e.requestBody);
        t.body = e.serializer.serialize(c, t.body, T, i);
        const v = D === ft.Stream;
        if (e.isXML) {
          const f = C ? `xmlns:${C}` : "xmlns", N = Eu(g, f, D, t.body, i);
          D === ft.Sequence ? t.body = a(Pu(N, A || y || u, f, g), { rootName: y || u, xmlCharKey: s }) : v || (t.body = a(N, {
            rootName: y || u,
            xmlCharKey: s
          }));
        } else {
          if (D === ft.String && ((m = e.contentType) != null && m.match("text/plain") || e.mediaType === "text"))
            return;
          v || (t.body = JSON.stringify(t.body));
        }
      }
    } catch (T) {
      throw new Error(`Error "${T.message}" occurred in serializing the payload - ${JSON.stringify(u, void 0, "  ")}.`);
    }
  } else if (e.formDataParameters && e.formDataParameters.length > 0) {
    t.formData = {};
    for (const c of e.formDataParameters) {
      const l = Ct(r, c);
      if (l != null) {
        const u = c.mapper.serializedName || _e(c);
        t.formData[u] = e.serializer.serialize(c.mapper, l, _e(c), i);
      }
    }
  }
}
function Eu(t, r, e, a, n) {
  if (t && !["Composite", "Sequence", "Dictionary"].includes(e)) {
    const i = {};
    return i[n.xml.xmlCharKey] = a, i[oe] = { [r]: t }, i;
  }
  return a;
}
function Pu(t, r, e, a) {
  if (Array.isArray(t) || (t = [t]), !e || !a)
    return { [r]: t };
  const n = { [r]: t };
  return n[oe] = { [e]: a }, n;
}
function Qi(t = {}) {
  const r = Rp(t ?? {});
  return t.credentialOptions && r.addPolicy(La({
    credential: t.credentialOptions.credential,
    scopes: t.credentialOptions.credentialScopes
  })), r.addPolicy(Di(t.serializationOptions), { phase: "Serialize" }), r.addPolicy(gu(t.deserializationOptions), {
    phase: "Deserialize"
  }), r;
}
let oa;
function wu() {
  return oa || (oa = Ii()), oa;
}
const Su = {
  CSV: ",",
  SSV: " ",
  Multi: "Multi",
  TSV: "	",
  Pipes: "|"
};
function Ru(t, r, e, a) {
  const n = zu(r, e, a);
  let i = !1, s = Tn(t, n);
  if (r.path) {
    let c = Tn(r.path, n);
    r.path === "/{nextLink}" && c.startsWith("/") && (c = c.substring(1)), Mu(c) ? (s = c, i = !0) : s = Du(s, c);
  }
  const { queryParams: o, sequenceParams: m } = Qu(r, e, a);
  return s = vu(s, o, m, i), s;
}
function Tn(t, r) {
  let e = t;
  for (const [a, n] of r)
    e = e.split(a).join(n);
  return e;
}
function zu(t, r, e) {
  var n;
  const a = /* @__PURE__ */ new Map();
  if ((n = t.urlParameters) != null && n.length)
    for (const i of t.urlParameters) {
      let s = Ct(r, i, e);
      const o = _e(i);
      s = t.serializer.serialize(i.mapper, s, o), i.skipEncoding || (s = encodeURIComponent(s)), a.set(`{${i.mapper.serializedName || o}}`, s);
    }
  return a;
}
function Mu(t) {
  return t.includes("://");
}
function Du(t, r) {
  if (!r)
    return t;
  const e = new URL(t);
  let a = e.pathname;
  a.endsWith("/") || (a = `${a}/`), r.startsWith("/") && (r = r.substring(1));
  const n = r.indexOf("?");
  if (n !== -1) {
    const i = r.substring(0, n), s = r.substring(n + 1);
    a = a + i, s && (e.search = e.search ? `${e.search}&${s}` : s);
  } else
    a = a + r;
  return Object.assign(e, { pathname: a }), e.toString();
}
function Qu(t, r, e) {
  var i;
  const a = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
  if ((i = t.queryParameters) != null && i.length)
    for (const s of t.queryParameters) {
      s.mapper.type.name === "Sequence" && s.mapper.serializedName && n.add(s.mapper.serializedName);
      let o = Ct(r, s, e);
      if (o != null || s.mapper.required) {
        o = t.serializer.serialize(s.mapper, o, _e(s));
        const m = s.collectionFormat ? Su[s.collectionFormat] : "";
        if (Array.isArray(o) && (o = o.map((c) => c ?? "")), s.collectionFormat === "Multi" && o.length === 0)
          continue;
        Array.isArray(o) && (s.collectionFormat === "SSV" || s.collectionFormat === "TSV") && (o = o.join(m)), s.skipEncoding || (Array.isArray(o) ? o = o.map((c) => encodeURIComponent(c)) : o = encodeURIComponent(o)), Array.isArray(o) && (s.collectionFormat === "CSV" || s.collectionFormat === "Pipes") && (o = o.join(m)), a.set(s.mapper.serializedName || _e(s), o);
      }
    }
  return {
    queryParams: a,
    sequenceParams: n
  };
}
function Tu(t) {
  const r = /* @__PURE__ */ new Map();
  if (!t || t[0] !== "?")
    return r;
  t = t.slice(1);
  const e = t.split("&");
  for (const a of e) {
    const [n, i] = a.split("=", 2), s = r.get(n);
    s ? Array.isArray(s) ? s.push(i) : r.set(n, [s, i]) : r.set(n, i);
  }
  return r;
}
function vu(t, r, e, a = !1) {
  if (r.size === 0)
    return t;
  const n = new URL(t), i = Tu(n.search);
  for (const [o, m] of r) {
    const c = i.get(o);
    if (Array.isArray(c))
      if (Array.isArray(m)) {
        c.push(...m);
        const l = new Set(c);
        i.set(o, Array.from(l));
      } else
        c.push(m);
    else c ? (Array.isArray(m) ? m.unshift(c) : e.has(o) && i.set(o, [c, m]), a || i.set(o, m)) : i.set(o, m);
  }
  const s = [];
  for (const [o, m] of i)
    if (typeof m == "string")
      s.push(`${o}=${m}`);
    else if (Array.isArray(m))
      for (const c of m)
        s.push(`${o}=${c}`);
    else
      s.push(`${o}=${m}`);
  return n.search = s.length ? `?${s.join("&")}` : "", n.toString();
}
const Hu = Hr("core-client");
class ku {
  /**
   * The ServiceClient constructor
   * @param options - The service client options that govern the behavior of the client.
   */
  constructor(r = {}) {
    /**
     * If specified, this is the base URI that requests will be made against for this ServiceClient.
     * If it is not specified, then all OperationSpecs must contain a baseUrl property.
     */
    d(this, "_endpoint");
    /**
     * The default request content type for the service.
     * Used if no requestContentType is present on an OperationSpec.
     */
    d(this, "_requestContentType");
    /**
     * Set to true if the request is sent over HTTP instead of HTTPS
     */
    d(this, "_allowInsecureConnection");
    /**
     * The HTTP client that will be used to send requests.
     */
    d(this, "_httpClient");
    /**
     * The pipeline used by this client to make requests
     */
    d(this, "pipeline");
    var e;
    if (this._requestContentType = r.requestContentType, this._endpoint = r.endpoint ?? r.baseUri, r.baseUri && Hu.warning("The baseUri option for SDK Clients has been deprecated, please use endpoint instead."), this._allowInsecureConnection = r.allowInsecureConnection, this._httpClient = r.httpClient || wu(), this.pipeline = r.pipeline || Lu(r), (e = r.additionalPolicies) != null && e.length)
      for (const { policy: a, position: n } of r.additionalPolicies) {
        const i = n === "perRetry" ? "Sign" : void 0;
        this.pipeline.addPolicy(a, {
          afterPhase: i
        });
      }
  }
  /**
   * Send the provided httpRequest.
   */
  sendRequest(r) {
    return this.pipeline.sendRequest(this._httpClient, r);
  }
  /**
   * Send an HTTP request that is populated using the provided OperationSpec.
   * @typeParam T - The typed result of the request, based on the OperationSpec.
   * @param operationArguments - The arguments that the HTTP request's templated values will be populated from.
   * @param operationSpec - The OperationSpec to use to populate the httpRequest.
   */
  async sendOperationRequest(r, e) {
    const a = e.baseUrl || this._endpoint;
    if (!a)
      throw new Error("If operationSpec.baseUrl is not specified, then the ServiceClient must have a endpoint string property that contains the base URL to use.");
    const n = Ru(a, e, r, this), i = Bi({
      url: n
    });
    i.method = e.httpMethod;
    const s = Et(i);
    s.operationSpec = e, s.operationArguments = r;
    const o = e.contentType || this._requestContentType;
    o && e.requestBody && i.headers.set("Content-Type", o);
    const m = r.options;
    if (m) {
      const c = m.requestOptions;
      c && (c.timeout && (i.timeout = c.timeout), c.onUploadProgress && (i.onUploadProgress = c.onUploadProgress), c.onDownloadProgress && (i.onDownloadProgress = c.onDownloadProgress), c.shouldDeserialize !== void 0 && (s.shouldDeserialize = c.shouldDeserialize), c.allowInsecureConnection && (i.allowInsecureConnection = !0)), m.abortSignal && (i.abortSignal = m.abortSignal), m.tracingOptions && (i.tracingOptions = m.tracingOptions);
    }
    this._allowInsecureConnection && (i.allowInsecureConnection = !0), i.streamResponseStatusCodes === void 0 && (i.streamResponseStatusCodes = xu(e));
    try {
      const c = await this.sendRequest(i), l = zn(c, e.responses[c.status]);
      return m != null && m.onResponse && m.onResponse(c, l), l;
    } catch (c) {
      if (typeof c == "object" && (c != null && c.response)) {
        const l = c.response, u = zn(l, e.responses[c.statusCode] || e.responses.default);
        c.details = u, m != null && m.onResponse && m.onResponse(l, u, c);
      }
      throw c;
    }
  }
}
function Lu(t) {
  const r = Uu(t), e = t.credential && r ? { credentialScopes: r, credential: t.credential } : void 0;
  return Qi({
    ...t,
    credentialOptions: e
  });
}
function Uu(t) {
  if (t.credentialScopes)
    return t.credentialScopes;
  if (t.endpoint)
    return `${t.endpoint}/.default`;
  if (t.baseUri)
    return `${t.baseUri}/.default`;
  if (t.credential)
    throw new Error("When using credentials, the ServiceClientOptions must contain either a endpoint or a credentialScopes. Unable to create a bearerTokenAuthenticationPolicy");
}
const Ti = {
  DefaultScope: "/.default",
  /**
   * Defines constants for use with HTTP headers.
   */
  HeaderConstants: {
    /**
     * The Authorization header.
     */
    AUTHORIZATION: "authorization"
  }
};
function qu(t) {
  return /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(t);
}
const vi = async (t) => {
  const r = Yu(t.request), e = _u(t.response);
  if (e) {
    const a = Gu(e), n = Fu(t, a), i = Ou(a);
    if (!i)
      return !1;
    const s = await t.getAccessToken(n, {
      ...r,
      tenantId: i
    });
    return s ? (t.request.headers.set(Ti.HeaderConstants.AUTHORIZATION, `${s.tokenType ?? "Bearer"} ${s.token}`), !0) : !1;
  }
  return !1;
};
function Ou(t) {
  const a = new URL(t.authorization_uri).pathname.split("/")[1];
  if (a && qu(a))
    return a;
}
function Fu(t, r) {
  if (!r.resource_id)
    return t.scopes;
  const e = new URL(r.resource_id);
  let a = new URL(Ti.DefaultScope, e.origin).toString();
  return a === "https://disk.azure.com/.default" && (a = "https://disk.azure.com//.default"), [a];
}
function _u(t) {
  const r = t.headers.get("WWW-Authenticate");
  if (t.status === 401 && r)
    return r;
}
function Gu(t) {
  return `${t.slice(7).trim()} `.split(" ").filter((n) => n).map((n) => (([i, s]) => ({ [i]: s }))(n.trim().split("="))).reduce((n, i) => ({ ...n, ...i }), {});
}
function Yu(t) {
  return {
    abortSignal: t.abortSignal,
    requestOptions: {
      timeout: t.timeout
    },
    tracingOptions: t.tracingOptions
  };
}
const Hi = Symbol("Original PipelineRequest"), Ku = Symbol.for("@azure/core-client original request");
function Ua(t, r = {}) {
  const a = t[Hi], n = kr(t.headers.toJson({ preserveCase: !0 }));
  if (a)
    return a.headers = n, a;
  {
    const i = Bi({
      url: t.url,
      method: t.method,
      headers: n,
      withCredentials: t.withCredentials,
      timeout: t.timeout,
      requestId: t.requestId,
      abortSignal: t.abortSignal,
      body: t.body,
      formData: t.formData,
      disableKeepAlive: !!t.keepAlive,
      onDownloadProgress: t.onDownloadProgress,
      onUploadProgress: t.onUploadProgress,
      proxySettings: t.proxySettings,
      streamResponseStatusCodes: t.streamResponseStatusCodes,
      agent: t.agent,
      requestOverrides: t.requestOverrides
    });
    return r.originalRequest && (i[Ku] = r.originalRequest), i;
  }
}
function Lr(t, r) {
  const e = (r == null ? void 0 : r.originalRequest) ?? t, a = {
    url: t.url,
    method: t.method,
    headers: qa(t.headers),
    withCredentials: t.withCredentials,
    timeout: t.timeout,
    requestId: t.headers.get("x-ms-client-request-id") || t.requestId,
    abortSignal: t.abortSignal,
    body: t.body,
    formData: t.formData,
    keepAlive: !!t.disableKeepAlive,
    onDownloadProgress: t.onDownloadProgress,
    onUploadProgress: t.onUploadProgress,
    proxySettings: t.proxySettings,
    streamResponseStatusCodes: t.streamResponseStatusCodes,
    agent: t.agent,
    requestOverrides: t.requestOverrides,
    clone() {
      throw new Error("Cannot clone a non-proxied WebResourceLike");
    },
    prepare() {
      throw new Error("WebResourceLike.prepare() is not supported by @azure/core-http-compat");
    },
    validateRequestProperties() {
    }
  };
  return r != null && r.createProxy ? new Proxy(a, {
    get(n, i, s) {
      return i === Hi ? t : i === "clone" ? () => Lr(Ua(a, { originalRequest: e }), {
        createProxy: !0,
        originalRequest: e
      }) : Reflect.get(n, i, s);
    },
    set(n, i, s, o) {
      return i === "keepAlive" && (t.disableKeepAlive = !s), typeof i == "string" && [
        "url",
        "method",
        "withCredentials",
        "timeout",
        "requestId",
        "abortSignal",
        "body",
        "formData",
        "onDownloadProgress",
        "onUploadProgress",
        "proxySettings",
        "streamResponseStatusCodes",
        "agent",
        "requestOverrides"
      ].includes(i) && (t[i] = s), Reflect.set(n, i, s, o);
    }
  }) : a;
}
function qa(t) {
  return new Oa(t.toJSON({ preserveCase: !0 }));
}
function Jt(t) {
  return t.toLowerCase();
}
class Oa {
  constructor(r) {
    d(this, "_headersMap");
    if (this._headersMap = {}, r)
      for (const e in r)
        this.set(e, r[e]);
  }
  /**
   * Set a header in this collection with the provided name and value. The name is
   * case-insensitive.
   * @param headerName - The name of the header to set. This value is case-insensitive.
   * @param headerValue - The value of the header to set.
   */
  set(r, e) {
    this._headersMap[Jt(r)] = {
      name: r,
      value: e.toString()
    };
  }
  /**
   * Get the header value for the provided header name, or undefined if no header exists in this
   * collection with the provided name.
   * @param headerName - The name of the header.
   */
  get(r) {
    const e = this._headersMap[Jt(r)];
    return e ? e.value : void 0;
  }
  /**
   * Get whether or not this header collection contains a header entry for the provided header name.
   */
  contains(r) {
    return !!this._headersMap[Jt(r)];
  }
  /**
   * Remove the header with the provided headerName. Return whether or not the header existed and
   * was removed.
   * @param headerName - The name of the header to remove.
   */
  remove(r) {
    const e = this.contains(r);
    return delete this._headersMap[Jt(r)], e;
  }
  /**
   * Get the headers that are contained this collection as an object.
   */
  rawHeaders() {
    return this.toJson({ preserveCase: !0 });
  }
  /**
   * Get the headers that are contained in this collection as an array.
   */
  headersArray() {
    const r = [];
    for (const e in this._headersMap)
      r.push(this._headersMap[e]);
    return r;
  }
  /**
   * Get the header names that are contained in this collection.
   */
  headerNames() {
    const r = [], e = this.headersArray();
    for (let a = 0; a < e.length; ++a)
      r.push(e[a].name);
    return r;
  }
  /**
   * Get the header values that are contained in this collection.
   */
  headerValues() {
    const r = [], e = this.headersArray();
    for (let a = 0; a < e.length; ++a)
      r.push(e[a].value);
    return r;
  }
  /**
   * Get the JSON object representation of this HTTP header collection.
   */
  toJson(r = {}) {
    const e = {};
    if (r.preserveCase)
      for (const a in this._headersMap) {
        const n = this._headersMap[a];
        e[n.name] = n.value;
      }
    else
      for (const a in this._headersMap) {
        const n = this._headersMap[a];
        e[Jt(n.name)] = n.value;
      }
    return e;
  }
  /**
   * Get the string representation of this HTTP header collection.
   */
  toString() {
    return JSON.stringify(this.toJson({ preserveCase: !0 }));
  }
  /**
   * Create a deep clone/copy of this HttpHeaders collection.
   */
  clone() {
    const r = {};
    for (const e in this._headersMap) {
      const a = this._headersMap[e];
      r[a.name] = a.value;
    }
    return new Oa(r);
  }
}
const ki = Symbol("Original FullOperationResponse");
function Li(t, r) {
  let e = Lr(t.request), a = qa(t.headers);
  return r != null && r.createProxy ? new Proxy(t, {
    get(n, i, s) {
      return i === "headers" ? a : i === "request" ? e : i === ki ? t : Reflect.get(n, i, s);
    },
    set(n, i, s, o) {
      return i === "headers" ? a = s : i === "request" && (e = s), Reflect.set(n, i, s, o);
    }
  }) : {
    ...t,
    request: e,
    headers: a
  };
}
function Ui(t) {
  const e = t[ki], a = kr(t.headers.toJson({ preserveCase: !0 }));
  return e ? (e.headers = a, e) : {
    ...t,
    headers: a,
    request: Ua(t.request)
  };
}
class Ju extends ku {
  constructor(r) {
    var e, a;
    super(r), ((e = r.keepAliveOptions) == null ? void 0 : e.enable) === !1 && !kp(this.pipeline) && this.pipeline.addPolicy(Hp()), ((a = r.redirectOptions) == null ? void 0 : a.handleRedirects) === !1 && this.pipeline.removePolicy({
      name: Zd
    });
  }
  /**
   * Compatible send operation request function.
   *
   * @param operationArguments - Operation arguments
   * @param operationSpec - Operation Spec
   * @returns
   */
  async sendOperationRequest(r, e) {
    var o;
    const a = (o = r == null ? void 0 : r.options) == null ? void 0 : o.onResponse;
    let n;
    function i(m, c, l) {
      n = m, a && a(m, c, l);
    }
    r.options = {
      ...r.options,
      onResponse: i
    };
    const s = await super.sendOperationRequest(r, e);
    return n && Object.defineProperty(s, "_response", {
      value: Li(n)
    }), s;
  }
}
var vn;
(function(t) {
  t[t.ERROR = 1] = "ERROR", t[t.INFO = 3] = "INFO", t[t.OFF = 0] = "OFF", t[t.WARNING = 2] = "WARNING";
})(vn || (vn = {}));
const Xu = {
  log(t, r) {
  },
  shouldLog(t) {
    return !1;
  }
}, Wu = "RequestPolicyFactoryPolicy";
function ju(t) {
  const r = t.slice().reverse();
  return {
    name: Wu,
    async sendRequest(e, a) {
      let n = {
        async sendRequest(o) {
          const m = await a(Ua(o));
          return Li(m, { createProxy: !0 });
        }
      };
      for (const o of r)
        n = o.create(n, Xu);
      const i = Lr(e, { createProxy: !0 }), s = await n.sendRequest(i);
      return Ui(s);
    }
  };
}
function Zu(t) {
  return {
    sendRequest: async (r) => {
      const e = await t.sendRequest(Lr(r, { createProxy: !0 }));
      return Ui(e);
    }
  };
}
const Vt = "$", qi = "_";
if (!document || !DOMParser || !Node || !XMLSerializer)
  throw new Error('This library depends on the following DOM objects: ["document", "DOMParser", "Node", "XMLSerializer"] to parse XML, but some of these are undefined. You may provide a polyfill to make these globally available in order to support your environment. For more information, please refer to https://aka.ms/azsdk/js/web-workers. ');
let tt;
try {
  typeof self.trustedTypes < "u" && (tt = self.trustedTypes.createPolicy("@azure/core-xml#xml.browser", {
    createHTML: (t) => t
  }));
} catch {
  console.warn('Could not create trusted types policy "@azure/core-xml#xml.browser"');
}
const Xt = document.implementation.createDocument(null, null, null), Oi = new DOMParser();
function Vu(t, r = {}) {
  try {
    const e = {
      rootName: r.rootName ?? "",
      includeRoot: r.includeRoot ?? !1,
      xmlCharKey: r.xmlCharKey ?? qi,
      cdataPropName: r.cdataPropName ?? "__cdata",
      stopNodes: r.stopNodes ?? []
    }, a = Oi.parseFromString((tt == null ? void 0 : tt.createHTML(t)) ?? t, "application/xml");
    eg(a);
    let n;
    return e.includeRoot ? n = Ia(a, e) : n = Ia(a.childNodes[0], e), Promise.resolve(n);
  } catch (e) {
    return Promise.reject(e);
  }
}
let Wt;
function $u() {
  if (Wt === void 0)
    try {
      const t = (tt == null ? void 0 : tt.createHTML("INVALID")) ?? "INVALID";
      Wt = Oi.parseFromString(t, "text/xml").getElementsByTagName("parsererror")[0].namespaceURI ?? "";
    } catch {
      Wt = "";
    }
  return Wt;
}
function eg(t) {
  const r = t.getElementsByTagName("parsererror");
  if (r.length > 0 && $u()) {
    for (let e = 0; e < r.length; e++)
      if (r[e].namespaceURI === Wt)
        throw new Error(r[e].innerHTML);
  }
}
function tg(t) {
  return !!t.attributes;
}
function rg(t) {
  return tg(t) && t.hasAttributes() ? t : void 0;
}
function Ia(t, r) {
  var o;
  let e = {};
  const a = t.childNodes.length, n = t.childNodes[0], i = n && a === 1 && n.nodeType === Node.TEXT_NODE && n.nodeValue || void 0, s = rg(t);
  if (s) {
    e[Vt] = {};
    for (let m = 0; m < s.attributes.length; m++) {
      const c = s.attributes[m];
      e[Vt][c.nodeName] = c.nodeValue;
    }
    i && (e[r.xmlCharKey] = i);
  } else a === 0 ? e = "" : i && (e = i);
  if (!i)
    for (let m = 0; m < a; m++) {
      const c = t.childNodes[m];
      if ((c == null ? void 0 : c.nodeType) === Node.CDATA_SECTION_NODE)
        e = c.textContent;
      else if (((o = c == null ? void 0 : c.firstChild) == null ? void 0 : o.nodeType) === Node.CDATA_SECTION_NODE)
        e[c.nodeName] = c.textContent;
      else if (c.nodeType !== Node.TEXT_NODE) {
        const l = Ia(c, r);
        e[c.nodeName] ? Array.isArray(e[c.nodeName]) ? e[c.nodeName].push(l) : e[c.nodeName] = [e[c.nodeName], l] : e[c.nodeName] = l;
      }
    }
  return e;
}
const ag = new XMLSerializer();
function Fi(t, r = {}) {
  const e = {
    rootName: r.rootName ?? "root",
    includeRoot: r.includeRoot ?? !1,
    xmlCharKey: r.xmlCharKey ?? qi,
    cdataPropName: r.cdataPropName ?? "__cdata",
    stopNodes: r.stopNodes ?? []
  }, a = Ba(t, e.rootName, e)[0];
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + ag.serializeToString(a).replace(/ xmlns=""/g, "");
}
function ng(t) {
  const r = [];
  for (const e of Object.keys(t)) {
    const a = Xt.createAttribute(e);
    a.value = t[e].toString(), r.push(a);
  }
  return r;
}
function Ba(t, r, e) {
  var a;
  if (t == null || typeof t == "string" || typeof t == "number" || typeof t == "boolean") {
    const n = Xt.createElement(r);
    return n.textContent = t == null ? "" : t.toString(), [n];
  } else if (Array.isArray(t)) {
    const n = [];
    for (const i of t)
      for (const s of Ba(i, r, e))
        n.push(s);
    return n;
  } else if (typeof t == "object") {
    let n;
    (a = t[Vt]) != null && a.xmlns ? n = Xt.createElementNS(t[Vt].xmlns, r) : n = Xt.createElement(r);
    for (const i of Object.keys(t))
      if (i === Vt)
        for (const s of ng(t[i]))
          n.attributes.setNamedItem(s);
      else if (i === e.xmlCharKey)
        n.textContent = t[i].toString();
      else if (i === e.cdataPropName) {
        const s = Xt.createCDATASection(t[i].toString());
        n.appendChild(s);
      } else
        for (const s of Ba(t[i], i, e))
          n.appendChild(s);
    return [n];
  } else
    throw new Error(`Illegal value passed to buildObject: ${t}`);
}
const _i = Hr("storage-blob");
class ig {
  constructor(r, e, a, n, i, s) {
    throw new Error("BufferScheduler is not supported in non-Node.js environments.");
  }
  async do() {
    throw new Error("BufferScheduler is not supported in non-Node.js environments.");
  }
}
var sg = (() => {
  var t = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return typeof __filename < "u" && (t = t || __filename), (function(r) {
    r = r || {};
    var e = typeof r < "u" ? r : {}, a, n;
    e.ready = new Promise(function(p, x) {
      a = p, n = x;
    }), ["_malloc", "_free", "_emscripten_bind_VoidPtr___destroy___0", "_emscripten_bind_Crc64Hash_Crc64Hash_0", "_emscripten_bind_Crc64Hash_OnAppend_2", "_emscripten_bind_Crc64Hash_OnFinal_3", "_emscripten_bind_Crc64Hash___destroy___0", "_fflush", "onRuntimeInitialized"].forEach((p) => {
      Object.getOwnPropertyDescriptor(e.ready, p) || Object.defineProperty(e.ready, p, {
        get: () => he("You are getting " + p + " on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js"),
        set: () => he("You are setting " + p + " on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js")
      });
    });
    var i = Object.assign({}, e), s = typeof window == "object", o = typeof importScripts == "function", m = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string", c = !s && !m && !o;
    if (e.ENVIRONMENT)
      throw new Error("Module.ENVIRONMENT has been deprecated. To force the environment, use the ENVIRONMENT compile-time option (for example, -sENVIRONMENT=web or -sENVIRONMENT=node)");
    var l = "";
    function u(p) {
      return e.locateFile ? e.locateFile(p, l) : l + p;
    }
    if (m) {
      if (typeof process > "u" || !process.release || process.release.name !== "node") throw new Error("not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)");
      require("fs");
      var y = require("path");
      o ? l = y.dirname(l) + "/" : l = __dirname + "/", process.argv.length > 1 && process.argv[1].replace(/\\/g, "/"), process.argv.slice(2), process.on("uncaughtException", function(p) {
        if (!(p instanceof jc))
          throw p;
      }), process.on("unhandledRejection", function(p) {
        throw p;
      }), e.inspect = function() {
        return "[Emscripten Module object]";
      };
    } else if (c) {
      if (typeof process == "object" && typeof require == "function" || typeof window == "object" || typeof importScripts == "function") throw new Error("not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)");
      typeof scriptArgs < "u" && scriptArgs, typeof print < "u" && (typeof console > "u" && (console = /** @type{!Console} */
      {}), console.log = /** @type{!function(this:Console, ...*): undefined} */
      print, console.warn = console.error = /** @type{!function(this:Console, ...*): undefined} */
      typeof printErr < "u" ? printErr : print);
    } else if (s || o) {
      if (o ? l = self.location.href : typeof document < "u" && document.currentScript && (l = document.currentScript.src), t && (l = t), l.indexOf("blob:") !== 0 ? l = l.substr(0, l.replace(/[?#].*/, "").lastIndexOf("/") + 1) : l = "", !(typeof window == "object" || typeof importScripts == "function")) throw new Error("not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)");
    } else
      throw new Error("environment detection error");
    var A = e.print || console.log.bind(console), g = e.printErr || console.warn.bind(console);
    Object.assign(e, i), i = null, sl(), e.arguments && e.arguments, C("arguments", "arguments_"), e.thisProgram && e.thisProgram, C("thisProgram", "thisProgram"), e.quit && e.quit, C("quit", "quit_"), h(typeof e.memoryInitializerPrefixURL > "u", "Module.memoryInitializerPrefixURL option was removed, use Module.locateFile instead"), h(typeof e.pthreadMainPrefixURL > "u", "Module.pthreadMainPrefixURL option was removed, use Module.locateFile instead"), h(typeof e.cdInitializerPrefixURL > "u", "Module.cdInitializerPrefixURL option was removed, use Module.locateFile instead"), h(typeof e.filePackagePrefixURL > "u", "Module.filePackagePrefixURL option was removed, use Module.locateFile instead"), h(typeof e.read > "u", "Module.read option was removed (modify read_ in JS)"), h(typeof e.readAsync > "u", "Module.readAsync option was removed (modify readAsync in JS)"), h(typeof e.readBinary > "u", "Module.readBinary option was removed (modify readBinary in JS)"), h(typeof e.setWindowTitle > "u", "Module.setWindowTitle option was removed (modify setWindowTitle in JS)"), h(typeof e.TOTAL_MEMORY > "u", "Module.TOTAL_MEMORY has been renamed Module.INITIAL_MEMORY"), C("read", "read_"), C("readAsync", "readAsync"), C("readBinary", "readBinary"), C("setWindowTitle", "setWindowTitle"), h(!c, "shell environment detected but not enabled at build time.  Add 'shell' to `-sENVIRONMENT` to enable.");
    function C(p, x) {
      Object.getOwnPropertyDescriptor(e, p) || Object.defineProperty(e, p, {
        configurable: !0,
        get: function() {
          he("Module." + p + " has been replaced with plain " + x + " (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)");
        }
      });
    }
    function R(p) {
      Object.getOwnPropertyDescriptor(e, p) && he("`Module." + p + "` was supplied but `" + p + "` not included in INCOMING_MODULE_JS_API");
    }
    function D(p) {
      return p === "FS_createPath" || p === "FS_createDataFile" || p === "FS_createPreloadedFile" || p === "FS_unlink" || p === "addRunDependency" || // The old FS has some functionality that WasmFS lacks.
      p === "FS_createLazyFile" || p === "FS_createDevice" || p === "removeRunDependency";
    }
    function T(p) {
      typeof globalThis < "u" && !Object.getOwnPropertyDescriptor(globalThis, p) && Object.defineProperty(globalThis, p, {
        configurable: !0,
        get: function() {
          var x = "`" + p + "` is a library symbol and not included by default; add it to your library.js __deps or to DEFAULT_LIBRARY_FUNCS_TO_INCLUDE on the command line", H = p;
          H.startsWith("_") || (H = "$" + p), x += " (e.g. -sDEFAULT_LIBRARY_FUNCS_TO_INCLUDE=" + H + ")", D(p) && (x += ". Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you"), pt(x);
        }
      });
    }
    function v(p) {
      Object.getOwnPropertyDescriptor(e, p) || Object.defineProperty(e, p, {
        configurable: !0,
        get: function() {
          var x = "'" + p + "' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)";
          D(p) && (x += ". Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you"), he(x);
        }
      });
    }
    e.wasmBinary && e.wasmBinary, C("wasmBinary", "wasmBinary"), e.noExitRuntime, C("noExitRuntime", "noExitRuntime"), typeof WebAssembly != "object" && he("no native wasm support detected");
    var f, N = !1;
    function h(p, x) {
      p || he("Assertion failed" + (x ? ": " + x : ""));
    }
    var z = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
    function Q(p, x, H) {
      for (var J = x + H, j = x; p[j] && !(j >= J); ) ++j;
      if (j - x > 16 && p.buffer && z)
        return z.decode(p.subarray(x, j));
      for (var pe = ""; x < j; ) {
        var Z = p[x++];
        if (!(Z & 128)) {
          pe += String.fromCharCode(Z);
          continue;
        }
        var ne = p[x++] & 63;
        if ((Z & 224) == 192) {
          pe += String.fromCharCode((Z & 31) << 6 | ne);
          continue;
        }
        var ie = p[x++] & 63;
        if ((Z & 240) == 224 ? Z = (Z & 15) << 12 | ne << 6 | ie : ((Z & 248) != 240 && pt("Invalid UTF-8 leading byte " + hr(Z) + " encountered when deserializing a UTF-8 string in wasm memory to a JS string!"), Z = (Z & 7) << 18 | ne << 12 | ie << 6 | p[x++] & 63), Z < 65536)
          pe += String.fromCharCode(Z);
        else {
          var Ue = Z - 65536;
          pe += String.fromCharCode(55296 | Ue >> 10, 56320 | Ue & 1023);
        }
      }
      return pe;
    }
    var _, k, W;
    function Le(p) {
      _ = p, e.HEAP8 = new Int8Array(p), e.HEAP16 = new Int16Array(p), e.HEAP32 = new Int32Array(p), e.HEAPU8 = k = new Uint8Array(p), e.HEAPU16 = new Uint16Array(p), e.HEAPU32 = W = new Uint32Array(p), e.HEAPF32 = new Float32Array(p), e.HEAPF64 = new Float64Array(p);
    }
    var lt = 5242880;
    e.STACK_SIZE && h(lt === e.STACK_SIZE, "the stack size can no longer be determined at runtime");
    var Gt = e.INITIAL_MEMORY || 16777216;
    C("INITIAL_MEMORY", "INITIAL_MEMORY"), h(Gt >= lt, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + Gt + "! (STACK_SIZE=" + lt + ")"), h(
      typeof Int32Array < "u" && typeof Float64Array < "u" && Int32Array.prototype.subarray != null && Int32Array.prototype.set != null,
      "JS engine does not provide full typed array support"
    ), h(!e.wasmMemory, "Use of `wasmMemory` detected.  Use -sIMPORTED_MEMORY to define wasmMemory externally"), h(Gt == 16777216, "Detected runtime INITIAL_MEMORY setting.  Use -sIMPORTED_MEMORY to define wasmMemory dynamically");
    var dn;
    function Qc() {
      var p = aa();
      h((p & 3) == 0), p == 0 && (p += 4), W[p >> 2] = 34821223, W[p + 4 >> 2] = 2310721022, W[0] = 1668509029;
    }
    function ea() {
      if (!N) {
        var p = aa();
        p == 0 && (p += 4);
        var x = W[p >> 2], H = W[p + 4 >> 2];
        (x != 34821223 || H != 2310721022) && he("Stack overflow! Stack cookie has been overwritten at " + hr(p) + ", expected hex dwords 0x89BACDFE and 0x2135467, but received " + hr(H) + " " + hr(x)), W[0] !== 1668509029 && he("Runtime error: The application has corrupted its heap memory area (address zero)!");
      }
    }
    (function() {
      var p = new Int16Array(1), x = new Int8Array(p.buffer);
      if (p[0] = 25459, x[0] !== 115 || x[1] !== 99) throw "Runtime error: expected the system to be little-endian! (Run with -sSUPPORT_BIG_ENDIAN to bypass)";
    })();
    var pn = [], un = [], gn = [], ta = !1;
    function Tc() {
      if (e.preRun)
        for (typeof e.preRun == "function" && (e.preRun = [e.preRun]); e.preRun.length; )
          kc(e.preRun.shift());
      ra(pn);
    }
    function vc() {
      h(!ta), ta = !0, ea(), ra(un);
    }
    function Hc() {
      if (ea(), e.postRun)
        for (typeof e.postRun == "function" && (e.postRun = [e.postRun]); e.postRun.length; )
          Uc(e.postRun.shift());
      ra(gn);
    }
    function kc(p) {
      pn.unshift(p);
    }
    function Lc(p) {
      un.unshift(p);
    }
    function Uc(p) {
      gn.unshift(p);
    }
    h(Math.imul, "This browser does not support Math.imul(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill"), h(Math.fround, "This browser does not support Math.fround(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill"), h(Math.clz32, "This browser does not support Math.clz32(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill"), h(Math.trunc, "This browser does not support Math.trunc(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill");
    var Ze = 0, Ve = null, Yt = null, Kt = {};
    function qc(p) {
      Ze++, e.monitorRunDependencies && e.monitorRunDependencies(Ze), h(!Kt[p]), Kt[p] = 1, Ve === null && typeof setInterval < "u" && (Ve = setInterval(function() {
        if (N) {
          clearInterval(Ve), Ve = null;
          return;
        }
        var x = !1;
        for (var H in Kt)
          x || (x = !0, g("still waiting on run dependencies:")), g("dependency: " + H);
        x && g("(end of list)");
      }, 1e4));
    }
    function Oc(p) {
      if (Ze--, e.monitorRunDependencies && e.monitorRunDependencies(Ze), h(Kt[p]), delete Kt[p], Ze == 0 && (Ve !== null && (clearInterval(Ve), Ve = null), Yt)) {
        var x = Yt;
        Yt = null, x();
      }
    }
    function he(p) {
      e.onAbort && e.onAbort(p), p = "Aborted(" + p + ")", g(p), N = !0;
      var x = new WebAssembly.RuntimeError(p);
      throw n(x), x;
    }
    var Ne = {
      error: function() {
        he("Filesystem support (FS) was not included. The problem is that you are using files from JS, but files were not used from C/C++, so filesystem support was not auto-included. You can force-include filesystem support with -sFORCE_FILESYSTEM");
      },
      init: function() {
        Ne.error();
      },
      createDataFile: function() {
        Ne.error();
      },
      createPreloadedFile: function() {
        Ne.error();
      },
      createLazyFile: function() {
        Ne.error();
      },
      open: function() {
        Ne.error();
      },
      mkdev: function() {
        Ne.error();
      },
      registerDevice: function() {
        Ne.error();
      },
      analyzePath: function() {
        Ne.error();
      },
      loadFilesFromDB: function() {
        Ne.error();
      },
      ErrnoError: function() {
        Ne.error();
      }
    };
    e.FS_createDataFile = Ne.createDataFile, e.FS_createPreloadedFile = Ne.createPreloadedFile;
    var Fc = "data:application/octet-stream;base64,";
    function _c(p) {
      return p.startsWith(Fc);
    }
    function Gc(p) {
      return p.startsWith("file://");
    }
    function le(p, x) {
      return function() {
        var H = p, J = x;
        return J = e.asm, h(ta, "native function `" + H + "` called before runtime initialization"), J[p] || h(J[p], "exported native function `" + H + "` not found"), J[p].apply(null, arguments);
      };
    }
    var dt;
    dt = "crc64.wasm", _c(dt) || (dt = u(dt));
    var yn = [
      "AGFzbQEAAAABzYCAgAAMYAF/AX9gAAF/YAF/AGAAAGADf35/AX5gA39/fwBgBH9/f38AYAN/f38Bf2AFf39",
      "/f38Bf2AEf39/fwF/YAR/f35/AX5gBH9+f38BfwKPgYCAAAUDZW52BWFib3J0AAMDZW52FmVtc2NyaXB0ZW",
      "5fcmVzaXplX2hlYXAAABZ3YXNpX3NuYXBzaG90X3ByZXZpZXcxCGZkX2Nsb3NlAAAWd2FzaV9zbmFwc2hvd",
      "F9wcmV2aWV3MQhmZF93cml0ZQAJFndhc2lfc25hcHNob3RfcHJldmlldzEHZmRfc2VlawAIA62AgIAALAMF",
      "BgIBAAUGAgEBAAACAAIAAAAHBAQCAgEDAAIAAQIBAQIAAQMBAQEACggLBIWAgIAAAXABBAQFh4CAgAABAYA",
      "CgIACBsiAgIAACn8BQYCAwAILfwFBAAt/AUEAC38BQQALfwBBnJHBAgt/AEGwkcECC38AQZyRwQILfwBBsJ",
      "HBAgt/AEGwkcECC38AQZKSwQILB/qEgIAAGwZtZW1vcnkCABFfX3dhc21fY2FsbF9jdG9ycwAFJWVtc2Nya",
      "XB0ZW5fYmluZF9Wb2lkUHRyX19fZGVzdHJveV9fXzAACCVlbXNjcmlwdGVuX2JpbmRfQ3JjNjRIYXNoX0Ny",
      "YzY0SGFzaF8wAAkkZW1zY3JpcHRlbl9iaW5kX0NyYzY0SGFzaF9PbkFwcGVuZF8yAAsjZW1zY3JpcHRlbl9",
      "iaW5kX0NyYzY0SGFzaF9PbkZpbmFsXzMADCdlbXNjcmlwdGVuX2JpbmRfQ3JjNjRIYXNoX19fZGVzdHJveV",
      "9fXzAADRtfX2VtX2xpYl9kZXBzX3dlYmlkbF9iaW5kZXIDBCFfX2VtX2pzX19hcnJheV9ib3VuZHNfY2hlY",
      "2tfZXJyb3IDBRlfX2luZGlyZWN0X2Z1bmN0aW9uX3RhYmxlAQAQX19lcnJub19sb2NhdGlvbgAPBmZmbHVz",
      "aAAtBm1hbGxvYwARBGZyZWUAEhVlbXNjcmlwdGVuX3N0YWNrX2luaXQAKRllbXNjcmlwdGVuX3N0YWNrX2d",
      "ldF9mcmVlACoZZW1zY3JpcHRlbl9zdGFja19nZXRfYmFzZQArGGVtc2NyaXB0ZW5fc3RhY2tfZ2V0X2VuZA",
      "AsCXN0YWNrU2F2ZQAlDHN0YWNrUmVzdG9yZQAmCnN0YWNrQWxsb2MAJxxlbXNjcmlwdGVuX3N0YWNrX2dld",
      "F9jdXJyZW50ACgTX19zdGFydF9lbV9saWJfZGVwcwMGEl9fc3RvcF9lbV9saWJfZGVwcwMHDV9fc3RhcnRf",
      "ZW1fanMDCAxfX3N0b3BfZW1fanMDCQxkeW5DYWxsX2ppamkALwmJgICAAAEAQQELAxYYGgqtkYGAACwEABA",
      "pC81IAvcCf6EFfiMAIQNBgAEhBCADIARrIQUgBSAANgJ8IAUgATYCeCAFIAI2AnQgBSgCfCEGIAUoAnghBy",
      "AFIAc2AnAgBSgCdCEIIAghCSAJrCH6AiAGKQMIIfsCIPsCIPoCfCH8AiAGIPwCNwMIIAYpAwAh/QJCfyH+A",
      "iD9AiD+AoUh/wIgBSD/AjcDaEIAIYADIAUggAM3A2AgBSgCdCEKIAUoAnQhC0EgIQwgCyAMbyENIAogDWsh",
      "DiAFIA42AlwgBSgCXCEPQcAAIRAgDyERIBAhEiARIBJPIRNBASEUIBMgFHEhFQJAIBVFDQAgBSgCcCEWIAU",
      "gFjYCWEIAIYEDIAUggQM3A1BCACGCAyAFIIIDNwNIQgAhgwMgBSCDAzcDQEIAIYQDIAUghAM3AzggBSkDYC",
      "GFAyAFKAJcIRcgFyEYIBitIYYDIIUDIIYDfCGHA0IgIYgDIIcDIIgDfSGJAyAFIIkDNwMwIAUoAlwhGSAFK",
      "AJ0IRogGiAZayEbIAUgGzYCdCAFKQNoIYoDIAUgigM3A1ACQANAIAUpA2AhiwMgBSkDMCGMAyCLAyGNAyCM",
      "AyGOAyCNAyCOA1QhHEEBIR0gHCAdcSEeIB5FDQEgBSgCWCEfIB8pAwAhjwMgBSkDUCGQAyCPAyCQA4UhkQM",
      "gBSCRAzcDKCAFKAJYISAgICkDCCGSAyAFKQNIIZMDIJIDIJMDhSGUAyAFIJQDNwMgIAUoAlghISAhKQMQIZ",
      "UDIAUpA0AhlgMglQMglgOFIZcDIAUglwM3AxggBSgCWCEiICIpAxghmAMgBSkDOCGZAyCYAyCZA4UhmgMgB",
      "SCaAzcDECAFKQMoIZsDQv8BIZwDIJsDIJwDgyGdA0KADiGeAyCdAyCeA3whnwMgnwOnISNBgIDAAiEkQQMh",
      "JSAjICV0ISYgJCAmaiEnICcpAwAhoAMgBSCgAzcDUCAFKQMoIaEDQgghogMgoQMgogOIIaMDIAUgowM3Ayg",
      "gBSkDICGkA0L/ASGlAyCkAyClA4MhpgNCgA4hpwMgpgMgpwN8IagDIKgDpyEoQYCAwAIhKUEDISogKCAqdC",
      "ErICkgK2ohLCAsKQMAIakDIAUgqQM3A0ggBSkDICGqA0IIIasDIKoDIKsDiCGsAyAFIKwDNwMgIAUpAxghr",
      "QNC/wEhrgMgrQMgrgODIa8DQoAOIbADIK8DILADfCGxAyCxA6chLUGAgMACIS5BAyEvIC0gL3QhMCAuIDBq",
      "ITEgMSkDACGyAyAFILIDNwNAIAUpAxghswNCCCG0AyCzAyC0A4ghtQMgBSC1AzcDGCAFKQMQIbYDQv8BIbc",
      "DILYDILcDgyG4A0KADiG5AyC4AyC5A3whugMgugOnITJBgIDAAiEzQQMhNCAyIDR0ITUgMyA1aiE2IDYpAw",
      "AhuwMgBSC7AzcDOCAFKQMQIbwDQgghvQMgvAMgvQOIIb4DIAUgvgM3AxAgBSkDKCG/A0L/ASHAAyC/AyDAA",
      "4MhwQNCgAwhwgMgwQMgwgN8IcMDIMMDpyE3QYCAwAIhOEEDITkgNyA5dCE6IDggOmohOyA7KQMAIcQDIAUp",
      "A1AhxQMgxQMgxAOFIcYDIAUgxgM3A1AgBSkDKCHHA0IIIcgDIMcDIMgDiCHJAyAFIMkDNwMoIAUpAyAhygN",
      "C/wEhywMgygMgywODIcwDQoAMIc0DIMwDIM0DfCHOAyDOA6chPEGAgMACIT1BAyE+IDwgPnQhPyA9ID9qIU",
      "AgQCkDACHPAyAFKQNIIdADINADIM8DhSHRAyAFINEDNwNIIAUpAyAh0gNCCCHTAyDSAyDTA4gh1AMgBSDUA",
      "zcDICAFKQMYIdUDQv8BIdYDINUDINYDgyHXA0KADCHYAyDXAyDYA3wh2QMg2QOnIUFBgIDAAiFCQQMhQyBB",
      "IEN0IUQgQiBEaiFFIEUpAwAh2gMgBSkDQCHbAyDbAyDaA4Uh3AMgBSDcAzcDQCAFKQMYId0DQggh3gMg3QM",
      "g3gOIId8DIAUg3wM3AxggBSkDECHgA0L/ASHhAyDgAyDhA4Mh4gNCgAwh4wMg4gMg4wN8IeQDIOQDpyFGQY",
      "CAwAIhR0EDIUggRiBIdCFJIEcgSWohSiBKKQMAIeUDIAUpAzgh5gMg5gMg5QOFIecDIAUg5wM3AzggBSkDE",
      "CHoA0IIIekDIOgDIOkDiCHqAyAFIOoDNwMQIAUpAygh6wNC/wEh7AMg6wMg7AODIe0DQoAKIe4DIO0DIO4D",
      "fCHvAyDvA6chS0GAgMACIUxBAyFNIEsgTXQhTiBMIE5qIU8gTykDACHwAyAFKQNQIfEDIPEDIPADhSHyAyA",
      "FIPIDNwNQIAUpAygh8wNCCCH0AyDzAyD0A4gh9QMgBSD1AzcDKCAFKQMgIfYDQv8BIfcDIPYDIPcDgyH4A0",
      "KACiH5AyD4AyD5A3wh+gMg+gOnIVBBgIDAAiFRQQMhUiBQIFJ0IVMgUSBTaiFUIFQpAwAh+wMgBSkDSCH8A",
      "yD8AyD7A4Uh/QMgBSD9AzcDSCAFKQMgIf4DQggh/wMg/gMg/wOIIYAEIAUggAQ3AyAgBSkDGCGBBEL/ASGC",
      "BCCBBCCCBIMhgwRCgAohhAQggwQghAR8IYUEIIUEpyFVQYCAwAIhVkEDIVcgVSBXdCFYIFYgWGohWSBZKQM",
      "AIYYEIAUpA0AhhwQghwQghgSFIYgEIAUgiAQ3A0AgBSkDGCGJBEIIIYoEIIkEIIoEiCGLBCAFIIsENwMYIA",
      "UpAxAhjARC/wEhjQQgjAQgjQSDIY4EQoAKIY8EII4EII8EfCGQBCCQBKchWkGAgMACIVtBAyFcIFogXHQhX",
      "SBbIF1qIV4gXikDACGRBCAFKQM4IZIEIJIEIJEEhSGTBCAFIJMENwM4IAUpAxAhlARCCCGVBCCUBCCVBIgh",
      "lgQgBSCWBDcDECAFKQMoIZcEQv8BIZgEIJcEIJgEgyGZBEKACCGaBCCZBCCaBHwhmwQgmwSnIV9BgIDAAiF",
      "gQQMhYSBfIGF0IWIgYCBiaiFjIGMpAwAhnAQgBSkDUCGdBCCdBCCcBIUhngQgBSCeBDcDUCAFKQMoIZ8EQg",
      "ghoAQgnwQgoASIIaEEIAUgoQQ3AyggBSkDICGiBEL/ASGjBCCiBCCjBIMhpARCgAghpQQgpAQgpQR8IaYEI",
      "KYEpyFkQYCAwAIhZUEDIWYgZCBmdCFnIGUgZ2ohaCBoKQMAIacEIAUpA0ghqAQgqAQgpwSFIakEIAUgqQQ3",
      "A0ggBSkDICGqBEIIIasEIKoEIKsEiCGsBCAFIKwENwMgIAUpAxghrQRC/wEhrgQgrQQgrgSDIa8EQoAIIbA",
      "EIK8EILAEfCGxBCCxBKchaUGAgMACIWpBAyFrIGkga3QhbCBqIGxqIW0gbSkDACGyBCAFKQNAIbMEILMEIL",
      "IEhSG0BCAFILQENwNAIAUpAxghtQRCCCG2BCC1BCC2BIghtwQgBSC3BDcDGCAFKQMQIbgEQv8BIbkEILgEI",
      "LkEgyG6BEKACCG7BCC6BCC7BHwhvAQgvASnIW5BgIDAAiFvQQMhcCBuIHB0IXEgbyBxaiFyIHIpAwAhvQQg",
      "BSkDOCG+BCC+BCC9BIUhvwQgBSC/BDcDOCAFKQMQIcAEQgghwQQgwAQgwQSIIcIEIAUgwgQ3AxAgBSkDKCH",
      "DBEL/ASHEBCDDBCDEBIMhxQRCgAYhxgQgxQQgxgR8IccEIMcEpyFzQYCAwAIhdEEDIXUgcyB1dCF2IHQgdm",
      "ohdyB3KQMAIcgEIAUpA1AhyQQgyQQgyASFIcoEIAUgygQ3A1AgBSkDKCHLBEIIIcwEIMsEIMwEiCHNBCAFI",
      "M0ENwMoIAUpAyAhzgRC/wEhzwQgzgQgzwSDIdAEQoAGIdEEINAEINEEfCHSBCDSBKcheEGAgMACIXlBAyF6",
      "IHggenQheyB5IHtqIXwgfCkDACHTBCAFKQNIIdQEINQEINMEhSHVBCAFINUENwNIIAUpAyAh1gRCCCHXBCD",
      "WBCDXBIgh2AQgBSDYBDcDICAFKQMYIdkEQv8BIdoEINkEINoEgyHbBEKABiHcBCDbBCDcBHwh3QQg3QSnIX",
      "1BgIDAAiF+QQMhfyB9IH90IYABIH4ggAFqIYEBIIEBKQMAId4EIAUpA0Ah3wQg3wQg3gSFIeAEIAUg4AQ3A",
      "0AgBSkDGCHhBEIIIeIEIOEEIOIEiCHjBCAFIOMENwMYIAUpAxAh5ARC/wEh5QQg5AQg5QSDIeYEQoAGIecE",
      "IOYEIOcEfCHoBCDoBKchggFBgIDAAiGDAUEDIYQBIIIBIIQBdCGFASCDASCFAWohhgEghgEpAwAh6QQgBSk",
      "DOCHqBCDqBCDpBIUh6wQgBSDrBDcDOCAFKQMQIewEQggh7QQg7AQg7QSIIe4EIAUg7gQ3AxAgBSkDKCHvBE",
      "L/ASHwBCDvBCDwBIMh8QRCgAQh8gQg8QQg8gR8IfMEIPMEpyGHAUGAgMACIYgBQQMhiQEghwEgiQF0IYoBI",
      "IgBIIoBaiGLASCLASkDACH0BCAFKQNQIfUEIPUEIPQEhSH2BCAFIPYENwNQIAUpAygh9wRCCCH4BCD3BCD4",
      "BIgh+QQgBSD5BDcDKCAFKQMgIfoEQv8BIfsEIPoEIPsEgyH8BEKABCH9BCD8BCD9BHwh/gQg/gSnIYwBQYC",
      "AwAIhjQFBAyGOASCMASCOAXQhjwEgjQEgjwFqIZABIJABKQMAIf8EIAUpA0ghgAUggAUg/wSFIYEFIAUggQ",
      "U3A0ggBSkDICGCBUIIIYMFIIIFIIMFiCGEBSAFIIQFNwMgIAUpAxghhQVC/wEhhgUghQUghgWDIYcFQoAEI",
      "YgFIIcFIIgFfCGJBSCJBachkQFBgIDAAiGSAUEDIZMBIJEBIJMBdCGUASCSASCUAWohlQEglQEpAwAhigUg",
      "BSkDQCGLBSCLBSCKBYUhjAUgBSCMBTcDQCAFKQMYIY0FQgghjgUgjQUgjgWIIY8FIAUgjwU3AxggBSkDECG",
      "QBUL/ASGRBSCQBSCRBYMhkgVCgAQhkwUgkgUgkwV8IZQFIJQFpyGWAUGAgMACIZcBQQMhmAEglgEgmAF0IZ",
      "kBIJcBIJkBaiGaASCaASkDACGVBSAFKQM4IZYFIJYFIJUFhSGXBSAFIJcFNwM4IAUpAxAhmAVCCCGZBSCYB",
      "SCZBYghmgUgBSCaBTcDECAFKQMoIZsFQv8BIZwFIJsFIJwFgyGdBUKAAiGeBSCdBSCeBXwhnwUgnwWnIZsB",
      "QYCAwAIhnAFBAyGdASCbASCdAXQhngEgnAEgngFqIZ8BIJ8BKQMAIaAFIAUpA1AhoQUgoQUgoAWFIaIFIAU",
      "gogU3A1AgBSkDKCGjBUIIIaQFIKMFIKQFiCGlBSAFIKUFNwMoIAUpAyAhpgVC/wEhpwUgpgUgpwWDIagFQo",
      "ACIakFIKgFIKkFfCGqBSCqBachoAFBgIDAAiGhAUEDIaIBIKABIKIBdCGjASChASCjAWohpAEgpAEpAwAhq",
      "wUgBSkDSCGsBSCsBSCrBYUhrQUgBSCtBTcDSCAFKQMgIa4FQgghrwUgrgUgrwWIIbAFIAUgsAU3AyAgBSkD",
      "GCGxBUL/ASGyBSCxBSCyBYMhswVCgAIhtAUgswUgtAV8IbUFILUFpyGlAUGAgMACIaYBQQMhpwEgpQEgpwF",
      "0IagBIKYBIKgBaiGpASCpASkDACG2BSAFKQNAIbcFILcFILYFhSG4BSAFILgFNwNAIAUpAxghuQVCCCG6BS",
      "C5BSC6BYghuwUgBSC7BTcDGCAFKQMQIbwFQv8BIb0FILwFIL0FgyG+BUKAAiG/BSC+BSC/BXwhwAUgwAWnI",
      "aoBQYCAwAIhqwFBAyGsASCqASCsAXQhrQEgqwEgrQFqIa4BIK4BKQMAIcEFIAUpAzghwgUgwgUgwQWFIcMF",
      "IAUgwwU3AzggBSkDECHEBUIIIcUFIMQFIMUFiCHGBSAFIMYFNwMQIAUpAyghxwVC/wEhyAUgxwUgyAWDIck",
      "FQgAhygUgyQUgygV8IcsFIMsFpyGvAUGAgMACIbABQQMhsQEgrwEgsQF0IbIBILABILIBaiGzASCzASkDAC",
      "HMBSAFKQNQIc0FIM0FIMwFhSHOBSAFIM4FNwNQIAUpAyAhzwVC/wEh0AUgzwUg0AWDIdEFQgAh0gUg0QUg0",
      "gV8IdMFINMFpyG0AUGAgMACIbUBQQMhtgEgtAEgtgF0IbcBILUBILcBaiG4ASC4ASkDACHUBSAFKQNIIdUF",
      "INUFINQFhSHWBSAFINYFNwNIIAUpAxgh1wVC/wEh2AUg1wUg2AWDIdkFQgAh2gUg2QUg2gV8IdsFINsFpyG",
      "5AUGAgMACIboBQQMhuwEguQEguwF0IbwBILoBILwBaiG9ASC9ASkDACHcBSAFKQNAId0FIN0FINwFhSHeBS",
      "AFIN4FNwNAIAUpAxAh3wVC/wEh4AUg3wUg4AWDIeEFQgAh4gUg4QUg4gV8IeMFIOMFpyG+AUGAgMACIb8BQ",
      "QMhwAEgvgEgwAF0IcEBIL8BIMEBaiHCASDCASkDACHkBSAFKQM4IeUFIOUFIOQFhSHmBSAFIOYFNwM4IAUp",
      "A2Ah5wVCICHoBSDnBSDoBXwh6QUgBSDpBTcDYCAFKAJYIcMBQSAhxAEgwwEgxAFqIcUBIAUgxQE2AlgMAAs",
      "AC0IAIeoFIAUg6gU3A2ggBSgCWCHGASDGASkDACHrBSAFKQNQIewFIOsFIOwFhSHtBSAFKQNoIe4FIO4FIO",
      "0FhSHvBSAFIO8FNwNoIAUpA2gh8AVCCCHxBSDwBSDxBYgh8gUgBSkDaCHzBUL/ASH0BSDzBSD0BYMh9QUg9",
      "QWnIccBQYCAwQIhyAFBAyHJASDHASDJAXQhygEgyAEgygFqIcsBIMsBKQMAIfYFIPIFIPYFhSH3BSAFIPcF",
      "NwNoIAUpA2gh+AVCCCH5BSD4BSD5BYgh+gUgBSkDaCH7BUL/ASH8BSD7BSD8BYMh/QUg/QWnIcwBQYCAwQI",
      "hzQFBAyHOASDMASDOAXQhzwEgzQEgzwFqIdABINABKQMAIf4FIPoFIP4FhSH/BSAFIP8FNwNoIAUpA2ghgA",
      "ZCCCGBBiCABiCBBoghggYgBSkDaCGDBkL/ASGEBiCDBiCEBoMhhQYghQanIdEBQYCAwQIh0gFBAyHTASDRA",
      "SDTAXQh1AEg0gEg1AFqIdUBINUBKQMAIYYGIIIGIIYGhSGHBiAFIIcGNwNoIAUpA2ghiAZCCCGJBiCIBiCJ",
      "BoghigYgBSkDaCGLBkL/ASGMBiCLBiCMBoMhjQYgjQanIdYBQYCAwQIh1wFBAyHYASDWASDYAXQh2QEg1wE",
      "g2QFqIdoBINoBKQMAIY4GIIoGII4GhSGPBiAFII8GNwNoIAUpA2ghkAZCCCGRBiCQBiCRBoghkgYgBSkDaC",
      "GTBkL/ASGUBiCTBiCUBoMhlQYglQanIdsBQYCAwQIh3AFBAyHdASDbASDdAXQh3gEg3AEg3gFqId8BIN8BK",
      "QMAIZYGIJIGIJYGhSGXBiAFIJcGNwNoIAUpA2ghmAZCCCGZBiCYBiCZBoghmgYgBSkDaCGbBkL/ASGcBiCb",
      "BiCcBoMhnQYgnQanIeABQYCAwQIh4QFBAyHiASDgASDiAXQh4wEg4QEg4wFqIeQBIOQBKQMAIZ4GIJoGIJ4",
      "GhSGfBiAFIJ8GNwNoIAUpA2ghoAZCCCGhBiCgBiChBoghogYgBSkDaCGjBkL/ASGkBiCjBiCkBoMhpQYgpQ",
      "anIeUBQYCAwQIh5gFBAyHnASDlASDnAXQh6AEg5gEg6AFqIekBIOkBKQMAIaYGIKIGIKYGhSGnBiAFIKcGN",
      "wNoIAUpA2ghqAZCCCGpBiCoBiCpBoghqgYgBSkDaCGrBkL/ASGsBiCrBiCsBoMhrQYgrQanIeoBQYCAwQIh",
      "6wFBAyHsASDqASDsAXQh7QEg6wEg7QFqIe4BIO4BKQMAIa4GIKoGIK4GhSGvBiAFIK8GNwNoIAUoAlgh7wE",
      "g7wEpAwghsAYgBSkDSCGxBiCwBiCxBoUhsgYgBSkDaCGzBiCzBiCyBoUhtAYgBSC0BjcDaCAFKQNoIbUGQg",
      "ghtgYgtQYgtgaIIbcGIAUpA2ghuAZC/wEhuQYguAYguQaDIboGILoGpyHwAUGAgMECIfEBQQMh8gEg8AEg8",
      "gF0IfMBIPEBIPMBaiH0ASD0ASkDACG7BiC3BiC7BoUhvAYgBSC8BjcDaCAFKQNoIb0GQgghvgYgvQYgvgaI",
      "Ib8GIAUpA2ghwAZC/wEhwQYgwAYgwQaDIcIGIMIGpyH1AUGAgMECIfYBQQMh9wEg9QEg9wF0IfgBIPYBIPg",
      "BaiH5ASD5ASkDACHDBiC/BiDDBoUhxAYgBSDEBjcDaCAFKQNoIcUGQgghxgYgxQYgxgaIIccGIAUpA2ghyA",
      "ZC/wEhyQYgyAYgyQaDIcoGIMoGpyH6AUGAgMECIfsBQQMh/AEg+gEg/AF0If0BIPsBIP0BaiH+ASD+ASkDA",
      "CHLBiDHBiDLBoUhzAYgBSDMBjcDaCAFKQNoIc0GQgghzgYgzQYgzgaIIc8GIAUpA2gh0AZC/wEh0QYg0AYg",
      "0QaDIdIGINIGpyH/AUGAgMECIYACQQMhgQIg/wEggQJ0IYICIIACIIICaiGDAiCDAikDACHTBiDPBiDTBoU",
      "h1AYgBSDUBjcDaCAFKQNoIdUGQggh1gYg1QYg1gaIIdcGIAUpA2gh2AZC/wEh2QYg2AYg2QaDIdoGINoGpy",
      "GEAkGAgMECIYUCQQMhhgIghAIghgJ0IYcCIIUCIIcCaiGIAiCIAikDACHbBiDXBiDbBoUh3AYgBSDcBjcDa",
      "CAFKQNoId0GQggh3gYg3QYg3gaIId8GIAUpA2gh4AZC/wEh4QYg4AYg4QaDIeIGIOIGpyGJAkGAgMECIYoC",
      "QQMhiwIgiQIgiwJ0IYwCIIoCIIwCaiGNAiCNAikDACHjBiDfBiDjBoUh5AYgBSDkBjcDaCAFKQNoIeUGQgg",
      "h5gYg5QYg5gaIIecGIAUpA2gh6AZC/wEh6QYg6AYg6QaDIeoGIOoGpyGOAkGAgMECIY8CQQMhkAIgjgIgkA",
      "J0IZECII8CIJECaiGSAiCSAikDACHrBiDnBiDrBoUh7AYgBSDsBjcDaCAFKQNoIe0GQggh7gYg7QYg7gaII",
      "e8GIAUpA2gh8AZC/wEh8QYg8AYg8QaDIfIGIPIGpyGTAkGAgMECIZQCQQMhlQIgkwIglQJ0IZYCIJQCIJYC",
      "aiGXAiCXAikDACHzBiDvBiDzBoUh9AYgBSD0BjcDaCAFKAJYIZgCIJgCKQMQIfUGIAUpA0Ah9gYg9QYg9ga",
      "FIfcGIAUpA2gh+AYg+AYg9waFIfkGIAUg+QY3A2ggBSkDaCH6BkIIIfsGIPoGIPsGiCH8BiAFKQNoIf0GQv",
      "8BIf4GIP0GIP4GgyH/BiD/BqchmQJBgIDBAiGaAkEDIZsCIJkCIJsCdCGcAiCaAiCcAmohnQIgnQIpAwAhg",
      "Acg/AYggAeFIYEHIAUggQc3A2ggBSkDaCGCB0IIIYMHIIIHIIMHiCGEByAFKQNoIYUHQv8BIYYHIIUHIIYH",
      "gyGHByCHB6chngJBgIDBAiGfAkEDIaACIJ4CIKACdCGhAiCfAiChAmohogIgogIpAwAhiAcghAcgiAeFIYk",
      "HIAUgiQc3A2ggBSkDaCGKB0IIIYsHIIoHIIsHiCGMByAFKQNoIY0HQv8BIY4HII0HII4HgyGPByCPB6chow",
      "JBgIDBAiGkAkEDIaUCIKMCIKUCdCGmAiCkAiCmAmohpwIgpwIpAwAhkAcgjAcgkAeFIZEHIAUgkQc3A2ggB",
      "SkDaCGSB0IIIZMHIJIHIJMHiCGUByAFKQNoIZUHQv8BIZYHIJUHIJYHgyGXByCXB6chqAJBgIDBAiGpAkED",
      "IaoCIKgCIKoCdCGrAiCpAiCrAmohrAIgrAIpAwAhmAcglAcgmAeFIZkHIAUgmQc3A2ggBSkDaCGaB0IIIZs",
      "HIJoHIJsHiCGcByAFKQNoIZ0HQv8BIZ4HIJ0HIJ4HgyGfByCfB6chrQJBgIDBAiGuAkEDIa8CIK0CIK8CdC",
      "GwAiCuAiCwAmohsQIgsQIpAwAhoAcgnAcgoAeFIaEHIAUgoQc3A2ggBSkDaCGiB0IIIaMHIKIHIKMHiCGkB",
      "yAFKQNoIaUHQv8BIaYHIKUHIKYHgyGnByCnB6chsgJBgIDBAiGzAkEDIbQCILICILQCdCG1AiCzAiC1Amoh",
      "tgIgtgIpAwAhqAcgpAcgqAeFIakHIAUgqQc3A2ggBSkDaCGqB0IIIasHIKoHIKsHiCGsByAFKQNoIa0HQv8",
      "BIa4HIK0HIK4HgyGvByCvB6chtwJBgIDBAiG4AkEDIbkCILcCILkCdCG6AiC4AiC6AmohuwIguwIpAwAhsA",
      "cgrAcgsAeFIbEHIAUgsQc3A2ggBSkDaCGyB0IIIbMHILIHILMHiCG0ByAFKQNoIbUHQv8BIbYHILUHILYHg",
      "yG3ByC3B6chvAJBgIDBAiG9AkEDIb4CILwCIL4CdCG/AiC9AiC/AmohwAIgwAIpAwAhuAcgtAcguAeFIbkH",
      "IAUguQc3A2ggBSgCWCHBAiDBAikDGCG6ByAFKQM4IbsHILoHILsHhSG8ByAFKQNoIb0HIL0HILwHhSG+ByA",
      "FIL4HNwNoIAUpA2ghvwdCCCHAByC/ByDAB4ghwQcgBSkDaCHCB0L/ASHDByDCByDDB4MhxAcgxAenIcICQY",
      "CAwQIhwwJBAyHEAiDCAiDEAnQhxQIgwwIgxQJqIcYCIMYCKQMAIcUHIMEHIMUHhSHGByAFIMYHNwNoIAUpA",
      "2ghxwdCCCHIByDHByDIB4ghyQcgBSkDaCHKB0L/ASHLByDKByDLB4MhzAcgzAenIccCQYCAwQIhyAJBAyHJ",
      "AiDHAiDJAnQhygIgyAIgygJqIcsCIMsCKQMAIc0HIMkHIM0HhSHOByAFIM4HNwNoIAUpA2ghzwdCCCHQByD",
      "PByDQB4gh0QcgBSkDaCHSB0L/ASHTByDSByDTB4Mh1Acg1AenIcwCQYCAwQIhzQJBAyHOAiDMAiDOAnQhzw",
      "IgzQIgzwJqIdACINACKQMAIdUHINEHINUHhSHWByAFINYHNwNoIAUpA2gh1wdCCCHYByDXByDYB4gh2QcgB",
      "SkDaCHaB0L/ASHbByDaByDbB4Mh3Acg3AenIdECQYCAwQIh0gJBAyHTAiDRAiDTAnQh1AIg0gIg1AJqIdUC",
      "INUCKQMAId0HINkHIN0HhSHeByAFIN4HNwNoIAUpA2gh3wdCCCHgByDfByDgB4gh4QcgBSkDaCHiB0L/ASH",
      "jByDiByDjB4Mh5Acg5AenIdYCQYCAwQIh1wJBAyHYAiDWAiDYAnQh2QIg1wIg2QJqIdoCINoCKQMAIeUHIO",
      "EHIOUHhSHmByAFIOYHNwNoIAUpA2gh5wdCCCHoByDnByDoB4gh6QcgBSkDaCHqB0L/ASHrByDqByDrB4Mh7",
      "Acg7AenIdsCQYCAwQIh3AJBAyHdAiDbAiDdAnQh3gIg3AIg3gJqId8CIN8CKQMAIe0HIOkHIO0HhSHuByAF",
      "IO4HNwNoIAUpA2gh7wdCCCHwByDvByDwB4gh8QcgBSkDaCHyB0L/ASHzByDyByDzB4Mh9Acg9AenIeACQYC",
      "AwQIh4QJBAyHiAiDgAiDiAnQh4wIg4QIg4wJqIeQCIOQCKQMAIfUHIPEHIPUHhSH2ByAFIPYHNwNoIAUpA2",
      "gh9wdCCCH4ByD3ByD4B4gh+QcgBSkDaCH6B0L/ASH7ByD6ByD7B4Mh/Acg/AenIeUCQYCAwQIh5gJBAyHnA",
      "iDlAiDnAnQh6AIg5gIg6AJqIekCIOkCKQMAIf0HIPkHIP0HhSH+ByAFIP4HNwNoIAUpA2Ah/wdCICGACCD/",
      "ByCACHwhgQggBSCBCDcDYAtCACGCCCAFIIIINwMIAkADQCAFKQMIIYMIIAUoAnQh6gIg6gIh6wIg6wKsIYQ",
      "IIIMIIYUIIIQIIYYIIIUIIIYIVCHsAkEBIe0CIOwCIO0CcSHuAiDuAkUNASAFKQNoIYcIQgghiAgghwggiA",
      "iIIYkIIAUpA2ghigggBSgCcCHvAiAFKQNgIYsIIIsIpyHwAiDvAiDwAmoh8QIg8QItAAAh8gJB/wEh8wIg8",
      "gIg8wJxIfQCIPQCrSGMCCCKCCCMCIUhjQhC/wEhjgggjQggjgiDIY8III8IpyH1AkGAgMECIfYCQQMh9wIg",
      "9QIg9wJ0IfgCIPYCIPgCaiH5AiD5AikDACGQCCCJCCCQCIUhkQggBSCRCDcDaCAFKQMIIZIIQgEhkwggkgg",
      "gkwh8IZQIIAUglAg3AwggBSkDYCGVCEIBIZYIIJUIIJYIfCGXCCAFIJcINwNgDAALAAsgBSkDaCGYCEJ/IZ",
      "kIIJgIIJkIhSGaCCAGIJoINwMADwudAgIcfwV+IwAhBEEgIQUgBCAFayEGIAYkACAGIAA2AhwgBiABNgIYI",
      "AYgAjYCFCAGIAM2AhAgBigCHCEHIAYoAhghCCAGKAIUIQkgByAIIAkQBiAGKAIQIQogBiAKNgIMQQAhCyAG",
      "IAs2AggCQANAIAYoAgghDEEIIQ0gDCEOIA0hDyAOIA9JIRBBASERIBAgEXEhEiASRQ0BIAcpAwAhICAGKAI",
      "IIRNBAyEUIBMgFHQhFSAVIRYgFq0hISAgICGIISJC/wEhIyAiICODISQgJKchFyAGKAIMIRggBigCCCEZIB",
      "ggGWohGiAaIBc6AAAgBigCCCEbQQEhHCAbIBxqIR0gBiAdNgIIDAALAAtBICEeIAYgHmohHyAfJAAPC14BD",
      "H8jACEBQRAhAiABIAJrIQMgAyQAIAMgADYCDCADKAIMIQRBACEFIAQhBiAFIQcgBiAHRiEIQQEhCSAIIAlx",
      "IQoCQCAKDQAgBBAUC0EQIQsgAyALaiEMIAwkAA8LNQIEfwF+QRAhACAAEBMhAUIAIQQgASAENwMAQQghAiA",
      "BIAJqIQMgAyAENwMAIAEQChogAQ8LPAIEfwJ+IwAhAUEQIQIgASACayEDIAMgADYCDCADKAIMIQRCACEFIA",
      "QgBTcDAEIAIQYgBCAGNwMIIAQPC1kBCH8jACEDQRAhBCADIARrIQUgBSQAIAUgADYCDCAFIAE2AgggBSACN",
      "gIEIAUoAgwhBiAFKAIIIQcgBSgCBCEIIAYgByAIEAZBECEJIAUgCWohCiAKJAAPC2kBCX8jACEEQRAhBSAE",
      "IAVrIQYgBiQAIAYgADYCDCAGIAE2AgggBiACNgIEIAYgAzYCACAGKAIMIQcgBigCCCEIIAYoAgQhCSAGKAI",
      "AIQogByAIIAkgChAHQRAhCyAGIAtqIQwgDCQADwteAQx/IwAhAUEQIQIgASACayEDIAMkACADIAA2AgwgAy",
      "gCDCEEQQAhBSAEIQYgBSEHIAYgB0YhCEEBIQkgCCAJcSEKAkAgCg0AIAQQFAtBECELIAMgC2ohDCAMJAAPC",
      "wcAPwBBEHQLBwBBlJLBAgtUAQJ/QQAoAoCQwQIiASAAQQdqQXhxIgJqIQACQAJAIAJFDQAgACABTQ0BCwJA",
      "IAAQDk0NACAAEAFFDQELQQAgADYCgJDBAiABDwsQD0EwNgIAQX8LviwBC38jAEEQayIBJAACQAJAAkACQAJ",
      "AAkACQAJAAkACQAJAAkACQAJAAkAgAEH0AUsNAAJAQQAoApiSwQIiAkEQIABBC2pBeHEgAEELSRsiA0EDdi",
      "IEdiIAQQNxRQ0AAkACQCAAQX9zQQFxIARqIgVBA3QiBEHAksECaiIAIARByJLBAmooAgAiBCgCCCIDRw0AQ",
      "QAgAkF+IAV3cTYCmJLBAgwBCyADIAA2AgwgACADNgIICyAEQQhqIQAgBCAFQQN0IgVBA3I2AgQgBCAFaiIE",
      "IAQoAgRBAXI2AgQMDwsgA0EAKAKgksECIgZNDQECQCAARQ0AAkACQCAAIAR0QQIgBHQiAEEAIABrcnEiAEE",
      "AIABrcWgiBEEDdCIAQcCSwQJqIgUgAEHIksECaigCACIAKAIIIgdHDQBBACACQX4gBHdxIgI2ApiSwQIMAQ",
      "sgByAFNgIMIAUgBzYCCAsgACADQQNyNgIEIAAgA2oiByAEQQN0IgQgA2siBUEBcjYCBCAAIARqIAU2AgACQ",
      "CAGRQ0AIAZBeHFBwJLBAmohA0EAKAKsksECIQQCQAJAIAJBASAGQQN2dCIIcQ0AQQAgAiAIcjYCmJLBAiAD",
      "IQgMAQsgAygCCCEICyADIAQ2AgggCCAENgIMIAQgAzYCDCAEIAg2AggLIABBCGohAEEAIAc2AqySwQJBACA",
      "FNgKgksECDA8LQQAoApySwQIiCUUNASAJQQAgCWtxaEECdEHIlMECaigCACIHKAIEQXhxIANrIQQgByEFAk",
      "ADQAJAIAUoAhAiAA0AIAVBFGooAgAiAEUNAgsgACgCBEF4cSADayIFIAQgBSAESSIFGyEEIAAgByAFGyEHI",
      "AAhBQwACwALIAcoAhghCgJAIAcoAgwiCCAHRg0AIAcoAggiAEEAKAKoksECSRogACAINgIMIAggADYCCAwO",
      "CwJAIAdBFGoiBSgCACIADQAgBygCECIARQ0DIAdBEGohBQsDQCAFIQsgACIIQRRqIgUoAgAiAA0AIAhBEGo",
      "hBSAIKAIQIgANAAsgC0EANgIADA0LQX8hAyAAQb9/Sw0AIABBC2oiAEF4cSEDQQAoApySwQIiBkUNAEEAIQ",
      "sCQCADQYACSQ0AQR8hCyADQf///wdLDQAgA0EmIABBCHZnIgBrdkEBcSAAQQF0a0E+aiELC0EAIANrIQQCQ",
      "AJAAkACQCALQQJ0QciUwQJqKAIAIgUNAEEAIQBBACEIDAELQQAhACADQQBBGSALQQF2ayALQR9GG3QhB0EA",
      "IQgDQAJAIAUoAgRBeHEgA2siAiAETw0AIAIhBCAFIQggAg0AQQAhBCAFIQggBSEADAMLIAAgBUEUaigCACI",
      "CIAIgBSAHQR12QQRxakEQaigCACIFRhsgACACGyEAIAdBAXQhByAFDQALCwJAIAAgCHINAEEAIQhBAiALdC",
      "IAQQAgAGtyIAZxIgBFDQMgAEEAIABrcWhBAnRByJTBAmooAgAhAAsgAEUNAQsDQCAAKAIEQXhxIANrIgIgB",
      "EkhBwJAIAAoAhAiBQ0AIABBFGooAgAhBQsgAiAEIAcbIQQgACAIIAcbIQggBSEAIAUNAAsLIAhFDQAgBEEA",
      "KAKgksECIANrTw0AIAgoAhghCwJAIAgoAgwiByAIRg0AIAgoAggiAEEAKAKoksECSRogACAHNgIMIAcgADY",
      "CCAwMCwJAIAhBFGoiBSgCACIADQAgCCgCECIARQ0DIAhBEGohBQsDQCAFIQIgACIHQRRqIgUoAgAiAA0AIA",
      "dBEGohBSAHKAIQIgANAAsgAkEANgIADAsLAkBBACgCoJLBAiIAIANJDQBBACgCrJLBAiEEAkACQCAAIANrI",
      "gVBEEkNAEEAIAU2AqCSwQJBACAEIANqIgc2AqySwQIgByAFQQFyNgIEIAQgAGogBTYCACAEIANBA3I2AgQM",
      "AQtBAEEANgKsksECQQBBADYCoJLBAiAEIABBA3I2AgQgBCAAaiIAIAAoAgRBAXI2AgQLIARBCGohAAwNCwJ",
      "AQQAoAqSSwQIiByADTQ0AQQAgByADayIENgKkksECQQBBACgCsJLBAiIAIANqIgU2ArCSwQIgBSAEQQFyNg",
      "IEIAAgA0EDcjYCBCAAQQhqIQAMDQsCQAJAQQAoAvCVwQJFDQBBACgC+JXBAiEEDAELQQBCfzcC/JXBAkEAQ",
      "oCggICAgAQ3AvSVwQJBACABQQxqQXBxQdiq1aoFczYC8JXBAkEAQQA2AoSWwQJBAEEANgLUlcECQYAgIQQL",
      "QQAhACAEIANBL2oiBmoiAkEAIARrIgtxIgggA00NDEEAIQACQEEAKALQlcECIgRFDQBBACgCyJXBAiIFIAh",
      "qIgkgBU0NDSAJIARLDQ0LAkACQEEALQDUlcECQQRxDQACQAJAAkACQAJAQQAoArCSwQIiBEUNAEHYlcECIQ",
      "ADQAJAIAAoAgAiBSAESw0AIAUgACgCBGogBEsNAwsgACgCCCIADQALC0EAEBAiB0F/Rg0DIAghAgJAQQAoA",
      "vSVwQIiAEF/aiIEIAdxRQ0AIAggB2sgBCAHakEAIABrcWohAgsgAiADTQ0DAkBBACgC0JXBAiIARQ0AQQAo",
      "AsiVwQIiBCACaiIFIARNDQQgBSAASw0ECyACEBAiACAHRw0BDAULIAIgB2sgC3EiAhAQIgcgACgCACAAKAI",
      "EakYNASAHIQALIABBf0YNAQJAIANBMGogAksNACAAIQcMBAsgBiACa0EAKAL4lcECIgRqQQAgBGtxIgQQEE",
      "F/Rg0BIAQgAmohAiAAIQcMAwsgB0F/Rw0CC0EAQQAoAtSVwQJBBHI2AtSVwQILIAgQECEHQQAQECEAIAdBf",
      "0YNBSAAQX9GDQUgByAATw0FIAAgB2siAiADQShqTQ0FC0EAQQAoAsiVwQIgAmoiADYCyJXBAgJAIABBACgC",
      "zJXBAk0NAEEAIAA2AsyVwQILAkACQEEAKAKwksECIgRFDQBB2JXBAiEAA0AgByAAKAIAIgUgACgCBCIIakY",
      "NAiAAKAIIIgANAAwFCwALAkACQEEAKAKoksECIgBFDQAgByAATw0BC0EAIAc2AqiSwQILQQAhAEEAIAI2At",
      "yVwQJBACAHNgLYlcECQQBBfzYCuJLBAkEAQQAoAvCVwQI2ArySwQJBAEEANgLklcECA0AgAEEDdCIEQciSw",
      "QJqIARBwJLBAmoiBTYCACAEQcySwQJqIAU2AgAgAEEBaiIAQSBHDQALQQAgAkFYaiIAQXggB2tBB3FBACAH",
      "QQhqQQdxGyIEayIFNgKkksECQQAgByAEaiIENgKwksECIAQgBUEBcjYCBCAHIABqQSg2AgRBAEEAKAKAlsE",
      "CNgK0ksECDAQLIAAtAAxBCHENAiAEIAVJDQIgBCAHTw0CIAAgCCACajYCBEEAIARBeCAEa0EHcUEAIARBCG",
      "pBB3EbIgBqIgU2ArCSwQJBAEEAKAKkksECIAJqIgcgAGsiADYCpJLBAiAFIABBAXI2AgQgBCAHakEoNgIEQ",
      "QBBACgCgJbBAjYCtJLBAgwDC0EAIQgMCgtBACEHDAgLAkAgB0EAKAKoksECIghPDQBBACAHNgKoksECIAch",
      "CAsgByACaiEFQdiVwQIhAAJAAkACQAJAA0AgACgCACAFRg0BIAAoAggiAA0ADAILAAsgAC0ADEEIcUUNAQt",
      "B2JXBAiEAA0ACQCAAKAIAIgUgBEsNACAFIAAoAgRqIgUgBEsNAwsgACgCCCEADAALAAsgACAHNgIAIAAgAC",
      "gCBCACajYCBCAHQXggB2tBB3FBACAHQQhqQQdxG2oiCyADQQNyNgIEIAVBeCAFa0EHcUEAIAVBCGpBB3Eba",
      "iICIAsgA2oiA2shAAJAIAIgBEcNAEEAIAM2ArCSwQJBAEEAKAKkksECIABqIgA2AqSSwQIgAyAAQQFyNgIE",
      "DAgLAkAgAkEAKAKsksECRw0AQQAgAzYCrJLBAkEAQQAoAqCSwQIgAGoiADYCoJLBAiADIABBAXI2AgQgAyA",
      "AaiAANgIADAgLIAIoAgQiBEEDcUEBRw0GIARBeHEhBgJAIARB/wFLDQAgAigCCCIFIARBA3YiCEEDdEHAks",
      "ECaiIHRhoCQCACKAIMIgQgBUcNAEEAQQAoApiSwQJBfiAId3E2ApiSwQIMBwsgBCAHRhogBSAENgIMIAQgB",
      "TYCCAwGCyACKAIYIQkCQCACKAIMIgcgAkYNACACKAIIIgQgCEkaIAQgBzYCDCAHIAQ2AggMBQsCQCACQRRq",
      "IgUoAgAiBA0AIAIoAhAiBEUNBCACQRBqIQULA0AgBSEIIAQiB0EUaiIFKAIAIgQNACAHQRBqIQUgBygCECI",
      "EDQALIAhBADYCAAwEC0EAIAJBWGoiAEF4IAdrQQdxQQAgB0EIakEHcRsiCGsiCzYCpJLBAkEAIAcgCGoiCD",
      "YCsJLBAiAIIAtBAXI2AgQgByAAakEoNgIEQQBBACgCgJbBAjYCtJLBAiAEIAVBJyAFa0EHcUEAIAVBWWpBB",
      "3EbakFRaiIAIAAgBEEQakkbIghBGzYCBCAIQRBqQQApAuCVwQI3AgAgCEEAKQLYlcECNwIIQQAgCEEIajYC",
      "4JXBAkEAIAI2AtyVwQJBACAHNgLYlcECQQBBADYC5JXBAiAIQRhqIQADQCAAQQc2AgQgAEEIaiEHIABBBGo",
      "hACAHIAVJDQALIAggBEYNACAIIAgoAgRBfnE2AgQgBCAIIARrIgdBAXI2AgQgCCAHNgIAAkAgB0H/AUsNAC",
      "AHQXhxQcCSwQJqIQACQAJAQQAoApiSwQIiBUEBIAdBA3Z0IgdxDQBBACAFIAdyNgKYksECIAAhBQwBCyAAK",
      "AIIIQULIAAgBDYCCCAFIAQ2AgwgBCAANgIMIAQgBTYCCAwBC0EfIQACQCAHQf///wdLDQAgB0EmIAdBCHZn",
      "IgBrdkEBcSAAQQF0a0E+aiEACyAEIAA2AhwgBEIANwIQIABBAnRByJTBAmohBQJAAkACQEEAKAKcksECIgh",
      "BASAAdCICcQ0AQQAgCCACcjYCnJLBAiAFIAQ2AgAgBCAFNgIYDAELIAdBAEEZIABBAXZrIABBH0YbdCEAIA",
      "UoAgAhCANAIAgiBSgCBEF4cSAHRg0CIABBHXYhCCAAQQF0IQAgBSAIQQRxaiICQRBqKAIAIggNAAsgAkEQa",
      "iAENgIAIAQgBTYCGAsgBCAENgIMIAQgBDYCCAwBCyAFKAIIIgAgBDYCDCAFIAQ2AgggBEEANgIYIAQgBTYC",
      "DCAEIAA2AggLQQAoAqSSwQIiACADTQ0AQQAgACADayIENgKkksECQQBBACgCsJLBAiIAIANqIgU2ArCSwQI",
      "gBSAEQQFyNgIEIAAgA0EDcjYCBCAAQQhqIQAMCAsQD0EwNgIAQQAhAAwHC0EAIQcLIAlFDQACQAJAIAIgAi",
      "gCHCIFQQJ0QciUwQJqIgQoAgBHDQAgBCAHNgIAIAcNAUEAQQAoApySwQJBfiAFd3E2ApySwQIMAgsgCUEQQ",
      "RQgCSgCECACRhtqIAc2AgAgB0UNAQsgByAJNgIYAkAgAigCECIERQ0AIAcgBDYCECAEIAc2AhgLIAJBFGoo",
      "AgAiBEUNACAHQRRqIAQ2AgAgBCAHNgIYCyAGIABqIQAgAiAGaiICKAIEIQQLIAIgBEF+cTYCBCADIABBAXI",
      "2AgQgAyAAaiAANgIAAkAgAEH/AUsNACAAQXhxQcCSwQJqIQQCQAJAQQAoApiSwQIiBUEBIABBA3Z0IgBxDQ",
      "BBACAFIAByNgKYksECIAQhAAwBCyAEKAIIIQALIAQgAzYCCCAAIAM2AgwgAyAENgIMIAMgADYCCAwBC0EfI",
      "QQCQCAAQf///wdLDQAgAEEmIABBCHZnIgRrdkEBcSAEQQF0a0E+aiEECyADIAQ2AhwgA0IANwIQIARBAnRB",
      "yJTBAmohBQJAAkACQEEAKAKcksECIgdBASAEdCIIcQ0AQQAgByAIcjYCnJLBAiAFIAM2AgAgAyAFNgIYDAE",
      "LIABBAEEZIARBAXZrIARBH0YbdCEEIAUoAgAhBwNAIAciBSgCBEF4cSAARg0CIARBHXYhByAEQQF0IQQgBS",
      "AHQQRxaiIIQRBqKAIAIgcNAAsgCEEQaiADNgIAIAMgBTYCGAsgAyADNgIMIAMgAzYCCAwBCyAFKAIIIgAgA",
      "zYCDCAFIAM2AgggA0EANgIYIAMgBTYCDCADIAA2AggLIAtBCGohAAwCCwJAIAtFDQACQAJAIAggCCgCHCIF",
      "QQJ0QciUwQJqIgAoAgBHDQAgACAHNgIAIAcNAUEAIAZBfiAFd3EiBjYCnJLBAgwCCyALQRBBFCALKAIQIAh",
      "GG2ogBzYCACAHRQ0BCyAHIAs2AhgCQCAIKAIQIgBFDQAgByAANgIQIAAgBzYCGAsgCEEUaigCACIARQ0AIA",
      "dBFGogADYCACAAIAc2AhgLAkACQCAEQQ9LDQAgCCAEIANqIgBBA3I2AgQgCCAAaiIAIAAoAgRBAXI2AgQMA",
      "QsgCCADQQNyNgIEIAggA2oiByAEQQFyNgIEIAcgBGogBDYCAAJAIARB/wFLDQAgBEF4cUHAksECaiEAAkAC",
      "QEEAKAKYksECIgVBASAEQQN2dCIEcQ0AQQAgBSAEcjYCmJLBAiAAIQQMAQsgACgCCCEECyAAIAc2AgggBCA",
      "HNgIMIAcgADYCDCAHIAQ2AggMAQtBHyEAAkAgBEH///8HSw0AIARBJiAEQQh2ZyIAa3ZBAXEgAEEBdGtBPm",
      "ohAAsgByAANgIcIAdCADcCECAAQQJ0QciUwQJqIQUCQAJAAkAgBkEBIAB0IgNxDQBBACAGIANyNgKcksECI",
      "AUgBzYCACAHIAU2AhgMAQsgBEEAQRkgAEEBdmsgAEEfRht0IQAgBSgCACEDA0AgAyIFKAIEQXhxIARGDQIg",
      "AEEddiEDIABBAXQhACAFIANBBHFqIgJBEGooAgAiAw0ACyACQRBqIAc2AgAgByAFNgIYCyAHIAc2AgwgByA",
      "HNgIIDAELIAUoAggiACAHNgIMIAUgBzYCCCAHQQA2AhggByAFNgIMIAcgADYCCAsgCEEIaiEADAELAkAgCk",
      "UNAAJAAkAgByAHKAIcIgVBAnRByJTBAmoiACgCAEcNACAAIAg2AgAgCA0BQQAgCUF+IAV3cTYCnJLBAgwCC",
      "yAKQRBBFCAKKAIQIAdGG2ogCDYCACAIRQ0BCyAIIAo2AhgCQCAHKAIQIgBFDQAgCCAANgIQIAAgCDYCGAsg",
      "B0EUaigCACIARQ0AIAhBFGogADYCACAAIAg2AhgLAkACQCAEQQ9LDQAgByAEIANqIgBBA3I2AgQgByAAaiI",
      "AIAAoAgRBAXI2AgQMAQsgByADQQNyNgIEIAcgA2oiBSAEQQFyNgIEIAUgBGogBDYCAAJAIAZFDQAgBkF4cU",
      "HAksECaiEDQQAoAqySwQIhAAJAAkBBASAGQQN2dCIIIAJxDQBBACAIIAJyNgKYksECIAMhCAwBCyADKAIII",
      "QgLIAMgADYCCCAIIAA2AgwgACADNgIMIAAgCDYCCAtBACAFNgKsksECQQAgBDYCoJLBAgsgB0EIaiEACyAB",
      "QRBqJAAgAAuDDQEHfwJAIABFDQAgAEF4aiIBIABBfGooAgAiAkF4cSIAaiEDAkAgAkEBcQ0AIAJBA3FFDQE",
      "gASABKAIAIgJrIgFBACgCqJLBAiIESQ0BIAIgAGohAAJAAkACQCABQQAoAqySwQJGDQACQCACQf8BSw0AIA",
      "EoAggiBCACQQN2IgVBA3RBwJLBAmoiBkYaAkAgASgCDCICIARHDQBBAEEAKAKYksECQX4gBXdxNgKYksECD",
      "AULIAIgBkYaIAQgAjYCDCACIAQ2AggMBAsgASgCGCEHAkAgASgCDCIGIAFGDQAgASgCCCICIARJGiACIAY2",
      "AgwgBiACNgIIDAMLAkAgAUEUaiIEKAIAIgINACABKAIQIgJFDQIgAUEQaiEECwNAIAQhBSACIgZBFGoiBCg",
      "CACICDQAgBkEQaiEEIAYoAhAiAg0ACyAFQQA2AgAMAgsgAygCBCICQQNxQQNHDQJBACAANgKgksECIAMgAk",
      "F+cTYCBCABIABBAXI2AgQgAyAANgIADwtBACEGCyAHRQ0AAkACQCABIAEoAhwiBEECdEHIlMECaiICKAIAR",
      "w0AIAIgBjYCACAGDQFBAEEAKAKcksECQX4gBHdxNgKcksECDAILIAdBEEEUIAcoAhAgAUYbaiAGNgIAIAZF",
      "DQELIAYgBzYCGAJAIAEoAhAiAkUNACAGIAI2AhAgAiAGNgIYCyABQRRqKAIAIgJFDQAgBkEUaiACNgIAIAI",
      "gBjYCGAsgASADTw0AIAMoAgQiAkEBcUUNAAJAAkACQAJAAkAgAkECcQ0AAkAgA0EAKAKwksECRw0AQQAgAT",
      "YCsJLBAkEAQQAoAqSSwQIgAGoiADYCpJLBAiABIABBAXI2AgQgAUEAKAKsksECRw0GQQBBADYCoJLBAkEAQ",
      "QA2AqySwQIPCwJAIANBACgCrJLBAkcNAEEAIAE2AqySwQJBAEEAKAKgksECIABqIgA2AqCSwQIgASAAQQFy",
      "NgIEIAEgAGogADYCAA8LIAJBeHEgAGohAAJAIAJB/wFLDQAgAygCCCIEIAJBA3YiBUEDdEHAksECaiIGRho",
      "CQCADKAIMIgIgBEcNAEEAQQAoApiSwQJBfiAFd3E2ApiSwQIMBQsgAiAGRhogBCACNgIMIAIgBDYCCAwECy",
      "ADKAIYIQcCQCADKAIMIgYgA0YNACADKAIIIgJBACgCqJLBAkkaIAIgBjYCDCAGIAI2AggMAwsCQCADQRRqI",
      "gQoAgAiAg0AIAMoAhAiAkUNAiADQRBqIQQLA0AgBCEFIAIiBkEUaiIEKAIAIgINACAGQRBqIQQgBigCECIC",
      "DQALIAVBADYCAAwCCyADIAJBfnE2AgQgASAAQQFyNgIEIAEgAGogADYCAAwDC0EAIQYLIAdFDQACQAJAIAM",
      "gAygCHCIEQQJ0QciUwQJqIgIoAgBHDQAgAiAGNgIAIAYNAUEAQQAoApySwQJBfiAEd3E2ApySwQIMAgsgB0",
      "EQQRQgBygCECADRhtqIAY2AgAgBkUNAQsgBiAHNgIYAkAgAygCECICRQ0AIAYgAjYCECACIAY2AhgLIANBF",
      "GooAgAiAkUNACAGQRRqIAI2AgAgAiAGNgIYCyABIABBAXI2AgQgASAAaiAANgIAIAFBACgCrJLBAkcNAEEA",
      "IAA2AqCSwQIPCwJAIABB/wFLDQAgAEF4cUHAksECaiECAkACQEEAKAKYksECIgRBASAAQQN2dCIAcQ0AQQA",
      "gBCAAcjYCmJLBAiACIQAMAQsgAigCCCEACyACIAE2AgggACABNgIMIAEgAjYCDCABIAA2AggPC0EfIQICQC",
      "AAQf///wdLDQAgAEEmIABBCHZnIgJrdkEBcSACQQF0a0E+aiECCyABIAI2AhwgAUIANwIQIAJBAnRByJTBA",
      "mohBAJAAkACQAJAQQAoApySwQIiBkEBIAJ0IgNxDQBBACAGIANyNgKcksECIAQgATYCACABIAQ2AhgMAQsg",
      "AEEAQRkgAkEBdmsgAkEfRht0IQIgBCgCACEGA0AgBiIEKAIEQXhxIABGDQIgAkEddiEGIAJBAXQhAiAEIAZ",
      "BBHFqIgNBEGooAgAiBg0ACyADQRBqIAE2AgAgASAENgIYCyABIAE2AgwgASABNgIIDAELIAQoAggiACABNg",
      "IMIAQgATYCCCABQQA2AhggASAENgIMIAEgADYCCAtBAEEAKAK4ksECQX9qIgFBfyABGzYCuJLBAgsLMQEBf",
      "yAAQQEgABshAQJAA0AgARARIgANAQJAECIiAEUNACAAEQMADAELCxAAAAsgAAsGACAAEBILBAAgAAsLACAA",
      "KAI8EBUQAgsVAAJAIAANAEEADwsQDyAANgIAQX8L4wIBB38jAEEgayIDJAAgAyAAKAIcIgQ2AhAgACgCFCE",
      "FIAMgAjYCHCADIAE2AhggAyAFIARrIgE2AhQgASACaiEGIANBEGohBEECIQcCQAJAAkACQAJAIAAoAjwgA0",
      "EQakECIANBDGoQAxAXRQ0AIAQhBQwBCwNAIAYgAygCDCIBRg0CAkAgAUF/Sg0AIAQhBQwECyAEIAEgBCgCB",
      "CIISyIJQQN0aiIFIAUoAgAgASAIQQAgCRtrIghqNgIAIARBDEEEIAkbaiIEIAQoAgAgCGs2AgAgBiABayEG",
      "IAUhBCAAKAI8IAUgByAJayIHIANBDGoQAxAXRQ0ACwsgBkF/Rw0BCyAAIAAoAiwiATYCHCAAIAE2AhQgACA",
      "BIAAoAjBqNgIQIAIhAQwBC0EAIQEgAEEANgIcIABCADcDECAAIAAoAgBBIHI2AgAgB0ECRg0AIAIgBSgCBG",
      "shAQsgA0EgaiQAIAELNwEBfyMAQRBrIgMkACAAIAEgAkH/AXEgA0EIahAwEBchAiADKQMIIQEgA0EQaiQAQ",
      "n8gASACGwsNACAAKAI8IAEgAhAZCwIACwIACw4AQZCWwQIQG0GUlsECCwkAQZCWwQIQHAsEAEEBCwIACwcA",
      "IAAoAgALCQBBnJbBAhAhCwYAIAAkAQsEACMBCwQAIwALBgAgACQACxIBAn8jACAAa0FwcSIBJAAgAQsEACM",
      "ACxMAQYCAwAIkA0EAQQ9qQXBxJAILBwAjACMCawsEACMDCwQAIwILuAIBA38CQCAADQBBACEBAkBBACgCmJ",
      "bBAkUNAEEAKAKYlsECEC0hAQsCQEEAKAKYkcECRQ0AQQAoApiRwQIQLSABciEBCwJAEB0oAgAiAEUNAANAQ",
      "QAhAgJAIAAoAkxBAEgNACAAEB8hAgsCQCAAKAIUIAAoAhxGDQAgABAtIAFyIQELAkAgAkUNACAAECALIAAo",
      "AjgiAA0ACwsQHiABDwtBACECAkAgACgCTEEASA0AIAAQHyECCwJAAkACQCAAKAIUIAAoAhxGDQAgAEEAQQA",
      "gACgCJBEHABogACgCFA0AQX8hASACDQEMAgsCQCAAKAIEIgEgACgCCCIDRg0AIAAgASADa6xBASAAKAIoEQ",
      "QAGgtBACEBIABBADYCHCAAQgA3AxAgAEIANwIEIAJFDQELIAAQIAsgAQsNACABIAIgAyAAEQQACyMBAX4gA",
      "CABIAKtIAOtQiCGhCAEEC4hBSAFQiCIpxAjIAWnCxMAIAAgAacgAUIgiKcgAiADEAQLC7aSgYAABABBgIDA",
      "AguAkAEAAAAAAAAAADGyfhfBM8W4CfdqdtFBU0U4RRRhEHKW/RLu1eyig6aKI1yr+2OwYzIbGb+ac8L1zyq",
      "rwY2y8TB3T088gRYhlCF+/UKW1xJRmUa4VvfHYMdkdwoo4AZTAtxdoelttKIyq2wTl3p1kfcTVFaDG2XjYe",
      "5l5P0MpNCkVp6eeAItQihDrywGFexx7fuXaRJ0/AN7BqbbbGM9ML6+jHCt7o/Bjsm9wtP5TvJLcYWHx5heg",
      "N2MtDW5j5+zGDTR0USDO2O8YuBjOpT6UHna2CYu9eoi7yfplFDiKxEqn8M/kW+Z4Bro8o3veFjT31DKyPsZ",
      "SKFJrft6hQ6JkowVPD3xBFqEUIYNj48Tm7eVPjXKm3KLxQPDBHjlZUr2xnsu0yTo+Af2DB9hWv85NDO0JyR",
      "OnilGpUkWljCJ6HVg8XNyzYVMpcSnQsCzko2WAR96hafzneSX4ks32eRc11JaYZwYae4mYi1QLmZ+LxWnlW",
      "hrch8/ZzFoWdkMCP5U9NCio4kGd8Z4xZMR9xG29b19q1TjcKaHK4Ca5p1nZ7TuOLBNXOrVRd5Pgf8i/RR2G",
      "/e5ujacBASNCogISIvFN0iy7ey1h2Hn7OTcXsuQoNQpXOQb3/Gwpr+h1amh5nGVehn/AmBrw2RKbs6wHnwC",
      "V4/W9vUKHRIlGSvHR3QK0xbckxPpdVHnLng4IlsLRiYdvYAaHh8nNm8rfSusYTD3XO7FAQegvUWt3rIwtd6",
      "qhJ4bCgjwysuU7I33OUK03FXfSE9cpknQ8Q/sGW0UN8cwPCmhVVEjpiBOv1xk412x4X165E5InDxTjEqTf/",
      "riK5K/jytHv/ZKgs0Z1nYNiF1D/txujXcNU8psUHu8xXNEC1+Vw4SAZyUbLQM+tTIZMtoexoafmdi/aO/28",
      "a4rpqip3DNJlm6yybmupbSn3MzeeJ1gDMI4MdLcTcRa84pPxR1+AeLLz1ukDQyXH/p9JbPMP1Kn0NbkPn7O",
      "YtDhZJopv/2naNkhjkivjzGV6JPwX2689C0v1IRVvaoovh5m+kJ8me0GJiPuI2zre/sXkZA0rdi+Qz06Ubk",
      "fKY40DIgvrt4aS4w0zTvPzmjdcQV/RdgPWxjJYJu41KuLvJ9RKcbDarh5J2ls0qJ6yu/aWN6stbv5KmJydW",
      "04CQgaFUPHEy/IO9+te4IHTthJSVBKMHlZGXqM6LFK/FeQ6AD9gPiCQFHbxUW4vZYhQalTuIkP6DaAmpYAo",
      "6QpuzJrpneSFles81hjz6pTQ83jKvUym+E92iIZMIr+BcDWhsmU3M+3vsFH+lFk9/KqoFeIx5nGQNS3lrsC",
      "IezrFTokSjJW3VlrLeV59+7lHH9M9QthE9SuAVs0OKSrJtLros5d8HAXYJW1D241yC8lgdQfHKM1Hpf/w94",
      "vZo00PD5ObN5W+gWOQFmt7ZNCPctUOL2fBb8MeSovfKzAB2md1yPYfGRRWC+pNBlPoelgar1VCT03FFHYw0",
      "LIDvKse3MCz3r/wttKwXzYu8wHY3KEaLmrvpGeQzYWrmqNVCa4TJOg4x/YM4n+7bciLB2Lsbv51jJei3aAC",
      "YfB821OzqqiRkxBnH65mxA4W4CvuwGjVSw6kN0t/JLnUi1R7uhE9wOvIfU+TBLGsdE2NA2Jqv70xVckfx9X",
      "z0a7QOVM2u/l7XrNV73qmNRfBNqWji8g7BoQu4b8ud3dqG6sR898ZRrvGqaU2aD2K11ksVXqZU4TGHDQRZj",
      "zsyKqDseEqzYLCAHPSjZaBnw5s7Fd92nDxAH2pTznG1U5METbKyYokIFVoCYngvg012QSWDBDy/FvXFdMUV",
      "O5Z5Jt5TJGkoqiKkdO88sge5JddvyN3OFIV+VOuZm98TrBGH8L56owCQSghHFipLmbiLW1wxyzeKhNDY2GC",
      "NJo2tvwvDR2xanpHkiWn7dIGxguP6ctyV/aK+uHn2jdPspZfXqu2qMpC2q4wss+XiWvuhyU+owgMm6J2SzC",
      "yTRTfvtP0fN7SkS/yIpp2dCLyQ05uh7oYvXezAp/ptAn4b/ceOlb4ZWfqB1LLOM1O57zKXOISASJ4OToQE3",
      "wPMz0hfgy2w0NfoqSOQEetSfVSx+L8C7CFmc1CErD63ouIiFpWrF9hx+QX36bgrg/enSicj9SHGlLxtxl/m",
      "HZ0XODyATuE08sQjG2Ey8gipRomneendG641koCYlc4n9bYW0d6EyQ6aZQ32P/jaMsHqul5vEEMaALmheY5",
      "sUCZbOiUoyH1XDzTpPg8pAUQzb2uUszHaayBoGI+U0KZ4HDObC8WWt381XEgQ4nfLbAkHzk6tpwEhA0KtVY",
      "pGfTI/GS7R2wBsNRZ2/cr84RAmKi1/YED5ywk5Kgx7Zxi3GgVxj/82XqYdLB5c5BG/2g4QRdCQZv93P32M4",
      "4tBHgssQddgDxBYGitouLMUN7lmOFTjMb6Lob0XR+RCpaxAwQR7v8Eh/QbQA1LQEjra56wQbouUZJU3Zl1k",
      "zvd/stYaTliVdPvjkAtJcfqn4MRxd1pNoSVKeGmsdV6mVlFfiNBmYv3V1Q7OwWFLkgbOKS+9cnfJiXmBf1X",
      "rXwjaYqaeKfhjU1nm99g4/0o8iv3QOUTsdmcIV2whn8NlYHtMS8Dj0Fk7+MgahvLXcFQr0z1njsRMD62Ncr",
      "dEiUZKzpZVVjiaehFNEgQQKZ1Tfp4JI/FVjm8lHKOf6Y6hfCJvuLgI8rJAeew86U7jtWkWPyfOr5+mVU2wA",
      "AAAAAAAAASEfgaLc09/b7HVeJPU832bNat+GKe8Avnag5Sii4t4bV79kin4xAcGa1bsMV94BfLvKOq6LDd6",
      "lRwuTMA1a2ORmFBKS0YkHPqt+zRT4ZgeDimFMtiS12Fsxq3YYr7gG/hC097pza9kk3d4oPFqE2Zn8wamehl",
      "cGQooTJmQesbHPqwynxsJibhVmZnhA641uqEd5+eI3XrFw/LPDTLxTb9XdrELuYICwDxDGnWhJb7CyMdkcy",
      "pW8b2vNGLVUE+tpKuwHNPbPOLbwIW3rcObXtk0AcmrSOgRplbu4UHyxCbcwmqfR3m3aaOpXzQ5YRDVoV3bS",
      "j/qY5reNECZMzD1jZ5gxOc1u4bC4QvxTEujIX7j/3UyTShSMZydmhqnkn4G5gkeZKEZDUmZYivP3wGq9ZuW",
      "r7HZitm65PFct3/wwOb99djJeXuzqYKe7WIHYxQVgGppHAHoZ1r/CIY061JLbYWcAkrt2Tgi+vc34ZPBn57",
      "4A7OflUrs0YduaNWqoI9LWVrsq6wr/AQmMdkA0jNbuCTFXX7UuCj3W6eyVj4CBMAhMzYoOIl3j15YA4NGkd",
      "AzXKyH/UAao3wjy3T75mC6IDrP8IXg68lvRaTFLp7zbtNHUEFQmHgdnDgyrnhywjGrQqYqBnRJQuQ9zR+tC",
      "lHlWD85m9MM2pYXQF44GxP02Wa/mrxlFX+qKcDxic5rZw2VwgUNsG3sftq9Z+KYh1ZS7cfzZuaB3SGiuJhT",
      "Tf/Fhh66bNcz+U71UcULJDVfNOwN3A+gS1m/n0KjZJXgJ6c4/qGQEZ4hLEux3vL+tsuWZ4akZnrIzR0Uyds",
      "NT2OzBbN12fnLHbWOwDqmlBBXimSjoHiglCmM79DvB8uhgvL3d1MFPyX89HwEHHpdytQexigrAMlOqhhNW2",
      "R/onsBZlX82H1W/39g3o+XAjEMecaklssbNYgHwC/lhGRevay+N0I4Zqo50ri8MXcZyNb6UgYdQGNcUoRUj",
      "W4PHDdnLyqVybMew+NRLB66/GGqeIIgxCzrIf78/CZPX6RelclXWFf4GFxhTSle3ItXIwOiAbRmp2BZlyZ/",
      "su3ULyb8E9TM9XOTJAiXqsp+ANxbb2SsbAQZgEJr4NJqj2rPPQDVeRSXzXM/9FEHEhy+PECWvi/4ppILOgI",
      "6Uf4t4URFaQ/6gDVG+Eedi4SGvjW3OPBQzrlUVi3mxNSwv98lYpmv4RvBx4Lem1tlZcdM8ZHkOYpNLfbdpp",
      "6tDjMrfa7p4cY7mFVlCVXjMr/mU+56GpxVTOD1lGNGhVHInvMfEAn6Ov01jQe3tfjOeUuLjMT6h6yWY2E26",
      "M39OBIdZ72bgoJTJ7YZpTw+gKejyB8uT3H/ytkPQnyQoOxuXXFE9+PvkwVo2jrvRFOR8eykPGQ3HO6TA4zW",
      "3hsrlAeH8tBVaGTrbLJZrk3P2OmYNieoxryXlv/FIQ68pcuP+0FfCDfWhPCQdPR2L3E48mTwinCkAneNBh+",
      "imh4uQPeSm9yclV0PiPmud+KN+rOKDSoJ5AaJ/PVg8UPb7OpmK1R1Pd1nmSlUP0CWo38+lVbLxOil9E3aKa",
      "krwE9OYe1TPa++ScUSoixWmhU33bUeLqIeazFWxlFRxe1tlyzfDUjBaRORp6xCN6pcuO+/C/41XtjG6TR4s",
      "Uo8N+4DjlSGMKizkAUFJ8lPw4Y7ex2AdU03AkV9lvM6Ml6ZlnFMZS1yCh3od8cWYg1hKEMJ37HeD5WsPQ9U",
      "wpFw90MV5e7upgpjx2vjZZ3pdQjywJ19OlV3/Ha+m/ZJGgibhbg9jFBGEZ8BxjsHIwlu9DRtRR+EtWwAsBN",
      "DlPf6E2JfO6ku281p9ttFr6Woghad7u7RvQ8+FGlqkNc2fHFrBLHa6Nwf67UwNaTuV2ykylsAD5BPyxjIr4",
      "RxlsS4V7fNa1l8fpRgzVnvJ3r15y+yMtqMBO1Ak7DGXvICZjPcz6Gt9KQcKoDWpSmKopdZz6nOHCHcj/5zq",
      "zqYX9oEjTzUWHd3ML6hC67M8wk2NdJE0afGokgtdfjTU0LcTqYGt6w04RRRiEnGU/BlalcDOoksm1DBKRud",
      "NS5v1L8vkO56UQ07l8Uqwk0rmb/pw6GxAlTyikK9uRa+VgYOPLsyZfEpYf06HUh8rTBleUQbww/iTw5M72X",
      "bqF5N+siRY1DbETKYJ7mJ6vcmSAyjx49hhGk3Z5Zs8Xkj1TWTEhL38lCaSv7JWMgYMwCUyk0mzpNAT+uheI",
      "2wi+fz6VX887YAlLyWNxPbXLq4i+yjl6VaMcvEk8iiDiQpbHiRPCZwIqIfN+5b1XaE2AZr919RCIJTdSSIN",
      "GSj/EvSmIrA4N36wKHX9aIP9RB6jeCPNouLFvH+r/BdviBo6VkT8qk6Xm5iKlyNwKGNYri8S82UJfNkM88E",
      "sv8QWBoraLiwC5QmHKAb989pew72GjfAtf3/cPCRRI/KlsrbjonjM8hiTqWIApB8twW9oy54iSCuATndKPP",
      "6b9FqDHZW613T056ICFBgLpys/GcgutoCq9Zo4168UXHkqQPW9cJJ1lir91KLxMKlF9SaicH7KMaNCq4Nv/",
      "2jtcJ1xTgUg7sSfncxvGqFMGExCFNTQm+KTQZyx9c8aQE+SQ2s4pcXGZn1D1hm6RGS6rpwP5Xvt+jz5mk7E",
      "ZGxY4CpFlAkOs97JxUUpKBEyfBUWmvGT2wjSnhtEVLLEiXBCyJuOf65W9msnmzNesddUt/RE6AAAAAAAAAA",
      "BdMxKlPcGwcbpmJEp7gmHj51U270ZD0ZIfXt/MpSIa8kJtzWmY46qDpTj7ht6gexH4C+kj42HLYFUvKcEYY",
      "+3QCBw7ZCWiXaHvSQ2LY+GMM7J6Hy5eIDxCSnH2Db1B9yIXQuSogIBHU/AX0kfGw5bBrSTA4vsCJrDBzcXa",
      "YuADlZz+139fIbPke6vhkBliYnYmmPM1JKPSB96TGhbHwhlng6AIs/oDqRZk9T5cvEB4hDnGLPmBgcj1lOL",
      "sG3qD7kXJ0f6+R0JeNC6EyFEBAY+mc7fa9DzAP9eLvDPX36H0t9aPIXLiYETGMdoXnaQjlVRs6QU4meIlJe",
      "kIHO2W5t4etDsOSKsnbm9Tbjin7WS//Q5dKgLQpQ+M9lbDITPExOyrZdGEDgV0nUww52tIRqUPEQP1znWHF",
      "X68JzUsjoUzzuEUJ4mzRIO/BkERZvUHUi1bcgPDyMbiXKN56uArpyk8/kr4RRZmmU0ZH86qUCVI30Qs3A9t",
      "5PiuKMXZN/QG3Yt19suSycdt+pKj/X2PhLxoz5Dv2LJFDBk3mwb7USTHeWqoFF5s5XcIjf0isSqmpprQzjA",
      "UF2cW633q8PbsZTBbINniU9GkgCrHjNS8l+dRuJq/xhmqJuHJYrQvOklHKqk/hz2fdIaa2NjSC3AyxUtKhe",
      "EZ1Q8E+zvSETjaLc29PY8iKn8QDA1MaHcckFZP3N41RA41a45sr81P5xaI76fPkHz1s7UuF753KcNc823GL",
      "Coa0fnOrHZdhz4RGzWuUO3aDQO+CG/gnD1YNVFOLDEOYGsn9HPtgX+YYM7XkIxKH8VT3HKtTfpuIgbqnesO",
      "K/x/Nfg41s+bjRPc/QBPLb6oTu/vpXLsDtmputlKNK/fS/SJy+8Jbm86DIIizOoPpFpRsTBp184UK7bkBoa",
      "RjcW569cUI6xMdchG89TBV05TeBvAxmRqj+MJ/JXwiyzMMpuhpuIuEQ2C6lmtCw3ybEmKBJ4ZqM+t+fvjyy",
      "9Hie4oab74PeK0L5gYOxkkN7srYyNmKjaShurTUoF/AH3AqQLA3EwS2P1osrEkR/v7Hgl50Xl06V4jyMmgn",
      "iHfsWWLGDLDEs0UWEqoQ242DfajSI7zMwUfU56JPoLUUCm82MrvEIljOxnlC19hcWjSOgZqlAEsW8CfO6sk",
      "cMsO9nB96PXilj3k1UApRZP61OHt2ctgtqfn80jkCtDHQLLFp6JJAVUdgdcCn4ixJOWKPiF86XpEuLkshEE",
      "oyjVf7BprB2sbpwLfCM46qqvWr/vILMGojWbyyNqJ/Gk9FxWd7Ga6KuyFSK7+w4frXPSwpRfgZIqXlO2WBU",
      "VZSyflCsMzqh8I9ndX8CEPIslGBqQjcLRbmnt7+RBiEWZbywoeRVT+IBgamEN2Rlsd2arpu32veP64YYnmT",
      "r3dw3nR+AEbizKFOgBqXCiZl7j7sBvxDFl1Q/mWq6w/S9B+OCbaS2p9Pzh790gWWW+aBbpHOe5Shrnm24xZ",
      "s2GUHNsaPChUNKLznVntugkHsFagmF3LZe61bjl6eO443afLBLvIn9+IkSRC+BkNgruDgX85qXx6sGqinFh",
      "iHCeDeAehmdJtwNZO6OfaA/+d5VxN2huzjjDBnK8hGZU+bfKOChzYJU+Kp7jlWpv03deUqkBnWkSsL59DY4",
      "Q7j8xyrFHGufo/vZX5Zyn/ue4vyMp1jMJ4Xl5NK2xZzXylZRAYfvzwvRUU901IE7b+xIaqflq2iz9091J1s",
      "5VoXr+XD0ahMFWfD+boE5ffE9zedLUghXouHW4FGARFmNUfSLVFN1c96N74xKJiYdKunSlW/1Fzd5NcmScH",
      "WppUcD1SR1ppiPFN/OI2vTy+Hgu/M6TgD6y7Nn6D1YzmqYOvnKbw0dW7JpJdFoE2gI3J1B7HE2uzn2zp33d",
      "ik7h2Twq+vALOi2TqN38McyneUgVxPN3hdO1AoEz9bZDZyYBCt/9LIIT6kueKPvtRY6+kCMx9KsM+nLat8b",
      "yassaXX44S3VHSm6RNKy8c4aN88XvEaV8wMSHCaWFUnoBAdjJIbnZXxkYrAVrLS5Z2N8xUbCQN1aelkWd+g",
      "TAUF9RpbJei03XctDRfhQfutGzF0wqz6Kj3vVeOOaFNlTYNJiMdYa9uNCuWfi5zClP1m+eZe0XlFbZKdcRI",
      "V0Aod/oEPEO+Y8sWMWRhcKzG9teBFYYlmimwlFCH2xaIjI1V4Pa3/420FLfF0+rMnxEpdnWiDZmp/m81pDB",
      "QqrtbUvQUQaihUnixld8h9ZJA3YxUb1ASx3Yyyhe+wk/0ZJf31g6z4tCkdQzUKAO/47bQMRWYcli2gD93Vk",
      "ngBYWSmkqX+ZH9jnu5qfYy8aC9aRyUN4KAR+hf89J0UxIa201W77XjY586VIPgsRhYwglGJt1wqCklXHDJm",
      "zN5u3hvYmym8snKgGSLT0WTAqrdV5nqeFKy2zoCrwU+EWNJZzG9oAPQ0zjKFX1C+NL1iJcmb+fFE0X5cHNZ",
      "CINQlGstQEutvpEkGtVLoo5d8O96iHiwK2AxXwtvLYbEJnKOmTIelGEbsz7oXveRWYJRG80DxIP8v5CrvOS",
      "RtRP503ouuaKntsQSyl9BqU6VJ3MBPxyaXDAasrFO+89q31zxYNym/Hh6YTDQrQvYuJiaMvYdVuuqPafzRm",
      "yxvpzS4bCX/uyNjnfccSePFIZnVD8Q7O9JtXXxAtFcnq7gQx5Eko0M89NRu3lTPX0AAAAAAAAAAF6RFQ9Ib",
      "Nu/17G8RsP+b0uJIKlJi5K09K5jeY2G/d+W8PJsgs6RBCl50sXLRQOw3SdD0MQNb2tiN1RlQl7dZhlpxXBN",
      "FrG9puDl2QSdIwlSvnTMC9VP0u2ZNxzP2CC5j8emCcCQTGIwToagiRve1sQQF7WGU7INe26oyoS8us0yMDn",
      "fi/TWFo25GXbCf0SieeeIY803KHnGwMuzCTpHEqSeWqYGcivJGxd6D0/5uX3vSesaQLHVplBZ/K/G4merKw",
      "dtusmqC3CUjk0TgCGZxGDQ3AaPafUf3/ef1ktkmnS9qQ7DRCz2rwIgLmoNp2Qb9n6/fwLvCMBJ3FCVCXl1m",
      "2WCwYAGMRlA2gvhKU+6i/QuVXA8QPLnL5FyM+yE/4hE8yyi+Yu35J9MpYJQwjx2K7j7E0XNdBrwB+sE8Esn",
      "qP18tZXlRG/EJsM8tUwN5FaSN2IkWQKsOkmIRWeJxqFVIuob9pzJ6Tn5VZLWNYBiq02hzEcgjyrHlh6y+F+",
      "Nxc9WV+xpSoKNo43oZUnjywYxORw72PbETl3ioxybJgBDMonBQgozDwteUn7LKppGgMzmipW7j0nIoD01ha",
      "w6z5sSME7bPS/A037r8VIdholY7F8FDIyThhCAhLorz0NCHe/v2HVeVk1VgzRn/H7/BN4RgJOi7+oLln1bL",
      "LihKhPy6jbL5jA/HLqG7XRvEJZVMRRZgDGBg1p5eII/FsJTnnQX6V1IU0aRPHsy4sFz79i36YYWn+L61/+F",
      "XamP9U9RrDdQ0tFkWl7kW4ttWETzF2/JP5kG1eYYJ6XkJiGWNtwqyo9Efwcj02KmVPv2J4qa6TTgD6i2n5W",
      "hWDuw1gngl05Q+/mImPWYBjwgRgG4XNGNrpSyXylJ3sXCTw14apkayK0kbyb7jBWAwf/Qr9slXAtTSyTxSj",
      "BTQz+Qm+FdhdUQjZ3gv8yQ2ljhRl827DmT03Pyq2h9LJybHykUTz78WJZwQnYRr+lX3hyZyZiPQB5Vji09x",
      "h5VER3i9oJk8b8ai5+trjpgqhXD83YRs0ADXEhhwuXt0RZTAA0ZWsqSxpcNYnI4lAPTmEUOqYcdI3rRzpwd",
      "c0Oyb96G8MbMU6XaWNVCy7cNNM9XnS4QCIQUZh4WvKT82oVzEV7Qf0P9xqPVU78UIaNXttob08+eKncfk5B",
      "Be2p05gqc2C2g1QpZdZ43JWCcVMhgkX9JuyPd6MnY9NsP14N53Ne8t9RopDoME7HYvwr6qxkc+bRktXOLsF",
      "VyJtBBLRqlWjpKC/49DRDcafgGhWOcBdMhlN066rysmqoGac60LbmV4mqycZNuaVHvBdkTzf98XqdpAqxE3",
      "9UXLPu2WBpOwBhkl23nG9DCfrfztKJFQddx/59vHcxhfjh0DdvpkvBrNzxhAFa1s7vzMQ5rNOsirvx5YrCL",
      "YgIHtfLwBH88kxK6upzfwCyEpzzpLtK7chWyM6FCCQT7NRt6KtC98KWkDnVivGZPgufesW/TDS3cdsu+J7/",
      "WklVWYvesLWJmC8d3+ORBudl1eAj6C0l5kCvpHfVDJaIvosm0vMi3Ftv8WKGzgNvNZNsbcXeNtKYGhYpkeM",
      "XYfbkMqs0xTkrJTVI72D4GJhLyQixtuFWUH4kcvXi3HfjENpWd0f6WanDCywzE8d4Gq33sTxQ102nAH7LeA",
      "TqbBRugO/6ocxCXr1Rlb718WPt068eAV3fOhi/HmRFCeIbq9HgQMesxDXhAjE6g/j5FFJszaeMu+kh78FE3",
      "cjv1ABcr7r5SkryLhZ8a4MOHs8PpRKXw1DI1kFtJ3q5FJzrYN5JhJ2WOc1OlJpV59Jt8G8n9Kl63S7gWppZ",
      "IACZet17KTfeJBvf+1Vj5A9eX4vGdNCK8qSid83I84vX3uYj8OlA5Sn6ZIbWxwo2+IAg0uvmuVgEHS+R+9M",
      "E9Y1na8XG8rebc0PpYODc/UiiOa003f1OJl558+LEs4YTswO3tvmSNX1NJzUT37x/rpxdcUfinczAYMB+BP",
      "KocW3pujpQz4nCAxeeuPXpp4jQxuT8odSGO746jcehtRRmCaf3g/WINdVnWdMBUK4bn7SIqUUEkzos2nQ0S",
      "keDD5F3/U4OE74uIhkDaoy2mABoytIQyOKlIdukLlCWNLxvE5HDKtJggU6g/z0OUMWnYOos7HQUkZpBWUIQ",
      "6RvSinTk75mTX4a3VVeBZ7fdI5F7HVK2zZl3rFquPEs3ZIun5o09bk0g35rHPlOQaaJ6vOl0gEET5i6ByMf",
      "uvY7pbZH9ekM09K05rNzJLcrQL5yK8oP+G6pryLfTMJDn6jUerp34pQqQcUqTvEvL9LTz77WSARglzre7iL",
      "OydtlTuPiYhg/bUCn8rKWnvLWuDX4Jg4n2Zn93Ol2+qEUIgfyF9ZDxsGQwhsGhrdADCs6iQwSL/knZH9gHU",
      "Lbf+rfjRQgTpupHGmo/TEeby/R0lBvO4r3lvqdFYYq2gMQNybkh1GCZisX8VFuQNKSrdpKqfxKRgoU8QXsF",
      "VsW/pI8vh5hZhq+RMoIO4h3SkrCB7PDGn3e0nss/IbzbI4m/eFHcRibfggNbUPk8You/Iug+BxjgLpkMou3",
      "WYqR6pC0Rgyr/qzm0GKwuo4XvbYk5H0BdoW3IrxdVk4zbKZySNub9cJt3Sot4Lsid4TMetlmdpmPFsbuQd9",
      "d1sr/1761WZBtOIvqsvWPZtsdYvviAQmrYOXw8XaZsIAvoBngJm02TZRQAAAAAAAAAAdw3hKr0Wpj7uGsJV",
      "ei1MfZkXI3/HO+pD3DWEq/RamPqrOGWBSUw+xDIvRv6Od9SHRSKn1DNhcrnT+J8PupPpwaT1fiUHhU//PeJ",
      "dWsC+pbxK77xwfagDgg/NG6ROyXE7eMD6jvPf1wXh19nxNOQ9RpbaONuJ8pt4zWKoRycBCre6b0ltmhesiS",
      "N4ahJdLEbKVHWLOOA64PQRVyzs01uSTWZazcZuTTRz/03uual23jCIQA+TFGB4Dh6aN0idkuN2aZfWYiCER",
      "UjwgPUd57+vC4eNFDdaqQk1wq+z42nIe4y1olLJ1N7dsiy1cbYT5TfxW7iQnK7zkc/xVsfXHSTNWoZbJv2g",
      "MmtkH0wFgmcJgSdoQeSo2h8nGS1jQ3zpflWgWm6iVlRo857DeYEpk1MZ3bR0YAMuRb/jIq5Y2Ke3JJtVo7n",
      "yGqGCpcy0mo3dmmjmu7l7p2CMztj+m9xzU+28YYmWPVnu+xpfEIEeJinA8BxnjP8MlNZWIjw0b5A6JcftSz",
      "mOuoczYdPSLq3FQAiLkKUjTO/9Hi2u4AHrO85/XxeXDAoRc2n5KQ4bKW60UhNqeRbIRAlEtVTvzPCfgLYuL",
      "JjBEbU9oIgSAdYyyvqbYlF229PgR43EbzP5dDR07LbWRPSVHsn6EOjd47ZhDsH6q6ruV0uz11yV4q2OrztI",
      "mrWVoG+Fhl48iwy3TPpBZdbIe7qt0PxzcPY+mAoEzxICT0mV6y5yBKRx0ILIUbU/TjKnjyl7CCnoDDFVEaC",
      "B23N0RljwijzN1UrfT9P1+/Y/CahCMt9G4Jk37WCVC3WB646abXQhyJdNsAN6V14PrKfzdHe2dLK6Ac0vzy",
      "boHEmQAljCx8KhXzY8wdXkvWZk3H+22AWX23J6QfP6okPoEwj4hPdDaVUFrsYd4GAWkj5EhWrtgTwvKOK7/",
      "De556baecOLOljNG8zf/RIte7Lc9zW+ZSCamGHhk4AgAj1MUoDhOVcP3GbvlkcHzhj/GSitrUS5FR4zlbsL",
      "ehP7SXgmbFfvZPaoUpt68dH94YstXEEbkorsagfhV72sz87N09I2zxW4wyz5byBpKyHUD4aoG4NoVtnurBU",
      "NJVbAA9Z3nP++LrcON10h6RgQLhkUIubS8lNZFPUIW8RUbRw2UtxopSbUazuz9tWzgOryLJCJEohqqYUhca",
      "OvnsyX3pnhPwFtXViplAAVvHv7ZjCDI2p7QBElR47CQMZWtxsCrGWU9TfFonWhhL5IIWOc7LanwY8aid+bu",
      "0brMgwv4Q1hfjC7/rSZemyfGgboEqfje7xlwdP45JR2XU98xV7a0VT6m0+kLGOmWRux8rKKXT9OOM41iWAe",
      "SEPZ5IifxiCvyIoHJLbtX9jFay2ZoEthQdJIUl6boSI236l4440HHHP9DqzQ7HWlBPDvhm3605ud58z5qsE",
      "52OrqLdMX15/mfDAVCJ4lBJ4LPfQiIzOioJIq113kCEjj5Sc2d1ke7t2gBZGjan+cZNcIcInXaTpaTh9T9h",
      "BS0Bk5ErLcrUR2J2KqIkADt+foFafDar6hQdaMsOAVeZqrlfu9AT/EjA2rvp+m6/ftfxLJkkfBSvvZLFCFZ",
      "L6NwDNvJ4iFlDDWlVGxUr1PuSQOKcZfXGUEMqgXX0h/GsMJQlQoRZ4wfh/kam1nOeRNfpbTGmrYzvBoMO2D",
      "ffuxN1ParvRwGpuKRXyQXp5N0DmSIAUpk6z6hISGO7CEj4VDv2x4x4lur/6pykaCq8l7zci4//WmKFFw3h7",
      "BbLELLrfl9IIbvOoECvNSvI1m0t+DAcnE+msz9T4Xb/pjfBCK+SyFuRRx8aBEOiOHUVNWdHdbUT4mXrdeyk",
      "33AL9JlCENdh1DyER1C7Bgu32T/OWXHpMqsuTxBL2jhYyMfeYnwmS+Zs8K68bo2ajA8U/JYTzqybJIOMSAF",
      "lffFHah06NpkOT+NdbeQkMt8lgLQAR6mKQAw3M3CZuyGRZlTa4euM3eLY8O2RNZ52M7KTCcMf4zUFpbies8",
      "HxntTP23cis8Zip3F/QFJt1Ml2Gxyk1lBKgf/nfqOmjlgqLo0dSjf8b9ZdM7l9RyJ9fYxZ2pkVCAA+uk7xD",
      "mXWEpVrJJLn9KQlaRiaNtCEejfCyfBVOenZunpW2eK+mQeo0YezgVcIdZ8t9A0lYHirjYYlZ0aEKoHwxRNw",
      "bRNaX+JuwhoO+sst1ZKxpKrNu/PHOWDOySgAes7zj/fV33Ck3FhenbY24dbrpC0jEgGRCPkP/Elx5cMihEz",
      "KXlpys/yW5xs0OZsijqEbaIqdrFJQs7C54P5FP/M+CCbJScJPLSyj96MqK95fG1+EHY4croEJ9FV37fj8q3",
      "S3Y2DGb4x1ZhyyCqWGHQdR4MG0AbFt2UNLEN5iW8M8N/Atq6sMs+IlW/zByOUikBKnj39s0lJOAAxeFQ82A",
      "GR9T2gCJKFwum/kuWhHSOHIWBjK1uN/kRZKsxu8gJb8tccLhJU3EYxr1aBV/1T4HRniXCZB8M9tx/D39yuT",
      "Kz/tjbTBPLi8TzOfHxBW21XeQajjY+h/Yq6fukiyghyHFRazgl27AHBlyKEpjNFjmfS6ltX/b8euhGSEfi4",
      "FpErWTvk9GBKP3aaQ65bJeOw0N+LcarrGSANHPM7Ba6wr6iqfQ3n0hZxtWkFR0iXv/4TLM2YuVlFbs7vtdI",
      "WHOzhX6ccJxrEsE8CZGRttYEZwKQhrLJET+NQeeLU+OsKSt/AAAAAAAAAADlUZmWzImUFsqjMi2ZEyktL/K",
      "ru1WavTuUR2VaMidSWnEW/Mz+rsZMXuRXd6s0e3e7tc7hZ73vYSiPyrRkTqS0zd5TIqjHMKLiLPiZ/V2NmQ",
      "d9YQ8x1BmPvMiv7lZp9u5ZmTZ4muBi+HZrncPPet/DkzoEVQPzS9U7jQIxmrqRXd7cm6dWMwVL8S4wHAOpu",
      "HAUf6mKzyAsZq/KZ2uoncMHSpv+/WQUVxFlaVVGMY7qKoA4zND9B348EwLIhf70Nen2U1ETMn2h/9mh+qhn",
      "5xzEPPBjPqtuiNKHRa3fzNNns2IUNEkAWvOlTeaf8lXATp6otwZkmUnaiHYaBWI0dSO7k0uc9Pj8t628uTd",
      "PrWYKllnortlh756A4l1gOAZSceEHDPmuytvl9yj+UhWfQVjMza/Lg1PIzNpelc/WUDuHD7vEVkCcshMZlD",
      "b9+8koriJxZ2RtBaE6NMrSqoxiHNVVL4MzGq6VQUMAcZih+w/8eOUgATc3hmhuTZcHU67Psuaoxp7FYkYm8",
      "Ic0NX433JvLYmWs6PtVD93Z0GIJnOjgvDyB+59QYXSqE3NQJAX7yZH2IsmyyXJdh2UYzefKgRZSgElUcQYI",
      "gkSvu//KU5I/f0rqZlyfG6tp8V+ovfimRAgUDjErNC/QHjv8mpBhtW0l3q0DBq08+TOHp52cO8yfQmL2BAr",
      "3RQtUTQSvsaLftm+oVTYnblYieRPg+MYJ680Y9rFhUMViWQ7ZQ8rrkPjkNTwSU31ccXAjryhXKF+CO/ZKec",
      "6+kwuv4GWLZQXGkRLbgNr8kwoYhs07bzJybaVprN4+q+ShLP268cwAX/S2QIEUnZnJOD/Ul7wqn62hdg4fW",
      "XsGO23/mgl2ia2AOGUnMpPYNBb07LMkKG3695NRXEXNPGNhX9jIU+LOyNoKQnVoB59RTMbL4X6UpVUZxTiq",
      "q3H0zI8JsT69XgZnNFwrg4a7V/6ikKIXkADiMEP3H/jx5bOp1TuWbOfKQQJubgzR3C8Qm/iihUXK8b2Y/g+",
      "5vPkU7AFowzAo7zseqtOWqpXU3k8zRVojAcJl+v2kPZ7uo4CrZDLxF3q1r1nPiaSNx45KCFYfaARTmNkyUk",
      "pr9xhNPGPL3Kd+jFsTkWBn8uQxYPbA+fE+baV2TXU3EFnQSheoJK6GlVneAYfWBT3Aw2M6YoecqwxK9yzKM",
      "JrPlQMtpC9hA1lZirmyAJOo4gwQBInlwjF0wJmQn153/5WnJH/+uyZmA2ut6+iU1M24PjdW03GFVC7yvsLF",
      "4r9Qe/FNiRAH7sntPcQdBigcYlZoXqA9zU37wKTXNCt2+DUhw2rbSpOprLcP409cvFsHDFp58mdZCp6alvB",
      "mcQ5POzl3mD+F6x6ir7sRq5PE7AkU7osWqCG9kIIiAoK+mgheY0W/bd9/Wcf1iTb5yVCrbE7crETytfr12B",
      "Al0OQmwPGNE9abMcORaBvfXw8n7GPDoIrFshwJMlo2RkwmCrKHlNch8clrV9YNQe14XX14JKb6uOLgRp11P",
      "2x0a3RQNcI5CO0irtjQk6CeIas6zv9hCyV0MYf1GjCSs7i4E+OhhVxS3wX8gkTUxcQTjGiUayZuf0YW1a+O",
      "d/fpip9BuR1N87yJbAps+BxqKkXlnnrX7sGREH8jQTK/WAfc9rdXiQqW5rtLWDZsWw9wd8LMIEOppMsiWHE",
      "bpvg9Xe7R5Q14VT5bQ+0cPp0Ep82PZIgosvYMdtr+NRNXp5XgFnehBewSWwFxyk5kCUPCl71D2nImsWks6N",
      "lnScPg8LokUPNfUNr07yejuIq1i2156yosnJp5xsK+sJGnfyhfVHI5BbHEnZG1FYTq0CHMCCPZDX7GDj6jm",
      "IyXw/3rbzoOQB5X60PYPGrZV41jpoml/BXeGXWJew5HQESkTmwql9GMzTBY159ZMOtw3zkyzsCmJ/lLLx08",
      "ax1yY/YU+G3yi77qYgJrV/bevRkp144Gb0hxkL3BofTE8yQKAPpEpV1l6IOU7P8Qk4SPPnuNGkEKEkO375s",
      "1s6GpFi1SoNDiOD/apMa2ieimpUxUoMdsuT8zgN000UNLlIjVR4nqphoNHhnOHfwdr8P/fnPynfj+Wmmy+m",
      "aL1wzx0udg27AyXWhEK+lPpqFnbBEoGgRzRDb1h+STkGVrxF48sQktXo6Vx6p9gLlINSAJSxo9VinQcZDd1",
      "rTCP/+DO2aDLn8EGtKi8E+n6xKyZaSU1u4xmlc0PQIaZ6WMeMaWuU/9GLedlw8vg3SMoSYiwc7kyWPAw3NY",
      "WChA99bsgfPjfdpK7QnQanWxU977mupuILKglS5/u/e2fikBOFBJXA0rs7wDtRjFm+c6KBUOrQt6gIfHdOv",
      "8kuxMDlNixA45VxmU7lkhX6DB1R16T//yo8d4IYN8GqM6UbSoF2o1UZHq4TKqUdAACHwtuz5Ha7XGnUoG0S",
      "aO5F8Lho9FMKEW9LDTFfgLREdtJh+cbB3XfWlzHG8nyDIs8OXQ5rPeHd5bXoV8DuX4j8LISfWa80M6DCkuS",
      "HWSpmuVv+LB4YSJmT4Et1tcv2zIp5J70sipxH+h9uKbEiEhLjhgLhKGNw7ck9t7iDsM640KTbcBrxpQOMSs",
      "0LxAe7VpXTocNdRtmpv2gUmvaVZ/ym8XhSb9QOzwa0KG1baVCaHy1EpcIoMmU1lvH8afuMMCwPnTTwuueLc",
      "OGLTy5M+d5peOeHtw2bIUPDUt4c3iV0Wlo+FoWfQAAAAAAAAAAH+du6PRNu0K/jp3R6Nt2hWBp8zkcls3H/",
      "x17o5G27Qrg+hVLZftWSECT5nJ5bZuPn3SImo0gIM0+OvcHY22aVeHdme+XICEXQbRq1ou27NCeUwQ+f/tX",
      "kgEnjKTy23dfHsDiTAaWzB2+qRF1GgAB2mFOf53uTbqY/DXuTsabdOuj0oCmMtbPqQO7c58uQAJu3Fwdd9o",
      "NuSxDKJXtVy2Z4VzP+wWjYCKj/KYIPL/272QjQWbUS7tUJoIPGUml9u6+Xeh3oVG7Vfz9gYSYTS2YOyJm6n",
      "C5YCN5vRJi6jRAA7Si9QwCwA249gKc/zvcm3Ux3XuR0yjWznNizzkL2f8f2n0oV+MtsqSY3UGk2jEkaV8Cp",
      "soyxWnSHZ3SQqhISfLQgjUsQLwESZIiXN95oJKEVf27sZFU3z8XXPXODLqShY+DEqDkTt8+zSN7U91SSfMK",
      "/Jw9NaYESEhj6LWvKyRohXwP20ffadPH3GYofsP/HgADgUaWN7KlQp7610UfZGsxwR25resp0HNhdEqU978",
      "dtL6TJHwD8qb2Iees5o7Shjs+AMIOep89eZ5pMTdmCfC+QY5f35JES/zgwCBCfAnxZD8nTqqIREomn069k5",
      "TSh+FAqdN7YJ88o9/dW+HtvxxuwDo1CRnypyxgU8YwBWRq67+0qNjxKdGpBZ5yF/O+P/SaeRz/B/OEtjoQ7",
      "8YbZUlx5feBLu8o8jN6gwm0YgjS/mVkZ1yWRWm8xQ2UZYrTpHsa6vqNfp4fObukhRCQ06WhZEPr+GSeHuPE",
      "KhjBeAjTJBvNdimMRWhmhLn+swFlSKubXpBb9Sjz6Ts3Y2Lpvj4u5NANih3zhWx5q5xZNSVLHyZM8rHBaPB",
      "dhiUBiN3+PZpZwm9gKbOG2Ma25/qkk6YV2VGJElDeHVd5OHorTEjQkKbfFMO4BWvSB5FrXlZI0UrYdgW2og",
      "VqCHgf9o++k6fPp/iYZ0reHI04jBD9x/48QCdrfhUzs4cChwKNLC8lSsVY5ePE22jxh+dRSxwqQSAu+LYl9",
      "N4Mm2xY39bNwppWq4c4uCU21+3pGEwwv7v3zSQHq15XT7p2ZqfCrW5TLLuheCXDhqdhAOPZa7wbSSy6ewaM",
      "0vO9YQE5puUhyqH3zP55Ak8iVbp3vOZ2x7jYmldx+ZGpUCzX7DNZ+FppMEEh9IYfNIHEDJq2G2SlUuzaVMV",
      "Eg8u6GJfvh+TqOIMEASJAOw1Wa/BMmQKked7xfWy5z7uesBmJIQKNG/dDIJW3z0rEEC3IYfp0CGVeUlWPt8",
      "6Qurk8vXv6ddIa0M+EZ2y4FcU3oWyTIQNXWkMp9h4BI5pFpEce6kyY2OXNtCf22lUfOirazwKX7l2R2EH58",
      "/XJpE4/LxEHuHLm7lbcKBsuvyExsbLA72MEY67FOlpiQySusSJUspYOn+wRS6eLiphSK86syWN+1elpb+K2",
      "/pCYU/GwBdgWZNXosxBsKy94QyV0z4tFx4wOnjZQ/81dAS6++08Yo7X1YwW573FQjOn1yH4wlj5kHbhzPK3",
      "tr7c1br1P8grBX8EjBg1SYzJm3bXLyo2EXI4p+HCIEvDUFKTYUEUNF7r8UJXrB61+ScVMAybAcpknLbhOnY",
      "LT11iwVgMnGgwwNliiTpxYrFnFYb7YUZ9zvquJSpXq3ezKIxPHtcoQ8y1N+zP4cVJTRL7CL268lYyj0CrbI",
      "wfXMxd48ioK1n4s8BYa3kdtPIyZ5SPC0aD7U36LyzacG7nMCgNRu7w7dNPtbblP8YA2c4SegFNnTfGsY/Bo",
      "pyr2sw0tj/VJZ0wr0srhHb0q92lyoxIkobw6rq1EfMxV8YHsMjD0VtjRoSEt15q+LJwaY42+aYcwCtekUlk",
      "Hb8RHbObPIpa87JGilZDF+FQY3BnXMKwLbQRK1BDvS2WF8AdvUnA/7R99J0+fb9iD94lq9N3PsXDOlfw5Gh",
      "BWHiZhsYJYsRhhu4/8OMBu/w9Te7GDgs6W/GpnJ05FEXGSgpNq9QeOBRoYHkrVypHidPDqB26IMYuHyfaRo",
      "0/ubOkhAtwYDVRGM+4AS/ZQy6FdBvQGTRJryK4/6JCA1bQvwNcc3TuXK1tITZH9G1o0vCalZbCgGJTV1Zx5",
      "Jm3fSzK7dI1r1p3qfMTpYyZsBTWbqgGXa9dHlfJZOIv9GoBKFTfQf7ChwtVhv0rykIEPyobRogbdOk1q7yK",
      "bGkv3irUITHPuBkzIKHPdoMbQgrt3lLNIMp05+df9QHEuC/Q+CBoumdpGT3yXbqYDV2ZvsYiJyOujK9TzKO",
      "A70r+9GTT3B1U6S/CidlZJKqelvRjuia5ET1Hwo6wpx7d2TWZua/Yg2Z65K9UpaVRRBDQL9eR2sz/swEZOp",
      "tbazNXc0INhCT2iPSidOCO2iQrl2bTpiqluZA0t+VLICQeXNDFvnw/W4PncxSIkTUmUcUZIAgSAVnMfrrxP",
      "v8L2GuyXoNlyBSn9gn9UlMlHiLP94rrZc99XVJMKTpTInfc9YDNSAgVaKNoO26ZPvhi3roZBK2+e1ahJ6Kn",
      "fIiWXCCAbkMO06FDXx3V4N/lTEkq85KsfL51hFVuKQ+tiJiO1Mnl69/Tr5GrVF5IDuVCm9aGfCI6ZcGvqRv",
      "HgetTLKUovAtlmQgbulchsMZIPvaw0hhOsfEIHNOthfUSID7x2SwiOfZSZcbGU7+CVYNTK8wubaA/t9Oo+F",
      "HwG5xm5UXy0FfXeBS+cu2vymzbxYif5wAAAAAAAAAAAPUEklguvLBreZ584nqhVWuMmu66VB3l1vI8+cT1Q",
      "qvWBzhrnNv+G72LooUmj+P+vX6mF36hX07Hdu6q2s1cYseD6jiC4+DSrA9w1ji3/Tes+nREYJlBhxGE0lMe",
      "OB7JEXHWwUYWonl6/Uwv/EK/nHoISL2kbAMsju3cVbWbucSOGNjH7bUFdOWUQilX4RiR5WFGuw/PpCFYH+C",
      "scW77b1jq5D4pQEffM2Z+0JMUWjozk3pCyzrmikmbMv9vVuWmSW42bTd4WRYi4qyDjSxE8yIXqBHVAvhDn2",
      "kOBqujpw2fnAqU840bvfQQkHpJ2QZY9OWU6BH3uuh3SC7zORGqvXe9KmFhPxYNHDGwj9trC+gcxLQdg0W3W",
      "KG6Egr95OgWoU8WmKXKVKbKw4x2H55JQ8o2iORHsPXzsD7AWePc9t+wy8TLu/JKb9tHXiUBpleK27Jat1mI",
      "6zpmzPygJym0dGY5+DJ/BwjEDbVi3MVTFSENQGZOnX2pkfml8qaMihN5+VD2NNSkr8mS3GzabvCyLJIpaEg",
      "23g6cL1fOX0h/UdIvosrNEFHtYkQuUCOqBfCHRNtUsfIrTDc+0xwMVkdPGz4mGJ4OafOrVaqCcLQ97k5VX4",
      "bi7BNS/ughIPWSsg2w6NQkZ8qcsQCDWL6JcMis5YOtuhso5hBVhQPLviAEjU+F9s8seCox/+56VcLCfiwa7",
      "o9RUJpQkKpT8fdH5PHP5FME89W833NUOIhpOwaLbrE4fW2pXqXSAUJ1JRT6ydEtQoAhhqLnbZ0pDLtoGLNw",
      "eCn5v/pAnczIlIcZ7T48k4aUch1/ZhIvNv/+h5HcRjLT/wuDA4RojmML7hfrlZ80iwsbE3nNsYg7YJeJl3f",
      "lld5gYo0FL8spbt0cKxJRanYg3ekvgAlEypC2ZbVusxDXdbaQsfzrPmvFzJj5QU9SaOnMbf3TF3zUWafhZz",
      "2tKMm8pxRjr/UGdQwaasW4i6cqQhqfwSrTiZbycRNbxGndixdx5l9WMfM3p/JL5U0ZFSfy8r7h30E7m0KZM",
      "nsx+2+Gp5nHf6OjQToXJLnZtN3gZVkkTN0mhc7Z6U/AR8g/msQMTzVDWme0eLw1PQvnw9h7kDXID3Wb9scg",
      "XkSVmyGi2sVesZEJeYxmdePPNx4HLTk74zozjF8DhYuItqli5VeYbohDrfC9eSTefKY5GKyOnjZ8Uz2K9KA",
      "ihhffp2RO9D9jFyqj9hbag9OqVAXhaHvcnaqhAXMwVWAtwS2bnYoBfcjB2J8P0i/BeLvQ17J2Q8JUuyXTIC",
      "5tfuTQqUnOlDljAdBcTVzMF9+xbSLrS7K2gP9t1+/Z6pg8TwZbdTdQzCGqBq5xpQjinRoKB5Z9QQganwryk",
      "u8ZJqYvYX4IAaNyu8phiwyT+1wHetz1qoSF/Vg03ACuFt3T5IS3jDT4Z4f5Ybd5MGo/qUXRzXF415vFRv3N",
      "hHxFw+v6TaYI5qt5v+eopv3iOSGRWxgbg0QuXzAEVht2QLwHHrjmcPraUr1KpQNwD97A5WQZs4TqSij0k6N",
      "bhB9Ouqy9H+vvk9RUFukCDu9m0MZOx76+Uhh20TBm4fBS7XJDaEhdQDlh6K3SHEClOZTsP4oy/BVDnKSCLl",
      "7/OUNpoBB2cEOJKOU6/swkXmwoED5slAri3JVumHvqq72SlZuc6bKFASL+FwYHCNEcx/7iApVQ/6B3fU+4j",
      "ngZsCJ9urwcIDcMkhY2JvKaYxF3FsMiYMJNrcervYR3vOzyiatIgOXkwk45wMQaC16WU9zAMR6ZBrjvbLo5",
      "ViSi1OxAusxStvr6UPDRQMhYQK5NFdG1zMoYgPGlbMtq3WYhrutsPm5PPg8SWwey9KGEWw++B0fwM9x1sw7",
      "zomTbzYIJ5vNXYEmVrLVWmNv6py/4qLOYLv41d9YUAyVQWCIJd0tNJaVcsFFZ9/1OKcZe6w3qGE7cwsyzI1",
      "aoNNSKcRdPVYQ0IY7jT2HpNF+tFA31NfTRX1gQn60bSGHiJraI07oXL+LTshqLlKufiV8o9DHAtnqJqixma",
      "e4Kyo8EXcNhDJfQj/FZUTkiK2DkfcO/g3Y2heSIxy3bWIo1WfZhOqX51XtZA2Wo/ddpyzKP/0ZHg3QuMnr7",
      "1B+tyJ5IcrNpu8HLskiHt/vj73cCIwstFVm7aucj/imHAZXWV56Aj5B/NIkZnnWLAicaNan1+RHsnU4oTPU",
      "MFX7FYJT8AemBltSXLhQBHIUEjLmSpGqQH+o27Y9BamUbeG7DM/HXG71vEGJsv9fuuf1ITNAPvGIjE/IYze",
      "q8lyeBqjZxWsafbzwOWnJ2xmprrlZ0zsat5vFA7CDTI60T9dK0Dm+TEG1TxcqvMN0QmFdXkoGMbXsUzbko1",
      "ZGIe+HJK3D7LTj4THMwWB09bfi5d6IAM4HdkzXtTLpnnDiTwOne4kkgiC6+T8mc6H/GLktLW8TGw3ZFx9G1",
      "fpLek0Uy1ScmvGIjPzqdmoLQYQ8/z5kI2v7dv1RDA+ZgqsBaVLYHdDiEfOrpyKFjRiUjpOk9pfEeC58UgrE",
      "/H6RfgvGCRDuN/HE+QXahr2XthoSpdlSr97WoOBkd2DEZD/wl/B0tNYtX0plMoFOTnClzxgKgppcOcV16ss",
      "sqDeDLCWdXy98JcpMn2+ex10HPN0vYy7EiRV1vZWR72q7fs9UxeZ7aW9shjR/FLmclfTbzvppgZ9B5pKuQJ",
      "tAMXONKEcQ7NQyp59hJ6oeFAAAAAAAAAAB5iTUwyPBuf/ISa2CQ4d3+i5teUFgRs4GPtkGYc+ViyfY/dKi7",
      "FQy2faQq+OMEvzcELR/IK/TRSHX+FGi07BymDHchWHwcctmH7H8IJA3BWP5lSjjs/a8n+khV8McJfm+DwWD",
      "AD/kQEAhaPpBX6KORcdMLoJ8Yze6Bb76IO//gePjmi7jzD44Hc33V6KsePYYK9ODYY+5T+Q7Z/xBIGoKxd1",
      "DKIIDq7M78y5Rw2PtfT4VCoUAQCzEw9JGq4I8T/N6NGJ/QR+OSoQaDwYAf8iEgfwr0sNcCT197J+t4/PaeF",
      "wKu3kg0BvBoiTWAGGwXQ+nwvLUopOctlgLffBF3/sHxe1ZJIb8Or47wzRdx5x8cD4lEIkEv73JwjWk9iQQb",
      "ozj04Ai5zOvNR397VumU+n7GBvJj2VwKELl3IWh5wxLdVw6oXUkL4rMohTMDGVPzAKn8ujYpmwNu1viXKeG",
      "w97+egR4c0XgH0eEKhUKBIBZiYHMMd7Ho5gwfg7DCmUwBIYn6OfephPFP9nGiqfnc4Px3CCucyRQQkggMBo",
      "MBP+RDQHWPtjH3FC0//hToYa8Fnr6Hnd1RZ/XwwfZO1vH47T0vj8fjwTAdU1AEXL2RaAzg0X3ViKGg/I6ue",
      "fiXaYsIX+YAcaJZQ/gxmYvq/Akb6YIY8mPJOdMZ7GdvLW56vdpa1xakW0p1KjSonT8FGi07hynktjAq5cvp",
      "VuCbL+LOPzgemRIa0gbPVmESiUSCXt7l4GsAcbKWLoufGtN6Egk2RnFjWk8iwcYoDujBEXKZ15uPkUgkQlE",
      "n9fCVZTuKetMkuOzsDrqyI0rHZ3dQ6uoy+UYe/mXaIsKXOe5C0PKGJbqvl8vlwk7V1NAcULuSFsRnUWXZjq",
      "LeNAkuYfSRavXA2GYYfaRaPTC2GZPm+gplIQWY6m/POq3Ra+ebvMSaMsmmCeI18ar6Och2aa6v+qIoe/cQJ",
      "5rKatgViBQKhQJBLMTAbYOwMoncqr/mGO5i0c0ZPp+R21IZPXdBbfISa8okmyYUeydbAtT1WZ/geQtaxUbY",
      "5mlMO5I1KKfiRFPzucH575vNZsNxMZeQEFY4kykgJBFp3w2j4dBKbhgMBgN+yIeAYYUzM7Y46f/qHm1j7il",
      "afpOXWFMm2TQBl7pHmw0t5UnuM3Krxd2LNmWoLPudzDi3HCEZy1U8Vsjsnazj8dt7XpUUmdM5KxUhHo/Hg2",
      "E6pqBnBvKzqcrI32Mr7XuCPhmXGqLYS0rOd+iROYYbEt/EaeiwsyvaL6oWmWO4i0U3Z/jg6o27jccJh2tx0",
      "+vV1roGEvjm2x0m1HkW1fkTNtIFMW9czCP+ImtO5MeSc6Yz2M+dTqdDbsO2sLXJS6wpk2yazEB+nOFjAuVH",
      "2yDMuXKxZD5SFfxxgt8bOn8KNFp2DlND9j8EkoZgLMhtYVTKl9OtseRUZAJnvdLAN1/EnX9wPLm+avRVjx5",
      "DMiU0pA2ercJLrAGUxW7DvU+BHlzumhL1NggrbCZqfIq9k3U8fnvPC8QaQAy2i6F0NKb1JBJsjOJNL8AU2p",
      "zinca0nkSCjVEcvz2rdEp9P2O7ELS8YYnuK8KZgYypeYBUSQLf3PFoM9Uwi+rsOZhdqkFY4UymgJBEONHUf",
      "G5w/juzSoosNmFNusrDvxz+kSPFzu6g1NVl8o23Z5XkHZWc8jz8y7RFhC9zRXX+hI10QQy3Fje9Xm2ta86f",
      "Ao2WncMURQRc3c6McJU8jWntBnwe6jigdiUtiM+iQSlDFeV4od3Ksh1FvWkSXLM7KHV1mXwjwugj1eqBsc2",
      "7YRblInHfsjD6SLV6YGwzSXN9hbKQAkxNXmJNmWTTBDTXV31RlL17v0wJLQmFDvrGxTwdwXVghTZ5iTVlkk",
      "0TT/C8Ba1iI2zEa+JV9XOQ7b3i12U9g/6Suc/IrRZ3L9rARv2d3odBpUvdo82GlvIkMlSW/U5mnFtDh51d0",
      "X5RtToOqG0Zjj/KsZX2PUGfjEvIHMMNiW/iNMwx3MWimzN8tbjp9WprXQM+I7elMnrugkeqgpX6ioD92uQl",
      "1pRJNk2jbRDmXLlYMij2TrYEqOuzUX97hsxYhcxVUmRO56xUhCzbUX4vXDr7p0APLndNiXreyToev73nBa8",
      "aMb4gpSrr1pMEjuhVRJRdCFresET3FSSBb+54tJlqIKxwJlNASCJZJUUWm7AmXdK+G0bDoZXcqzcudgtR+6",
      "Nbi5ter7bWNSICrm5nRrhKqZnwPj9XC8vQEMUO96dltNQ92sbcU7T8rbTv9hSj2oMmL7GmTLJpAl+mhJaEQ",
      "gd9LnWPNhtaypNX/LoG06qk7Nxn5FaLuxdtpe7RZkNLeRKhw86uaL+oWthK+56gT8YlU9GlzvhedaQqWJD+",
      "MK4b29g7Wcfjt/e8obJs9ytHmcMqKTKnc1YqQlOgB5e7pkQ9V40YX5BSlXUuBC1vWKL7CqWfcz8As0iL3BZ",
      "GD8hDJvStxU2vV1vrGtRMeJ+fq4VlX9cmz8e6NuQmXhP/D0pYmyJzDDckvonTW/o5B+xO56zQYWdXtF9ULa",
      "noUmd8rzpSWVTnT9hIF8Qg3dJ/ELh5u6tGjC9Iqco60s+5H4BZpEXW4qbXq611Da9rk+djXRtyJPDNtztMq",
      "PNdefiH87zGjCyq8ydspAtiVSPGF6RUZR3euJhH/EXWnKcxrXc0tbjjoxyyvx9BaavalYeP17EH1FEO2d+P",
      "oLRVKIfs70dQ2ioAQYCQwQILnAEgS1AAAAAAAAUAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
      "AAAIAAAADAAAAEEtQAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAD//////////wAAAAAAAAAAAAAAAA",
      "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhIUAAAQZyRwQILFCRpb",
      "nRBcnJheUZyb21TdHJpbmcAAEGwkcECC2Ioc2l6ZV90IGlkeCwgc2l6ZV90IHNpemUpPDo6PnsgdGhyb3cg",
      "J0FycmF5IGluZGV4ICcgKyBpZHggKyAnIG91dCBvZiBib3VuZHM6IFswLCcgKyBzaXplICsgJyknOyB9AA=="
    ].join("");
    function Yc(p) {
      for (var x = window.atob(p), H = x.length, J = new Uint8Array(H), j = 0; j < H; j++)
        J[j] = x.charCodeAt(j);
      return J;
    }
    function Kc(p) {
      return typeof Buffer == "function" ? Buffer.from(yn, "base64") : Yc(yn);
    }
    function Jc() {
      return Promise.resolve().then(function() {
        return Kc();
      });
    }
    function Xc() {
      var p = {
        env: hn,
        wasi_snapshot_preview1: hn
      };
      function x(ne, ie) {
        var Ue = ne.exports;
        e.asm = Ue, f = e.asm.memory, h(f, "memory not found in wasm exports"), Le(f.buffer), dn = e.asm.__indirect_function_table, h(dn, "table not found in wasm exports"), Lc(e.asm.__wasm_call_ctors), Oc("wasm-instantiate");
      }
      qc("wasm-instantiate");
      var H = e;
      function J(ne) {
        h(e === H, "the Module object should not be replaced during async compilation - perhaps the order of HTML elements is wrong?"), H = null, x(ne.instance);
      }
      function j(ne) {
        return Jc().then(function(ie) {
          return WebAssembly.instantiate(ie, p);
        }).then(function(ie) {
          return ie;
        }).then(ne, function(ie) {
          g("failed to asynchronously prepare wasm: " + ie), Gc(dt) && g("warning: Loading from a file URI (" + dt + ") is not supported in most browsers. See https://emscripten.org/docs/getting_started/FAQ.html#how-do-i-run-a-local-webserver-for-testing-why-does-my-program-stall-in-downloading-or-preparing"), he(ie);
        });
      }
      function pe() {
        return j(J);
      }
      if (e.instantiateWasm)
        try {
          var Z = e.instantiateWasm(p, x);
          return Z;
        } catch (ne) {
          g("Module.instantiateWasm callback failed with error: " + ne), n(ne);
        }
      return pe().catch(n), {};
    }
    function Wc(p, x) {
      throw "Array index " + p + " out of bounds: [0," + x + ")";
    }
    function jc(p) {
      this.name = "ExitStatus", this.message = "Program terminated with exit(" + p + ")", this.status = p;
    }
    function ra(p) {
      for (; p.length > 0; )
        p.shift()(e);
    }
    function hr(p) {
      return "0x" + p.toString(16).padStart(8, "0");
    }
    function pt(p) {
      pt.shown || (pt.shown = {}), pt.shown[p] || (pt.shown[p] = 1, m && (p = "warning: " + p), g(p));
    }
    function Zc() {
      he("native code called abort()");
    }
    function Vc() {
      return 2147483648;
    }
    function $c(p) {
      try {
        return f.grow(p - _.byteLength + 65535 >>> 16), Le(f.buffer), 1;
      } catch (x) {
        g("emscripten_realloc_buffer: Attempted to grow heap from " + _.byteLength + " bytes to " + p + " bytes, but got error: " + x);
      }
    }
    function el(p) {
      var x = k.length;
      p = p >>> 0, h(p > x);
      var H = Vc();
      if (p > H)
        return g("Cannot enlarge memory, asked to go up to " + p + " bytes, but the limit is " + H + " bytes!"), !1;
      let J = (ie, Ue) => ie + (Ue - ie % Ue) % Ue;
      for (var j = 1; j <= 4; j *= 2) {
        var pe = x * (1 + 0.2 / j);
        pe = Math.min(pe, p + 100663296);
        var Z = Math.min(H, J(Math.max(p, pe), 65536)), ne = $c(Z);
        if (ne)
          return !0;
      }
      return g("Failed to grow the heap from " + x + " bytes to " + Z + " bytes, not enough memory!"), !1;
    }
    function tl(p) {
      he("fd_close called without SYSCALLS_REQUIRE_FILESYSTEM");
    }
    function rl(p, x, H, J, j) {
      return 70;
    }
    var al = [null, [], []];
    function nl(p, x) {
      var H = al[p];
      h(H), x === 0 || x === 10 ? ((p === 1 ? A : g)(Q(H, 0)), H.length = 0) : H.push(x);
    }
    function il(p, x, H, J) {
      for (var j = 0, pe = 0; pe < H; pe++) {
        var Z = W[x >> 2], ne = W[x + 4 >> 2];
        x += 8;
        for (var ie = 0; ie < ne; ie++)
          nl(p, k[Z + ie]);
        j += ne;
      }
      return W[J >> 2] = j, 0;
    }
    function sl() {
      R("fetchSettings");
    }
    var hn = {
      abort: Zc,
      array_bounds_check_error: Wc,
      emscripten_resize_heap: el,
      fd_close: tl,
      fd_seek: rl,
      fd_write: il
    };
    Xc(), e.___wasm_call_ctors = le("__wasm_call_ctors");
    var ol = e._emscripten_bind_VoidPtr___destroy___0 = le("emscripten_bind_VoidPtr___destroy___0"), ml = e._emscripten_bind_Crc64Hash_Crc64Hash_0 = le("emscripten_bind_Crc64Hash_Crc64Hash_0"), cl = e._emscripten_bind_Crc64Hash_OnAppend_2 = le("emscripten_bind_Crc64Hash_OnAppend_2"), ll = e._emscripten_bind_Crc64Hash_OnFinal_3 = le("emscripten_bind_Crc64Hash_OnFinal_3"), dl = e._emscripten_bind_Crc64Hash___destroy___0 = le("emscripten_bind_Crc64Hash___destroy___0");
    e.___errno_location = le("__errno_location"), e._fflush = le("fflush"), e._malloc = le("malloc"), e._free = le("free");
    var fn = e._emscripten_stack_init = function() {
      return (fn = e._emscripten_stack_init = e.asm.emscripten_stack_init).apply(null, arguments);
    };
    e._emscripten_stack_get_free = function() {
      return (e._emscripten_stack_get_free = e.asm.emscripten_stack_get_free).apply(null, arguments);
    }, e._emscripten_stack_get_base = function() {
      return (e._emscripten_stack_get_base = e.asm.emscripten_stack_get_base).apply(null, arguments);
    };
    var aa = e._emscripten_stack_get_end = function() {
      return (aa = e._emscripten_stack_get_end = e.asm.emscripten_stack_get_end).apply(null, arguments);
    };
    e.stackSave = le("stackSave"), e.stackRestore = le("stackRestore"), e.stackAlloc = le("stackAlloc"), e._emscripten_stack_get_current = function() {
      return (e._emscripten_stack_get_current = e.asm.emscripten_stack_get_current).apply(null, arguments);
    }, e.dynCall_jiji = le("dynCall_jiji"), e.___start_em_js = 5261488, e.___stop_em_js = 5261586;
    var pl = [
      "run",
      "UTF8ArrayToString",
      "UTF8ToString",
      "stringToUTF8Array",
      "stringToUTF8",
      "lengthBytesUTF8",
      "addOnPreRun",
      "addOnInit",
      "addOnPreMain",
      "addOnExit",
      "addOnPostRun",
      "addRunDependency",
      "removeRunDependency",
      "FS_createFolder",
      "FS_createPath",
      "FS_createDataFile",
      "FS_createPreloadedFile",
      "FS_createLazyFile",
      "FS_createLink",
      "FS_createDevice",
      "FS_unlink",
      "getLEB",
      "getFunctionTables",
      "alignFunctionTables",
      "registerFunctions",
      "prettyPrint",
      "getCompilerSetting",
      "out",
      "err",
      "callMain",
      "abort",
      "keepRuntimeAlive",
      "wasmMemory",
      "stackAlloc",
      "stackSave",
      "stackRestore",
      "getTempRet0",
      "setTempRet0",
      "writeStackCookie",
      "checkStackCookie",
      "ptrToString",
      "zeroMemory",
      "stringToNewUTF8",
      "exitJS",
      "getHeapMax",
      "emscripten_realloc_buffer",
      "ENV",
      "ERRNO_CODES",
      "ERRNO_MESSAGES",
      "setErrNo",
      "inetPton4",
      "inetNtop4",
      "inetPton6",
      "inetNtop6",
      "readSockaddr",
      "writeSockaddr",
      "DNS",
      "getHostByName",
      "Protocols",
      "Sockets",
      "getRandomDevice",
      "warnOnce",
      "traverseStack",
      "UNWIND_CACHE",
      "convertPCtoSourceLocation",
      "readEmAsmArgsArray",
      "readEmAsmArgs",
      "runEmAsmFunction",
      "runMainThreadEmAsm",
      "jstoi_q",
      "jstoi_s",
      "getExecutableName",
      "listenOnce",
      "autoResumeAudioContext",
      "dynCallLegacy",
      "getDynCaller",
      "dynCall",
      "handleException",
      "runtimeKeepalivePush",
      "runtimeKeepalivePop",
      "callUserCallback",
      "maybeExit",
      "safeSetTimeout",
      "asmjsMangle",
      "asyncLoad",
      "alignMemory",
      "mmapAlloc",
      "writeI53ToI64",
      "writeI53ToI64Clamped",
      "writeI53ToI64Signaling",
      "writeI53ToU64Clamped",
      "writeI53ToU64Signaling",
      "readI53FromI64",
      "readI53FromU64",
      "convertI32PairToI53",
      "convertI32PairToI53Checked",
      "convertU32PairToI53",
      "getCFunc",
      "ccall",
      "cwrap",
      "uleb128Encode",
      "sigToWasmTypes",
      "generateFuncType",
      "convertJsFunctionToWasm",
      "freeTableIndexes",
      "functionsInTableMap",
      "getEmptyTableSlot",
      "updateTableMap",
      "addFunction",
      "removeFunction",
      "reallyNegative",
      "unSign",
      "strLen",
      "reSign",
      "formatString",
      "setValue",
      "getValue",
      "PATH",
      "PATH_FS",
      "intArrayFromString",
      "intArrayToString",
      "AsciiToString",
      "stringToAscii",
      "UTF16Decoder",
      "UTF16ToString",
      "stringToUTF16",
      "lengthBytesUTF16",
      "UTF32ToString",
      "stringToUTF32",
      "lengthBytesUTF32",
      "allocateUTF8",
      "allocateUTF8OnStack",
      "writeStringToMemory",
      "writeArrayToMemory",
      "writeAsciiToMemory",
      "SYSCALLS",
      "getSocketFromFD",
      "getSocketAddress",
      "JSEvents",
      "registerKeyEventCallback",
      "specialHTMLTargets",
      "maybeCStringToJsString",
      "findEventTarget",
      "findCanvasEventTarget",
      "getBoundingClientRect",
      "fillMouseEventData",
      "registerMouseEventCallback",
      "registerWheelEventCallback",
      "registerUiEventCallback",
      "registerFocusEventCallback",
      "fillDeviceOrientationEventData",
      "registerDeviceOrientationEventCallback",
      "fillDeviceMotionEventData",
      "registerDeviceMotionEventCallback",
      "screenOrientation",
      "fillOrientationChangeEventData",
      "registerOrientationChangeEventCallback",
      "fillFullscreenChangeEventData",
      "registerFullscreenChangeEventCallback",
      "JSEvents_requestFullscreen",
      "JSEvents_resizeCanvasForFullscreen",
      "registerRestoreOldStyle",
      "hideEverythingExceptGivenElement",
      "restoreHiddenElements",
      "setLetterbox",
      "currentFullscreenStrategy",
      "restoreOldWindowedStyle",
      "softFullscreenResizeWebGLRenderTarget",
      "doRequestFullscreen",
      "fillPointerlockChangeEventData",
      "registerPointerlockChangeEventCallback",
      "registerPointerlockErrorEventCallback",
      "requestPointerLock",
      "fillVisibilityChangeEventData",
      "registerVisibilityChangeEventCallback",
      "registerTouchEventCallback",
      "fillGamepadEventData",
      "registerGamepadEventCallback",
      "registerBeforeUnloadEventCallback",
      "fillBatteryEventData",
      "battery",
      "registerBatteryEventCallback",
      "setCanvasElementSize",
      "getCanvasElementSize",
      "demangle",
      "demangleAll",
      "jsStackTrace",
      "stackTrace",
      "ExitStatus",
      "getEnvStrings",
      "checkWasiClock",
      "flush_NO_FILESYSTEM",
      "dlopenMissingError",
      "createDyncallWrapper",
      "setImmediateWrapped",
      "clearImmediateWrapped",
      "polyfillSetImmediate",
      "uncaughtExceptionCount",
      "exceptionLast",
      "exceptionCaught",
      "ExceptionInfo",
      "exception_addRef",
      "exception_decRef",
      "Browser",
      "setMainLoop",
      "wget",
      "FS",
      "MEMFS",
      "TTY",
      "PIPEFS",
      "SOCKFS",
      "_setNetworkCallback",
      "tempFixedLengthArray",
      "miniTempWebGLFloatBuffers",
      "heapObjectForWebGLType",
      "heapAccessShiftForWebGLHeap",
      "GL",
      "emscriptenWebGLGet",
      "computeUnpackAlignedImageSize",
      "emscriptenWebGLGetTexPixelData",
      "emscriptenWebGLGetUniform",
      "webglGetUniformLocation",
      "webglPrepareUniformLocationsBeforeFirstUse",
      "webglGetLeftBracePos",
      "emscriptenWebGLGetVertexAttrib",
      "writeGLArray",
      "AL",
      "SDL_unicode",
      "SDL_ttfContext",
      "SDL_audio",
      "SDL",
      "SDL_gfx",
      "GLUT",
      "EGL",
      "GLFW_Window",
      "GLFW",
      "GLEW",
      "IDBStore",
      "runAndAbortIfError",
      "ALLOC_NORMAL",
      "ALLOC_STACK",
      "allocate"
    ];
    pl.forEach(v);
    var ul = [
      "zeroMemory",
      "stringToNewUTF8",
      "exitJS",
      "setErrNo",
      "inetPton4",
      "inetNtop4",
      "inetPton6",
      "inetNtop6",
      "readSockaddr",
      "writeSockaddr",
      "getHostByName",
      "getRandomDevice",
      "traverseStack",
      "convertPCtoSourceLocation",
      "readEmAsmArgs",
      "runEmAsmFunction",
      "runMainThreadEmAsm",
      "jstoi_q",
      "jstoi_s",
      "getExecutableName",
      "listenOnce",
      "autoResumeAudioContext",
      "dynCallLegacy",
      "getDynCaller",
      "dynCall",
      "handleException",
      "runtimeKeepalivePush",
      "runtimeKeepalivePop",
      "callUserCallback",
      "maybeExit",
      "safeSetTimeout",
      "asmjsMangle",
      "asyncLoad",
      "alignMemory",
      "mmapAlloc",
      "writeI53ToI64",
      "writeI53ToI64Clamped",
      "writeI53ToI64Signaling",
      "writeI53ToU64Clamped",
      "writeI53ToU64Signaling",
      "readI53FromI64",
      "readI53FromU64",
      "convertI32PairToI53",
      "convertU32PairToI53",
      "getCFunc",
      "ccall",
      "cwrap",
      "uleb128Encode",
      "sigToWasmTypes",
      "generateFuncType",
      "convertJsFunctionToWasm",
      "getEmptyTableSlot",
      "updateTableMap",
      "addFunction",
      "removeFunction",
      "reallyNegative",
      "unSign",
      "strLen",
      "reSign",
      "formatString",
      "intArrayToString",
      "AsciiToString",
      "stringToAscii",
      "UTF16ToString",
      "stringToUTF16",
      "lengthBytesUTF16",
      "UTF32ToString",
      "stringToUTF32",
      "lengthBytesUTF32",
      "allocateUTF8",
      "allocateUTF8OnStack",
      "writeStringToMemory",
      "writeArrayToMemory",
      "writeAsciiToMemory",
      "getSocketFromFD",
      "getSocketAddress",
      "registerKeyEventCallback",
      "maybeCStringToJsString",
      "findEventTarget",
      "findCanvasEventTarget",
      "getBoundingClientRect",
      "fillMouseEventData",
      "registerMouseEventCallback",
      "registerWheelEventCallback",
      "registerUiEventCallback",
      "registerFocusEventCallback",
      "fillDeviceOrientationEventData",
      "registerDeviceOrientationEventCallback",
      "fillDeviceMotionEventData",
      "registerDeviceMotionEventCallback",
      "screenOrientation",
      "fillOrientationChangeEventData",
      "registerOrientationChangeEventCallback",
      "fillFullscreenChangeEventData",
      "registerFullscreenChangeEventCallback",
      "JSEvents_requestFullscreen",
      "JSEvents_resizeCanvasForFullscreen",
      "registerRestoreOldStyle",
      "hideEverythingExceptGivenElement",
      "restoreHiddenElements",
      "setLetterbox",
      "softFullscreenResizeWebGLRenderTarget",
      "doRequestFullscreen",
      "fillPointerlockChangeEventData",
      "registerPointerlockChangeEventCallback",
      "registerPointerlockErrorEventCallback",
      "requestPointerLock",
      "fillVisibilityChangeEventData",
      "registerVisibilityChangeEventCallback",
      "registerTouchEventCallback",
      "fillGamepadEventData",
      "registerGamepadEventCallback",
      "registerBeforeUnloadEventCallback",
      "fillBatteryEventData",
      "battery",
      "registerBatteryEventCallback",
      "setCanvasElementSize",
      "getCanvasElementSize",
      "demangle",
      "demangleAll",
      "jsStackTrace",
      "stackTrace",
      "getEnvStrings",
      "checkWasiClock",
      "createDyncallWrapper",
      "setImmediateWrapped",
      "clearImmediateWrapped",
      "polyfillSetImmediate",
      "ExceptionInfo",
      "exception_addRef",
      "exception_decRef",
      "setMainLoop",
      "_setNetworkCallback",
      "heapObjectForWebGLType",
      "heapAccessShiftForWebGLHeap",
      "emscriptenWebGLGet",
      "computeUnpackAlignedImageSize",
      "emscriptenWebGLGetTexPixelData",
      "emscriptenWebGLGetUniform",
      "webglGetUniformLocation",
      "webglPrepareUniformLocationsBeforeFirstUse",
      "webglGetLeftBracePos",
      "emscriptenWebGLGetVertexAttrib",
      "writeGLArray",
      "SDL_unicode",
      "SDL_ttfContext",
      "SDL_audio",
      "GLFW_Window",
      "runAndAbortIfError",
      "ALLOC_NORMAL",
      "ALLOC_STACK",
      "allocate"
    ];
    ul.forEach(T);
    var fr;
    Yt = function p() {
      fr || An(), fr || (Yt = p);
    };
    function gl() {
      fn(), Qc();
    }
    function An(p) {
      if (Ze > 0 || (gl(), Tc(), Ze > 0))
        return;
      function x() {
        fr || (fr = !0, e.calledRun = !0, !N && (vc(), a(e), e.onRuntimeInitialized && e.onRuntimeInitialized(), h(!e._main, 'compiled without a main, but one is present. if you added it from JS, use Module["onRuntimeInitialized"]'), Hc()));
      }
      e.setStatus ? (e.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          e.setStatus("");
        }, 1), x();
      }, 1)) : x(), ea();
    }
    if (e.preInit)
      for (typeof e.preInit == "function" && (e.preInit = [e.preInit]); e.preInit.length > 0; )
        e.preInit.pop()();
    An();
    function Ce() {
    }
    Ce.prototype = Object.create(Ce.prototype), Ce.prototype.constructor = Ce, Ce.prototype.__class__ = Ce, Ce.__cache__ = {}, e.WrapperObject = Ce;
    function Ar(p) {
      return (p || Ce).__cache__;
    }
    e.getCache = Ar;
    function na(p, x) {
      var H = Ar(x), J = H[p];
      return J || (J = Object.create((x || Ce).prototype), J.ptr = p, H[p] = J);
    }
    e.wrapPointer = na;
    function yl(p, x) {
      return na(p.ptr, x);
    }
    e.castObject = yl, e.NULL = na(0);
    function hl(p) {
      if (!p.__destroy__) throw "Error: Cannot destroy object. (Did you create it yourself?)";
      p.__destroy__(), delete Ar(p.__class__)[p.ptr];
    }
    e.destroy = hl;
    function fl(p, x) {
      return p.ptr === x.ptr;
    }
    e.compare = fl;
    function Al(p) {
      return p.ptr;
    }
    e.getPointer = Al;
    function Nl(p) {
      return p.__class__;
    }
    e.getClass = Nl;
    function Qe() {
      throw "cannot construct a VoidPtr, no constructor in IDL";
    }
    Qe.prototype = Object.create(Ce.prototype), Qe.prototype.constructor = Qe, Qe.prototype.__class__ = Qe, Qe.__cache__ = {}, e.VoidPtr = Qe, Qe.prototype.__destroy__ = Qe.prototype.__destroy__ = /** @suppress {undefinedVars, duplicate} @this{Object} */
    function() {
      var p = this.ptr;
      ol(p);
    };
    function de() {
      this.ptr = ml(), Ar(de)[this.ptr] = this;
    }
    return de.prototype = Object.create(Ce.prototype), de.prototype.constructor = de, de.prototype.__class__ = de, de.__cache__ = {}, e.Crc64Hash = de, de.prototype.OnAppend = de.prototype.OnAppend = /** @suppress {undefinedVars, duplicate} @this{Object} */
    function(p, x) {
      var H = this.ptr;
      p && typeof p == "object" && (p = p.ptr), x && typeof x == "object" && (x = x.ptr), cl(H, p, x);
    }, de.prototype.OnFinal = de.prototype.OnFinal = /** @suppress {undefinedVars, duplicate} @this{Object} */
    function(p, x, H) {
      var J = this.ptr;
      p && typeof p == "object" && (p = p.ptr), x && typeof x == "object" && (x = x.ptr), H && typeof H == "object" && (H = H.ptr), ll(J, p, x, H);
    }, de.prototype.__destroy__ = de.prototype.__destroy__ = /** @suppress {undefinedVars, duplicate} @this{Object} */
    function() {
      var p = this.ptr;
      dl(p);
    }, r.ready;
  });
})();
const ge = class ge {
  constructor() {
    d(this, "nativeCrc64Hash");
    this.nativeCrc64Hash = new ge.nativeInstance.Crc64Hash();
  }
  /**
   * Initialize environment for CRC64 checksum calculator
   */
  static async init() {
    return this.initPromise || (this.initPromise = sg().then((r) => {
      this.nativeInstance = r;
    })), this.initPromise;
  }
  /**
   * Append data for CRC64 checksum calculator
   * @param body - content to be append
   * @param length - length of the content
   */
  append(r, e) {
    const a = ge.nativeInstance._malloc(e);
    ge.nativeInstance.HEAPU8.set(r, a), this.nativeCrc64Hash.OnAppend(a, e), ge.nativeInstance._free(a);
  }
  /**
   * Complete CRC64 checksum calculating and get the final result.
   * @param body -
   * @param length -
   * @returns
   */
  final(r, e) {
    const a = ge.nativeInstance._malloc(e);
    ge.nativeInstance.HEAPU8.set(r, a);
    const n = ge.nativeInstance._malloc(8);
    this.nativeCrc64Hash.OnFinal(a, e, n), ge.nativeInstance._free(a);
    const i = new Uint8Array(8);
    return i.set(ge.nativeInstance.HEAPU8.subarray(n, n + 8)), ge.nativeInstance._free(n), i;
  }
};
d(ge, "nativeInstance"), d(ge, "initPromise");
let ze = ge;
const og = 1, Hn = 13, kn = 10, Ln = 8, Un = 4 * 1024 * 1024;
var ue;
(function(t) {
  t[t.StreamHeader = 0] = "StreamHeader", t[t.StreamFooter = 1] = "StreamFooter", t[t.SegmentHeader = 2] = "SegmentHeader", t[t.SegmentFooter = 3] = "SegmentFooter", t[t.SegmentContent = 4] = "SegmentContent", t[t.Completed = 5] = "Completed";
})(ue || (ue = {}));
class mg {
  constructor(r, e) {
    d(this, "pushData");
    d(this, "contentLength");
    d(this, "messageLength");
    d(this, "currentDataOffset");
    d(this, "contentOffset");
    d(this, "segmentsCount");
    d(this, "messageHeaderBuffer");
    d(this, "segmentNumber");
    d(this, "segmentContentLength");
    d(this, "segmentContentOffset");
    d(this, "segmentCrc64");
    d(this, "messageCrc64");
    d(this, "state");
    d(this, "sourceDataHandler", (r) => {
      for (this.currentDataOffset = 0, this.state === ue.StreamHeader && this.handlingMessageHeader(); this.segmentNumber < this.segmentsCount && (this.segmentContentLength = Math.min(Un, this.contentLength - this.contentOffset), this.state === ue.SegmentHeader && this.handlingSegmentHeader(), this.state === ue.SegmentContent && this.handlingSegmentContent(r), this.state === ue.SegmentFooter && (this.handlingSegmentFooter(), this.contentOffset += this.segmentContentLength), this.currentDataOffset !== r.length); )
        ;
      this.state === ue.StreamFooter && this.handlingMessageFooter();
    });
    this.pushData = r, this.contentLength = e, this.contentOffset = 0, this.currentDataOffset = 0, this.segmentsCount = Math.ceil(this.contentLength / Un), this.messageLength = this.contentLength + Hn + (kn + Ln) * this.segmentsCount + Ln, this.messageHeaderBuffer = new Uint8Array(Hn), this.segmentNumber = 0, this.segmentContentLength = 0, this.segmentContentOffset = 0, this.state = ue.StreamHeader, this.segmentCrc64 = new ze(), this.messageCrc64 = new ze();
  }
  handlingMessageHeader() {
    this.messageHeaderBuffer[0] = og, this.fillInt64(this.messageHeaderBuffer, 1, this.messageLength), this.fillInt16(this.messageHeaderBuffer, 9, 1), this.fillInt16(this.messageHeaderBuffer, 11, this.segmentsCount), this.pushData(this.messageHeaderBuffer), this.state = ue.SegmentHeader;
  }
  handlingSegmentHeader() {
    const r = new Uint8Array(kn);
    this.fillInt16(r, 0, this.segmentNumber + 1), this.fillInt64(r, 2, this.segmentContentLength), this.segmentContentOffset = 0, this.pushData(r), this.state = ue.SegmentContent;
  }
  handlingSegmentContent(r) {
    const e = Math.min(this.segmentContentLength - this.segmentContentOffset, r.length - this.currentDataOffset);
    if (e !== 0) {
      const a = Uint8Array.prototype.slice.call(r, this.currentDataOffset, this.currentDataOffset + e);
      this.messageCrc64.append(a, e), this.segmentCrc64.append(a, e), this.pushData(a);
    }
    this.segmentContentOffset += e, this.currentDataOffset += e, this.segmentContentOffset === this.segmentContentLength && (this.state = ue.SegmentFooter);
  }
  handlingSegmentFooter() {
    const r = this.segmentCrc64.final(new Uint8Array([]), 0);
    this.pushData(r), this.segmentCrc64 = new ze(), ++this.segmentNumber, this.segmentNumber === this.segmentsCount ? this.state = ue.StreamFooter : this.state = ue.SegmentHeader;
  }
  handlingMessageFooter() {
    const r = this.messageCrc64.final(new Uint8Array([]), 0);
    this.pushData(r), this.pushData, this.state = ue.Completed;
  }
  fillInt64(r, e, a) {
    if (r.length < e + 8)
      throw new Error("Uint8Array length is not expected.");
    new DataView(r.buffer, r.byteOffset + e, 8).setBigUint64(0, BigInt(a), !0);
  }
  fillInt16(r, e, a) {
    if (r.length < e + 2)
      throw new Error("Uint8Array length is not expected.");
    new DataView(r.buffer, r.byteOffset + e, 2).setUint16(0, a, !0);
  }
}
async function cg(t, r, e) {
  const { done: a, value: n } = await t.read();
  if (n && e.stream.sourceDataHandler(n), a) {
    e.closed || (e.closed = !0, r.close());
    return;
  }
}
async function ma(t, r) {
  const a = (t instanceof Blob ? t.stream() : t).getReader();
  let n;
  const i = new ReadableStream({
    start(o) {
      n = {
        stream: new mg((m) => {
          o.enqueue(m);
        }, r),
        closed: !1
      };
    },
    pull(o) {
      cg(a, o, n).then(() => {
      }).catch((m) => {
        o.error(m);
      });
    }
  });
  return {
    content: await new Response(i).blob(),
    encodedContentLength: n.stream.messageLength
  };
}
async function lg(t, r) {
  if (t === null)
    return {
      body: t,
      encodedContentLength: r
    };
  if (t instanceof Blob) {
    const e = await ma(t, r);
    return {
      body: e.content,
      encodedContentLength: e.encodedContentLength
    };
  }
  if (typeof t == "string" || t instanceof ArrayBuffer) {
    const e = await ma(new Blob([t]), r);
    return {
      body: e.content,
      encodedContentLength: e.encodedContentLength
    };
  }
  if (ArrayBuffer.isView(t)) {
    let e;
    if (t.buffer instanceof ArrayBuffer)
      return e = await ma(new Blob([t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength)]), r), {
        body: e.content,
        encodedContentLength: e.encodedContentLength
      };
  }
  throw new Error("The specified request body type is not supported for CRC64 checksum");
}
const dg = 1, ca = 13, la = 10, ut = 8;
var fe;
(function(t) {
  t[t.StreamHeader = 0] = "StreamHeader", t[t.StreamFooter = 1] = "StreamFooter", t[t.SegmentHeader = 2] = "SegmentHeader", t[t.SegmentFooter = 3] = "SegmentFooter", t[t.SegmentContent = 4] = "SegmentContent";
})(fe || (fe = {}));
class pg {
  constructor(r) {
    d(this, "pushData");
    d(this, "segmentsCount");
    //   private currentState: SMRegion;
    d(this, "currentOffset");
    d(this, "currentDataOffset");
    d(this, "messageHeaderBuffer");
    d(this, "messageHeaderOffset");
    d(this, "segmentNumber");
    d(this, "segmentHeaderOffset");
    d(this, "segmentHeaderBuffer");
    d(this, "segmentContentOffset");
    d(this, "segmentContentLength");
    d(this, "segmentFooterOffset");
    d(this, "segmentFooterBuffer");
    d(this, "messageFooterOffset");
    d(this, "messageFooterBuffer");
    d(this, "segmentCrc64");
    d(this, "messageCrc64");
    d(this, "state");
    d(this, "sourceDataHandler", (r) => {
      for (this.currentDataOffset = 0, this.state === fe.StreamHeader && this.parseMessageHeader(r); this.segmentNumber < this.segmentsCount && this.currentDataOffset < r.length; )
        this.state === fe.SegmentHeader && this.parseSegmentHeader(r), this.state === fe.SegmentContent && this.parseSegmentContent(r), this.state === fe.SegmentFooter && this.parseSegmentFooter(r);
      this.state === fe.StreamFooter && this.parseMessageFooter(r);
    });
    this.pushData = r, this.currentOffset = 0, this.segmentsCount = 0, this.messageHeaderOffset = 0, this.messageHeaderBuffer = new Uint8Array(ca), this.currentDataOffset = 0, this.segmentNumber = 0, this.segmentHeaderOffset = 0, this.segmentHeaderBuffer = new Uint8Array(la), this.segmentContentOffset = 0, this.segmentContentLength = 0, this.state = fe.StreamHeader, this.segmentFooterOffset = 0, this.segmentFooterBuffer = new Uint8Array(ut), this.messageFooterOffset = 0, this.messageFooterBuffer = new Uint8Array(ut), this.segmentCrc64 = new ze(), this.messageCrc64 = new ze();
  }
  parseMessageHeader(r) {
    const e = Math.min(ca - this.messageHeaderOffset, r.length - this.currentDataOffset);
    if (this.messageHeaderBuffer.set(Uint8Array.prototype.slice.call(r, this.currentDataOffset, this.currentDataOffset + e), this.messageHeaderOffset), this.currentDataOffset += e, this.messageHeaderOffset += e, this.currentOffset += e, this.messageHeaderOffset === ca) {
      if (this.messageHeaderBuffer[0] !== dg)
        throw new Error("Unexpected message version");
      this.segmentsCount = this.toInt16(Uint8Array.prototype.slice.call(this.messageHeaderBuffer, 11, 13)), this.state = fe.SegmentHeader;
    }
  }
  parseSegmentHeader(r) {
    const e = Math.min(la - this.segmentHeaderOffset, r.length - this.currentDataOffset);
    if (this.segmentHeaderBuffer.set(Uint8Array.prototype.slice.call(r, this.currentDataOffset, this.currentDataOffset + e), this.segmentHeaderOffset), this.currentDataOffset += e, this.segmentHeaderOffset += e, this.currentOffset += e, this.segmentHeaderOffset === la) {
      if (this.toInt16(Uint8Array.prototype.slice.call(this.segmentHeaderBuffer, 0, 2)) !== this.segmentNumber + 1)
        throw new Error("Segment number is unexpected.");
      this.segmentContentLength = this.toInt64(this.segmentHeaderBuffer, 2), this.segmentContentOffset = 0, this.state = fe.SegmentContent;
    }
  }
  parseSegmentContent(r) {
    const e = Math.min(this.segmentContentLength - this.segmentContentOffset, r.length - this.currentDataOffset), a = Uint8Array.prototype.slice.call(r, this.currentDataOffset, this.currentDataOffset + e);
    this.segmentCrc64.append(a, e), this.messageCrc64.append(a, e), this.pushData(a), this.currentDataOffset += e, this.segmentContentOffset += e, this.currentOffset += e, this.segmentContentOffset === this.segmentContentLength && (this.state = fe.SegmentFooter);
  }
  parseSegmentFooter(r) {
    const e = Math.min(ut - this.segmentFooterOffset, r.length - this.currentDataOffset);
    if (this.segmentFooterBuffer.set(Uint8Array.prototype.slice.call(r, this.currentDataOffset, this.currentDataOffset + e), this.segmentFooterOffset), this.currentDataOffset += e, this.segmentFooterOffset += e, this.currentOffset += e, this.segmentFooterOffset === ut) {
      const a = this.segmentCrc64.final(new Uint8Array([]), 0);
      if (!this.checkCrc64CheckSum(a, this.segmentFooterBuffer))
        throw new Error(`Segment check sum mismatch, segmentNumber: ${this.segmentNumber}`);
      ++this.segmentNumber, this.segmentNumber === this.segmentsCount ? this.state = fe.StreamFooter : (this.segmentHeaderOffset = 0, this.segmentFooterOffset = 0, this.segmentCrc64 = new ze(), this.state = fe.SegmentHeader);
    }
  }
  parseMessageFooter(r) {
    const e = Math.min(ut - this.messageFooterOffset, r.length - this.currentDataOffset);
    if (this.messageFooterBuffer.set(Uint8Array.prototype.slice.call(r, this.currentDataOffset, this.currentDataOffset + e), this.messageFooterOffset), this.currentDataOffset += e, this.messageFooterOffset += e, this.currentOffset += e, this.messageFooterOffset === ut) {
      const a = this.messageCrc64.final(new Uint8Array([]), 0);
      if (!this.checkCrc64CheckSum(a, this.messageFooterBuffer))
        throw new Error("Check sum mismatch");
      this.pushData(null);
    }
  }
  toInt64(r, e) {
    if (r.length < e + 8)
      throw new Error("CRC64 buffer error, something wrong with crc64 calculator");
    const a = new DataView(r.buffer, r.byteOffset + e, 8);
    return Number(a.getBigUint64(0, !0));
  }
  toInt16(r) {
    if (r.length !== 2)
      throw new Error("CRC64 buffer error, something wrong with crc64 calculator");
    return r[0] + r[1] * 256;
  }
  checkCrc64CheckSum(r, e) {
    if (r.length !== 8 || e.length !== 8)
      throw new Error("CRC64 buffer error, something wrong with crc64 calculator");
    for (let a = 0; a < 8; ++a)
      if (r[a] !== e[a])
        return !1;
    return !0;
  }
}
async function ug(t, r) {
  const { done: e, value: a } = await t.read();
  e || r.sourceDataHandler(a);
}
async function gg(t) {
  const e = (t instanceof Blob ? t.stream() : t).getReader();
  let a;
  const n = new ReadableStream({
    start(s) {
      a = new pg((o) => {
        o !== null ? s.enqueue(o) : s.close();
      });
    },
    pull(s) {
      ug(e, a).then(() => {
      }).catch((o) => {
        s.error(o);
      });
    }
  });
  return new Response(n).blob();
}
let da;
function yg() {
  return da || (da = Ii()), da;
}
class Fa {
  /**
   * The main method to implement that manipulates a request/response.
   */
  constructor(r, e) {
    d(this, "_nextPolicy");
    d(this, "_options");
    this._nextPolicy = r, this._options = e;
  }
  /**
   * Get whether or not a log with the provided log level should be logged.
   * @param logLevel - The log level of the log that will be logged.
   * @returns Whether or not a log with the provided log level should be logged.
   */
  shouldLog(r) {
    return this._options.shouldLog(r);
  }
  /**
   * Attempt to log the provided message to the provided logger. If no logger was provided or if
   * the log level does not meat the logger's threshold, then nothing will be logged.
   * @param logLevel - The log level of this log.
   * @param message - The message of this log.
   */
  log(r, e) {
    this._options.log(r, e);
  }
}
const Ur = {
  Parameters: {
    FORCE_BROWSER_NO_CACHE: "_",
    TIMEOUT: "timeout"
  }
}, xt = {
  CONTENT_LENGTH: "Content-Length",
  COOKIE: "Cookie",
  X_MS_CopySourceErrorCode: "x-ms-copy-source-error-code"
};
function qr(t, r, e) {
  const a = new URL(t), n = encodeURIComponent(r), i = e ? encodeURIComponent(e) : void 0, s = a.search === "" ? "?" : a.search, o = [];
  for (const m of s.slice(1).split("&"))
    if (m) {
      const [c] = m.split("=", 2);
      c !== n && o.push(m);
    }
  return i && o.push(`${n}=${i}`), a.search = o.length ? `?${o.join("&")}` : "", a.toString();
}
function Gi(t, r) {
  const e = new URL(t);
  return e.hostname = r, e.toString();
}
async function Yi(t, r, e) {
  return new Promise((a, n) => {
    let i;
    const s = () => {
      i !== void 0 && clearTimeout(i), n(e);
    };
    i = setTimeout(() => {
      r !== void 0 && r.removeEventListener("abort", s), a();
    }, t), r !== void 0 && r.addEventListener("abort", s);
  });
}
class hg extends Fa {
  /**
   * Creates an instance of StorageBrowserPolicy.
   * @param nextPolicy -
   * @param options -
   */
  // The base class has a protected constructor. Adding a public one to enable constructing of this class.
  /* eslint-disable-next-line @typescript-eslint/no-useless-constructor*/
  constructor(r, e) {
    super(r, e);
  }
  /**
   * Sends out request.
   *
   * @param request -
   */
  async sendRequest(r) {
    return (r.method.toUpperCase() === "GET" || r.method.toUpperCase() === "HEAD") && (r.url = qr(r.url, Ur.Parameters.FORCE_BROWSER_NO_CACHE, (/* @__PURE__ */ new Date()).getTime().toString())), r.headers.remove(xt.COOKIE), r.headers.remove(xt.CONTENT_LENGTH), this._nextPolicy.sendRequest(r);
  }
}
class fg {
  /**
   * Creates a StorageBrowserPolicyFactory object.
   *
   * @param nextPolicy -
   * @param options -
   */
  create(r, e) {
    return new hg(r, e);
  }
}
class Ag extends Fa {
  /**
   * Sends out request.
   *
   * @param request -
   */
  sendRequest(r) {
    return this._nextPolicy.sendRequest(this.signRequest(r));
  }
  /**
   * Child classes must implement this method with request signing. This method
   * will be executed in {@link sendRequest}.
   *
   * @param request -
   */
  signRequest(r) {
    return r;
  }
}
class Ng extends Ag {
  /**
   * Creates an instance of AnonymousCredentialPolicy.
   * @param nextPolicy -
   * @param options -
   */
  // The base class has a protected constructor. Adding a public one to enable constructing of this class.
  /* eslint-disable-next-line @typescript-eslint/no-useless-constructor*/
  constructor(r, e) {
    super(r, e);
  }
}
class Ki {
  /**
   * Creates a RequestPolicy object.
   *
   * @param _nextPolicy -
   * @param _options -
   */
  create(r, e) {
    throw new Error("Method should be implemented in children classes.");
  }
}
class K extends Ki {
  /**
   * Creates an {@link AnonymousCredentialPolicy} object.
   *
   * @param nextPolicy -
   * @param options -
   */
  create(r, e) {
    return new Ng(r, e);
  }
}
class Me extends Ki {
  /**
   * Creates an instance of StorageSharedKeyCredential.
   * @param accountName -
   * @param accountKey -
   */
  constructor(e, a) {
    super();
    /**
     * Azure Storage account name; readonly.
     */
    d(this, "accountName");
    throw new Error("StorageSharedKeyCredential is not supported in the browser.");
  }
  /**
   * Creates a StorageSharedKeyCredentialPolicy object.
   *
   * @param _nextPolicy -
   * @param _options -
   */
  create(e, a) {
    throw new Error("StorageSharedKeyCredential is not supported in the browser.");
  }
  /**
   * Generates a hash signature for an HTTP request or for a SAS.
   *
   * @param _stringToSign -
   */
  computeHMACSHA256(e) {
    throw new Error("StorageSharedKeyCredential is not supported in the browser.");
  }
}
const se = Hr("storage-common");
var Ge;
(function(t) {
  t[t.EXPONENTIAL = 0] = "EXPONENTIAL", t[t.FIXED = 1] = "FIXED";
})(Ge || (Ge = {}));
const qe = {
  maxRetryDelayInMs: 120 * 1e3,
  maxTries: 4,
  retryDelayInMs: 4 * 1e3,
  retryPolicyType: Ge.EXPONENTIAL,
  secondaryHost: "",
  tryTimeoutInMs: void 0
  // Use server side default timeout strategy
}, Cg = new Ha("The operation was aborted.");
class xg extends Fa {
  /**
   * Creates an instance of RetryPolicy.
   *
   * @param nextPolicy -
   * @param options -
   * @param retryOptions -
   */
  constructor(e, a, n = qe) {
    super(e, a);
    /**
     * RetryOptions.
     */
    d(this, "retryOptions");
    this.retryOptions = {
      retryPolicyType: n.retryPolicyType ? n.retryPolicyType : qe.retryPolicyType,
      maxTries: n.maxTries && n.maxTries >= 1 ? Math.floor(n.maxTries) : qe.maxTries,
      tryTimeoutInMs: n.tryTimeoutInMs && n.tryTimeoutInMs >= 0 ? n.tryTimeoutInMs : qe.tryTimeoutInMs,
      retryDelayInMs: n.retryDelayInMs && n.retryDelayInMs >= 0 ? Math.min(n.retryDelayInMs, n.maxRetryDelayInMs ? n.maxRetryDelayInMs : qe.maxRetryDelayInMs) : qe.retryDelayInMs,
      maxRetryDelayInMs: n.maxRetryDelayInMs && n.maxRetryDelayInMs >= 0 ? n.maxRetryDelayInMs : qe.maxRetryDelayInMs,
      secondaryHost: n.secondaryHost ? n.secondaryHost : qe.secondaryHost
    };
  }
  /**
   * Sends request.
   *
   * @param request -
   */
  async sendRequest(e) {
    return this.attemptSendRequest(e, !1, 1);
  }
  /**
   * Decide and perform next retry. Won't mutate request parameter.
   *
   * @param request -
   * @param secondaryHas404 -  If attempt was against the secondary & it returned a StatusNotFound (404), then
   *                                   the resource was not found. This may be due to replication delay. So, in this
   *                                   case, we'll never try the secondary again for this operation.
   * @param attempt -           How many retries has been attempted to performed, starting from 1, which includes
   *                                   the attempt will be performed by this method call.
   */
  async attemptSendRequest(e, a, n) {
    const i = e.clone(), s = a || !this.retryOptions.secondaryHost || !(e.method === "GET" || e.method === "HEAD" || e.method === "OPTIONS") || n % 2 === 1;
    s || (i.url = Gi(i.url, this.retryOptions.secondaryHost)), this.retryOptions.tryTimeoutInMs && (i.url = qr(i.url, Ur.Parameters.TIMEOUT, Math.floor(this.retryOptions.tryTimeoutInMs / 1e3).toString()));
    let o;
    try {
      if (se.info(`RetryPolicy: =====> Try=${n} ${s ? "Primary" : "Secondary"}`), o = await this._nextPolicy.sendRequest(i), !this.shouldRetry(s, n, o))
        return o;
      a = a || !s && o.status === 404;
    } catch (m) {
      if (se.error(`RetryPolicy: Caught error, message: ${m.message}, code: ${m.code}`), !this.shouldRetry(s, n, o, m))
        throw m;
    }
    return await this.delay(s, n, e.abortSignal), this.attemptSendRequest(e, a, ++n);
  }
  /**
   * Decide whether to retry according to last HTTP response and retry counters.
   *
   * @param isPrimaryRetry -
   * @param attempt -
   * @param response -
   * @param err -
   */
  shouldRetry(e, a, n, i) {
    if (a >= this.retryOptions.maxTries)
      return se.info(`RetryPolicy: Attempt(s) ${a} >= maxTries ${this.retryOptions.maxTries}, no further try.`), !1;
    const s = [
      "ETIMEDOUT",
      "ESOCKETTIMEDOUT",
      "ECONNREFUSED",
      "ECONNRESET",
      "ENOENT",
      "ENOTFOUND",
      "TIMEOUT",
      "EPIPE",
      "REQUEST_SEND_ERROR"
      // For default xhr based http client provided in ms-rest-js
    ];
    if (i) {
      for (const o of s)
        if (i.name.toUpperCase().includes(o) || i.message.toUpperCase().includes(o) || i.code && i.code.toString().toUpperCase() === o)
          return se.info(`RetryPolicy: Network error ${o} found, will retry.`), !0;
    }
    if (n || i) {
      const o = n ? n.status : i ? i.statusCode : 0;
      if (!e && o === 404)
        return se.info("RetryPolicy: Secondary access with 404, will retry."), !0;
      if (o === 503 || o === 500)
        return se.info(`RetryPolicy: Will retry for status code ${o}.`), !0;
    }
    if (n && (n == null ? void 0 : n.status) >= 400) {
      const o = n.headers.get(xt.X_MS_CopySourceErrorCode);
      if (o !== void 0)
        switch (o) {
          case "InternalError":
          case "OperationTimedOut":
          case "ServerBusy":
            return !0;
        }
    }
    return (i == null ? void 0 : i.code) === "PARSE_ERROR" && (i != null && i.message.startsWith('Error "Error: Unclosed root tag')) ? (se.info("RetryPolicy: Incomplete XML response likely due to service timeout, will retry."), !0) : !1;
  }
  /**
   * Delay a calculated time between retries.
   *
   * @param isPrimaryRetry -
   * @param attempt -
   * @param abortSignal -
   */
  async delay(e, a, n) {
    let i = 0;
    if (e)
      switch (this.retryOptions.retryPolicyType) {
        case Ge.EXPONENTIAL:
          i = Math.min((Math.pow(2, a - 1) - 1) * this.retryOptions.retryDelayInMs, this.retryOptions.maxRetryDelayInMs);
          break;
        case Ge.FIXED:
          i = this.retryOptions.retryDelayInMs;
          break;
      }
    else
      i = Math.random() * 1e3;
    return se.info(`RetryPolicy: Delay for ${i}ms`), Yi(i, n, Cg);
  }
}
class Ig {
  /**
   * Creates an instance of StorageRetryPolicyFactory.
   * @param retryOptions -
   */
  constructor(r) {
    d(this, "retryOptions");
    this.retryOptions = r;
  }
  /**
   * Creates a StorageRetryPolicy object.
   *
   * @param nextPolicy -
   * @param options -
   */
  create(r, e) {
    return new xg(r, e, this.retryOptions);
  }
}
const Bg = "storageBrowserPolicy";
function bg() {
  return {
    name: Bg,
    async sendRequest(t, r) {
      return (t.method === "GET" || t.method === "HEAD") && (t.url = qr(t.url, Ur.Parameters.FORCE_BROWSER_NO_CACHE, (/* @__PURE__ */ new Date()).getTime().toString())), t.headers.delete(xt.COOKIE), t.headers.delete(xt.CONTENT_LENGTH), r(t);
    }
  };
}
const Eg = "StorageCorrectContentLengthPolicy";
function Pg() {
  return {
    name: Eg,
    async sendRequest(t, r) {
      return r(t);
    }
  };
}
const wg = "storageRetryPolicy", gt = {
  maxRetryDelayInMs: 120 * 1e3,
  maxTries: 4,
  retryDelayInMs: 4 * 1e3,
  retryPolicyType: Ge.EXPONENTIAL,
  secondaryHost: "",
  tryTimeoutInMs: void 0
  // Use server side default timeout strategy
}, Sg = [
  "ETIMEDOUT",
  "ESOCKETTIMEDOUT",
  "ECONNREFUSED",
  "ECONNRESET",
  "ENOENT",
  "ENOTFOUND",
  "TIMEOUT",
  "EPIPE",
  "REQUEST_SEND_ERROR"
], Rg = new Ha("The operation was aborted.");
function zg(t = {}) {
  const r = t.retryPolicyType ?? gt.retryPolicyType, e = t.maxTries ?? gt.maxTries, a = t.retryDelayInMs ?? gt.retryDelayInMs, n = t.maxRetryDelayInMs ?? gt.maxRetryDelayInMs, i = t.secondaryHost ?? gt.secondaryHost, s = t.tryTimeoutInMs ?? gt.tryTimeoutInMs;
  function o({ isPrimaryRetry: c, attempt: l, response: u, error: y }) {
    if (l >= e)
      return se.info(`RetryPolicy: Attempt(s) ${l} >= maxTries ${e}, no further try.`), !1;
    if (y) {
      for (const A of Sg)
        if (y.name.toUpperCase().includes(A) || y.message.toUpperCase().includes(A) || y.code && y.code.toString().toUpperCase() === A)
          return se.info(`RetryPolicy: Network error ${A} found, will retry.`), !0;
      if ((y == null ? void 0 : y.code) === "PARSE_ERROR" && (y != null && y.message.startsWith('Error "Error: Unclosed root tag')))
        return se.info("RetryPolicy: Incomplete XML response likely due to service timeout, will retry."), !0;
    }
    if (u || y) {
      const A = (u == null ? void 0 : u.status) ?? (y == null ? void 0 : y.statusCode) ?? 0;
      if (!c && A === 404)
        return se.info("RetryPolicy: Secondary access with 404, will retry."), !0;
      if (A === 503 || A === 500)
        return se.info(`RetryPolicy: Will retry for status code ${A}.`), !0;
    }
    if (u && (u == null ? void 0 : u.status) >= 400) {
      const A = u.headers.get(xt.X_MS_CopySourceErrorCode);
      if (A !== void 0)
        switch (A) {
          case "InternalError":
          case "OperationTimedOut":
          case "ServerBusy":
            return !0;
        }
    }
    return !1;
  }
  function m(c, l) {
    let u = 0;
    if (c)
      switch (r) {
        case Ge.EXPONENTIAL:
          u = Math.min((Math.pow(2, l - 1) - 1) * a, n);
          break;
        case Ge.FIXED:
          u = a;
          break;
      }
    else
      u = Math.random() * 1e3;
    return se.info(`RetryPolicy: Delay for ${u}ms`), u;
  }
  return {
    name: wg,
    async sendRequest(c, l) {
      s && (c.url = qr(c.url, Ur.Parameters.TIMEOUT, String(Math.floor(s / 1e3))));
      const u = c.url, y = i ? Gi(c.url, i) : void 0;
      let A = !1, g = 1, C = !0, R, D;
      for (; C; ) {
        const T = A || !y || !["GET", "HEAD", "OPTIONS"].includes(c.method) || g % 2 === 1;
        c.url = T ? u : y, R = void 0, D = void 0;
        try {
          se.info(`RetryPolicy: =====> Try=${g} ${T ? "Primary" : "Secondary"}`), R = await l(c), A = A || !T && R.status === 404;
        } catch (v) {
          if (ka(v))
            se.error(`RetryPolicy: Caught error, message: ${v.message}, code: ${v.code}`), D = v;
          else
            throw se.error(`RetryPolicy: Caught error, message: ${lr(v)}`), v;
        }
        C = o({ isPrimaryRetry: T, attempt: g, response: R, error: D }), C && await Yi(m(T, g), c.abortSignal, Rg), g++;
      }
      if (R)
        return R;
      throw D ?? new ar("RetryPolicy failed without known error.");
    }
  };
}
const Mg = "storageSharedKeyCredentialPolicy";
function Ji(t) {
  return {
    name: Mg,
    async sendRequest(r, e) {
      return e(r);
    }
  };
}
const Dg = "storageRequestFailureDetailsParserPolicy";
function Qg() {
  return {
    name: Dg,
    async sendRequest(t, r) {
      try {
        return await r(t);
      } catch (e) {
        throw typeof e == "object" && e !== null && e.response && e.response.parsedBody && e.response.parsedBody.code === "InvalidHeaderValue" && e.response.parsedBody.HeaderName === "x-ms-version" && (e.message = `The provided service version is not enabled on this storage account. Please see https://learn.microsoft.com/rest/api/storageservices/versioning-for-the-azure-storage-services for additional information.
`), e;
      }
    }
  };
}
class Tg {
  constructor(r, e) {
    d(this, "accountName");
    d(this, "userDelegationKey");
    throw this.accountName = r, this.userDelegationKey = e, new Error("UserDelegationKeyCredential is not supported in the browser.");
  }
  computeHMACSHA256(r) {
    throw new Error("UserDelegationKeyCredential is not supported in the browser.");
  }
}
const Xi = "12.32.0", _a = "2026-04-06", pa = 256 * 1024 * 1024, ua = 4e3 * 1024 * 1024, Ir = 5e4, vg = 8 * 1024 * 1024, ba = 4 * 1024 * 1024, Wi = "https://storage.azure.com/.default", et = {
  Parameters: {
    SNAPSHOT: "snapshot",
    VERSIONID: "versionid"
  }
}, Hg = {
  HTTP_ACCEPTED: 202
}, At = {
  CONTENT_ID: "Content-ID",
  CONTENT_TRANSFER_ENCODING: "Content-Transfer-Encoding",
  CONTENT_TYPE: "Content-Type",
  X_MS_ERROR_CODE: "x-ms-error-code",
  X_MS_VERSION: "x-ms-version"
}, Re = "", ji = "*", qn = 256, Te = `\r
`, Zi = "HTTP/1.1", kg = "AES256", Lg = "DefaultEndpointsProtocol=http;AccountName=devstoreaccount1;AccountKey=Eby8vdM02xNOcqFlqUwJPLlmEtlCDXJ1OUzFT50uSRZ6IFsuFq2UVErCz4I6tq/K1SZFPTOtr/KBHBeksoGMGw==;BlobEndpoint=http://127.0.0.1:10000/devstoreaccount1;", Ug = [
  "Access-Control-Allow-Origin",
  "Cache-Control",
  "Content-Length",
  "Content-Type",
  "Date",
  "Request-Id",
  "traceparent",
  "Transfer-Encoding",
  "User-Agent",
  "x-ms-client-request-id",
  "x-ms-date",
  "x-ms-error-code",
  "x-ms-request-id",
  "x-ms-return-client-request-id",
  "x-ms-version",
  "Accept-Ranges",
  "Content-Disposition",
  "Content-Encoding",
  "Content-Language",
  "Content-MD5",
  "Content-Range",
  "ETag",
  "Last-Modified",
  "Server",
  "Vary",
  "x-ms-content-crc64",
  "x-ms-copy-action",
  "x-ms-copy-completion-time",
  "x-ms-copy-id",
  "x-ms-copy-progress",
  "x-ms-copy-status",
  "x-ms-has-immutability-policy",
  "x-ms-has-legal-hold",
  "x-ms-lease-state",
  "x-ms-lease-status",
  "x-ms-range",
  "x-ms-request-server-encrypted",
  "x-ms-server-encrypted",
  "x-ms-snapshot",
  "x-ms-source-range",
  "If-Match",
  "If-Modified-Since",
  "If-None-Match",
  "If-Unmodified-Since",
  "x-ms-access-tier",
  "x-ms-access-tier-change-time",
  "x-ms-access-tier-inferred",
  "x-ms-account-kind",
  "x-ms-archive-status",
  "x-ms-blob-append-offset",
  "x-ms-blob-cache-control",
  "x-ms-blob-committed-block-count",
  "x-ms-blob-condition-appendpos",
  "x-ms-blob-condition-maxsize",
  "x-ms-blob-content-disposition",
  "x-ms-blob-content-encoding",
  "x-ms-blob-content-language",
  "x-ms-blob-content-length",
  "x-ms-blob-content-md5",
  "x-ms-blob-content-type",
  "x-ms-blob-public-access",
  "x-ms-blob-sequence-number",
  "x-ms-blob-type",
  "x-ms-copy-destination-snapshot",
  "x-ms-creation-time",
  "x-ms-default-encryption-scope",
  "x-ms-delete-snapshots",
  "x-ms-delete-type-permanent",
  "x-ms-deny-encryption-scope-override",
  "x-ms-encryption-algorithm",
  "x-ms-if-sequence-number-eq",
  "x-ms-if-sequence-number-le",
  "x-ms-if-sequence-number-lt",
  "x-ms-incremental-copy",
  "x-ms-lease-action",
  "x-ms-lease-break-period",
  "x-ms-lease-duration",
  "x-ms-lease-id",
  "x-ms-lease-time",
  "x-ms-page-write",
  "x-ms-proposed-lease-id",
  "x-ms-range-get-content-md5",
  "x-ms-rehydrate-priority",
  "x-ms-sequence-number-action",
  "x-ms-sku-name",
  "x-ms-source-content-md5",
  "x-ms-source-if-match",
  "x-ms-source-if-modified-since",
  "x-ms-source-if-none-match",
  "x-ms-source-if-unmodified-since",
  "x-ms-tag-count",
  "x-ms-encryption-key-sha256",
  "x-ms-copy-source-error-code",
  "x-ms-copy-source-status-code",
  "x-ms-if-tags",
  "x-ms-source-if-tags"
], qg = [
  "comp",
  "maxresults",
  "rscc",
  "rscd",
  "rsce",
  "rscl",
  "rsct",
  "se",
  "si",
  "sip",
  "sp",
  "spr",
  "sr",
  "srt",
  "ss",
  "st",
  "sv",
  "include",
  "marker",
  "prefix",
  "copyid",
  "restype",
  "blockid",
  "blocklisttype",
  "delimiter",
  "prevsnapshot",
  "ske",
  "skoid",
  "sks",
  "skt",
  "sktid",
  "skv",
  "snapshot"
], Og = "BlobUsesCustomerSpecifiedEncryption", Fg = "BlobDoesNotUseCustomerSpecifiedEncryption", _g = [
  "10000",
  "10001",
  "10002",
  "10003",
  "10004",
  "10100",
  "10101",
  "10102",
  "10103",
  "10104",
  "11000",
  "11001",
  "11002",
  "11003",
  "11004",
  "11100",
  "11101",
  "11102",
  "11103",
  "11104"
];
function nt(t) {
  if (!t || typeof t != "object")
    return !1;
  const r = t;
  return Array.isArray(r.factories) && typeof r.options == "object" && typeof r.toServiceClientOptions == "function";
}
class Vi {
  /**
   * Creates an instance of Pipeline. Customize HTTPClient by implementing IHttpClient interface.
   *
   * @param factories -
   * @param options -
   */
  constructor(r, e = {}) {
    /**
     * A list of chained request policy factories.
     */
    d(this, "factories");
    /**
     * Configures pipeline logger and HTTP client.
     */
    d(this, "options");
    this.factories = r, this.options = e;
  }
  /**
   * Transfer Pipeline object to ServiceClientOptions object which is required by
   * ServiceClient constructor.
   *
   * @returns The ServiceClientOptions object from this Pipeline.
   */
  toServiceClientOptions() {
    return {
      httpClient: this.options.httpClient,
      requestPolicyFactories: this.factories
    };
  }
}
function V(t, r = {}) {
  t || (t = new K());
  const e = new Vi([], r);
  return e._credential = t, e;
}
function Gg(t) {
  const r = [
    Yg,
    ts,
    Kg,
    Jg,
    Xg,
    Wg,
    Zg
  ];
  if (t.factories.length) {
    const e = t.factories.filter((a) => !r.some((n) => n(a)));
    if (e.length) {
      const a = e.some((n) => jg(n));
      return {
        wrappedPolicies: ju(e),
        afterRetry: a
      };
    }
  }
}
function $i(t) {
  const { httpClient: r, ...e } = t.options;
  let a = t._coreHttpClient;
  a || (a = r ? Zu(r) : yg(), t._coreHttpClient = a);
  let n = t._corePipeline;
  if (!n) {
    const i = `azsdk-js-azure-storage-blob/${Xi}`, s = e.userAgentOptions && e.userAgentOptions.userAgentPrefix ? `${e.userAgentOptions.userAgentPrefix} ${i}` : `${i}`;
    n = Qi({
      ...e,
      loggingOptions: {
        additionalAllowedHeaderNames: Ug,
        additionalAllowedQueryParameters: qg,
        logger: _i.info
      },
      userAgentOptions: {
        userAgentPrefix: s
      },
      serializationOptions: {
        stringifyXML: Fi,
        serializerOptions: {
          xml: {
            // Use customized XML char key of "#" so we can deserialize metadata
            // with "_" key
            xmlCharKey: "#"
          }
        }
      },
      deserializationOptions: {
        parseXML: Vu,
        serializerOptions: {
          xml: {
            // Use customized XML char key of "#" so we can deserialize metadata
            // with "_" key
            xmlCharKey: "#"
          }
        }
      }
    }), n.removePolicy({ phase: "Retry" }), n.removePolicy({ name: mp }), n.addPolicy(Pg()), n.addPolicy(zg(e.retryOptions), { phase: "Retry" }), n.addPolicy(Qg()), n.addPolicy(bg());
    const o = Gg(t);
    o && n.addPolicy(o.wrappedPolicies, o.afterRetry ? { afterPhase: "Retry" } : void 0);
    const m = es(t);
    Ie(m) ? n.addPolicy(La({
      credential: m,
      scopes: e.audience ?? Wi,
      challengeCallbacks: { authorizeRequestOnChallenge: vi }
    }), { phase: "Sign" }) : m instanceof Me && n.addPolicy(Ji({
      accountName: m.accountName,
      accountKey: m.accountKey
    }), { phase: "Sign" }), t._corePipeline = n;
  }
  return {
    ...e,
    allowInsecureConnection: !0,
    httpClient: a,
    pipeline: n
  };
}
function es(t) {
  if (t._credential)
    return t._credential;
  let r = new K();
  for (const e of t.factories)
    if (Ie(e.credential))
      r = e.credential;
    else if (ts(e))
      return e;
  return r;
}
function ts(t) {
  return t instanceof Me ? !0 : t.constructor.name === "StorageSharedKeyCredential";
}
function Yg(t) {
  return t instanceof K ? !0 : t.constructor.name === "AnonymousCredential";
}
function Kg(t) {
  return Ie(t.credential);
}
function Jg(t) {
  return t instanceof fg ? !0 : t.constructor.name === "StorageBrowserPolicyFactory";
}
function Xg(t) {
  return t instanceof Ig ? !0 : t.constructor.name === "StorageRetryPolicyFactory";
}
function Wg(t) {
  return t.constructor.name === "TelemetryPolicyFactory";
}
function jg(t) {
  return t.constructor.name === "InjectorPolicyFactory";
}
function Zg(t) {
  const r = [
    "GenerateClientRequestIdPolicy",
    "TracingPolicy",
    "LogPolicy",
    "ProxyPolicy",
    "DisableResponseDecompressionPolicy",
    "KeepAlivePolicy",
    "DeserializationPolicy"
  ], e = {
    sendRequest: async (s) => ({
      request: s,
      headers: s.headers.clone(),
      status: 500
    })
  }, a = {
    log(s, o) {
    },
    shouldLog(s) {
      return !1;
    }
  }, i = t.create(e, a).constructor.name;
  return r.some((s) => i.startsWith(s));
}
var On;
(function(t) {
  t.AES256 = "AES256";
})(On || (On = {}));
var Fn;
(function(t) {
  t.Backup = "backup";
})(Fn || (Fn = {}));
var _n;
(function(t) {
  t.NeverExpire = "NeverExpire", t.RelativeToCreation = "RelativeToCreation", t.RelativeToNow = "RelativeToNow", t.Absolute = "Absolute";
})(_n || (_n = {}));
var Gn;
(function(t) {
  t.AccountAlreadyExists = "AccountAlreadyExists", t.AccountBeingCreated = "AccountBeingCreated", t.AccountIsDisabled = "AccountIsDisabled", t.AuthenticationFailed = "AuthenticationFailed", t.AuthorizationFailure = "AuthorizationFailure", t.ConditionHeadersNotSupported = "ConditionHeadersNotSupported", t.ConditionNotMet = "ConditionNotMet", t.EmptyMetadataKey = "EmptyMetadataKey", t.InsufficientAccountPermissions = "InsufficientAccountPermissions", t.InternalError = "InternalError", t.InvalidAuthenticationInfo = "InvalidAuthenticationInfo", t.InvalidHeaderValue = "InvalidHeaderValue", t.InvalidHttpVerb = "InvalidHttpVerb", t.InvalidInput = "InvalidInput", t.InvalidMd5 = "InvalidMd5", t.InvalidMetadata = "InvalidMetadata", t.InvalidQueryParameterValue = "InvalidQueryParameterValue", t.InvalidRange = "InvalidRange", t.InvalidResourceName = "InvalidResourceName", t.InvalidUri = "InvalidUri", t.InvalidXmlDocument = "InvalidXmlDocument", t.InvalidXmlNodeValue = "InvalidXmlNodeValue", t.Md5Mismatch = "Md5Mismatch", t.MetadataTooLarge = "MetadataTooLarge", t.MissingContentLengthHeader = "MissingContentLengthHeader", t.MissingRequiredQueryParameter = "MissingRequiredQueryParameter", t.MissingRequiredHeader = "MissingRequiredHeader", t.MissingRequiredXmlNode = "MissingRequiredXmlNode", t.MultipleConditionHeadersNotSupported = "MultipleConditionHeadersNotSupported", t.OperationTimedOut = "OperationTimedOut", t.OutOfRangeInput = "OutOfRangeInput", t.OutOfRangeQueryParameterValue = "OutOfRangeQueryParameterValue", t.RequestBodyTooLarge = "RequestBodyTooLarge", t.ResourceTypeMismatch = "ResourceTypeMismatch", t.RequestUrlFailedToParse = "RequestUrlFailedToParse", t.ResourceAlreadyExists = "ResourceAlreadyExists", t.ResourceNotFound = "ResourceNotFound", t.ServerBusy = "ServerBusy", t.UnsupportedHeader = "UnsupportedHeader", t.UnsupportedXmlNode = "UnsupportedXmlNode", t.UnsupportedQueryParameter = "UnsupportedQueryParameter", t.UnsupportedHttpVerb = "UnsupportedHttpVerb", t.AppendPositionConditionNotMet = "AppendPositionConditionNotMet", t.BlobAlreadyExists = "BlobAlreadyExists", t.BlobImmutableDueToPolicy = "BlobImmutableDueToPolicy", t.BlobNotFound = "BlobNotFound", t.BlobOverwritten = "BlobOverwritten", t.BlobTierInadequateForContentLength = "BlobTierInadequateForContentLength", t.BlobUsesCustomerSpecifiedEncryption = "BlobUsesCustomerSpecifiedEncryption", t.BlockCountExceedsLimit = "BlockCountExceedsLimit", t.BlockListTooLong = "BlockListTooLong", t.CannotChangeToLowerTier = "CannotChangeToLowerTier", t.CannotVerifyCopySource = "CannotVerifyCopySource", t.ContainerAlreadyExists = "ContainerAlreadyExists", t.ContainerBeingDeleted = "ContainerBeingDeleted", t.ContainerDisabled = "ContainerDisabled", t.ContainerNotFound = "ContainerNotFound", t.ContentLengthLargerThanTierLimit = "ContentLengthLargerThanTierLimit", t.CopyAcrossAccountsNotSupported = "CopyAcrossAccountsNotSupported", t.CopyIdMismatch = "CopyIdMismatch", t.FeatureVersionMismatch = "FeatureVersionMismatch", t.IncrementalCopyBlobMismatch = "IncrementalCopyBlobMismatch", t.IncrementalCopyOfEarlierSnapshotNotAllowed = "IncrementalCopyOfEarlierSnapshotNotAllowed", t.IncrementalCopySourceMustBeSnapshot = "IncrementalCopySourceMustBeSnapshot", t.InfiniteLeaseDurationRequired = "InfiniteLeaseDurationRequired", t.InvalidBlobOrBlock = "InvalidBlobOrBlock", t.InvalidBlobTier = "InvalidBlobTier", t.InvalidBlobType = "InvalidBlobType", t.InvalidBlockId = "InvalidBlockId", t.InvalidBlockList = "InvalidBlockList", t.InvalidOperation = "InvalidOperation", t.InvalidPageRange = "InvalidPageRange", t.InvalidSourceBlobType = "InvalidSourceBlobType", t.InvalidSourceBlobUrl = "InvalidSourceBlobUrl", t.InvalidVersionForPageBlobOperation = "InvalidVersionForPageBlobOperation", t.LeaseAlreadyPresent = "LeaseAlreadyPresent", t.LeaseAlreadyBroken = "LeaseAlreadyBroken", t.LeaseIdMismatchWithBlobOperation = "LeaseIdMismatchWithBlobOperation", t.LeaseIdMismatchWithContainerOperation = "LeaseIdMismatchWithContainerOperation", t.LeaseIdMismatchWithLeaseOperation = "LeaseIdMismatchWithLeaseOperation", t.LeaseIdMissing = "LeaseIdMissing", t.LeaseIsBreakingAndCannotBeAcquired = "LeaseIsBreakingAndCannotBeAcquired", t.LeaseIsBreakingAndCannotBeChanged = "LeaseIsBreakingAndCannotBeChanged", t.LeaseIsBrokenAndCannotBeRenewed = "LeaseIsBrokenAndCannotBeRenewed", t.LeaseLost = "LeaseLost", t.LeaseNotPresentWithBlobOperation = "LeaseNotPresentWithBlobOperation", t.LeaseNotPresentWithContainerOperation = "LeaseNotPresentWithContainerOperation", t.LeaseNotPresentWithLeaseOperation = "LeaseNotPresentWithLeaseOperation", t.MaxBlobSizeConditionNotMet = "MaxBlobSizeConditionNotMet", t.NoAuthenticationInformation = "NoAuthenticationInformation", t.NoPendingCopyOperation = "NoPendingCopyOperation", t.OperationNotAllowedOnIncrementalCopyBlob = "OperationNotAllowedOnIncrementalCopyBlob", t.PendingCopyOperation = "PendingCopyOperation", t.PreviousSnapshotCannotBeNewer = "PreviousSnapshotCannotBeNewer", t.PreviousSnapshotNotFound = "PreviousSnapshotNotFound", t.PreviousSnapshotOperationNotSupported = "PreviousSnapshotOperationNotSupported", t.SequenceNumberConditionNotMet = "SequenceNumberConditionNotMet", t.SequenceNumberIncrementTooLarge = "SequenceNumberIncrementTooLarge", t.SnapshotCountExceeded = "SnapshotCountExceeded", t.SnapshotOperationRateExceeded = "SnapshotOperationRateExceeded", t.SnapshotsPresent = "SnapshotsPresent", t.SourceConditionNotMet = "SourceConditionNotMet", t.SystemInUse = "SystemInUse", t.TargetConditionNotMet = "TargetConditionNotMet", t.UnauthorizedBlobOverwrite = "UnauthorizedBlobOverwrite", t.BlobBeingRehydrated = "BlobBeingRehydrated", t.BlobArchived = "BlobArchived", t.BlobNotArchived = "BlobNotArchived", t.AuthorizationSourceIPMismatch = "AuthorizationSourceIPMismatch", t.AuthorizationProtocolMismatch = "AuthorizationProtocolMismatch", t.AuthorizationPermissionMismatch = "AuthorizationPermissionMismatch", t.AuthorizationServiceMismatch = "AuthorizationServiceMismatch", t.AuthorizationResourceTypeMismatch = "AuthorizationResourceTypeMismatch", t.BlobAccessTierNotSupportedForAccountType = "BlobAccessTierNotSupportedForAccountType";
})(Gn || (Gn = {}));
const Ga = {
  serializedName: "BlobServiceProperties",
  xmlName: "StorageServiceProperties",
  type: {
    name: "Composite",
    className: "BlobServiceProperties",
    modelProperties: {
      blobAnalyticsLogging: {
        serializedName: "Logging",
        xmlName: "Logging",
        type: {
          name: "Composite",
          className: "Logging"
        }
      },
      hourMetrics: {
        serializedName: "HourMetrics",
        xmlName: "HourMetrics",
        type: {
          name: "Composite",
          className: "Metrics"
        }
      },
      minuteMetrics: {
        serializedName: "MinuteMetrics",
        xmlName: "MinuteMetrics",
        type: {
          name: "Composite",
          className: "Metrics"
        }
      },
      cors: {
        serializedName: "Cors",
        xmlName: "Cors",
        xmlIsWrapped: !0,
        xmlElementName: "CorsRule",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CorsRule"
            }
          }
        }
      },
      defaultServiceVersion: {
        serializedName: "DefaultServiceVersion",
        xmlName: "DefaultServiceVersion",
        type: {
          name: "String"
        }
      },
      deleteRetentionPolicy: {
        serializedName: "DeleteRetentionPolicy",
        xmlName: "DeleteRetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy"
        }
      },
      staticWebsite: {
        serializedName: "StaticWebsite",
        xmlName: "StaticWebsite",
        type: {
          name: "Composite",
          className: "StaticWebsite"
        }
      }
    }
  }
}, Vg = {
  serializedName: "Logging",
  type: {
    name: "Composite",
    className: "Logging",
    modelProperties: {
      version: {
        serializedName: "Version",
        required: !0,
        xmlName: "Version",
        type: {
          name: "String"
        }
      },
      deleteProperty: {
        serializedName: "Delete",
        required: !0,
        xmlName: "Delete",
        type: {
          name: "Boolean"
        }
      },
      read: {
        serializedName: "Read",
        required: !0,
        xmlName: "Read",
        type: {
          name: "Boolean"
        }
      },
      write: {
        serializedName: "Write",
        required: !0,
        xmlName: "Write",
        type: {
          name: "Boolean"
        }
      },
      retentionPolicy: {
        serializedName: "RetentionPolicy",
        xmlName: "RetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy"
        }
      }
    }
  }
}, $g = {
  serializedName: "RetentionPolicy",
  type: {
    name: "Composite",
    className: "RetentionPolicy",
    modelProperties: {
      enabled: {
        serializedName: "Enabled",
        required: !0,
        xmlName: "Enabled",
        type: {
          name: "Boolean"
        }
      },
      days: {
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "Days",
        xmlName: "Days",
        type: {
          name: "Number"
        }
      }
    }
  }
}, ey = {
  serializedName: "Metrics",
  type: {
    name: "Composite",
    className: "Metrics",
    modelProperties: {
      version: {
        serializedName: "Version",
        xmlName: "Version",
        type: {
          name: "String"
        }
      },
      enabled: {
        serializedName: "Enabled",
        required: !0,
        xmlName: "Enabled",
        type: {
          name: "Boolean"
        }
      },
      includeAPIs: {
        serializedName: "IncludeAPIs",
        xmlName: "IncludeAPIs",
        type: {
          name: "Boolean"
        }
      },
      retentionPolicy: {
        serializedName: "RetentionPolicy",
        xmlName: "RetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy"
        }
      }
    }
  }
}, ty = {
  serializedName: "CorsRule",
  type: {
    name: "Composite",
    className: "CorsRule",
    modelProperties: {
      allowedOrigins: {
        serializedName: "AllowedOrigins",
        required: !0,
        xmlName: "AllowedOrigins",
        type: {
          name: "String"
        }
      },
      allowedMethods: {
        serializedName: "AllowedMethods",
        required: !0,
        xmlName: "AllowedMethods",
        type: {
          name: "String"
        }
      },
      allowedHeaders: {
        serializedName: "AllowedHeaders",
        required: !0,
        xmlName: "AllowedHeaders",
        type: {
          name: "String"
        }
      },
      exposedHeaders: {
        serializedName: "ExposedHeaders",
        required: !0,
        xmlName: "ExposedHeaders",
        type: {
          name: "String"
        }
      },
      maxAgeInSeconds: {
        constraints: {
          InclusiveMinimum: 0
        },
        serializedName: "MaxAgeInSeconds",
        required: !0,
        xmlName: "MaxAgeInSeconds",
        type: {
          name: "Number"
        }
      }
    }
  }
}, ry = {
  serializedName: "StaticWebsite",
  type: {
    name: "Composite",
    className: "StaticWebsite",
    modelProperties: {
      enabled: {
        serializedName: "Enabled",
        required: !0,
        xmlName: "Enabled",
        type: {
          name: "Boolean"
        }
      },
      indexDocument: {
        serializedName: "IndexDocument",
        xmlName: "IndexDocument",
        type: {
          name: "String"
        }
      },
      errorDocument404Path: {
        serializedName: "ErrorDocument404Path",
        xmlName: "ErrorDocument404Path",
        type: {
          name: "String"
        }
      },
      defaultIndexDocumentPath: {
        serializedName: "DefaultIndexDocumentPath",
        xmlName: "DefaultIndexDocumentPath",
        type: {
          name: "String"
        }
      }
    }
  }
}, B = {
  serializedName: "StorageError",
  type: {
    name: "Composite",
    className: "StorageError",
    modelProperties: {
      message: {
        serializedName: "Message",
        xmlName: "Message",
        type: {
          name: "String"
        }
      },
      copySourceStatusCode: {
        serializedName: "CopySourceStatusCode",
        xmlName: "CopySourceStatusCode",
        type: {
          name: "Number"
        }
      },
      copySourceErrorCode: {
        serializedName: "CopySourceErrorCode",
        xmlName: "CopySourceErrorCode",
        type: {
          name: "String"
        }
      },
      copySourceErrorMessage: {
        serializedName: "CopySourceErrorMessage",
        xmlName: "CopySourceErrorMessage",
        type: {
          name: "String"
        }
      },
      code: {
        serializedName: "Code",
        xmlName: "Code",
        type: {
          name: "String"
        }
      },
      authenticationErrorDetail: {
        serializedName: "AuthenticationErrorDetail",
        xmlName: "AuthenticationErrorDetail",
        type: {
          name: "String"
        }
      }
    }
  }
}, rs = {
  serializedName: "BlobServiceStatistics",
  xmlName: "StorageServiceStats",
  type: {
    name: "Composite",
    className: "BlobServiceStatistics",
    modelProperties: {
      geoReplication: {
        serializedName: "GeoReplication",
        xmlName: "GeoReplication",
        type: {
          name: "Composite",
          className: "GeoReplication"
        }
      }
    }
  }
}, ay = {
  serializedName: "GeoReplication",
  type: {
    name: "Composite",
    className: "GeoReplication",
    modelProperties: {
      status: {
        serializedName: "Status",
        required: !0,
        xmlName: "Status",
        type: {
          name: "Enum",
          allowedValues: ["live", "bootstrap", "unavailable"]
        }
      },
      lastSyncOn: {
        serializedName: "LastSyncTime",
        required: !0,
        xmlName: "LastSyncTime",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, as = {
  serializedName: "ListContainersSegmentResponse",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "ListContainersSegmentResponse",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      prefix: {
        serializedName: "Prefix",
        xmlName: "Prefix",
        type: {
          name: "String"
        }
      },
      marker: {
        serializedName: "Marker",
        xmlName: "Marker",
        type: {
          name: "String"
        }
      },
      maxPageSize: {
        serializedName: "MaxResults",
        xmlName: "MaxResults",
        type: {
          name: "Number"
        }
      },
      containerItems: {
        serializedName: "ContainerItems",
        required: !0,
        xmlName: "Containers",
        xmlIsWrapped: !0,
        xmlElementName: "Container",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ContainerItem"
            }
          }
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, ny = {
  serializedName: "ContainerItem",
  xmlName: "Container",
  type: {
    name: "Composite",
    className: "ContainerItem",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: !0,
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      deleted: {
        serializedName: "Deleted",
        xmlName: "Deleted",
        type: {
          name: "Boolean"
        }
      },
      version: {
        serializedName: "Version",
        xmlName: "Version",
        type: {
          name: "String"
        }
      },
      properties: {
        serializedName: "Properties",
        xmlName: "Properties",
        type: {
          name: "Composite",
          className: "ContainerProperties"
        }
      },
      metadata: {
        serializedName: "Metadata",
        xmlName: "Metadata",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      }
    }
  }
}, iy = {
  serializedName: "ContainerProperties",
  type: {
    name: "Composite",
    className: "ContainerProperties",
    modelProperties: {
      lastModified: {
        serializedName: "Last-Modified",
        required: !0,
        xmlName: "Last-Modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "Etag",
        required: !0,
        xmlName: "Etag",
        type: {
          name: "String"
        }
      },
      leaseStatus: {
        serializedName: "LeaseStatus",
        xmlName: "LeaseStatus",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      leaseState: {
        serializedName: "LeaseState",
        xmlName: "LeaseState",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseDuration: {
        serializedName: "LeaseDuration",
        xmlName: "LeaseDuration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      publicAccess: {
        serializedName: "PublicAccess",
        xmlName: "PublicAccess",
        type: {
          name: "Enum",
          allowedValues: ["container", "blob"]
        }
      },
      hasImmutabilityPolicy: {
        serializedName: "HasImmutabilityPolicy",
        xmlName: "HasImmutabilityPolicy",
        type: {
          name: "Boolean"
        }
      },
      hasLegalHold: {
        serializedName: "HasLegalHold",
        xmlName: "HasLegalHold",
        type: {
          name: "Boolean"
        }
      },
      defaultEncryptionScope: {
        serializedName: "DefaultEncryptionScope",
        xmlName: "DefaultEncryptionScope",
        type: {
          name: "String"
        }
      },
      preventEncryptionScopeOverride: {
        serializedName: "DenyEncryptionScopeOverride",
        xmlName: "DenyEncryptionScopeOverride",
        type: {
          name: "Boolean"
        }
      },
      deletedOn: {
        serializedName: "DeletedTime",
        xmlName: "DeletedTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      remainingRetentionDays: {
        serializedName: "RemainingRetentionDays",
        xmlName: "RemainingRetentionDays",
        type: {
          name: "Number"
        }
      },
      isImmutableStorageWithVersioningEnabled: {
        serializedName: "ImmutableStorageWithVersioningEnabled",
        xmlName: "ImmutableStorageWithVersioningEnabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, ns = {
  serializedName: "KeyInfo",
  type: {
    name: "Composite",
    className: "KeyInfo",
    modelProperties: {
      startsOn: {
        serializedName: "Start",
        required: !0,
        xmlName: "Start",
        type: {
          name: "String"
        }
      },
      expiresOn: {
        serializedName: "Expiry",
        required: !0,
        xmlName: "Expiry",
        type: {
          name: "String"
        }
      },
      delegatedUserTid: {
        serializedName: "DelegatedUserTid",
        xmlName: "DelegatedUserTid",
        type: {
          name: "String"
        }
      }
    }
  }
}, is = {
  serializedName: "UserDelegationKey",
  type: {
    name: "Composite",
    className: "UserDelegationKey",
    modelProperties: {
      signedObjectId: {
        serializedName: "SignedOid",
        required: !0,
        xmlName: "SignedOid",
        type: {
          name: "String"
        }
      },
      signedTenantId: {
        serializedName: "SignedTid",
        required: !0,
        xmlName: "SignedTid",
        type: {
          name: "String"
        }
      },
      signedStartsOn: {
        serializedName: "SignedStart",
        required: !0,
        xmlName: "SignedStart",
        type: {
          name: "String"
        }
      },
      signedExpiresOn: {
        serializedName: "SignedExpiry",
        required: !0,
        xmlName: "SignedExpiry",
        type: {
          name: "String"
        }
      },
      signedService: {
        serializedName: "SignedService",
        required: !0,
        xmlName: "SignedService",
        type: {
          name: "String"
        }
      },
      signedVersion: {
        serializedName: "SignedVersion",
        required: !0,
        xmlName: "SignedVersion",
        type: {
          name: "String"
        }
      },
      signedDelegatedUserTenantId: {
        serializedName: "SignedDelegatedUserTid",
        xmlName: "SignedDelegatedUserTid",
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "Value",
        required: !0,
        xmlName: "Value",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ya = {
  serializedName: "FilterBlobSegment",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "FilterBlobSegment",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      where: {
        serializedName: "Where",
        required: !0,
        xmlName: "Where",
        type: {
          name: "String"
        }
      },
      blobs: {
        serializedName: "Blobs",
        required: !0,
        xmlName: "Blobs",
        xmlIsWrapped: !0,
        xmlElementName: "Blob",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FilterBlobItem"
            }
          }
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, sy = {
  serializedName: "FilterBlobItem",
  xmlName: "Blob",
  type: {
    name: "Composite",
    className: "FilterBlobItem",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: !0,
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      containerName: {
        serializedName: "ContainerName",
        required: !0,
        xmlName: "ContainerName",
        type: {
          name: "String"
        }
      },
      tags: {
        serializedName: "Tags",
        xmlName: "Tags",
        type: {
          name: "Composite",
          className: "BlobTags"
        }
      }
    }
  }
}, Ka = {
  serializedName: "BlobTags",
  xmlName: "Tags",
  type: {
    name: "Composite",
    className: "BlobTags",
    modelProperties: {
      blobTagSet: {
        serializedName: "BlobTagSet",
        required: !0,
        xmlName: "TagSet",
        xmlIsWrapped: !0,
        xmlElementName: "Tag",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobTag"
            }
          }
        }
      }
    }
  }
}, oy = {
  serializedName: "BlobTag",
  xmlName: "Tag",
  type: {
    name: "Composite",
    className: "BlobTag",
    modelProperties: {
      key: {
        serializedName: "Key",
        required: !0,
        xmlName: "Key",
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "Value",
        required: !0,
        xmlName: "Value",
        type: {
          name: "String"
        }
      }
    }
  }
}, my = {
  serializedName: "SignedIdentifier",
  xmlName: "SignedIdentifier",
  type: {
    name: "Composite",
    className: "SignedIdentifier",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: !0,
        xmlName: "Id",
        type: {
          name: "String"
        }
      },
      accessPolicy: {
        serializedName: "AccessPolicy",
        xmlName: "AccessPolicy",
        type: {
          name: "Composite",
          className: "AccessPolicy"
        }
      }
    }
  }
}, cy = {
  serializedName: "AccessPolicy",
  type: {
    name: "Composite",
    className: "AccessPolicy",
    modelProperties: {
      startsOn: {
        serializedName: "Start",
        xmlName: "Start",
        type: {
          name: "String"
        }
      },
      expiresOn: {
        serializedName: "Expiry",
        xmlName: "Expiry",
        type: {
          name: "String"
        }
      },
      permissions: {
        serializedName: "Permission",
        xmlName: "Permission",
        type: {
          name: "String"
        }
      }
    }
  }
}, ss = {
  serializedName: "ListBlobsFlatSegmentResponse",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "ListBlobsFlatSegmentResponse",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      containerName: {
        serializedName: "ContainerName",
        required: !0,
        xmlName: "ContainerName",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      prefix: {
        serializedName: "Prefix",
        xmlName: "Prefix",
        type: {
          name: "String"
        }
      },
      marker: {
        serializedName: "Marker",
        xmlName: "Marker",
        type: {
          name: "String"
        }
      },
      maxPageSize: {
        serializedName: "MaxResults",
        xmlName: "MaxResults",
        type: {
          name: "Number"
        }
      },
      segment: {
        serializedName: "Segment",
        xmlName: "Blobs",
        type: {
          name: "Composite",
          className: "BlobFlatListSegment"
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, ly = {
  serializedName: "BlobFlatListSegment",
  xmlName: "Blobs",
  type: {
    name: "Composite",
    className: "BlobFlatListSegment",
    modelProperties: {
      blobItems: {
        serializedName: "BlobItems",
        required: !0,
        xmlName: "BlobItems",
        xmlElementName: "Blob",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobItemInternal"
            }
          }
        }
      }
    }
  }
}, dy = {
  serializedName: "BlobItemInternal",
  xmlName: "Blob",
  type: {
    name: "Composite",
    className: "BlobItemInternal",
    modelProperties: {
      name: {
        serializedName: "Name",
        xmlName: "Name",
        type: {
          name: "Composite",
          className: "BlobName"
        }
      },
      deleted: {
        serializedName: "Deleted",
        required: !0,
        xmlName: "Deleted",
        type: {
          name: "Boolean"
        }
      },
      snapshot: {
        serializedName: "Snapshot",
        required: !0,
        xmlName: "Snapshot",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "VersionId",
        xmlName: "VersionId",
        type: {
          name: "String"
        }
      },
      isCurrentVersion: {
        serializedName: "IsCurrentVersion",
        xmlName: "IsCurrentVersion",
        type: {
          name: "Boolean"
        }
      },
      properties: {
        serializedName: "Properties",
        xmlName: "Properties",
        type: {
          name: "Composite",
          className: "BlobPropertiesInternal"
        }
      },
      metadata: {
        serializedName: "Metadata",
        xmlName: "Metadata",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      blobTags: {
        serializedName: "BlobTags",
        xmlName: "Tags",
        type: {
          name: "Composite",
          className: "BlobTags"
        }
      },
      objectReplicationMetadata: {
        serializedName: "ObjectReplicationMetadata",
        xmlName: "OrMetadata",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      hasVersionsOnly: {
        serializedName: "HasVersionsOnly",
        xmlName: "HasVersionsOnly",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, py = {
  serializedName: "BlobName",
  type: {
    name: "Composite",
    className: "BlobName",
    modelProperties: {
      encoded: {
        serializedName: "Encoded",
        xmlName: "Encoded",
        xmlIsAttribute: !0,
        type: {
          name: "Boolean"
        }
      },
      content: {
        serializedName: "content",
        xmlName: "content",
        xmlIsMsText: !0,
        type: {
          name: "String"
        }
      }
    }
  }
}, uy = {
  serializedName: "BlobPropertiesInternal",
  xmlName: "Properties",
  type: {
    name: "Composite",
    className: "BlobPropertiesInternal",
    modelProperties: {
      createdOn: {
        serializedName: "Creation-Time",
        xmlName: "Creation-Time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      lastModified: {
        serializedName: "Last-Modified",
        required: !0,
        xmlName: "Last-Modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "Etag",
        required: !0,
        xmlName: "Etag",
        type: {
          name: "String"
        }
      },
      contentLength: {
        serializedName: "Content-Length",
        xmlName: "Content-Length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "Content-Type",
        xmlName: "Content-Type",
        type: {
          name: "String"
        }
      },
      contentEncoding: {
        serializedName: "Content-Encoding",
        xmlName: "Content-Encoding",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "Content-Language",
        xmlName: "Content-Language",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "Content-MD5",
        xmlName: "Content-MD5",
        type: {
          name: "ByteArray"
        }
      },
      contentDisposition: {
        serializedName: "Content-Disposition",
        xmlName: "Content-Disposition",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "Cache-Control",
        xmlName: "Cache-Control",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      blobType: {
        serializedName: "BlobType",
        xmlName: "BlobType",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      leaseStatus: {
        serializedName: "LeaseStatus",
        xmlName: "LeaseStatus",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      leaseState: {
        serializedName: "LeaseState",
        xmlName: "LeaseState",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseDuration: {
        serializedName: "LeaseDuration",
        xmlName: "LeaseDuration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      copyId: {
        serializedName: "CopyId",
        xmlName: "CopyId",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "CopyStatus",
        xmlName: "CopyStatus",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      copySource: {
        serializedName: "CopySource",
        xmlName: "CopySource",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "CopyProgress",
        xmlName: "CopyProgress",
        type: {
          name: "String"
        }
      },
      copyCompletedOn: {
        serializedName: "CopyCompletionTime",
        xmlName: "CopyCompletionTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "CopyStatusDescription",
        xmlName: "CopyStatusDescription",
        type: {
          name: "String"
        }
      },
      serverEncrypted: {
        serializedName: "ServerEncrypted",
        xmlName: "ServerEncrypted",
        type: {
          name: "Boolean"
        }
      },
      incrementalCopy: {
        serializedName: "IncrementalCopy",
        xmlName: "IncrementalCopy",
        type: {
          name: "Boolean"
        }
      },
      destinationSnapshot: {
        serializedName: "DestinationSnapshot",
        xmlName: "DestinationSnapshot",
        type: {
          name: "String"
        }
      },
      deletedOn: {
        serializedName: "DeletedTime",
        xmlName: "DeletedTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      remainingRetentionDays: {
        serializedName: "RemainingRetentionDays",
        xmlName: "RemainingRetentionDays",
        type: {
          name: "Number"
        }
      },
      accessTier: {
        serializedName: "AccessTier",
        xmlName: "AccessTier",
        type: {
          name: "Enum",
          allowedValues: [
            "P4",
            "P6",
            "P10",
            "P15",
            "P20",
            "P30",
            "P40",
            "P50",
            "P60",
            "P70",
            "P80",
            "Hot",
            "Cool",
            "Archive",
            "Cold"
          ]
        }
      },
      accessTierInferred: {
        serializedName: "AccessTierInferred",
        xmlName: "AccessTierInferred",
        type: {
          name: "Boolean"
        }
      },
      archiveStatus: {
        serializedName: "ArchiveStatus",
        xmlName: "ArchiveStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "rehydrate-pending-to-hot",
            "rehydrate-pending-to-cool",
            "rehydrate-pending-to-cold"
          ]
        }
      },
      customerProvidedKeySha256: {
        serializedName: "CustomerProvidedKeySha256",
        xmlName: "CustomerProvidedKeySha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "EncryptionScope",
        xmlName: "EncryptionScope",
        type: {
          name: "String"
        }
      },
      accessTierChangedOn: {
        serializedName: "AccessTierChangeTime",
        xmlName: "AccessTierChangeTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      tagCount: {
        serializedName: "TagCount",
        xmlName: "TagCount",
        type: {
          name: "Number"
        }
      },
      expiresOn: {
        serializedName: "Expiry-Time",
        xmlName: "Expiry-Time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isSealed: {
        serializedName: "Sealed",
        xmlName: "Sealed",
        type: {
          name: "Boolean"
        }
      },
      rehydratePriority: {
        serializedName: "RehydratePriority",
        xmlName: "RehydratePriority",
        type: {
          name: "Enum",
          allowedValues: ["High", "Standard"]
        }
      },
      lastAccessedOn: {
        serializedName: "LastAccessTime",
        xmlName: "LastAccessTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiresOn: {
        serializedName: "ImmutabilityPolicyUntilDate",
        xmlName: "ImmutabilityPolicyUntilDate",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "ImmutabilityPolicyMode",
        xmlName: "ImmutabilityPolicyMode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      },
      legalHold: {
        serializedName: "LegalHold",
        xmlName: "LegalHold",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, os = {
  serializedName: "ListBlobsHierarchySegmentResponse",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "ListBlobsHierarchySegmentResponse",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      containerName: {
        serializedName: "ContainerName",
        required: !0,
        xmlName: "ContainerName",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      prefix: {
        serializedName: "Prefix",
        xmlName: "Prefix",
        type: {
          name: "String"
        }
      },
      marker: {
        serializedName: "Marker",
        xmlName: "Marker",
        type: {
          name: "String"
        }
      },
      maxPageSize: {
        serializedName: "MaxResults",
        xmlName: "MaxResults",
        type: {
          name: "Number"
        }
      },
      delimiter: {
        serializedName: "Delimiter",
        xmlName: "Delimiter",
        type: {
          name: "String"
        }
      },
      segment: {
        serializedName: "Segment",
        xmlName: "Blobs",
        type: {
          name: "Composite",
          className: "BlobHierarchyListSegment"
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, gy = {
  serializedName: "BlobHierarchyListSegment",
  xmlName: "Blobs",
  type: {
    name: "Composite",
    className: "BlobHierarchyListSegment",
    modelProperties: {
      blobPrefixes: {
        serializedName: "BlobPrefixes",
        xmlName: "BlobPrefixes",
        xmlElementName: "BlobPrefix",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobPrefix"
            }
          }
        }
      },
      blobItems: {
        serializedName: "BlobItems",
        required: !0,
        xmlName: "BlobItems",
        xmlElementName: "Blob",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobItemInternal"
            }
          }
        }
      }
    }
  }
}, yy = {
  serializedName: "BlobPrefix",
  type: {
    name: "Composite",
    className: "BlobPrefix",
    modelProperties: {
      name: {
        serializedName: "Name",
        xmlName: "Name",
        type: {
          name: "Composite",
          className: "BlobName"
        }
      }
    }
  }
}, ms = {
  serializedName: "BlockLookupList",
  xmlName: "BlockList",
  type: {
    name: "Composite",
    className: "BlockLookupList",
    modelProperties: {
      committed: {
        serializedName: "Committed",
        xmlName: "Committed",
        xmlElementName: "Committed",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      uncommitted: {
        serializedName: "Uncommitted",
        xmlName: "Uncommitted",
        xmlElementName: "Uncommitted",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      latest: {
        serializedName: "Latest",
        xmlName: "Latest",
        xmlElementName: "Latest",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
}, cs = {
  serializedName: "BlockList",
  type: {
    name: "Composite",
    className: "BlockList",
    modelProperties: {
      committedBlocks: {
        serializedName: "CommittedBlocks",
        xmlName: "CommittedBlocks",
        xmlIsWrapped: !0,
        xmlElementName: "Block",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Block"
            }
          }
        }
      },
      uncommittedBlocks: {
        serializedName: "UncommittedBlocks",
        xmlName: "UncommittedBlocks",
        xmlIsWrapped: !0,
        xmlElementName: "Block",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Block"
            }
          }
        }
      }
    }
  }
}, hy = {
  serializedName: "Block",
  type: {
    name: "Composite",
    className: "Block",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: !0,
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      size: {
        serializedName: "Size",
        required: !0,
        xmlName: "Size",
        type: {
          name: "Number"
        }
      }
    }
  }
}, Ja = {
  serializedName: "PageList",
  type: {
    name: "Composite",
    className: "PageList",
    modelProperties: {
      pageRange: {
        serializedName: "PageRange",
        xmlName: "PageRange",
        xmlElementName: "PageRange",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PageRange"
            }
          }
        }
      },
      clearRange: {
        serializedName: "ClearRange",
        xmlName: "ClearRange",
        xmlElementName: "ClearRange",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ClearRange"
            }
          }
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, fy = {
  serializedName: "PageRange",
  xmlName: "PageRange",
  type: {
    name: "Composite",
    className: "PageRange",
    modelProperties: {
      start: {
        serializedName: "Start",
        required: !0,
        xmlName: "Start",
        type: {
          name: "Number"
        }
      },
      end: {
        serializedName: "End",
        required: !0,
        xmlName: "End",
        type: {
          name: "Number"
        }
      }
    }
  }
}, Ay = {
  serializedName: "ClearRange",
  xmlName: "ClearRange",
  type: {
    name: "Composite",
    className: "ClearRange",
    modelProperties: {
      start: {
        serializedName: "Start",
        required: !0,
        xmlName: "Start",
        type: {
          name: "Number"
        }
      },
      end: {
        serializedName: "End",
        required: !0,
        xmlName: "End",
        type: {
          name: "Number"
        }
      }
    }
  }
}, ls = {
  serializedName: "QueryRequest",
  xmlName: "QueryRequest",
  type: {
    name: "Composite",
    className: "QueryRequest",
    modelProperties: {
      queryType: {
        serializedName: "QueryType",
        required: !0,
        xmlName: "QueryType",
        type: {
          name: "String"
        }
      },
      expression: {
        serializedName: "Expression",
        required: !0,
        xmlName: "Expression",
        type: {
          name: "String"
        }
      },
      inputSerialization: {
        serializedName: "InputSerialization",
        xmlName: "InputSerialization",
        type: {
          name: "Composite",
          className: "QuerySerialization"
        }
      },
      outputSerialization: {
        serializedName: "OutputSerialization",
        xmlName: "OutputSerialization",
        type: {
          name: "Composite",
          className: "QuerySerialization"
        }
      }
    }
  }
}, Ny = {
  serializedName: "QuerySerialization",
  type: {
    name: "Composite",
    className: "QuerySerialization",
    modelProperties: {
      format: {
        serializedName: "Format",
        xmlName: "Format",
        type: {
          name: "Composite",
          className: "QueryFormat"
        }
      }
    }
  }
}, Cy = {
  serializedName: "QueryFormat",
  type: {
    name: "Composite",
    className: "QueryFormat",
    modelProperties: {
      type: {
        serializedName: "Type",
        required: !0,
        xmlName: "Type",
        type: {
          name: "Enum",
          allowedValues: ["delimited", "json", "arrow", "parquet"]
        }
      },
      delimitedTextConfiguration: {
        serializedName: "DelimitedTextConfiguration",
        xmlName: "DelimitedTextConfiguration",
        type: {
          name: "Composite",
          className: "DelimitedTextConfiguration"
        }
      },
      jsonTextConfiguration: {
        serializedName: "JsonTextConfiguration",
        xmlName: "JsonTextConfiguration",
        type: {
          name: "Composite",
          className: "JsonTextConfiguration"
        }
      },
      arrowConfiguration: {
        serializedName: "ArrowConfiguration",
        xmlName: "ArrowConfiguration",
        type: {
          name: "Composite",
          className: "ArrowConfiguration"
        }
      },
      parquetTextConfiguration: {
        serializedName: "ParquetTextConfiguration",
        xmlName: "ParquetTextConfiguration",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } }
        }
      }
    }
  }
}, xy = {
  serializedName: "DelimitedTextConfiguration",
  xmlName: "DelimitedTextConfiguration",
  type: {
    name: "Composite",
    className: "DelimitedTextConfiguration",
    modelProperties: {
      columnSeparator: {
        serializedName: "ColumnSeparator",
        xmlName: "ColumnSeparator",
        type: {
          name: "String"
        }
      },
      fieldQuote: {
        serializedName: "FieldQuote",
        xmlName: "FieldQuote",
        type: {
          name: "String"
        }
      },
      recordSeparator: {
        serializedName: "RecordSeparator",
        xmlName: "RecordSeparator",
        type: {
          name: "String"
        }
      },
      escapeChar: {
        serializedName: "EscapeChar",
        xmlName: "EscapeChar",
        type: {
          name: "String"
        }
      },
      headersPresent: {
        serializedName: "HeadersPresent",
        xmlName: "HasHeaders",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, Iy = {
  serializedName: "JsonTextConfiguration",
  xmlName: "JsonTextConfiguration",
  type: {
    name: "Composite",
    className: "JsonTextConfiguration",
    modelProperties: {
      recordSeparator: {
        serializedName: "RecordSeparator",
        xmlName: "RecordSeparator",
        type: {
          name: "String"
        }
      }
    }
  }
}, By = {
  serializedName: "ArrowConfiguration",
  xmlName: "ArrowConfiguration",
  type: {
    name: "Composite",
    className: "ArrowConfiguration",
    modelProperties: {
      schema: {
        serializedName: "Schema",
        required: !0,
        xmlName: "Schema",
        xmlIsWrapped: !0,
        xmlElementName: "Field",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ArrowField"
            }
          }
        }
      }
    }
  }
}, by = {
  serializedName: "ArrowField",
  xmlName: "Field",
  type: {
    name: "Composite",
    className: "ArrowField",
    modelProperties: {
      type: {
        serializedName: "Type",
        required: !0,
        xmlName: "Type",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "Name",
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      precision: {
        serializedName: "Precision",
        xmlName: "Precision",
        type: {
          name: "Number"
        }
      },
      scale: {
        serializedName: "Scale",
        xmlName: "Scale",
        type: {
          name: "Number"
        }
      }
    }
  }
}, ds = {
  serializedName: "Service_setPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ServiceSetPropertiesHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ps = {
  serializedName: "Service_setPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceSetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, us = {
  serializedName: "Service_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetPropertiesHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, gs = {
  serializedName: "Service_getPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ys = {
  serializedName: "Service_getStatisticsHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetStatisticsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, hs = {
  serializedName: "Service_getStatisticsExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetStatisticsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, fs = {
  serializedName: "Service_listContainersSegmentHeaders",
  type: {
    name: "Composite",
    className: "ServiceListContainersSegmentHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, As = {
  serializedName: "Service_listContainersSegmentExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceListContainersSegmentExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ns = {
  serializedName: "Service_getUserDelegationKeyHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetUserDelegationKeyHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Cs = {
  serializedName: "Service_getUserDelegationKeyExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetUserDelegationKeyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, xs = {
  serializedName: "Service_getAccountInfoHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetAccountInfoHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      skuName: {
        serializedName: "x-ms-sku-name",
        xmlName: "x-ms-sku-name",
        type: {
          name: "Enum",
          allowedValues: [
            "Standard_LRS",
            "Standard_GRS",
            "Standard_RAGRS",
            "Standard_ZRS",
            "Premium_LRS",
            "Standard_GZRS",
            "Premium_ZRS",
            "Standard_RAGZRS"
          ]
        }
      },
      accountKind: {
        serializedName: "x-ms-account-kind",
        xmlName: "x-ms-account-kind",
        type: {
          name: "Enum",
          allowedValues: [
            "Storage",
            "BlobStorage",
            "StorageV2",
            "FileStorage",
            "BlockBlobStorage"
          ]
        }
      },
      isHierarchicalNamespaceEnabled: {
        serializedName: "x-ms-is-hns-enabled",
        xmlName: "x-ms-is-hns-enabled",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Is = {
  serializedName: "Service_getAccountInfoExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetAccountInfoExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Bs = {
  serializedName: "Service_submitBatchHeaders",
  type: {
    name: "Composite",
    className: "ServiceSubmitBatchHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, bs = {
  serializedName: "Service_submitBatchExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceSubmitBatchExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Es = {
  serializedName: "Service_filterBlobsHeaders",
  type: {
    name: "Composite",
    className: "ServiceFilterBlobsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ps = {
  serializedName: "Service_filterBlobsExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceFilterBlobsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ws = {
  serializedName: "Container_createHeaders",
  type: {
    name: "Composite",
    className: "ContainerCreateHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ss = {
  serializedName: "Container_createExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerCreateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Rs = {
  serializedName: "Container_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetPropertiesHeaders",
    modelProperties: {
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobPublicAccess: {
        serializedName: "x-ms-blob-public-access",
        xmlName: "x-ms-blob-public-access",
        type: {
          name: "Enum",
          allowedValues: ["container", "blob"]
        }
      },
      hasImmutabilityPolicy: {
        serializedName: "x-ms-has-immutability-policy",
        xmlName: "x-ms-has-immutability-policy",
        type: {
          name: "Boolean"
        }
      },
      hasLegalHold: {
        serializedName: "x-ms-has-legal-hold",
        xmlName: "x-ms-has-legal-hold",
        type: {
          name: "Boolean"
        }
      },
      defaultEncryptionScope: {
        serializedName: "x-ms-default-encryption-scope",
        xmlName: "x-ms-default-encryption-scope",
        type: {
          name: "String"
        }
      },
      denyEncryptionScopeOverride: {
        serializedName: "x-ms-deny-encryption-scope-override",
        xmlName: "x-ms-deny-encryption-scope-override",
        type: {
          name: "Boolean"
        }
      },
      isImmutableStorageWithVersioningEnabled: {
        serializedName: "x-ms-immutable-storage-with-versioning-enabled",
        xmlName: "x-ms-immutable-storage-with-versioning-enabled",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, zs = {
  serializedName: "Container_getPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ms = {
  serializedName: "Container_deleteHeaders",
  type: {
    name: "Composite",
    className: "ContainerDeleteHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ds = {
  serializedName: "Container_deleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerDeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Qs = {
  serializedName: "Container_setMetadataHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetMetadataHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ts = {
  serializedName: "Container_setMetadataExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetMetadataExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, vs = {
  serializedName: "Container_getAccessPolicyHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccessPolicyHeaders",
    modelProperties: {
      blobPublicAccess: {
        serializedName: "x-ms-blob-public-access",
        xmlName: "x-ms-blob-public-access",
        type: {
          name: "Enum",
          allowedValues: ["container", "blob"]
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Hs = {
  serializedName: "Container_getAccessPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccessPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ks = {
  serializedName: "Container_setAccessPolicyHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetAccessPolicyHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ls = {
  serializedName: "Container_setAccessPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetAccessPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Us = {
  serializedName: "Container_restoreHeaders",
  type: {
    name: "Composite",
    className: "ContainerRestoreHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, qs = {
  serializedName: "Container_restoreExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerRestoreExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Os = {
  serializedName: "Container_renameHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenameHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Fs = {
  serializedName: "Container_renameExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenameExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, _s = {
  serializedName: "Container_submitBatchHeaders",
  type: {
    name: "Composite",
    className: "ContainerSubmitBatchHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      }
    }
  }
}, Gs = {
  serializedName: "Container_submitBatchExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerSubmitBatchExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ys = {
  serializedName: "Container_filterBlobsHeaders",
  type: {
    name: "Composite",
    className: "ContainerFilterBlobsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Ks = {
  serializedName: "Container_filterBlobsExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerFilterBlobsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Js = {
  serializedName: "Container_acquireLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerAcquireLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Xs = {
  serializedName: "Container_acquireLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerAcquireLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ws = {
  serializedName: "Container_releaseLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerReleaseLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, js = {
  serializedName: "Container_releaseLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerReleaseLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Zs = {
  serializedName: "Container_renewLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenewLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Vs = {
  serializedName: "Container_renewLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenewLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, $s = {
  serializedName: "Container_breakLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerBreakLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseTime: {
        serializedName: "x-ms-lease-time",
        xmlName: "x-ms-lease-time",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, eo = {
  serializedName: "Container_breakLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerBreakLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, to = {
  serializedName: "Container_changeLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerChangeLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, ro = {
  serializedName: "Container_changeLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerChangeLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ao = {
  serializedName: "Container_listBlobFlatSegmentHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobFlatSegmentHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, no = {
  serializedName: "Container_listBlobFlatSegmentExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobFlatSegmentExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, io = {
  serializedName: "Container_listBlobHierarchySegmentHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobHierarchySegmentHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, so = {
  serializedName: "Container_listBlobHierarchySegmentExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobHierarchySegmentExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, oo = {
  serializedName: "Container_getAccountInfoHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccountInfoHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      skuName: {
        serializedName: "x-ms-sku-name",
        xmlName: "x-ms-sku-name",
        type: {
          name: "Enum",
          allowedValues: [
            "Standard_LRS",
            "Standard_GRS",
            "Standard_RAGRS",
            "Standard_ZRS",
            "Premium_LRS",
            "Standard_GZRS",
            "Premium_ZRS",
            "Standard_RAGZRS"
          ]
        }
      },
      accountKind: {
        serializedName: "x-ms-account-kind",
        xmlName: "x-ms-account-kind",
        type: {
          name: "Enum",
          allowedValues: [
            "Storage",
            "BlobStorage",
            "StorageV2",
            "FileStorage",
            "BlockBlobStorage"
          ]
        }
      },
      isHierarchicalNamespaceEnabled: {
        serializedName: "x-ms-is-hns-enabled",
        xmlName: "x-ms-is-hns-enabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, mo = {
  serializedName: "Container_getAccountInfoExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccountInfoExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ea = {
  serializedName: "Blob_downloadHeaders",
  type: {
    name: "Composite",
    className: "BlobDownloadHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      createdOn: {
        serializedName: "x-ms-creation-time",
        xmlName: "x-ms-creation-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      objectReplicationPolicyId: {
        serializedName: "x-ms-or-policy-id",
        xmlName: "x-ms-or-policy-id",
        type: {
          name: "String"
        }
      },
      objectReplicationRules: {
        serializedName: "x-ms-or",
        headerCollectionPrefix: "x-ms-or-",
        xmlName: "x-ms-or",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      contentLength: {
        serializedName: "content-length",
        xmlName: "content-length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      contentRange: {
        serializedName: "content-range",
        xmlName: "content-range",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      contentEncoding: {
        serializedName: "content-encoding",
        xmlName: "content-encoding",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "cache-control",
        xmlName: "cache-control",
        type: {
          name: "String"
        }
      },
      contentDisposition: {
        serializedName: "content-disposition",
        xmlName: "content-disposition",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "content-language",
        xmlName: "content-language",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      blobType: {
        serializedName: "x-ms-blob-type",
        xmlName: "x-ms-blob-type",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      copyCompletedOn: {
        serializedName: "x-ms-copy-completion-time",
        xmlName: "x-ms-copy-completion-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "x-ms-copy-status-description",
        xmlName: "x-ms-copy-status-description",
        type: {
          name: "String"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "x-ms-copy-progress",
        xmlName: "x-ms-copy-progress",
        type: {
          name: "String"
        }
      },
      copySource: {
        serializedName: "x-ms-copy-source",
        xmlName: "x-ms-copy-source",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      isCurrentVersion: {
        serializedName: "x-ms-is-current-version",
        xmlName: "x-ms-is-current-version",
        type: {
          name: "Boolean"
        }
      },
      acceptRanges: {
        serializedName: "accept-ranges",
        xmlName: "accept-ranges",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-server-encrypted",
        xmlName: "x-ms-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      blobContentMD5: {
        serializedName: "x-ms-blob-content-md5",
        xmlName: "x-ms-blob-content-md5",
        type: {
          name: "ByteArray"
        }
      },
      tagCount: {
        serializedName: "x-ms-tag-count",
        xmlName: "x-ms-tag-count",
        type: {
          name: "Number"
        }
      },
      isSealed: {
        serializedName: "x-ms-blob-sealed",
        xmlName: "x-ms-blob-sealed",
        type: {
          name: "Boolean"
        }
      },
      lastAccessed: {
        serializedName: "x-ms-last-access-time",
        xmlName: "x-ms-last-access-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiresOn: {
        serializedName: "x-ms-immutability-policy-until-date",
        xmlName: "x-ms-immutability-policy-until-date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "x-ms-immutability-policy-mode",
        xmlName: "x-ms-immutability-policy-mode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      },
      legalHold: {
        serializedName: "x-ms-legal-hold",
        xmlName: "x-ms-legal-hold",
        type: {
          name: "Boolean"
        }
      },
      structuredBodyType: {
        serializedName: "x-ms-structured-body",
        xmlName: "x-ms-structured-body",
        type: {
          name: "String"
        }
      },
      structuredContentLength: {
        serializedName: "x-ms-structured-content-length",
        xmlName: "x-ms-structured-content-length",
        type: {
          name: "Number"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      contentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      }
    }
  }
}, co = {
  serializedName: "Blob_downloadExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobDownloadExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, lo = {
  serializedName: "Blob_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "BlobGetPropertiesHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      createdOn: {
        serializedName: "x-ms-creation-time",
        xmlName: "x-ms-creation-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      objectReplicationPolicyId: {
        serializedName: "x-ms-or-policy-id",
        xmlName: "x-ms-or-policy-id",
        type: {
          name: "String"
        }
      },
      objectReplicationRules: {
        serializedName: "x-ms-or",
        headerCollectionPrefix: "x-ms-or-",
        xmlName: "x-ms-or",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      blobType: {
        serializedName: "x-ms-blob-type",
        xmlName: "x-ms-blob-type",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      copyCompletedOn: {
        serializedName: "x-ms-copy-completion-time",
        xmlName: "x-ms-copy-completion-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "x-ms-copy-status-description",
        xmlName: "x-ms-copy-status-description",
        type: {
          name: "String"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "x-ms-copy-progress",
        xmlName: "x-ms-copy-progress",
        type: {
          name: "String"
        }
      },
      copySource: {
        serializedName: "x-ms-copy-source",
        xmlName: "x-ms-copy-source",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      isIncrementalCopy: {
        serializedName: "x-ms-incremental-copy",
        xmlName: "x-ms-incremental-copy",
        type: {
          name: "Boolean"
        }
      },
      destinationSnapshot: {
        serializedName: "x-ms-copy-destination-snapshot",
        xmlName: "x-ms-copy-destination-snapshot",
        type: {
          name: "String"
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      contentLength: {
        serializedName: "content-length",
        xmlName: "content-length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      contentEncoding: {
        serializedName: "content-encoding",
        xmlName: "content-encoding",
        type: {
          name: "String"
        }
      },
      contentDisposition: {
        serializedName: "content-disposition",
        xmlName: "content-disposition",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "content-language",
        xmlName: "content-language",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "cache-control",
        xmlName: "cache-control",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      acceptRanges: {
        serializedName: "accept-ranges",
        xmlName: "accept-ranges",
        type: {
          name: "String"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-server-encrypted",
        xmlName: "x-ms-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      accessTier: {
        serializedName: "x-ms-access-tier",
        xmlName: "x-ms-access-tier",
        type: {
          name: "String"
        }
      },
      accessTierInferred: {
        serializedName: "x-ms-access-tier-inferred",
        xmlName: "x-ms-access-tier-inferred",
        type: {
          name: "Boolean"
        }
      },
      archiveStatus: {
        serializedName: "x-ms-archive-status",
        xmlName: "x-ms-archive-status",
        type: {
          name: "String"
        }
      },
      accessTierChangedOn: {
        serializedName: "x-ms-access-tier-change-time",
        xmlName: "x-ms-access-tier-change-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      isCurrentVersion: {
        serializedName: "x-ms-is-current-version",
        xmlName: "x-ms-is-current-version",
        type: {
          name: "Boolean"
        }
      },
      tagCount: {
        serializedName: "x-ms-tag-count",
        xmlName: "x-ms-tag-count",
        type: {
          name: "Number"
        }
      },
      expiresOn: {
        serializedName: "x-ms-expiry-time",
        xmlName: "x-ms-expiry-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isSealed: {
        serializedName: "x-ms-blob-sealed",
        xmlName: "x-ms-blob-sealed",
        type: {
          name: "Boolean"
        }
      },
      rehydratePriority: {
        serializedName: "x-ms-rehydrate-priority",
        xmlName: "x-ms-rehydrate-priority",
        type: {
          name: "Enum",
          allowedValues: ["High", "Standard"]
        }
      },
      lastAccessed: {
        serializedName: "x-ms-last-access-time",
        xmlName: "x-ms-last-access-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiresOn: {
        serializedName: "x-ms-immutability-policy-until-date",
        xmlName: "x-ms-immutability-policy-until-date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "x-ms-immutability-policy-mode",
        xmlName: "x-ms-immutability-policy-mode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      },
      legalHold: {
        serializedName: "x-ms-legal-hold",
        xmlName: "x-ms-legal-hold",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, po = {
  serializedName: "Blob_getPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobGetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, uo = {
  serializedName: "Blob_deleteHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, go = {
  serializedName: "Blob_deleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, yo = {
  serializedName: "Blob_undeleteHeaders",
  type: {
    name: "Composite",
    className: "BlobUndeleteHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ho = {
  serializedName: "Blob_undeleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobUndeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, fo = {
  serializedName: "Blob_setExpiryHeaders",
  type: {
    name: "Composite",
    className: "BlobSetExpiryHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Ao = {
  serializedName: "Blob_setExpiryExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetExpiryExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, No = {
  serializedName: "Blob_setHttpHeadersHeaders",
  type: {
    name: "Composite",
    className: "BlobSetHttpHeadersHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Co = {
  serializedName: "Blob_setHttpHeadersExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetHttpHeadersExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, xo = {
  serializedName: "Blob_setImmutabilityPolicyHeaders",
  type: {
    name: "Composite",
    className: "BlobSetImmutabilityPolicyHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiry: {
        serializedName: "x-ms-immutability-policy-until-date",
        xmlName: "x-ms-immutability-policy-until-date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "x-ms-immutability-policy-mode",
        xmlName: "x-ms-immutability-policy-mode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      }
    }
  }
}, Io = {
  serializedName: "Blob_setImmutabilityPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetImmutabilityPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Bo = {
  serializedName: "Blob_deleteImmutabilityPolicyHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteImmutabilityPolicyHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, bo = {
  serializedName: "Blob_deleteImmutabilityPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteImmutabilityPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Eo = {
  serializedName: "Blob_setLegalHoldHeaders",
  type: {
    name: "Composite",
    className: "BlobSetLegalHoldHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      legalHold: {
        serializedName: "x-ms-legal-hold",
        xmlName: "x-ms-legal-hold",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, Po = {
  serializedName: "Blob_setLegalHoldExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetLegalHoldExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, wo = {
  serializedName: "Blob_setMetadataHeaders",
  type: {
    name: "Composite",
    className: "BlobSetMetadataHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, So = {
  serializedName: "Blob_setMetadataExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetMetadataExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ro = {
  serializedName: "Blob_acquireLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobAcquireLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, zo = {
  serializedName: "Blob_acquireLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobAcquireLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Mo = {
  serializedName: "Blob_releaseLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobReleaseLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Do = {
  serializedName: "Blob_releaseLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobReleaseLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Qo = {
  serializedName: "Blob_renewLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobRenewLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, To = {
  serializedName: "Blob_renewLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobRenewLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, vo = {
  serializedName: "Blob_changeLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobChangeLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Ho = {
  serializedName: "Blob_changeLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobChangeLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ko = {
  serializedName: "Blob_breakLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobBreakLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseTime: {
        serializedName: "x-ms-lease-time",
        xmlName: "x-ms-lease-time",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Lo = {
  serializedName: "Blob_breakLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobBreakLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Uo = {
  serializedName: "Blob_createSnapshotHeaders",
  type: {
    name: "Composite",
    className: "BlobCreateSnapshotHeaders",
    modelProperties: {
      snapshot: {
        serializedName: "x-ms-snapshot",
        xmlName: "x-ms-snapshot",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, qo = {
  serializedName: "Blob_createSnapshotExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobCreateSnapshotExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Oo = {
  serializedName: "Blob_startCopyFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlobStartCopyFromURLHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Fo = {
  serializedName: "Blob_startCopyFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobStartCopyFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      copySourceErrorCode: {
        serializedName: "x-ms-copy-source-error-code",
        xmlName: "x-ms-copy-source-error-code",
        type: {
          name: "String"
        }
      },
      copySourceStatusCode: {
        serializedName: "x-ms-copy-source-status-code",
        xmlName: "x-ms-copy-source-status-code",
        type: {
          name: "Number"
        }
      }
    }
  }
}, _o = {
  serializedName: "Blob_copyFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlobCopyFromURLHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        defaultValue: "success",
        isConstant: !0,
        serializedName: "x-ms-copy-status",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Go = {
  serializedName: "Blob_copyFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobCopyFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      copySourceErrorCode: {
        serializedName: "x-ms-copy-source-error-code",
        xmlName: "x-ms-copy-source-error-code",
        type: {
          name: "String"
        }
      },
      copySourceStatusCode: {
        serializedName: "x-ms-copy-source-status-code",
        xmlName: "x-ms-copy-source-status-code",
        type: {
          name: "Number"
        }
      }
    }
  }
}, Yo = {
  serializedName: "Blob_abortCopyFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlobAbortCopyFromURLHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ko = {
  serializedName: "Blob_abortCopyFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobAbortCopyFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Pa = {
  serializedName: "Blob_setTierHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTierHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Jo = {
  serializedName: "Blob_setTierExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTierExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Xo = {
  serializedName: "Blob_getAccountInfoHeaders",
  type: {
    name: "Composite",
    className: "BlobGetAccountInfoHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      skuName: {
        serializedName: "x-ms-sku-name",
        xmlName: "x-ms-sku-name",
        type: {
          name: "Enum",
          allowedValues: [
            "Standard_LRS",
            "Standard_GRS",
            "Standard_RAGRS",
            "Standard_ZRS",
            "Premium_LRS",
            "Standard_GZRS",
            "Premium_ZRS",
            "Standard_RAGZRS"
          ]
        }
      },
      accountKind: {
        serializedName: "x-ms-account-kind",
        xmlName: "x-ms-account-kind",
        type: {
          name: "Enum",
          allowedValues: [
            "Storage",
            "BlobStorage",
            "StorageV2",
            "FileStorage",
            "BlockBlobStorage"
          ]
        }
      },
      isHierarchicalNamespaceEnabled: {
        serializedName: "x-ms-is-hns-enabled",
        xmlName: "x-ms-is-hns-enabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, Wo = {
  serializedName: "Blob_getAccountInfoExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobGetAccountInfoExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, wa = {
  serializedName: "Blob_queryHeaders",
  type: {
    name: "Composite",
    className: "BlobQueryHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      contentLength: {
        serializedName: "content-length",
        xmlName: "content-length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      contentRange: {
        serializedName: "content-range",
        xmlName: "content-range",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      contentEncoding: {
        serializedName: "content-encoding",
        xmlName: "content-encoding",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "cache-control",
        xmlName: "cache-control",
        type: {
          name: "String"
        }
      },
      contentDisposition: {
        serializedName: "content-disposition",
        xmlName: "content-disposition",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "content-language",
        xmlName: "content-language",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      blobType: {
        serializedName: "x-ms-blob-type",
        xmlName: "x-ms-blob-type",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      copyCompletionTime: {
        serializedName: "x-ms-copy-completion-time",
        xmlName: "x-ms-copy-completion-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "x-ms-copy-status-description",
        xmlName: "x-ms-copy-status-description",
        type: {
          name: "String"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "x-ms-copy-progress",
        xmlName: "x-ms-copy-progress",
        type: {
          name: "String"
        }
      },
      copySource: {
        serializedName: "x-ms-copy-source",
        xmlName: "x-ms-copy-source",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      acceptRanges: {
        serializedName: "accept-ranges",
        xmlName: "accept-ranges",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-server-encrypted",
        xmlName: "x-ms-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      blobContentMD5: {
        serializedName: "x-ms-blob-content-md5",
        xmlName: "x-ms-blob-content-md5",
        type: {
          name: "ByteArray"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      contentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      }
    }
  }
}, jo = {
  serializedName: "Blob_queryExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobQueryExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Zo = {
  serializedName: "Blob_getTagsHeaders",
  type: {
    name: "Composite",
    className: "BlobGetTagsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Vo = {
  serializedName: "Blob_getTagsExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobGetTagsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, $o = {
  serializedName: "Blob_setTagsHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTagsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, em = {
  serializedName: "Blob_setTagsExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTagsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, tm = {
  serializedName: "PageBlob_createHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCreateHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, rm = {
  serializedName: "PageBlob_createExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCreateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, am = {
  serializedName: "PageBlob_uploadPagesHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      structuredBodyType: {
        serializedName: "x-ms-structured-body",
        xmlName: "x-ms-structured-body",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, nm = {
  serializedName: "PageBlob_uploadPagesExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, im = {
  serializedName: "PageBlob_clearPagesHeaders",
  type: {
    name: "Composite",
    className: "PageBlobClearPagesHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, sm = {
  serializedName: "PageBlob_clearPagesExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobClearPagesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, om = {
  serializedName: "PageBlob_uploadPagesFromURLHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesFromURLHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, mm = {
  serializedName: "PageBlob_uploadPagesFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      copySourceErrorCode: {
        serializedName: "x-ms-copy-source-error-code",
        xmlName: "x-ms-copy-source-error-code",
        type: {
          name: "String"
        }
      },
      copySourceStatusCode: {
        serializedName: "x-ms-copy-source-status-code",
        xmlName: "x-ms-copy-source-status-code",
        type: {
          name: "Number"
        }
      }
    }
  }
}, cm = {
  serializedName: "PageBlob_getPageRangesHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      blobContentLength: {
        serializedName: "x-ms-blob-content-length",
        xmlName: "x-ms-blob-content-length",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, lm = {
  serializedName: "PageBlob_getPageRangesExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, dm = {
  serializedName: "PageBlob_getPageRangesDiffHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesDiffHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      blobContentLength: {
        serializedName: "x-ms-blob-content-length",
        xmlName: "x-ms-blob-content-length",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, pm = {
  serializedName: "PageBlob_getPageRangesDiffExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesDiffExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, um = {
  serializedName: "PageBlob_resizeHeaders",
  type: {
    name: "Composite",
    className: "PageBlobResizeHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, gm = {
  serializedName: "PageBlob_resizeExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobResizeExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ym = {
  serializedName: "PageBlob_updateSequenceNumberHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUpdateSequenceNumberHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, hm = {
  serializedName: "PageBlob_updateSequenceNumberExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUpdateSequenceNumberExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, fm = {
  serializedName: "PageBlob_copyIncrementalHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCopyIncrementalHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Am = {
  serializedName: "PageBlob_copyIncrementalExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCopyIncrementalExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Nm = {
  serializedName: "AppendBlob_createHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobCreateHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Cm = {
  serializedName: "AppendBlob_createExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobCreateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, xm = {
  serializedName: "AppendBlob_appendBlockHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobAppendOffset: {
        serializedName: "x-ms-blob-append-offset",
        xmlName: "x-ms-blob-append-offset",
        type: {
          name: "String"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      structuredBodyType: {
        serializedName: "x-ms-structured-body",
        xmlName: "x-ms-structured-body",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Im = {
  serializedName: "AppendBlob_appendBlockExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Bm = {
  serializedName: "AppendBlob_appendBlockFromUrlHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockFromUrlHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobAppendOffset: {
        serializedName: "x-ms-blob-append-offset",
        xmlName: "x-ms-blob-append-offset",
        type: {
          name: "String"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, bm = {
  serializedName: "AppendBlob_appendBlockFromUrlExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockFromUrlExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      copySourceErrorCode: {
        serializedName: "x-ms-copy-source-error-code",
        xmlName: "x-ms-copy-source-error-code",
        type: {
          name: "String"
        }
      },
      copySourceStatusCode: {
        serializedName: "x-ms-copy-source-status-code",
        xmlName: "x-ms-copy-source-status-code",
        type: {
          name: "Number"
        }
      }
    }
  }
}, Em = {
  serializedName: "AppendBlob_sealHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobSealHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isSealed: {
        serializedName: "x-ms-blob-sealed",
        xmlName: "x-ms-blob-sealed",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, Pm = {
  serializedName: "AppendBlob_sealExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobSealExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, wm = {
  serializedName: "BlockBlob_uploadHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobUploadHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      structuredBodyType: {
        serializedName: "x-ms-structured-body",
        xmlName: "x-ms-structured-body",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Sm = {
  serializedName: "BlockBlob_uploadExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobUploadExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Rm = {
  serializedName: "BlockBlob_putBlobFromUrlHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobPutBlobFromUrlHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, zm = {
  serializedName: "BlockBlob_putBlobFromUrlExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobPutBlobFromUrlExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      copySourceErrorCode: {
        serializedName: "x-ms-copy-source-error-code",
        xmlName: "x-ms-copy-source-error-code",
        type: {
          name: "String"
        }
      },
      copySourceStatusCode: {
        serializedName: "x-ms-copy-source-status-code",
        xmlName: "x-ms-copy-source-status-code",
        type: {
          name: "Number"
        }
      }
    }
  }
}, Mm = {
  serializedName: "BlockBlob_stageBlockHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockHeaders",
    modelProperties: {
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      structuredBodyType: {
        serializedName: "x-ms-structured-body",
        xmlName: "x-ms-structured-body",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Dm = {
  serializedName: "BlockBlob_stageBlockExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Qm = {
  serializedName: "BlockBlob_stageBlockFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockFromURLHeaders",
    modelProperties: {
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Tm = {
  serializedName: "BlockBlob_stageBlockFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      copySourceErrorCode: {
        serializedName: "x-ms-copy-source-error-code",
        xmlName: "x-ms-copy-source-error-code",
        type: {
          name: "String"
        }
      },
      copySourceStatusCode: {
        serializedName: "x-ms-copy-source-status-code",
        xmlName: "x-ms-copy-source-status-code",
        type: {
          name: "Number"
        }
      }
    }
  }
}, vm = {
  serializedName: "BlockBlob_commitBlockListHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobCommitBlockListHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Hm = {
  serializedName: "BlockBlob_commitBlockListExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobCommitBlockListExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, km = {
  serializedName: "BlockBlob_getBlockListHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobGetBlockListHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      blobContentLength: {
        serializedName: "x-ms-blob-content-length",
        xmlName: "x-ms-blob-content-length",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Lm = {
  serializedName: "BlockBlob_getBlockListExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobGetBlockListExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Pt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccessPolicy: cy,
  AppendBlobAppendBlockExceptionHeaders: Im,
  AppendBlobAppendBlockFromUrlExceptionHeaders: bm,
  AppendBlobAppendBlockFromUrlHeaders: Bm,
  AppendBlobAppendBlockHeaders: xm,
  AppendBlobCreateExceptionHeaders: Cm,
  AppendBlobCreateHeaders: Nm,
  AppendBlobSealExceptionHeaders: Pm,
  AppendBlobSealHeaders: Em,
  ArrowConfiguration: By,
  ArrowField: by,
  BlobAbortCopyFromURLExceptionHeaders: Ko,
  BlobAbortCopyFromURLHeaders: Yo,
  BlobAcquireLeaseExceptionHeaders: zo,
  BlobAcquireLeaseHeaders: Ro,
  BlobBreakLeaseExceptionHeaders: Lo,
  BlobBreakLeaseHeaders: ko,
  BlobChangeLeaseExceptionHeaders: Ho,
  BlobChangeLeaseHeaders: vo,
  BlobCopyFromURLExceptionHeaders: Go,
  BlobCopyFromURLHeaders: _o,
  BlobCreateSnapshotExceptionHeaders: qo,
  BlobCreateSnapshotHeaders: Uo,
  BlobDeleteExceptionHeaders: go,
  BlobDeleteHeaders: uo,
  BlobDeleteImmutabilityPolicyExceptionHeaders: bo,
  BlobDeleteImmutabilityPolicyHeaders: Bo,
  BlobDownloadExceptionHeaders: co,
  BlobDownloadHeaders: Ea,
  BlobFlatListSegment: ly,
  BlobGetAccountInfoExceptionHeaders: Wo,
  BlobGetAccountInfoHeaders: Xo,
  BlobGetPropertiesExceptionHeaders: po,
  BlobGetPropertiesHeaders: lo,
  BlobGetTagsExceptionHeaders: Vo,
  BlobGetTagsHeaders: Zo,
  BlobHierarchyListSegment: gy,
  BlobItemInternal: dy,
  BlobName: py,
  BlobPrefix: yy,
  BlobPropertiesInternal: uy,
  BlobQueryExceptionHeaders: jo,
  BlobQueryHeaders: wa,
  BlobReleaseLeaseExceptionHeaders: Do,
  BlobReleaseLeaseHeaders: Mo,
  BlobRenewLeaseExceptionHeaders: To,
  BlobRenewLeaseHeaders: Qo,
  BlobServiceProperties: Ga,
  BlobServiceStatistics: rs,
  BlobSetExpiryExceptionHeaders: Ao,
  BlobSetExpiryHeaders: fo,
  BlobSetHttpHeadersExceptionHeaders: Co,
  BlobSetHttpHeadersHeaders: No,
  BlobSetImmutabilityPolicyExceptionHeaders: Io,
  BlobSetImmutabilityPolicyHeaders: xo,
  BlobSetLegalHoldExceptionHeaders: Po,
  BlobSetLegalHoldHeaders: Eo,
  BlobSetMetadataExceptionHeaders: So,
  BlobSetMetadataHeaders: wo,
  BlobSetTagsExceptionHeaders: em,
  BlobSetTagsHeaders: $o,
  BlobSetTierExceptionHeaders: Jo,
  BlobSetTierHeaders: Pa,
  BlobStartCopyFromURLExceptionHeaders: Fo,
  BlobStartCopyFromURLHeaders: Oo,
  BlobTag: oy,
  BlobTags: Ka,
  BlobUndeleteExceptionHeaders: ho,
  BlobUndeleteHeaders: yo,
  Block: hy,
  BlockBlobCommitBlockListExceptionHeaders: Hm,
  BlockBlobCommitBlockListHeaders: vm,
  BlockBlobGetBlockListExceptionHeaders: Lm,
  BlockBlobGetBlockListHeaders: km,
  BlockBlobPutBlobFromUrlExceptionHeaders: zm,
  BlockBlobPutBlobFromUrlHeaders: Rm,
  BlockBlobStageBlockExceptionHeaders: Dm,
  BlockBlobStageBlockFromURLExceptionHeaders: Tm,
  BlockBlobStageBlockFromURLHeaders: Qm,
  BlockBlobStageBlockHeaders: Mm,
  BlockBlobUploadExceptionHeaders: Sm,
  BlockBlobUploadHeaders: wm,
  BlockList: cs,
  BlockLookupList: ms,
  ClearRange: Ay,
  ContainerAcquireLeaseExceptionHeaders: Xs,
  ContainerAcquireLeaseHeaders: Js,
  ContainerBreakLeaseExceptionHeaders: eo,
  ContainerBreakLeaseHeaders: $s,
  ContainerChangeLeaseExceptionHeaders: ro,
  ContainerChangeLeaseHeaders: to,
  ContainerCreateExceptionHeaders: Ss,
  ContainerCreateHeaders: ws,
  ContainerDeleteExceptionHeaders: Ds,
  ContainerDeleteHeaders: Ms,
  ContainerFilterBlobsExceptionHeaders: Ks,
  ContainerFilterBlobsHeaders: Ys,
  ContainerGetAccessPolicyExceptionHeaders: Hs,
  ContainerGetAccessPolicyHeaders: vs,
  ContainerGetAccountInfoExceptionHeaders: mo,
  ContainerGetAccountInfoHeaders: oo,
  ContainerGetPropertiesExceptionHeaders: zs,
  ContainerGetPropertiesHeaders: Rs,
  ContainerItem: ny,
  ContainerListBlobFlatSegmentExceptionHeaders: no,
  ContainerListBlobFlatSegmentHeaders: ao,
  ContainerListBlobHierarchySegmentExceptionHeaders: so,
  ContainerListBlobHierarchySegmentHeaders: io,
  ContainerProperties: iy,
  ContainerReleaseLeaseExceptionHeaders: js,
  ContainerReleaseLeaseHeaders: Ws,
  ContainerRenameExceptionHeaders: Fs,
  ContainerRenameHeaders: Os,
  ContainerRenewLeaseExceptionHeaders: Vs,
  ContainerRenewLeaseHeaders: Zs,
  ContainerRestoreExceptionHeaders: qs,
  ContainerRestoreHeaders: Us,
  ContainerSetAccessPolicyExceptionHeaders: Ls,
  ContainerSetAccessPolicyHeaders: ks,
  ContainerSetMetadataExceptionHeaders: Ts,
  ContainerSetMetadataHeaders: Qs,
  ContainerSubmitBatchExceptionHeaders: Gs,
  ContainerSubmitBatchHeaders: _s,
  CorsRule: ty,
  DelimitedTextConfiguration: xy,
  FilterBlobItem: sy,
  FilterBlobSegment: Ya,
  GeoReplication: ay,
  JsonTextConfiguration: Iy,
  KeyInfo: ns,
  ListBlobsFlatSegmentResponse: ss,
  ListBlobsHierarchySegmentResponse: os,
  ListContainersSegmentResponse: as,
  Logging: Vg,
  Metrics: ey,
  PageBlobClearPagesExceptionHeaders: sm,
  PageBlobClearPagesHeaders: im,
  PageBlobCopyIncrementalExceptionHeaders: Am,
  PageBlobCopyIncrementalHeaders: fm,
  PageBlobCreateExceptionHeaders: rm,
  PageBlobCreateHeaders: tm,
  PageBlobGetPageRangesDiffExceptionHeaders: pm,
  PageBlobGetPageRangesDiffHeaders: dm,
  PageBlobGetPageRangesExceptionHeaders: lm,
  PageBlobGetPageRangesHeaders: cm,
  PageBlobResizeExceptionHeaders: gm,
  PageBlobResizeHeaders: um,
  PageBlobUpdateSequenceNumberExceptionHeaders: hm,
  PageBlobUpdateSequenceNumberHeaders: ym,
  PageBlobUploadPagesExceptionHeaders: nm,
  PageBlobUploadPagesFromURLExceptionHeaders: mm,
  PageBlobUploadPagesFromURLHeaders: om,
  PageBlobUploadPagesHeaders: am,
  PageList: Ja,
  PageRange: fy,
  QueryFormat: Cy,
  QueryRequest: ls,
  QuerySerialization: Ny,
  RetentionPolicy: $g,
  ServiceFilterBlobsExceptionHeaders: Ps,
  ServiceFilterBlobsHeaders: Es,
  ServiceGetAccountInfoExceptionHeaders: Is,
  ServiceGetAccountInfoHeaders: xs,
  ServiceGetPropertiesExceptionHeaders: gs,
  ServiceGetPropertiesHeaders: us,
  ServiceGetStatisticsExceptionHeaders: hs,
  ServiceGetStatisticsHeaders: ys,
  ServiceGetUserDelegationKeyExceptionHeaders: Cs,
  ServiceGetUserDelegationKeyHeaders: Ns,
  ServiceListContainersSegmentExceptionHeaders: As,
  ServiceListContainersSegmentHeaders: fs,
  ServiceSetPropertiesExceptionHeaders: ps,
  ServiceSetPropertiesHeaders: ds,
  ServiceSubmitBatchExceptionHeaders: bs,
  ServiceSubmitBatchHeaders: Bs,
  SignedIdentifier: my,
  StaticWebsite: ry,
  StorageError: B,
  UserDelegationKey: is
}, Symbol.toStringTag, { value: "Module" })), wt = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
}, Ey = {
  parameterPath: "blobServiceProperties",
  mapper: Ga
}, Ye = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
}, b = {
  parameterPath: "url",
  mapper: {
    serializedName: "url",
    required: !0,
    xmlName: "url",
    type: {
      name: "String"
    }
  },
  skipEncoding: !0
}, Or = {
  parameterPath: "restype",
  mapper: {
    defaultValue: "service",
    isConstant: !0,
    serializedName: "restype",
    type: {
      name: "String"
    }
  }
}, Ke = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "properties",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, E = {
  parameterPath: ["options", "timeoutInSeconds"],
  mapper: {
    constraints: {
      InclusiveMinimum: 0
    },
    serializedName: "timeout",
    xmlName: "timeout",
    type: {
      name: "Number"
    }
  }
}, P = {
  parameterPath: "version",
  mapper: {
    defaultValue: "2026-04-06",
    isConstant: !0,
    serializedName: "x-ms-version",
    type: {
      name: "String"
    }
  }
}, w = {
  parameterPath: ["options", "requestId"],
  mapper: {
    serializedName: "x-ms-client-request-id",
    xmlName: "x-ms-client-request-id",
    type: {
      name: "String"
    }
  }
}, M = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
}, Py = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "stats",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Xa = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "list",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Wa = {
  parameterPath: ["options", "prefix"],
  mapper: {
    serializedName: "prefix",
    xmlName: "prefix",
    type: {
      name: "String"
    }
  }
}, it = {
  parameterPath: ["options", "marker"],
  mapper: {
    serializedName: "marker",
    xmlName: "marker",
    type: {
      name: "String"
    }
  }
}, st = {
  parameterPath: ["options", "maxPageSize"],
  mapper: {
    constraints: {
      InclusiveMinimum: 1
    },
    serializedName: "maxresults",
    xmlName: "maxresults",
    type: {
      name: "Number"
    }
  }
}, wy = {
  parameterPath: ["options", "include"],
  mapper: {
    serializedName: "include",
    xmlName: "include",
    xmlElementName: "ListContainersIncludeType",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: ["metadata", "deleted", "system"]
        }
      }
    }
  },
  collectionFormat: "CSV"
}, Sy = {
  parameterPath: "keyInfo",
  mapper: ns
}, Ry = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "userdelegationkey",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, ja = {
  parameterPath: "restype",
  mapper: {
    defaultValue: "account",
    isConstant: !0,
    serializedName: "restype",
    type: {
      name: "String"
    }
  }
}, Um = {
  parameterPath: "body",
  mapper: {
    serializedName: "body",
    required: !0,
    xmlName: "body",
    type: {
      name: "Stream"
    }
  }
}, qm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "batch",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Ae = {
  parameterPath: "contentLength",
  mapper: {
    serializedName: "Content-Length",
    required: !0,
    xmlName: "Content-Length",
    type: {
      name: "Number"
    }
  }
}, Om = {
  parameterPath: "multipartContentType",
  mapper: {
    serializedName: "Content-Type",
    required: !0,
    xmlName: "Content-Type",
    type: {
      name: "String"
    }
  }
}, Fm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "blobs",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, _m = {
  parameterPath: ["options", "where"],
  mapper: {
    serializedName: "where",
    xmlName: "where",
    type: {
      name: "String"
    }
  }
}, me = {
  parameterPath: "restype",
  mapper: {
    defaultValue: "container",
    isConstant: !0,
    serializedName: "restype",
    type: {
      name: "String"
    }
  }
}, Se = {
  parameterPath: ["options", "metadata"],
  mapper: {
    serializedName: "x-ms-meta",
    xmlName: "x-ms-meta",
    headerCollectionPrefix: "x-ms-meta-",
    type: {
      name: "Dictionary",
      value: { type: { name: "String" } }
    }
  }
}, Gm = {
  parameterPath: ["options", "access"],
  mapper: {
    serializedName: "x-ms-blob-public-access",
    xmlName: "x-ms-blob-public-access",
    type: {
      name: "Enum",
      allowedValues: ["container", "blob"]
    }
  }
}, zy = {
  parameterPath: [
    "options",
    "containerEncryptionScope",
    "defaultEncryptionScope"
  ],
  mapper: {
    serializedName: "x-ms-default-encryption-scope",
    xmlName: "x-ms-default-encryption-scope",
    type: {
      name: "String"
    }
  }
}, My = {
  parameterPath: [
    "options",
    "containerEncryptionScope",
    "preventEncryptionScopeOverride"
  ],
  mapper: {
    serializedName: "x-ms-deny-encryption-scope-override",
    xmlName: "x-ms-deny-encryption-scope-override",
    type: {
      name: "Boolean"
    }
  }
}, O = {
  parameterPath: ["options", "leaseAccessConditions", "leaseId"],
  mapper: {
    serializedName: "x-ms-lease-id",
    xmlName: "x-ms-lease-id",
    type: {
      name: "String"
    }
  }
}, U = {
  parameterPath: ["options", "modifiedAccessConditions", "ifModifiedSince"],
  mapper: {
    serializedName: "If-Modified-Since",
    xmlName: "If-Modified-Since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, q = {
  parameterPath: ["options", "modifiedAccessConditions", "ifUnmodifiedSince"],
  mapper: {
    serializedName: "If-Unmodified-Since",
    xmlName: "If-Unmodified-Since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, Ym = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "metadata",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Km = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "acl",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Dy = {
  parameterPath: ["options", "containerAcl"],
  mapper: {
    serializedName: "containerAcl",
    xmlName: "SignedIdentifiers",
    xmlIsWrapped: !0,
    xmlElementName: "SignedIdentifier",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Composite",
          className: "SignedIdentifier"
        }
      }
    }
  }
}, Jm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "undelete",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Qy = {
  parameterPath: ["options", "deletedContainerName"],
  mapper: {
    serializedName: "x-ms-deleted-container-name",
    xmlName: "x-ms-deleted-container-name",
    type: {
      name: "String"
    }
  }
}, Ty = {
  parameterPath: ["options", "deletedContainerVersion"],
  mapper: {
    serializedName: "x-ms-deleted-container-version",
    xmlName: "x-ms-deleted-container-version",
    type: {
      name: "String"
    }
  }
}, vy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "rename",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Hy = {
  parameterPath: "sourceContainerName",
  mapper: {
    serializedName: "x-ms-source-container-name",
    required: !0,
    xmlName: "x-ms-source-container-name",
    type: {
      name: "String"
    }
  }
}, ky = {
  parameterPath: ["options", "sourceLeaseId"],
  mapper: {
    serializedName: "x-ms-source-lease-id",
    xmlName: "x-ms-source-lease-id",
    type: {
      name: "String"
    }
  }
}, De = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "lease",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Xm = {
  parameterPath: "action",
  mapper: {
    defaultValue: "acquire",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, Wm = {
  parameterPath: ["options", "duration"],
  mapper: {
    serializedName: "x-ms-lease-duration",
    xmlName: "x-ms-lease-duration",
    type: {
      name: "Number"
    }
  }
}, jm = {
  parameterPath: ["options", "proposedLeaseId"],
  mapper: {
    serializedName: "x-ms-proposed-lease-id",
    xmlName: "x-ms-proposed-lease-id",
    type: {
      name: "String"
    }
  }
}, Zm = {
  parameterPath: "action",
  mapper: {
    defaultValue: "release",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, St = {
  parameterPath: "leaseId",
  mapper: {
    serializedName: "x-ms-lease-id",
    required: !0,
    xmlName: "x-ms-lease-id",
    type: {
      name: "String"
    }
  }
}, Vm = {
  parameterPath: "action",
  mapper: {
    defaultValue: "renew",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, $m = {
  parameterPath: "action",
  mapper: {
    defaultValue: "break",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, ec = {
  parameterPath: ["options", "breakPeriod"],
  mapper: {
    serializedName: "x-ms-lease-break-period",
    xmlName: "x-ms-lease-break-period",
    type: {
      name: "Number"
    }
  }
}, tc = {
  parameterPath: "action",
  mapper: {
    defaultValue: "change",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, rc = {
  parameterPath: "proposedLeaseId",
  mapper: {
    serializedName: "x-ms-proposed-lease-id",
    required: !0,
    xmlName: "x-ms-proposed-lease-id",
    type: {
      name: "String"
    }
  }
}, ac = {
  parameterPath: ["options", "include"],
  mapper: {
    serializedName: "include",
    xmlName: "include",
    xmlElementName: "ListBlobsIncludeItem",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: [
            "copy",
            "deleted",
            "metadata",
            "snapshots",
            "uncommittedblobs",
            "versions",
            "tags",
            "immutabilitypolicy",
            "legalhold",
            "deletedwithversions"
          ]
        }
      }
    }
  },
  collectionFormat: "CSV"
}, nc = {
  parameterPath: ["options", "startFrom"],
  mapper: {
    serializedName: "startFrom",
    xmlName: "startFrom",
    type: {
      name: "String"
    }
  }
}, Ly = {
  parameterPath: "delimiter",
  mapper: {
    serializedName: "delimiter",
    required: !0,
    xmlName: "delimiter",
    type: {
      name: "String"
    }
  }
}, Be = {
  parameterPath: ["options", "snapshot"],
  mapper: {
    serializedName: "snapshot",
    xmlName: "snapshot",
    type: {
      name: "String"
    }
  }
}, ve = {
  parameterPath: ["options", "versionId"],
  mapper: {
    serializedName: "versionid",
    xmlName: "versionid",
    type: {
      name: "String"
    }
  }
}, dr = {
  parameterPath: ["options", "range"],
  mapper: {
    serializedName: "x-ms-range",
    xmlName: "x-ms-range",
    type: {
      name: "String"
    }
  }
}, Uy = {
  parameterPath: ["options", "rangeGetContentMD5"],
  mapper: {
    serializedName: "x-ms-range-get-content-md5",
    xmlName: "x-ms-range-get-content-md5",
    type: {
      name: "Boolean"
    }
  }
}, qy = {
  parameterPath: ["options", "rangeGetContentCRC64"],
  mapper: {
    serializedName: "x-ms-range-get-content-crc64",
    xmlName: "x-ms-range-get-content-crc64",
    type: {
      name: "Boolean"
    }
  }
}, pr = {
  parameterPath: ["options", "structuredBodyType"],
  mapper: {
    serializedName: "x-ms-structured-body",
    xmlName: "x-ms-structured-body",
    type: {
      name: "String"
    }
  }
}, ee = {
  parameterPath: ["options", "cpkInfo", "encryptionKey"],
  mapper: {
    serializedName: "x-ms-encryption-key",
    xmlName: "x-ms-encryption-key",
    type: {
      name: "String"
    }
  }
}, te = {
  parameterPath: ["options", "cpkInfo", "encryptionKeySha256"],
  mapper: {
    serializedName: "x-ms-encryption-key-sha256",
    xmlName: "x-ms-encryption-key-sha256",
    type: {
      name: "String"
    }
  }
}, re = {
  parameterPath: ["options", "cpkInfo", "encryptionAlgorithm"],
  mapper: {
    serializedName: "x-ms-encryption-algorithm",
    xmlName: "x-ms-encryption-algorithm",
    type: {
      name: "String"
    }
  }
}, G = {
  parameterPath: ["options", "modifiedAccessConditions", "ifMatch"],
  mapper: {
    serializedName: "If-Match",
    xmlName: "If-Match",
    type: {
      name: "String"
    }
  }
}, Y = {
  parameterPath: ["options", "modifiedAccessConditions", "ifNoneMatch"],
  mapper: {
    serializedName: "If-None-Match",
    xmlName: "If-None-Match",
    type: {
      name: "String"
    }
  }
}, F = {
  parameterPath: ["options", "modifiedAccessConditions", "ifTags"],
  mapper: {
    serializedName: "x-ms-if-tags",
    xmlName: "x-ms-if-tags",
    type: {
      name: "String"
    }
  }
}, Oy = {
  parameterPath: ["options", "deleteSnapshots"],
  mapper: {
    serializedName: "x-ms-delete-snapshots",
    xmlName: "x-ms-delete-snapshots",
    type: {
      name: "Enum",
      allowedValues: ["include", "only"]
    }
  }
}, Fy = {
  parameterPath: ["options", "blobDeleteType"],
  mapper: {
    serializedName: "deletetype",
    xmlName: "deletetype",
    type: {
      name: "String"
    }
  }
}, _y = {
  parameterPath: ["options", "accessTierIfModifiedSince"],
  mapper: {
    serializedName: "x-ms-access-tier-if-modified-since",
    xmlName: "x-ms-access-tier-if-modified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, Gy = {
  parameterPath: ["options", "accessTierIfUnmodifiedSince"],
  mapper: {
    serializedName: "x-ms-access-tier-if-unmodified-since",
    xmlName: "x-ms-access-tier-if-unmodified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, Yy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "expiry",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Ky = {
  parameterPath: "expiryOptions",
  mapper: {
    serializedName: "x-ms-expiry-option",
    required: !0,
    xmlName: "x-ms-expiry-option",
    type: {
      name: "String"
    }
  }
}, Jy = {
  parameterPath: ["options", "expiresOn"],
  mapper: {
    serializedName: "x-ms-expiry-time",
    xmlName: "x-ms-expiry-time",
    type: {
      name: "String"
    }
  }
}, Rt = {
  parameterPath: ["options", "blobHttpHeaders", "blobCacheControl"],
  mapper: {
    serializedName: "x-ms-blob-cache-control",
    xmlName: "x-ms-blob-cache-control",
    type: {
      name: "String"
    }
  }
}, zt = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentType"],
  mapper: {
    serializedName: "x-ms-blob-content-type",
    xmlName: "x-ms-blob-content-type",
    type: {
      name: "String"
    }
  }
}, Mt = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentMD5"],
  mapper: {
    serializedName: "x-ms-blob-content-md5",
    xmlName: "x-ms-blob-content-md5",
    type: {
      name: "ByteArray"
    }
  }
}, Dt = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentEncoding"],
  mapper: {
    serializedName: "x-ms-blob-content-encoding",
    xmlName: "x-ms-blob-content-encoding",
    type: {
      name: "String"
    }
  }
}, Qt = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentLanguage"],
  mapper: {
    serializedName: "x-ms-blob-content-language",
    xmlName: "x-ms-blob-content-language",
    type: {
      name: "String"
    }
  }
}, Tt = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentDisposition"],
  mapper: {
    serializedName: "x-ms-blob-content-disposition",
    xmlName: "x-ms-blob-content-disposition",
    type: {
      name: "String"
    }
  }
}, ic = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "immutabilityPolicies",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, ot = {
  parameterPath: ["options", "immutabilityPolicyExpiry"],
  mapper: {
    serializedName: "x-ms-immutability-policy-until-date",
    xmlName: "x-ms-immutability-policy-until-date",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, mt = {
  parameterPath: ["options", "immutabilityPolicyMode"],
  mapper: {
    serializedName: "x-ms-immutability-policy-mode",
    xmlName: "x-ms-immutability-policy-mode",
    type: {
      name: "Enum",
      allowedValues: ["Mutable", "Unlocked", "Locked"]
    }
  }
}, Xy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "legalhold",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Wy = {
  parameterPath: "legalHold",
  mapper: {
    serializedName: "x-ms-legal-hold",
    required: !0,
    xmlName: "x-ms-legal-hold",
    type: {
      name: "Boolean"
    }
  }
}, ce = {
  parameterPath: ["options", "encryptionScope"],
  mapper: {
    serializedName: "x-ms-encryption-scope",
    xmlName: "x-ms-encryption-scope",
    type: {
      name: "String"
    }
  }
}, jy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "snapshot",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, vt = {
  parameterPath: ["options", "tier"],
  mapper: {
    serializedName: "x-ms-access-tier",
    xmlName: "x-ms-access-tier",
    type: {
      name: "Enum",
      allowedValues: [
        "P4",
        "P6",
        "P10",
        "P15",
        "P20",
        "P30",
        "P40",
        "P50",
        "P60",
        "P70",
        "P80",
        "Hot",
        "Cool",
        "Archive",
        "Cold"
      ]
    }
  }
}, sc = {
  parameterPath: ["options", "rehydratePriority"],
  mapper: {
    serializedName: "x-ms-rehydrate-priority",
    xmlName: "x-ms-rehydrate-priority",
    type: {
      name: "Enum",
      allowedValues: ["High", "Standard"]
    }
  }
}, Ht = {
  parameterPath: [
    "options",
    "sourceModifiedAccessConditions",
    "sourceIfModifiedSince"
  ],
  mapper: {
    serializedName: "x-ms-source-if-modified-since",
    xmlName: "x-ms-source-if-modified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, kt = {
  parameterPath: [
    "options",
    "sourceModifiedAccessConditions",
    "sourceIfUnmodifiedSince"
  ],
  mapper: {
    serializedName: "x-ms-source-if-unmodified-since",
    xmlName: "x-ms-source-if-unmodified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, Lt = {
  parameterPath: ["options", "sourceModifiedAccessConditions", "sourceIfMatch"],
  mapper: {
    serializedName: "x-ms-source-if-match",
    xmlName: "x-ms-source-if-match",
    type: {
      name: "String"
    }
  }
}, Ut = {
  parameterPath: [
    "options",
    "sourceModifiedAccessConditions",
    "sourceIfNoneMatch"
  ],
  mapper: {
    serializedName: "x-ms-source-if-none-match",
    xmlName: "x-ms-source-if-none-match",
    type: {
      name: "String"
    }
  }
}, oc = {
  parameterPath: ["options", "sourceModifiedAccessConditions", "sourceIfTags"],
  mapper: {
    serializedName: "x-ms-source-if-tags",
    xmlName: "x-ms-source-if-tags",
    type: {
      name: "String"
    }
  }
}, Fr = {
  parameterPath: "copySource",
  mapper: {
    serializedName: "x-ms-copy-source",
    required: !0,
    xmlName: "x-ms-copy-source",
    type: {
      name: "String"
    }
  }
}, ct = {
  parameterPath: ["options", "blobTagsString"],
  mapper: {
    serializedName: "x-ms-tags",
    xmlName: "x-ms-tags",
    type: {
      name: "String"
    }
  }
}, Zy = {
  parameterPath: ["options", "sealBlob"],
  mapper: {
    serializedName: "x-ms-seal-blob",
    xmlName: "x-ms-seal-blob",
    type: {
      name: "Boolean"
    }
  }
}, qt = {
  parameterPath: ["options", "legalHold"],
  mapper: {
    serializedName: "x-ms-legal-hold",
    xmlName: "x-ms-legal-hold",
    type: {
      name: "Boolean"
    }
  }
}, Vy = {
  parameterPath: "xMsRequiresSync",
  mapper: {
    defaultValue: "true",
    isConstant: !0,
    serializedName: "x-ms-requires-sync",
    type: {
      name: "String"
    }
  }
}, ur = {
  parameterPath: ["options", "sourceContentMD5"],
  mapper: {
    serializedName: "x-ms-source-content-md5",
    xmlName: "x-ms-source-content-md5",
    type: {
      name: "ByteArray"
    }
  }
}, gr = {
  parameterPath: ["options", "copySourceAuthorization"],
  mapper: {
    serializedName: "x-ms-copy-source-authorization",
    xmlName: "x-ms-copy-source-authorization",
    type: {
      name: "String"
    }
  }
}, mc = {
  parameterPath: ["options", "copySourceTags"],
  mapper: {
    serializedName: "x-ms-copy-source-tag-option",
    xmlName: "x-ms-copy-source-tag-option",
    type: {
      name: "Enum",
      allowedValues: ["REPLACE", "COPY"]
    }
  }
}, yr = {
  parameterPath: ["options", "fileRequestIntent"],
  mapper: {
    serializedName: "x-ms-file-request-intent",
    xmlName: "x-ms-file-request-intent",
    type: {
      name: "String"
    }
  }
}, $y = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "copy",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, eh = {
  parameterPath: "copyActionAbortConstant",
  mapper: {
    defaultValue: "abort",
    isConstant: !0,
    serializedName: "x-ms-copy-action",
    type: {
      name: "String"
    }
  }
}, th = {
  parameterPath: "copyId",
  mapper: {
    serializedName: "copyid",
    required: !0,
    xmlName: "copyid",
    type: {
      name: "String"
    }
  }
}, rh = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "tier",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, ah = {
  parameterPath: "tier",
  mapper: {
    serializedName: "x-ms-access-tier",
    required: !0,
    xmlName: "x-ms-access-tier",
    type: {
      name: "Enum",
      allowedValues: [
        "P4",
        "P6",
        "P10",
        "P15",
        "P20",
        "P30",
        "P40",
        "P50",
        "P60",
        "P70",
        "P80",
        "Hot",
        "Cool",
        "Archive",
        "Cold"
      ]
    }
  }
}, nh = {
  parameterPath: ["options", "queryRequest"],
  mapper: ls
}, ih = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "query",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, cc = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "tags",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, lc = {
  parameterPath: ["options", "blobModifiedAccessConditions", "ifModifiedSince"],
  mapper: {
    serializedName: "x-ms-blob-if-modified-since",
    xmlName: "x-ms-blob-if-modified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, dc = {
  parameterPath: [
    "options",
    "blobModifiedAccessConditions",
    "ifUnmodifiedSince"
  ],
  mapper: {
    serializedName: "x-ms-blob-if-unmodified-since",
    xmlName: "x-ms-blob-if-unmodified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, pc = {
  parameterPath: ["options", "blobModifiedAccessConditions", "ifMatch"],
  mapper: {
    serializedName: "x-ms-blob-if-match",
    xmlName: "x-ms-blob-if-match",
    type: {
      name: "String"
    }
  }
}, uc = {
  parameterPath: ["options", "blobModifiedAccessConditions", "ifNoneMatch"],
  mapper: {
    serializedName: "x-ms-blob-if-none-match",
    xmlName: "x-ms-blob-if-none-match",
    type: {
      name: "String"
    }
  }
}, sh = {
  parameterPath: ["options", "tags"],
  mapper: Ka
}, Je = {
  parameterPath: ["options", "transactionalContentMD5"],
  mapper: {
    serializedName: "Content-MD5",
    xmlName: "Content-MD5",
    type: {
      name: "ByteArray"
    }
  }
}, Ot = {
  parameterPath: ["options", "transactionalContentCrc64"],
  mapper: {
    serializedName: "x-ms-content-crc64",
    xmlName: "x-ms-content-crc64",
    type: {
      name: "ByteArray"
    }
  }
}, oh = {
  parameterPath: "blobType",
  mapper: {
    defaultValue: "PageBlob",
    isConstant: !0,
    serializedName: "x-ms-blob-type",
    type: {
      name: "String"
    }
  }
}, gc = {
  parameterPath: "blobContentLength",
  mapper: {
    serializedName: "x-ms-blob-content-length",
    required: !0,
    xmlName: "x-ms-blob-content-length",
    type: {
      name: "Number"
    }
  }
}, yc = {
  parameterPath: ["options", "blobSequenceNumber"],
  mapper: {
    defaultValue: 0,
    serializedName: "x-ms-blob-sequence-number",
    xmlName: "x-ms-blob-sequence-number",
    type: {
      name: "Number"
    }
  }
}, _r = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/octet-stream",
    isConstant: !0,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
}, Gr = {
  parameterPath: "body",
  mapper: {
    serializedName: "body",
    required: !0,
    xmlName: "body",
    type: {
      name: "Stream"
    }
  }
}, Yr = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
}, Za = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "page",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, hc = {
  parameterPath: "pageWrite",
  mapper: {
    defaultValue: "update",
    isConstant: !0,
    serializedName: "x-ms-page-write",
    type: {
      name: "String"
    }
  }
}, Va = {
  parameterPath: [
    "options",
    "sequenceNumberAccessConditions",
    "ifSequenceNumberLessThanOrEqualTo"
  ],
  mapper: {
    serializedName: "x-ms-if-sequence-number-le",
    xmlName: "x-ms-if-sequence-number-le",
    type: {
      name: "Number"
    }
  }
}, $a = {
  parameterPath: [
    "options",
    "sequenceNumberAccessConditions",
    "ifSequenceNumberLessThan"
  ],
  mapper: {
    serializedName: "x-ms-if-sequence-number-lt",
    xmlName: "x-ms-if-sequence-number-lt",
    type: {
      name: "Number"
    }
  }
}, en = {
  parameterPath: [
    "options",
    "sequenceNumberAccessConditions",
    "ifSequenceNumberEqualTo"
  ],
  mapper: {
    serializedName: "x-ms-if-sequence-number-eq",
    xmlName: "x-ms-if-sequence-number-eq",
    type: {
      name: "Number"
    }
  }
}, Kr = {
  parameterPath: ["options", "structuredContentLength"],
  mapper: {
    serializedName: "x-ms-structured-content-length",
    xmlName: "x-ms-structured-content-length",
    type: {
      name: "Number"
    }
  }
}, mh = {
  parameterPath: "pageWrite",
  mapper: {
    defaultValue: "clear",
    isConstant: !0,
    serializedName: "x-ms-page-write",
    type: {
      name: "String"
    }
  }
}, tn = {
  parameterPath: "sourceUrl",
  mapper: {
    serializedName: "x-ms-copy-source",
    required: !0,
    xmlName: "x-ms-copy-source",
    type: {
      name: "String"
    }
  }
}, ch = {
  parameterPath: "sourceRange",
  mapper: {
    serializedName: "x-ms-source-range",
    required: !0,
    xmlName: "x-ms-source-range",
    type: {
      name: "String"
    }
  }
}, rn = {
  parameterPath: ["options", "sourceContentCrc64"],
  mapper: {
    serializedName: "x-ms-source-content-crc64",
    xmlName: "x-ms-source-content-crc64",
    type: {
      name: "ByteArray"
    }
  }
}, lh = {
  parameterPath: "range",
  mapper: {
    serializedName: "x-ms-range",
    required: !0,
    xmlName: "x-ms-range",
    type: {
      name: "String"
    }
  }
}, Jr = {
  parameterPath: ["options", "sourceCpkInfo", "sourceEncryptionKey"],
  mapper: {
    serializedName: "x-ms-source-encryption-key",
    xmlName: "x-ms-source-encryption-key",
    type: {
      name: "String"
    }
  }
}, Xr = {
  parameterPath: ["options", "sourceCpkInfo", "sourceEncryptionKeySha256"],
  mapper: {
    serializedName: "x-ms-source-encryption-key-sha256",
    xmlName: "x-ms-source-encryption-key-sha256",
    type: {
      name: "String"
    }
  }
}, Wr = {
  parameterPath: ["options", "sourceCpkInfo", "sourceEncryptionAlgorithm"],
  mapper: {
    serializedName: "x-ms-source-encryption-algorithm",
    xmlName: "x-ms-source-encryption-algorithm",
    type: {
      name: "String"
    }
  }
}, fc = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "pagelist",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, dh = {
  parameterPath: ["options", "prevsnapshot"],
  mapper: {
    serializedName: "prevsnapshot",
    xmlName: "prevsnapshot",
    type: {
      name: "String"
    }
  }
}, ph = {
  parameterPath: ["options", "prevSnapshotUrl"],
  mapper: {
    serializedName: "x-ms-previous-snapshot-url",
    xmlName: "x-ms-previous-snapshot-url",
    type: {
      name: "String"
    }
  }
}, uh = {
  parameterPath: "sequenceNumberAction",
  mapper: {
    serializedName: "x-ms-sequence-number-action",
    required: !0,
    xmlName: "x-ms-sequence-number-action",
    type: {
      name: "Enum",
      allowedValues: ["max", "update", "increment"]
    }
  }
}, gh = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "incrementalcopy",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, yh = {
  parameterPath: "blobType",
  mapper: {
    defaultValue: "AppendBlob",
    isConstant: !0,
    serializedName: "x-ms-blob-type",
    type: {
      name: "String"
    }
  }
}, Ac = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "appendblock",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Nc = {
  parameterPath: ["options", "appendPositionAccessConditions", "maxSize"],
  mapper: {
    serializedName: "x-ms-blob-condition-maxsize",
    xmlName: "x-ms-blob-condition-maxsize",
    type: {
      name: "Number"
    }
  }
}, an = {
  parameterPath: [
    "options",
    "appendPositionAccessConditions",
    "appendPosition"
  ],
  mapper: {
    serializedName: "x-ms-blob-condition-appendpos",
    xmlName: "x-ms-blob-condition-appendpos",
    type: {
      name: "Number"
    }
  }
}, Cc = {
  parameterPath: ["options", "sourceRange"],
  mapper: {
    serializedName: "x-ms-source-range",
    xmlName: "x-ms-source-range",
    type: {
      name: "String"
    }
  }
}, hh = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "seal",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, xc = {
  parameterPath: "blobType",
  mapper: {
    defaultValue: "BlockBlob",
    isConstant: !0,
    serializedName: "x-ms-blob-type",
    type: {
      name: "String"
    }
  }
}, fh = {
  parameterPath: ["options", "copySourceBlobProperties"],
  mapper: {
    serializedName: "x-ms-copy-source-blob-properties",
    xmlName: "x-ms-copy-source-blob-properties",
    type: {
      name: "Boolean"
    }
  }
}, Ic = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "block",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Bc = {
  parameterPath: "blockId",
  mapper: {
    serializedName: "blockid",
    required: !0,
    xmlName: "blockid",
    type: {
      name: "String"
    }
  }
}, Ah = {
  parameterPath: "blocks",
  mapper: ms
}, bc = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "blocklist",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Nh = {
  parameterPath: "listType",
  mapper: {
    defaultValue: "committed",
    serializedName: "blocklisttype",
    required: !0,
    xmlName: "blocklisttype",
    type: {
      name: "Enum",
      allowedValues: ["committed", "uncommitted", "all"]
    }
  }
};
class Ch {
  /**
   * Initialize a new instance of the class Service class.
   * @param client Reference to the service client
   */
  constructor(r) {
    d(this, "client");
    this.client = r;
  }
  /**
   * Sets properties for a storage account's Blob service endpoint, including properties for Storage
   * Analytics and CORS (Cross-Origin Resource Sharing) rules
   * @param blobServiceProperties The StorageService properties.
   * @param options The options parameters.
   */
  setProperties(r, e) {
    return this.client.sendOperationRequest({ blobServiceProperties: r, options: e }, xh);
  }
  /**
   * gets the properties of a storage account's Blob service, including properties for Storage Analytics
   * and CORS (Cross-Origin Resource Sharing) rules.
   * @param options The options parameters.
   */
  getProperties(r) {
    return this.client.sendOperationRequest({ options: r }, Ih);
  }
  /**
   * Retrieves statistics related to replication for the Blob service. It is only available on the
   * secondary location endpoint when read-access geo-redundant replication is enabled for the storage
   * account.
   * @param options The options parameters.
   */
  getStatistics(r) {
    return this.client.sendOperationRequest({ options: r }, Bh);
  }
  /**
   * The List Containers Segment operation returns a list of the containers under the specified account
   * @param options The options parameters.
   */
  listContainersSegment(r) {
    return this.client.sendOperationRequest({ options: r }, bh);
  }
  /**
   * Retrieves a user delegation key for the Blob service. This is only a valid operation when using
   * bearer token authentication.
   * @param keyInfo Key information
   * @param options The options parameters.
   */
  getUserDelegationKey(r, e) {
    return this.client.sendOperationRequest({ keyInfo: r, options: e }, Eh);
  }
  /**
   * Returns the sku name and account kind
   * @param options The options parameters.
   */
  getAccountInfo(r) {
    return this.client.sendOperationRequest({ options: r }, Ph);
  }
  /**
   * The Batch operation allows multiple API calls to be embedded into a single HTTP request.
   * @param contentLength The length of the request.
   * @param multipartContentType Required. The value of this header must be multipart/mixed with a batch
   *                             boundary. Example header value: multipart/mixed; boundary=batch_<GUID>
   * @param body Initial data
   * @param options The options parameters.
   */
  submitBatch(r, e, a, n) {
    return this.client.sendOperationRequest({ contentLength: r, multipartContentType: e, body: a, options: n }, wh);
  }
  /**
   * The Filter Blobs operation enables callers to list blobs across all containers whose tags match a
   * given search expression.  Filter blobs searches across all containers within a storage account but
   * can be scoped within the expression to a single container.
   * @param options The options parameters.
   */
  filterBlobs(r) {
    return this.client.sendOperationRequest({ options: r }, Sh);
  }
}
const Xe = bt(
  Pt,
  /* isXml */
  !0
), xh = {
  path: "/",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: ds
    },
    default: {
      bodyMapper: B,
      headersMapper: ps
    }
  },
  requestBody: Ey,
  queryParameters: [
    Or,
    Ke,
    E
  ],
  urlParameters: [b],
  headerParameters: [
    wt,
    Ye,
    P,
    w
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: Xe
}, Ih = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Ga,
      headersMapper: us
    },
    default: {
      bodyMapper: B,
      headersMapper: gs
    }
  },
  queryParameters: [
    Or,
    Ke,
    E
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: Xe
}, Bh = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: rs,
      headersMapper: ys
    },
    default: {
      bodyMapper: B,
      headersMapper: hs
    }
  },
  queryParameters: [
    Or,
    E,
    Py
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: Xe
}, bh = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: as,
      headersMapper: fs
    },
    default: {
      bodyMapper: B,
      headersMapper: As
    }
  },
  queryParameters: [
    E,
    Xa,
    Wa,
    it,
    st,
    wy
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: Xe
}, Eh = {
  path: "/",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: is,
      headersMapper: Ns
    },
    default: {
      bodyMapper: B,
      headersMapper: Cs
    }
  },
  requestBody: Sy,
  queryParameters: [
    Or,
    E,
    Ry
  ],
  urlParameters: [b],
  headerParameters: [
    wt,
    Ye,
    P,
    w
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: Xe
}, Ph = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: xs
    },
    default: {
      bodyMapper: B,
      headersMapper: Is
    }
  },
  queryParameters: [
    Ke,
    E,
    ja
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: Xe
}, wh = {
  path: "/",
  httpMethod: "POST",
  responses: {
    202: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Bs
    },
    default: {
      bodyMapper: B,
      headersMapper: bs
    }
  },
  requestBody: Um,
  queryParameters: [E, qm],
  urlParameters: [b],
  headerParameters: [
    Ye,
    P,
    w,
    Ae,
    Om
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: Xe
}, Sh = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Ya,
      headersMapper: Es
    },
    default: {
      bodyMapper: B,
      headersMapper: Ps
    }
  },
  queryParameters: [
    E,
    it,
    st,
    Fm,
    _m
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: Xe
};
class Rh {
  /**
   * Initialize a new instance of the class Container class.
   * @param client Reference to the service client
   */
  constructor(r) {
    d(this, "client");
    this.client = r;
  }
  /**
   * creates a new container under the specified account. If the container with the same name already
   * exists, the operation fails
   * @param options The options parameters.
   */
  create(r) {
    return this.client.sendOperationRequest({ options: r }, zh);
  }
  /**
   * returns all user-defined metadata and system properties for the specified container. The data
   * returned does not include the container's list of blobs
   * @param options The options parameters.
   */
  getProperties(r) {
    return this.client.sendOperationRequest({ options: r }, Mh);
  }
  /**
   * operation marks the specified container for deletion. The container and any blobs contained within
   * it are later deleted during garbage collection
   * @param options The options parameters.
   */
  delete(r) {
    return this.client.sendOperationRequest({ options: r }, Dh);
  }
  /**
   * operation sets one or more user-defined name-value pairs for the specified container.
   * @param options The options parameters.
   */
  setMetadata(r) {
    return this.client.sendOperationRequest({ options: r }, Qh);
  }
  /**
   * gets the permissions for the specified container. The permissions indicate whether container data
   * may be accessed publicly.
   * @param options The options parameters.
   */
  getAccessPolicy(r) {
    return this.client.sendOperationRequest({ options: r }, Th);
  }
  /**
   * sets the permissions for the specified container. The permissions indicate whether blobs in a
   * container may be accessed publicly.
   * @param options The options parameters.
   */
  setAccessPolicy(r) {
    return this.client.sendOperationRequest({ options: r }, vh);
  }
  /**
   * Restores a previously-deleted container.
   * @param options The options parameters.
   */
  restore(r) {
    return this.client.sendOperationRequest({ options: r }, Hh);
  }
  /**
   * Renames an existing container.
   * @param sourceContainerName Required.  Specifies the name of the container to rename.
   * @param options The options parameters.
   */
  rename(r, e) {
    return this.client.sendOperationRequest({ sourceContainerName: r, options: e }, kh);
  }
  /**
   * The Batch operation allows multiple API calls to be embedded into a single HTTP request.
   * @param contentLength The length of the request.
   * @param multipartContentType Required. The value of this header must be multipart/mixed with a batch
   *                             boundary. Example header value: multipart/mixed; boundary=batch_<GUID>
   * @param body Initial data
   * @param options The options parameters.
   */
  submitBatch(r, e, a, n) {
    return this.client.sendOperationRequest({ contentLength: r, multipartContentType: e, body: a, options: n }, Lh);
  }
  /**
   * The Filter Blobs operation enables callers to list blobs in a container whose tags match a given
   * search expression.  Filter blobs searches within the given container.
   * @param options The options parameters.
   */
  filterBlobs(r) {
    return this.client.sendOperationRequest({ options: r }, Uh);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param options The options parameters.
   */
  acquireLease(r) {
    return this.client.sendOperationRequest({ options: r }, qh);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  releaseLease(r, e) {
    return this.client.sendOperationRequest({ leaseId: r, options: e }, Oh);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  renewLease(r, e) {
    return this.client.sendOperationRequest({ leaseId: r, options: e }, Fh);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param options The options parameters.
   */
  breakLease(r) {
    return this.client.sendOperationRequest({ options: r }, _h);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param leaseId Specifies the current lease ID on the resource.
   * @param proposedLeaseId Proposed lease ID, in a GUID string format. The Blob service returns 400
   *                        (Invalid request) if the proposed lease ID is not in the correct format. See Guid Constructor
   *                        (String) for a list of valid GUID string formats.
   * @param options The options parameters.
   */
  changeLease(r, e, a) {
    return this.client.sendOperationRequest({ leaseId: r, proposedLeaseId: e, options: a }, Gh);
  }
  /**
   * [Update] The List Blobs operation returns a list of the blobs under the specified container
   * @param options The options parameters.
   */
  listBlobFlatSegment(r) {
    return this.client.sendOperationRequest({ options: r }, Yh);
  }
  /**
   * [Update] The List Blobs operation returns a list of the blobs under the specified container
   * @param delimiter When the request includes this parameter, the operation returns a BlobPrefix
   *                  element in the response body that acts as a placeholder for all blobs whose names begin with the
   *                  same substring up to the appearance of the delimiter character. The delimiter may be a single
   *                  character or a string.
   * @param options The options parameters.
   */
  listBlobHierarchySegment(r, e) {
    return this.client.sendOperationRequest({ delimiter: r, options: e }, Kh);
  }
  /**
   * Returns the sku name and account kind
   * @param options The options parameters.
   */
  getAccountInfo(r) {
    return this.client.sendOperationRequest({ options: r }, Jh);
  }
}
const ae = bt(
  Pt,
  /* isXml */
  !0
), zh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: ws
    },
    default: {
      bodyMapper: B,
      headersMapper: Ss
    }
  },
  queryParameters: [E, me],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Se,
    Gm,
    zy,
    My
  ],
  isXML: !0,
  serializer: ae
}, Mh = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: Rs
    },
    default: {
      bodyMapper: B,
      headersMapper: zs
    }
  },
  queryParameters: [E, me],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O
  ],
  isXML: !0,
  serializer: ae
}, Dh = {
  path: "/{containerName}",
  httpMethod: "DELETE",
  responses: {
    202: {
      headersMapper: Ms
    },
    default: {
      bodyMapper: B,
      headersMapper: Ds
    }
  },
  queryParameters: [E, me],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q
  ],
  isXML: !0,
  serializer: ae
}, Qh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Qs
    },
    default: {
      bodyMapper: B,
      headersMapper: Ts
    }
  },
  queryParameters: [
    E,
    me,
    Ym
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Se,
    O,
    U
  ],
  isXML: !0,
  serializer: ae
}, Th = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: { name: "Composite", className: "SignedIdentifier" }
          }
        },
        serializedName: "SignedIdentifiers",
        xmlName: "SignedIdentifiers",
        xmlIsWrapped: !0,
        xmlElementName: "SignedIdentifier"
      },
      headersMapper: vs
    },
    default: {
      bodyMapper: B,
      headersMapper: Hs
    }
  },
  queryParameters: [
    E,
    me,
    Km
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O
  ],
  isXML: !0,
  serializer: ae
}, vh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: ks
    },
    default: {
      bodyMapper: B,
      headersMapper: Ls
    }
  },
  requestBody: Dy,
  queryParameters: [
    E,
    me,
    Km
  ],
  urlParameters: [b],
  headerParameters: [
    wt,
    Ye,
    P,
    w,
    Gm,
    O,
    U,
    q
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: ae
}, Hh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Us
    },
    default: {
      bodyMapper: B,
      headersMapper: qs
    }
  },
  queryParameters: [
    E,
    me,
    Jm
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Qy,
    Ty
  ],
  isXML: !0,
  serializer: ae
}, kh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Os
    },
    default: {
      bodyMapper: B,
      headersMapper: Fs
    }
  },
  queryParameters: [
    E,
    me,
    vy
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Hy,
    ky
  ],
  isXML: !0,
  serializer: ae
}, Lh = {
  path: "/{containerName}",
  httpMethod: "POST",
  responses: {
    202: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: _s
    },
    default: {
      bodyMapper: B,
      headersMapper: Gs
    }
  },
  requestBody: Um,
  queryParameters: [
    E,
    qm,
    me
  ],
  urlParameters: [b],
  headerParameters: [
    Ye,
    P,
    w,
    Ae,
    Om
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: ae
}, Uh = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Ya,
      headersMapper: Ys
    },
    default: {
      bodyMapper: B,
      headersMapper: Ks
    }
  },
  queryParameters: [
    E,
    it,
    st,
    Fm,
    _m,
    me
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: ae
}, qh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Js
    },
    default: {
      bodyMapper: B,
      headersMapper: Xs
    }
  },
  queryParameters: [
    E,
    me,
    De
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    Xm,
    Wm,
    jm
  ],
  isXML: !0,
  serializer: ae
}, Oh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Ws
    },
    default: {
      bodyMapper: B,
      headersMapper: js
    }
  },
  queryParameters: [
    E,
    me,
    De
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    Zm,
    St
  ],
  isXML: !0,
  serializer: ae
}, Fh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Zs
    },
    default: {
      bodyMapper: B,
      headersMapper: Vs
    }
  },
  queryParameters: [
    E,
    me,
    De
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    St,
    Vm
  ],
  isXML: !0,
  serializer: ae
}, _h = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: $s
    },
    default: {
      bodyMapper: B,
      headersMapper: eo
    }
  },
  queryParameters: [
    E,
    me,
    De
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    $m,
    ec
  ],
  isXML: !0,
  serializer: ae
}, Gh = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: to
    },
    default: {
      bodyMapper: B,
      headersMapper: ro
    }
  },
  queryParameters: [
    E,
    me,
    De
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    St,
    tc,
    rc
  ],
  isXML: !0,
  serializer: ae
}, Yh = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: ss,
      headersMapper: ao
    },
    default: {
      bodyMapper: B,
      headersMapper: no
    }
  },
  queryParameters: [
    E,
    Xa,
    Wa,
    it,
    st,
    me,
    ac,
    nc
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: ae
}, Kh = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: os,
      headersMapper: io
    },
    default: {
      bodyMapper: B,
      headersMapper: so
    }
  },
  queryParameters: [
    E,
    Xa,
    Wa,
    it,
    st,
    me,
    ac,
    nc,
    Ly
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: ae
}, Jh = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: oo
    },
    default: {
      bodyMapper: B,
      headersMapper: mo
    }
  },
  queryParameters: [
    Ke,
    E,
    ja
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: ae
};
class Xh {
  /**
   * Initialize a new instance of the class Blob class.
   * @param client Reference to the service client
   */
  constructor(r) {
    d(this, "client");
    this.client = r;
  }
  /**
   * The Download operation reads or downloads a blob from the system, including its metadata and
   * properties. You can also call Download to read a snapshot.
   * @param options The options parameters.
   */
  download(r) {
    return this.client.sendOperationRequest({ options: r }, Wh);
  }
  /**
   * The Get Properties operation returns all user-defined metadata, standard HTTP properties, and system
   * properties for the blob. It does not return the content of the blob.
   * @param options The options parameters.
   */
  getProperties(r) {
    return this.client.sendOperationRequest({ options: r }, jh);
  }
  /**
   * If the storage account's soft delete feature is disabled then, when a blob is deleted, it is
   * permanently removed from the storage account. If the storage account's soft delete feature is
   * enabled, then, when a blob is deleted, it is marked for deletion and becomes inaccessible
   * immediately. However, the blob service retains the blob or snapshot for the number of days specified
   * by the DeleteRetentionPolicy section of [Storage service properties]
   * (Set-Blob-Service-Properties.md). After the specified number of days has passed, the blob's data is
   * permanently removed from the storage account. Note that you continue to be charged for the
   * soft-deleted blob's storage until it is permanently removed. Use the List Blobs API and specify the
   * "include=deleted" query parameter to discover which blobs and snapshots have been soft deleted. You
   * can then use the Undelete Blob API to restore a soft-deleted blob. All other operations on a
   * soft-deleted blob or snapshot causes the service to return an HTTP status code of 404
   * (ResourceNotFound).
   * @param options The options parameters.
   */
  delete(r) {
    return this.client.sendOperationRequest({ options: r }, Zh);
  }
  /**
   * Undelete a blob that was previously soft deleted
   * @param options The options parameters.
   */
  undelete(r) {
    return this.client.sendOperationRequest({ options: r }, Vh);
  }
  /**
   * Sets the time a blob will expire and be deleted.
   * @param expiryOptions Required. Indicates mode of the expiry time
   * @param options The options parameters.
   */
  setExpiry(r, e) {
    return this.client.sendOperationRequest({ expiryOptions: r, options: e }, $h);
  }
  /**
   * The Set HTTP Headers operation sets system properties on the blob
   * @param options The options parameters.
   */
  setHttpHeaders(r) {
    return this.client.sendOperationRequest({ options: r }, ef);
  }
  /**
   * The Set Immutability Policy operation sets the immutability policy on the blob
   * @param options The options parameters.
   */
  setImmutabilityPolicy(r) {
    return this.client.sendOperationRequest({ options: r }, tf);
  }
  /**
   * The Delete Immutability Policy operation deletes the immutability policy on the blob
   * @param options The options parameters.
   */
  deleteImmutabilityPolicy(r) {
    return this.client.sendOperationRequest({ options: r }, rf);
  }
  /**
   * The Set Legal Hold operation sets a legal hold on the blob.
   * @param legalHold Specified if a legal hold should be set on the blob.
   * @param options The options parameters.
   */
  setLegalHold(r, e) {
    return this.client.sendOperationRequest({ legalHold: r, options: e }, af);
  }
  /**
   * The Set Blob Metadata operation sets user-defined metadata for the specified blob as one or more
   * name-value pairs
   * @param options The options parameters.
   */
  setMetadata(r) {
    return this.client.sendOperationRequest({ options: r }, nf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param options The options parameters.
   */
  acquireLease(r) {
    return this.client.sendOperationRequest({ options: r }, sf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  releaseLease(r, e) {
    return this.client.sendOperationRequest({ leaseId: r, options: e }, of);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  renewLease(r, e) {
    return this.client.sendOperationRequest({ leaseId: r, options: e }, mf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param leaseId Specifies the current lease ID on the resource.
   * @param proposedLeaseId Proposed lease ID, in a GUID string format. The Blob service returns 400
   *                        (Invalid request) if the proposed lease ID is not in the correct format. See Guid Constructor
   *                        (String) for a list of valid GUID string formats.
   * @param options The options parameters.
   */
  changeLease(r, e, a) {
    return this.client.sendOperationRequest({ leaseId: r, proposedLeaseId: e, options: a }, cf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param options The options parameters.
   */
  breakLease(r) {
    return this.client.sendOperationRequest({ options: r }, lf);
  }
  /**
   * The Create Snapshot operation creates a read-only snapshot of a blob
   * @param options The options parameters.
   */
  createSnapshot(r) {
    return this.client.sendOperationRequest({ options: r }, df);
  }
  /**
   * The Start Copy From URL operation copies a blob or an internet resource to a new blob.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  startCopyFromURL(r, e) {
    return this.client.sendOperationRequest({ copySource: r, options: e }, pf);
  }
  /**
   * The Copy From URL operation copies a blob or an internet resource to a new blob. It will not return
   * a response until the copy is complete.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  copyFromURL(r, e) {
    return this.client.sendOperationRequest({ copySource: r, options: e }, uf);
  }
  /**
   * The Abort Copy From URL operation aborts a pending Copy From URL operation, and leaves a destination
   * blob with zero length and full metadata.
   * @param copyId The copy identifier provided in the x-ms-copy-id header of the original Copy Blob
   *               operation.
   * @param options The options parameters.
   */
  abortCopyFromURL(r, e) {
    return this.client.sendOperationRequest({ copyId: r, options: e }, gf);
  }
  /**
   * The Set Tier operation sets the tier on a blob. The operation is allowed on a page blob in a premium
   * storage account and on a block blob in a blob storage account (locally redundant storage only). A
   * premium page blob's tier determines the allowed size, IOPS, and bandwidth of the blob. A block
   * blob's tier determines Hot/Cool/Archive storage type. This operation does not update the blob's
   * ETag.
   * @param tier Indicates the tier to be set on the blob.
   * @param options The options parameters.
   */
  setTier(r, e) {
    return this.client.sendOperationRequest({ tier: r, options: e }, yf);
  }
  /**
   * Returns the sku name and account kind
   * @param options The options parameters.
   */
  getAccountInfo(r) {
    return this.client.sendOperationRequest({ options: r }, hf);
  }
  /**
   * The Query operation enables users to select/project on blob data by providing simple query
   * expressions.
   * @param options The options parameters.
   */
  query(r) {
    return this.client.sendOperationRequest({ options: r }, ff);
  }
  /**
   * The Get Tags operation enables users to get the tags associated with a blob.
   * @param options The options parameters.
   */
  getTags(r) {
    return this.client.sendOperationRequest({ options: r }, Af);
  }
  /**
   * The Set Tags operation enables users to set tags on a blob.
   * @param options The options parameters.
   */
  setTags(r) {
    return this.client.sendOperationRequest({ options: r }, Nf);
  }
}
const X = bt(
  Pt,
  /* isXml */
  !0
), Wh = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Ea
    },
    206: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Ea
    },
    default: {
      bodyMapper: B,
      headersMapper: co
    }
  },
  queryParameters: [
    E,
    Be,
    ve
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    dr,
    Uy,
    qy,
    pr,
    ee,
    te,
    re,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: X
}, jh = {
  path: "/{containerName}/{blob}",
  httpMethod: "HEAD",
  responses: {
    200: {
      headersMapper: lo
    },
    default: {
      bodyMapper: B,
      headersMapper: po
    }
  },
  queryParameters: [
    E,
    Be,
    ve
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: X
}, Zh = {
  path: "/{containerName}/{blob}",
  httpMethod: "DELETE",
  responses: {
    202: {
      headersMapper: uo
    },
    default: {
      bodyMapper: B,
      headersMapper: go
    }
  },
  queryParameters: [
    E,
    Be,
    ve,
    Fy
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    G,
    Y,
    F,
    Oy,
    _y,
    Gy
  ],
  isXML: !0,
  serializer: X
}, Vh = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: yo
    },
    default: {
      bodyMapper: B,
      headersMapper: ho
    }
  },
  queryParameters: [E, Jm],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: X
}, $h = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: fo
    },
    default: {
      bodyMapper: B,
      headersMapper: Ao
    }
  },
  queryParameters: [E, Yy],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ky,
    Jy
  ],
  isXML: !0,
  serializer: X
}, ef = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: No
    },
    default: {
      bodyMapper: B,
      headersMapper: Co
    }
  },
  queryParameters: [Ke, E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    G,
    Y,
    F,
    Rt,
    zt,
    Mt,
    Dt,
    Qt,
    Tt
  ],
  isXML: !0,
  serializer: X
}, tf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: xo
    },
    default: {
      bodyMapper: B,
      headersMapper: Io
    }
  },
  queryParameters: [
    E,
    Be,
    ve,
    ic
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    q,
    ot,
    mt
  ],
  isXML: !0,
  serializer: X
}, rf = {
  path: "/{containerName}/{blob}",
  httpMethod: "DELETE",
  responses: {
    200: {
      headersMapper: Bo
    },
    default: {
      bodyMapper: B,
      headersMapper: bo
    }
  },
  queryParameters: [
    E,
    Be,
    ve,
    ic
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: X
}, af = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Eo
    },
    default: {
      bodyMapper: B,
      headersMapper: Po
    }
  },
  queryParameters: [
    E,
    Be,
    ve,
    Xy
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Wy
  ],
  isXML: !0,
  serializer: X
}, nf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: wo
    },
    default: {
      bodyMapper: B,
      headersMapper: So
    }
  },
  queryParameters: [E, Ym],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Se,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce
  ],
  isXML: !0,
  serializer: X
}, sf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Ro
    },
    default: {
      bodyMapper: B,
      headersMapper: zo
    }
  },
  queryParameters: [E, De],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    Xm,
    Wm,
    jm,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: X
}, of = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Mo
    },
    default: {
      bodyMapper: B,
      headersMapper: Do
    }
  },
  queryParameters: [E, De],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    Zm,
    St,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: X
}, mf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Qo
    },
    default: {
      bodyMapper: B,
      headersMapper: To
    }
  },
  queryParameters: [E, De],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    St,
    Vm,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: X
}, cf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: vo
    },
    default: {
      bodyMapper: B,
      headersMapper: Ho
    }
  },
  queryParameters: [E, De],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    St,
    tc,
    rc,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: X
}, lf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: ko
    },
    default: {
      bodyMapper: B,
      headersMapper: Lo
    }
  },
  queryParameters: [E, De],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    $m,
    ec,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: X
}, df = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Uo
    },
    default: {
      bodyMapper: B,
      headersMapper: qo
    }
  },
  queryParameters: [E, jy],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Se,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce
  ],
  isXML: !0,
  serializer: X
}, pf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: Oo
    },
    default: {
      bodyMapper: B,
      headersMapper: Fo
    }
  },
  queryParameters: [E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Se,
    O,
    U,
    q,
    G,
    Y,
    F,
    ot,
    mt,
    vt,
    sc,
    Ht,
    kt,
    Lt,
    Ut,
    oc,
    Fr,
    ct,
    Zy,
    qt
  ],
  isXML: !0,
  serializer: X
}, uf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: _o
    },
    default: {
      bodyMapper: B,
      headersMapper: Go
    }
  },
  queryParameters: [E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Se,
    O,
    U,
    q,
    G,
    Y,
    F,
    ot,
    mt,
    ce,
    vt,
    Ht,
    kt,
    Lt,
    Ut,
    Fr,
    ct,
    qt,
    Vy,
    ur,
    gr,
    mc,
    yr
  ],
  isXML: !0,
  serializer: X
}, gf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    204: {
      headersMapper: Yo
    },
    default: {
      bodyMapper: B,
      headersMapper: Ko
    }
  },
  queryParameters: [
    E,
    $y,
    th
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    eh
  ],
  isXML: !0,
  serializer: X
}, yf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Pa
    },
    202: {
      headersMapper: Pa
    },
    default: {
      bodyMapper: B,
      headersMapper: Jo
    }
  },
  queryParameters: [
    E,
    Be,
    ve,
    rh
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    F,
    sc,
    ah
  ],
  isXML: !0,
  serializer: X
}, hf = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: Xo
    },
    default: {
      bodyMapper: B,
      headersMapper: Wo
    }
  },
  queryParameters: [
    Ke,
    E,
    ja
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M
  ],
  isXML: !0,
  serializer: X
}, ff = {
  path: "/{containerName}/{blob}",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: wa
    },
    206: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: wa
    },
    default: {
      bodyMapper: B,
      headersMapper: jo
    }
  },
  requestBody: nh,
  queryParameters: [
    E,
    Be,
    ih
  ],
  urlParameters: [b],
  headerParameters: [
    wt,
    Ye,
    P,
    w,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: X
}, Af = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Ka,
      headersMapper: Zo
    },
    default: {
      bodyMapper: B,
      headersMapper: Vo
    }
  },
  queryParameters: [
    E,
    Be,
    ve,
    cc
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    F,
    lc,
    dc,
    pc,
    uc
  ],
  isXML: !0,
  serializer: X
}, Nf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    204: {
      headersMapper: $o
    },
    default: {
      bodyMapper: B,
      headersMapper: em
    }
  },
  requestBody: sh,
  queryParameters: [
    E,
    ve,
    cc
  ],
  urlParameters: [b],
  headerParameters: [
    wt,
    Ye,
    P,
    w,
    O,
    F,
    lc,
    dc,
    pc,
    uc,
    Je,
    Ot
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: X
};
class Cf {
  /**
   * Initialize a new instance of the class PageBlob class.
   * @param client Reference to the service client
   */
  constructor(r) {
    d(this, "client");
    this.client = r;
  }
  /**
   * The Create operation creates a new page blob.
   * @param contentLength The length of the request.
   * @param blobContentLength This header specifies the maximum size for the page blob, up to 1 TB. The
   *                          page blob size must be aligned to a 512-byte boundary.
   * @param options The options parameters.
   */
  create(r, e, a) {
    return this.client.sendOperationRequest({ contentLength: r, blobContentLength: e, options: a }, xf);
  }
  /**
   * The Upload Pages operation writes a range of pages to a page blob
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  uploadPages(r, e, a) {
    return this.client.sendOperationRequest({ contentLength: r, body: e, options: a }, If);
  }
  /**
   * The Clear Pages operation clears a set of pages from a page blob
   * @param contentLength The length of the request.
   * @param options The options parameters.
   */
  clearPages(r, e) {
    return this.client.sendOperationRequest({ contentLength: r, options: e }, Bf);
  }
  /**
   * The Upload Pages operation writes a range of pages to a page blob where the contents are read from a
   * URL
   * @param sourceUrl Specify a URL to the copy source.
   * @param sourceRange Bytes of source data in the specified range. The length of this range should
   *                    match the ContentLength header and x-ms-range/Range destination range header.
   * @param contentLength The length of the request.
   * @param range The range of bytes to which the source range would be written. The range should be 512
   *              aligned and range-end is required.
   * @param options The options parameters.
   */
  uploadPagesFromURL(r, e, a, n, i) {
    return this.client.sendOperationRequest({ sourceUrl: r, sourceRange: e, contentLength: a, range: n, options: i }, bf);
  }
  /**
   * The Get Page Ranges operation returns the list of valid page ranges for a page blob or snapshot of a
   * page blob
   * @param options The options parameters.
   */
  getPageRanges(r) {
    return this.client.sendOperationRequest({ options: r }, Ef);
  }
  /**
   * The Get Page Ranges Diff operation returns the list of valid page ranges for a page blob that were
   * changed between target blob and previous snapshot.
   * @param options The options parameters.
   */
  getPageRangesDiff(r) {
    return this.client.sendOperationRequest({ options: r }, Pf);
  }
  /**
   * Resize the Blob
   * @param blobContentLength This header specifies the maximum size for the page blob, up to 1 TB. The
   *                          page blob size must be aligned to a 512-byte boundary.
   * @param options The options parameters.
   */
  resize(r, e) {
    return this.client.sendOperationRequest({ blobContentLength: r, options: e }, wf);
  }
  /**
   * Update the sequence number of the blob
   * @param sequenceNumberAction Required if the x-ms-blob-sequence-number header is set for the request.
   *                             This property applies to page blobs only. This property indicates how the service should modify the
   *                             blob's sequence number
   * @param options The options parameters.
   */
  updateSequenceNumber(r, e) {
    return this.client.sendOperationRequest({ sequenceNumberAction: r, options: e }, Sf);
  }
  /**
   * The Copy Incremental operation copies a snapshot of the source page blob to a destination page blob.
   * The snapshot is copied such that only the differential changes between the previously copied
   * snapshot are transferred to the destination. The copied snapshots are complete copies of the
   * original snapshot and can be read or copied from as usual. This API is supported since REST version
   * 2016-05-31.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  copyIncremental(r, e) {
    return this.client.sendOperationRequest({ copySource: r, options: e }, Rf);
  }
}
const He = bt(
  Pt,
  /* isXml */
  !0
), xf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: tm
    },
    default: {
      bodyMapper: B,
      headersMapper: rm
    }
  },
  queryParameters: [E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ae,
    Se,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    Rt,
    zt,
    Mt,
    Dt,
    Qt,
    Tt,
    ot,
    mt,
    ce,
    vt,
    ct,
    qt,
    oh,
    gc,
    yc
  ],
  isXML: !0,
  serializer: He
}, If = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: am
    },
    default: {
      bodyMapper: B,
      headersMapper: nm
    }
  },
  requestBody: Gr,
  queryParameters: [E, Za],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    Ae,
    O,
    U,
    q,
    dr,
    pr,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce,
    Je,
    Ot,
    _r,
    Yr,
    hc,
    Va,
    $a,
    en,
    Kr
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: He
}, Bf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: im
    },
    default: {
      bodyMapper: B,
      headersMapper: sm
    }
  },
  queryParameters: [E, Za],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ae,
    O,
    U,
    q,
    dr,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce,
    Va,
    $a,
    en,
    mh
  ],
  isXML: !0,
  serializer: He
}, bf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: om
    },
    default: {
      bodyMapper: B,
      headersMapper: mm
    }
  },
  queryParameters: [E, Za],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ae,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce,
    Ht,
    kt,
    Lt,
    Ut,
    ur,
    gr,
    yr,
    hc,
    Va,
    $a,
    en,
    tn,
    ch,
    rn,
    lh,
    Jr,
    Xr,
    Wr
  ],
  isXML: !0,
  serializer: He
}, Ef = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Ja,
      headersMapper: cm
    },
    default: {
      bodyMapper: B,
      headersMapper: lm
    }
  },
  queryParameters: [
    E,
    it,
    st,
    Be,
    fc
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    dr,
    G,
    Y,
    F
  ],
  isXML: !0,
  serializer: He
}, Pf = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Ja,
      headersMapper: dm
    },
    default: {
      bodyMapper: B,
      headersMapper: pm
    }
  },
  queryParameters: [
    E,
    it,
    st,
    Be,
    fc,
    dh
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    dr,
    G,
    Y,
    F,
    ph
  ],
  isXML: !0,
  serializer: He
}, wf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: um
    },
    default: {
      bodyMapper: B,
      headersMapper: gm
    }
  },
  queryParameters: [Ke, E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce,
    gc
  ],
  isXML: !0,
  serializer: He
}, Sf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: ym
    },
    default: {
      bodyMapper: B,
      headersMapper: hm
    }
  },
  queryParameters: [Ke, E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    G,
    Y,
    F,
    yc,
    uh
  ],
  isXML: !0,
  serializer: He
}, Rf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: fm
    },
    default: {
      bodyMapper: B,
      headersMapper: Am
    }
  },
  queryParameters: [E, gh],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    U,
    q,
    G,
    Y,
    F,
    Fr
  ],
  isXML: !0,
  serializer: He
};
class zf {
  /**
   * Initialize a new instance of the class AppendBlob class.
   * @param client Reference to the service client
   */
  constructor(r) {
    d(this, "client");
    this.client = r;
  }
  /**
   * The Create Append Blob operation creates a new append blob.
   * @param contentLength The length of the request.
   * @param options The options parameters.
   */
  create(r, e) {
    return this.client.sendOperationRequest({ contentLength: r, options: e }, Mf);
  }
  /**
   * The Append Block operation commits a new block of data to the end of an existing append blob. The
   * Append Block operation is permitted only if the blob was created with x-ms-blob-type set to
   * AppendBlob. Append Block is supported only on version 2015-02-21 version or later.
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  appendBlock(r, e, a) {
    return this.client.sendOperationRequest({ contentLength: r, body: e, options: a }, Df);
  }
  /**
   * The Append Block operation commits a new block of data to the end of an existing append blob where
   * the contents are read from a source url. The Append Block operation is permitted only if the blob
   * was created with x-ms-blob-type set to AppendBlob. Append Block is supported only on version
   * 2015-02-21 version or later.
   * @param sourceUrl Specify a URL to the copy source.
   * @param contentLength The length of the request.
   * @param options The options parameters.
   */
  appendBlockFromUrl(r, e, a) {
    return this.client.sendOperationRequest({ sourceUrl: r, contentLength: e, options: a }, Qf);
  }
  /**
   * The Seal operation seals the Append Blob to make it read-only. Seal is supported only on version
   * 2019-12-12 version or later.
   * @param options The options parameters.
   */
  seal(r) {
    return this.client.sendOperationRequest({ options: r }, Tf);
  }
}
const jr = bt(
  Pt,
  /* isXml */
  !0
), Mf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Nm
    },
    default: {
      bodyMapper: B,
      headersMapper: Cm
    }
  },
  queryParameters: [E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ae,
    Se,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    Rt,
    zt,
    Mt,
    Dt,
    Qt,
    Tt,
    ot,
    mt,
    ce,
    ct,
    qt,
    yh
  ],
  isXML: !0,
  serializer: jr
}, Df = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: xm
    },
    default: {
      bodyMapper: B,
      headersMapper: Im
    }
  },
  requestBody: Gr,
  queryParameters: [E, Ac],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    Ae,
    O,
    U,
    q,
    pr,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce,
    Je,
    Ot,
    _r,
    Yr,
    Kr,
    Nc,
    an
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: jr
}, Qf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Bm
    },
    default: {
      bodyMapper: B,
      headersMapper: bm
    }
  },
  queryParameters: [E, Ac],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ae,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    ce,
    Ht,
    kt,
    Lt,
    Ut,
    ur,
    gr,
    yr,
    Je,
    tn,
    rn,
    Jr,
    Xr,
    Wr,
    Nc,
    an,
    Cc
  ],
  isXML: !0,
  serializer: jr
}, Tf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Em
    },
    default: {
      bodyMapper: B,
      headersMapper: Pm
    }
  },
  queryParameters: [E, hh],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    U,
    q,
    G,
    Y,
    an
  ],
  isXML: !0,
  serializer: jr
};
class vf {
  /**
   * Initialize a new instance of the class BlockBlob class.
   * @param client Reference to the service client
   */
  constructor(r) {
    d(this, "client");
    this.client = r;
  }
  /**
   * The Upload Block Blob operation updates the content of an existing block blob. Updating an existing
   * block blob overwrites any existing metadata on the blob. Partial updates are not supported with Put
   * Blob; the content of the existing blob is overwritten with the content of the new blob. To perform a
   * partial update of the content of a block blob, use the Put Block List operation.
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  upload(r, e, a) {
    return this.client.sendOperationRequest({ contentLength: r, body: e, options: a }, Hf);
  }
  /**
   * The Put Blob from URL operation creates a new Block Blob where the contents of the blob are read
   * from a given URL.  This API is supported beginning with the 2020-04-08 version. Partial updates are
   * not supported with Put Blob from URL; the content of an existing blob is overwritten with the
   * content of the new blob.  To perform partial updates to a block blob’s contents using a source URL,
   * use the Put Block from URL API in conjunction with Put Block List.
   * @param contentLength The length of the request.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  putBlobFromUrl(r, e, a) {
    return this.client.sendOperationRequest({ contentLength: r, copySource: e, options: a }, kf);
  }
  /**
   * The Stage Block operation creates a new block to be committed as part of a blob
   * @param blockId A valid Base64 string value that identifies the block. Prior to encoding, the string
   *                must be less than or equal to 64 bytes in size. For a given blob, the length of the value specified
   *                for the blockid parameter must be the same size for each block.
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  stageBlock(r, e, a, n) {
    return this.client.sendOperationRequest({ blockId: r, contentLength: e, body: a, options: n }, Lf);
  }
  /**
   * The Stage Block operation creates a new block to be committed as part of a blob where the contents
   * are read from a URL.
   * @param blockId A valid Base64 string value that identifies the block. Prior to encoding, the string
   *                must be less than or equal to 64 bytes in size. For a given blob, the length of the value specified
   *                for the blockid parameter must be the same size for each block.
   * @param contentLength The length of the request.
   * @param sourceUrl Specify a URL to the copy source.
   * @param options The options parameters.
   */
  stageBlockFromURL(r, e, a, n) {
    return this.client.sendOperationRequest({ blockId: r, contentLength: e, sourceUrl: a, options: n }, Uf);
  }
  /**
   * The Commit Block List operation writes a blob by specifying the list of block IDs that make up the
   * blob. In order to be written as part of a blob, a block must have been successfully written to the
   * server in a prior Put Block operation. You can call Put Block List to update a blob by uploading
   * only those blocks that have changed, then committing the new and existing blocks together. You can
   * do this by specifying whether to commit a block from the committed block list or from the
   * uncommitted block list, or to commit the most recently uploaded version of the block, whichever list
   * it may belong to.
   * @param blocks Blob Blocks.
   * @param options The options parameters.
   */
  commitBlockList(r, e) {
    return this.client.sendOperationRequest({ blocks: r, options: e }, qf);
  }
  /**
   * The Get Block List operation retrieves the list of blocks that have been uploaded as part of a block
   * blob
   * @param listType Specifies whether to return the list of committed blocks, the list of uncommitted
   *                 blocks, or both lists together.
   * @param options The options parameters.
   */
  getBlockList(r, e) {
    return this.client.sendOperationRequest({ listType: r, options: e }, Of);
  }
}
const Ft = bt(
  Pt,
  /* isXml */
  !0
), Hf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: wm
    },
    default: {
      bodyMapper: B,
      headersMapper: Sm
    }
  },
  requestBody: Gr,
  queryParameters: [E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    Ae,
    Se,
    O,
    U,
    q,
    pr,
    ee,
    te,
    re,
    G,
    Y,
    F,
    Rt,
    zt,
    Mt,
    Dt,
    Qt,
    Tt,
    ot,
    mt,
    ce,
    vt,
    ct,
    qt,
    Je,
    Ot,
    _r,
    Yr,
    Kr,
    xc
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: Ft
}, kf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Rm
    },
    default: {
      bodyMapper: B,
      headersMapper: zm
    }
  },
  queryParameters: [E],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ae,
    Se,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    Rt,
    zt,
    Mt,
    Dt,
    Qt,
    Tt,
    ce,
    vt,
    Ht,
    kt,
    Lt,
    Ut,
    oc,
    Fr,
    ct,
    ur,
    gr,
    mc,
    yr,
    Je,
    Jr,
    Xr,
    Wr,
    xc,
    fh
  ],
  isXML: !0,
  serializer: Ft
}, Lf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Mm
    },
    default: {
      bodyMapper: B,
      headersMapper: Dm
    }
  },
  requestBody: Gr,
  queryParameters: [
    E,
    Ic,
    Bc
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    Ae,
    O,
    pr,
    ee,
    te,
    re,
    ce,
    Je,
    Ot,
    _r,
    Yr,
    Kr
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: Ft
}, Uf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Qm
    },
    default: {
      bodyMapper: B,
      headersMapper: Tm
    }
  },
  queryParameters: [
    E,
    Ic,
    Bc
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    Ae,
    O,
    ee,
    te,
    re,
    ce,
    Ht,
    kt,
    Lt,
    Ut,
    ur,
    gr,
    yr,
    tn,
    rn,
    Jr,
    Xr,
    Wr,
    Cc
  ],
  isXML: !0,
  serializer: Ft
}, qf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: vm
    },
    default: {
      bodyMapper: B,
      headersMapper: Hm
    }
  },
  requestBody: Ah,
  queryParameters: [E, bc],
  urlParameters: [b],
  headerParameters: [
    wt,
    Ye,
    P,
    w,
    Se,
    O,
    U,
    q,
    ee,
    te,
    re,
    G,
    Y,
    F,
    Rt,
    zt,
    Mt,
    Dt,
    Qt,
    Tt,
    ot,
    mt,
    ce,
    vt,
    ct,
    qt,
    Je,
    Ot
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: Ft
}, Of = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: cs,
      headersMapper: km
    },
    default: {
      bodyMapper: B,
      headersMapper: Lm
    }
  },
  queryParameters: [
    E,
    Be,
    bc,
    Nh
  ],
  urlParameters: [b],
  headerParameters: [
    P,
    w,
    M,
    O,
    F
  ],
  isXML: !0,
  serializer: Ft
};
let Ff = class extends Ju {
  /**
   * Initializes a new instance of the StorageClient class.
   * @param url The URL of the service account, container, or blob that is the target of the desired
   *            operation.
   * @param options The parameter options
   */
  constructor(e, a) {
    if (e === void 0)
      throw new Error("'url' cannot be null");
    a || (a = {});
    const n = {
      requestContentType: "application/json; charset=utf-8"
    }, i = "azsdk-js-azure-storage-blob/12.32.0", s = a.userAgentOptions && a.userAgentOptions.userAgentPrefix ? `${a.userAgentOptions.userAgentPrefix} ${i}` : `${i}`, o = {
      ...n,
      ...a,
      userAgentOptions: {
        userAgentPrefix: s
      },
      endpoint: a.endpoint ?? a.baseUri ?? "{url}"
    };
    super(o);
    d(this, "url");
    d(this, "version");
    d(this, "service");
    d(this, "container");
    d(this, "blob");
    d(this, "pageBlob");
    d(this, "appendBlob");
    d(this, "blockBlob");
    this.url = e, this.version = a.version || "2026-04-06", this.service = new Ch(this), this.container = new Rh(this), this.blob = new Xh(this), this.pageBlob = new Cf(this), this.appendBlob = new zf(this), this.blockBlob = new vf(this);
  }
};
class Ec extends Ff {
  async sendOperationRequest(r, e) {
    const a = { ...e };
    return (a.path === "/{containerName}" || a.path === "/{containerName}/{blob}") && (a.path = ""), super.sendOperationRequest(r, a);
  }
}
function _f(t) {
  const r = new URL(t);
  let e = r.pathname;
  return e = e || "/", e = Yf(e), r.pathname = e, r.toString();
}
function Gf(t) {
  let r = "";
  if (t.search("DevelopmentStorageProxyUri=") !== -1) {
    const e = t.split(";");
    for (const a of e)
      a.trim().startsWith("DevelopmentStorageProxyUri=") && (r = a.trim().match("DevelopmentStorageProxyUri=(.*)")[1]);
  }
  return r;
}
function $e(t, r) {
  const e = t.split(";");
  for (const a of e)
    if (a.trim().startsWith(r))
      return a.trim().match(r + "=(.*)")[1];
  return "";
}
function _t(t) {
  let r = "";
  t.startsWith("UseDevelopmentStorage=true") && (r = Gf(t), t = Lg);
  let e = $e(t, "BlobEndpoint");
  if (e = e.endsWith("/") ? e.slice(0, -1) : e, t.search("DefaultEndpointsProtocol=") !== -1 && t.search("AccountKey=") !== -1) {
    let a = "", n = "", i = Buffer.from("accountKey", "base64"), s = "";
    if (n = $e(t, "AccountName"), i = Buffer.from($e(t, "AccountKey"), "base64"), !e) {
      a = $e(t, "DefaultEndpointsProtocol");
      const o = a.toLowerCase();
      if (o !== "https" && o !== "http")
        throw new Error("Invalid DefaultEndpointsProtocol in the provided Connection String. Expecting 'https' or 'http'");
      if (s = $e(t, "EndpointSuffix"), !s)
        throw new Error("Invalid EndpointSuffix in the provided Connection String");
      e = `${a}://${n}.blob.${s}`;
    }
    if (n) {
      if (i.length === 0)
        throw new Error("Invalid AccountKey in the provided Connection String");
    } else throw new Error("Invalid AccountName in the provided Connection String");
    return {
      kind: "AccountConnString",
      url: e,
      accountName: n,
      accountKey: i,
      proxyUri: r
    };
  } else {
    let a = $e(t, "SharedAccessSignature"), n = $e(t, "AccountName");
    if (n || (n = Sc(e)), e) {
      if (!a)
        throw new Error("Invalid SharedAccessSignature in the provided SAS Connection String");
    } else throw new Error("Invalid BlobEndpoint in the provided SAS Connection String");
    return a.startsWith("?") && (a = a.substring(1)), { kind: "SASConnString", url: e, accountName: n, accountSas: a };
  }
}
function Yf(t) {
  return encodeURIComponent(t).replace(/%2F/g, "/").replace(/'/g, "%27").replace(/\+/g, "%20").replace(/%25/g, "%");
}
function ye(t, r) {
  const e = new URL(t);
  let a = e.pathname;
  return a = a ? a.endsWith("/") ? `${a}${r}` : `${a}/${r}` : r, e.pathname = a, e.toString();
}
function ir(t, r, e) {
  const a = new URL(t), n = encodeURIComponent(r), i = e ? encodeURIComponent(e) : void 0, s = a.search === "" ? "?" : a.search, o = [];
  for (const m of s.slice(1).split("&"))
    if (m) {
      const [c] = m.split("=", 2);
      c !== n && o.push(m);
    }
  return i && o.push(`${n}=${i}`), a.search = o.length ? `?${o.join("&")}` : "", a.toString();
}
function Yn(t, r) {
  return new URL(t).searchParams.get(r) ?? void 0;
}
function Pc(t) {
  try {
    return new URL(t).pathname;
  } catch {
    return;
  }
}
function Kf(t) {
  try {
    const r = new URL(t);
    return r.protocol.endsWith(":") ? r.protocol.slice(0, -1) : r.protocol;
  } catch {
    return;
  }
}
function Jf(t) {
  const r = new URL(t), e = r.pathname;
  if (!e)
    throw new RangeError("Invalid url without valid path.");
  let a = r.search || "";
  return a = a.trim(), a !== "" && (a = a.startsWith("?") ? a : `?${a}`), `${e}${a}`;
}
function sr(t, r) {
  const e = new URL(t);
  let a = e.search;
  return a ? a += "&" + r : a = r, e.search = a, e.toString();
}
function L(t, r = !0) {
  const e = t.toISOString();
  return r ? e.substring(0, e.length - 1) + "0000Z" : e.substring(0, e.length - 5) + "Z";
}
function Xf(t) {
  return btoa(t);
}
function Kn(t, r) {
  t.length > 42 && (t = t.slice(0, 42));
  const i = t + Wf(r.toString(), 48 - t.length, "0");
  return Xf(i);
}
function Wf(t, r, e = " ") {
  return String.prototype.padStart ? t.padStart(r, e) : (e = e || " ", t.length > r ? t : (r = r - t.length, r > e.length && (e += e.repeat(r / e.length)), e.slice(0, r) + t));
}
function wc(t, r) {
  return t.toLocaleLowerCase() === r.toLocaleLowerCase();
}
function Sc(t) {
  const r = new URL(t);
  let e;
  try {
    return r.hostname.split(".")[1] === "blob" ? e = r.hostname.split(".")[0] : nn(r) ? e = r.pathname.split("/")[1] : e = "", e;
  } catch {
    throw new Error("Unable to extract accountName with provided information.");
  }
}
function nn(t) {
  const r = t.host;
  return /^.*:.*:.*$|^(localhost|host.docker.internal)(:[0-9]+)?$|^(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])){3}(:[0-9]+)?$/.test(r) || !!t.port && _g.includes(t.port);
}
function rt(t) {
  if (t === void 0)
    return;
  const r = [];
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      const a = t[e];
      r.push(`${encodeURIComponent(e)}=${encodeURIComponent(a)}`);
    }
  return r.join("&");
}
function jf(t) {
  if (t === void 0)
    return;
  const r = {
    blobTagSet: []
  };
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      const a = t[e];
      r.blobTagSet.push({
        key: e,
        value: a
      });
    }
  return r;
}
function $t(t) {
  if (t === void 0)
    return;
  const r = {};
  for (const e of t.blobTagSet)
    r[e.key] = e.value;
  return r;
}
function Dr(t) {
  if (!t || "policy-id" in t)
    return;
  const r = [];
  for (const e in t) {
    const a = e.split("_"), n = "or-";
    a[0].startsWith(n) && (a[0] = a[0].substring(n.length));
    const i = {
      ruleId: a[1],
      replicationStatus: t[e]
    }, s = r.findIndex((o) => o.policyId === a[0]);
    s > -1 ? r[s].rules.push(i) : r.push({
      policyId: a[0],
      rules: [i]
    });
  }
  return r;
}
function or(t) {
  return t ? t.scheme + " " + t.value : void 0;
}
function Nt(t) {
  return t.encoded ? decodeURIComponent(t.content) : t.content;
}
function Zf(t) {
  return {
    ...t,
    segment: {
      blobItems: t.segment.blobItems.map((r) => ({
        ...r,
        name: Nt(r.name)
      }))
    }
  };
}
function Vf(t) {
  var r;
  return {
    ...t,
    segment: {
      blobPrefixes: (r = t.segment.blobPrefixes) == null ? void 0 : r.map((e) => ({
        ...e,
        name: Nt(e.name)
      })),
      blobItems: t.segment.blobItems.map((e) => ({
        ...e,
        name: Nt(e.name)
      }))
    }
  };
}
function* Jn(t) {
  let r = [], e = [];
  t.pageRange && (r = t.pageRange), t.clearRange && (e = t.clearRange);
  let a = 0, n = 0;
  for (; a < r.length && n < e.length; )
    r[a].start < e[n].start ? (yield {
      start: r[a].start,
      end: r[a].end,
      isClear: !1
    }, ++a) : (yield {
      start: e[n].start,
      end: e[n].end,
      isClear: !0
    }, ++n);
  for (; a < r.length; ++a)
    yield {
      start: r[a].start,
      end: r[a].end,
      isClear: !1
    };
  for (; n < e.length; ++n)
    yield {
      start: e[n].start,
      end: e[n].end,
      isClear: !0
    };
}
function Br(t) {
  const r = t.split("/");
  for (let e = 0; e < r.length; e++)
    r[e] = encodeURIComponent(r[e]);
  return r.join("/");
}
function S(t) {
  if ("_response" in t)
    return t;
  throw new TypeError(`Unexpected response object ${t}`);
}
async function Qr(t, r, e, a, n) {
  let i = a.contentChecksumAlgorithm ?? n;
  i === void 0 && (i = "Customized"), i === "Auto" && (i = "StorageCrc64");
  let s;
  return i === "Customized" ? (e.transactionalContentMD5 = a.transactionalContentMD5, e.transactionalContentCrc64 = a.transactionalContentCrc64) : i === "StorageCrc64" && (await ze.init(), s = await lg(t, r), e.structuredBodyType = "XSM/1.0; properties=crc64", e.structuredContentLength = r), {
    body: i === "StorageCrc64" ? s.body : t,
    contentLength: i === "StorageCrc64" ? s.encodedContentLength : r,
    contentChecksumAlgorithm: i
  };
}
class sn {
  /**
   * Creates an instance of StorageClient.
   * @param url - url to resource
   * @param pipeline - request policy pipeline.
   */
  constructor(r, e) {
    /**
     * Encoded URL string value.
     */
    d(this, "url");
    d(this, "accountName");
    /**
     * Request policy pipeline.
     *
     * @internal
     */
    d(this, "pipeline");
    /**
     * Such as AnonymousCredential, StorageSharedKeyCredential or any credential from the `@azure/identity` package to authenticate requests to the service. You can also provide an object that implements the TokenCredential interface. If not specified, AnonymousCredential is used.
     */
    d(this, "credential");
    /**
     * StorageClient is a reference to protocol layer operations entry, which is
     * generated by AutoRest generator.
     */
    d(this, "storageClientContext");
    /**
     */
    d(this, "isHttps");
    this.url = _f(r), this.accountName = Sc(r), this.pipeline = e, this.storageClientContext = new Ec(this.url, $i(e)), this.isHttps = wc(Kf(this.url) || "", "https"), this.credential = es(e);
    const a = this.storageClientContext;
    a.requestContentType = void 0;
  }
}
const I = Ci({
  packageName: "@azure/storage-blob",
  packageVersion: Xi,
  namespace: "Microsoft.Storage"
});
class Ee {
  constructor() {
    /**
     * Specifies Read access granted.
     */
    d(this, "read", !1);
    /**
     * Specifies Add access granted.
     */
    d(this, "add", !1);
    /**
     * Specifies Create access granted.
     */
    d(this, "create", !1);
    /**
     * Specifies Write access granted.
     */
    d(this, "write", !1);
    /**
     * Specifies Delete access granted.
     */
    d(this, "delete", !1);
    /**
     * Specifies Delete version access granted.
     */
    d(this, "deleteVersion", !1);
    /**
     * Specfies Tag access granted.
     */
    d(this, "tag", !1);
    /**
     * Specifies Move access granted.
     */
    d(this, "move", !1);
    /**
     * Specifies Execute access granted.
     */
    d(this, "execute", !1);
    /**
     * Specifies SetImmutabilityPolicy access granted.
     */
    d(this, "setImmutabilityPolicy", !1);
    /**
     * Specifies that Permanent Delete is permitted.
     */
    d(this, "permanentDelete", !1);
  }
  /**
   * Creates a {@link BlobSASPermissions} from the specified permissions string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid permission.
   *
   * @param permissions -
   */
  static parse(r) {
    const e = new Ee();
    for (const a of r)
      switch (a) {
        case "r":
          e.read = !0;
          break;
        case "a":
          e.add = !0;
          break;
        case "c":
          e.create = !0;
          break;
        case "w":
          e.write = !0;
          break;
        case "d":
          e.delete = !0;
          break;
        case "x":
          e.deleteVersion = !0;
          break;
        case "t":
          e.tag = !0;
          break;
        case "m":
          e.move = !0;
          break;
        case "e":
          e.execute = !0;
          break;
        case "i":
          e.setImmutabilityPolicy = !0;
          break;
        case "y":
          e.permanentDelete = !0;
          break;
        default:
          throw new RangeError(`Invalid permission: ${a}`);
      }
    return e;
  }
  /**
   * Creates a {@link BlobSASPermissions} from a raw object which contains same keys as it
   * and boolean values for them.
   *
   * @param permissionLike -
   */
  static from(r) {
    const e = new Ee();
    return r.read && (e.read = !0), r.add && (e.add = !0), r.create && (e.create = !0), r.write && (e.write = !0), r.delete && (e.delete = !0), r.deleteVersion && (e.deleteVersion = !0), r.tag && (e.tag = !0), r.move && (e.move = !0), r.execute && (e.execute = !0), r.setImmutabilityPolicy && (e.setImmutabilityPolicy = !0), r.permanentDelete && (e.permanentDelete = !0), e;
  }
  /**
   * Converts the given permissions to a string. Using this method will guarantee the permissions are in an
   * order accepted by the service.
   *
   * @returns A string which represents the BlobSASPermissions
   */
  toString() {
    const r = [];
    return this.read && r.push("r"), this.add && r.push("a"), this.create && r.push("c"), this.write && r.push("w"), this.delete && r.push("d"), this.deleteVersion && r.push("x"), this.tag && r.push("t"), this.move && r.push("m"), this.execute && r.push("e"), this.setImmutabilityPolicy && r.push("i"), this.permanentDelete && r.push("y"), r.join("");
  }
}
class Pe {
  constructor() {
    /**
     * Specifies Read access granted.
     */
    d(this, "read", !1);
    /**
     * Specifies Add access granted.
     */
    d(this, "add", !1);
    /**
     * Specifies Create access granted.
     */
    d(this, "create", !1);
    /**
     * Specifies Write access granted.
     */
    d(this, "write", !1);
    /**
     * Specifies Delete access granted.
     */
    d(this, "delete", !1);
    /**
     * Specifies Delete version access granted.
     */
    d(this, "deleteVersion", !1);
    /**
     * Specifies List access granted.
     */
    d(this, "list", !1);
    /**
     * Specfies Tag access granted.
     */
    d(this, "tag", !1);
    /**
     * Specifies Move access granted.
     */
    d(this, "move", !1);
    /**
     * Specifies Execute access granted.
     */
    d(this, "execute", !1);
    /**
     * Specifies SetImmutabilityPolicy access granted.
     */
    d(this, "setImmutabilityPolicy", !1);
    /**
     * Specifies that Permanent Delete is permitted.
     */
    d(this, "permanentDelete", !1);
    /**
     * Specifies that Filter Blobs by Tags is permitted.
     */
    d(this, "filterByTags", !1);
  }
  /**
   * Creates an {@link ContainerSASPermissions} from the specified permissions string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid permission.
   *
   * @param permissions -
   */
  static parse(r) {
    const e = new Pe();
    for (const a of r)
      switch (a) {
        case "r":
          e.read = !0;
          break;
        case "a":
          e.add = !0;
          break;
        case "c":
          e.create = !0;
          break;
        case "w":
          e.write = !0;
          break;
        case "d":
          e.delete = !0;
          break;
        case "l":
          e.list = !0;
          break;
        case "t":
          e.tag = !0;
          break;
        case "x":
          e.deleteVersion = !0;
          break;
        case "m":
          e.move = !0;
          break;
        case "e":
          e.execute = !0;
          break;
        case "i":
          e.setImmutabilityPolicy = !0;
          break;
        case "y":
          e.permanentDelete = !0;
          break;
        case "f":
          e.filterByTags = !0;
          break;
        default:
          throw new RangeError(`Invalid permission ${a}`);
      }
    return e;
  }
  /**
   * Creates a {@link ContainerSASPermissions} from a raw object which contains same keys as it
   * and boolean values for them.
   *
   * @param permissionLike -
   */
  static from(r) {
    const e = new Pe();
    return r.read && (e.read = !0), r.add && (e.add = !0), r.create && (e.create = !0), r.write && (e.write = !0), r.delete && (e.delete = !0), r.list && (e.list = !0), r.deleteVersion && (e.deleteVersion = !0), r.tag && (e.tag = !0), r.move && (e.move = !0), r.execute && (e.execute = !0), r.setImmutabilityPolicy && (e.setImmutabilityPolicy = !0), r.permanentDelete && (e.permanentDelete = !0), r.filterByTags && (e.filterByTags = !0), e;
  }
  /**
   * Converts the given permissions to a string. Using this method will guarantee the permissions are in an
   * order accepted by the service.
   *
   * The order of the characters should be as specified here to ensure correctness.
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   */
  toString() {
    const r = [];
    return this.read && r.push("r"), this.add && r.push("a"), this.create && r.push("c"), this.write && r.push("w"), this.delete && r.push("d"), this.deleteVersion && r.push("x"), this.list && r.push("l"), this.tag && r.push("t"), this.move && r.push("m"), this.execute && r.push("e"), this.setImmutabilityPolicy && r.push("i"), this.permanentDelete && r.push("y"), this.filterByTags && r.push("f"), r.join("");
  }
}
function we(t) {
  return t.end ? `${t.start}-${t.end}` : t.start;
}
var Xn;
(function(t) {
  t.Https = "https", t.HttpsAndHttp = "https,http";
})(Xn || (Xn = {}));
class ke {
  constructor(r, e, a, n, i, s, o, m, c, l, u, y, A, g, C, R, D, T, v, f, N, h, z) {
    /**
     * The storage API version.
     */
    d(this, "version");
    /**
     * Optional. The allowed HTTP protocol(s).
     */
    d(this, "protocol");
    /**
     * Optional. The start time for this SAS token.
     */
    d(this, "startsOn");
    /**
     * Optional only when identifier is provided. The expiry time for this SAS token.
     */
    d(this, "expiresOn");
    /**
     * Optional only when identifier is provided.
     * Please refer to {@link AccountSASPermissions}, {@link BlobSASPermissions}, or {@link ContainerSASPermissions} for
     * more details.
     */
    d(this, "permissions");
    /**
     * Optional. The storage services being accessed (only for Account SAS). Please refer to {@link AccountSASServices}
     * for more details.
     */
    d(this, "services");
    /**
     * Optional. The storage resource types being accessed (only for Account SAS). Please refer to
     * {@link AccountSASResourceTypes} for more details.
     */
    d(this, "resourceTypes");
    /**
     * Optional. The signed identifier (only for {@link BlobSASSignatureValues}).
     *
     * @see https://learn.microsoft.com/rest/api/storageservices/establishing-a-stored-access-policy
     */
    d(this, "identifier");
    /**
     * Optional. Beginning in version 2025-07-05, this value specifies the Entra ID of the user would is authorized to
     * use the resulting SAS URL.  The resulting SAS URL must be used in conjunction with an Entra ID token that has been
     * issued to the user specified in this value.
     */
    d(this, "delegatedUserObjectId");
    /**
     * Optional. Encryption scope to use when sending requests authorized with this SAS URI.
     */
    d(this, "encryptionScope");
    /**
     * Optional. Specifies which resources are accessible via the SAS (only for {@link BlobSASSignatureValues}).
     * @see https://learn.microsoft.com/rest/api/storageservices/create-service-sas#specifying-the-signed-resource-blob-service-only
     */
    d(this, "resource");
    /**
     * The signature for the SAS token.
     */
    d(this, "signature");
    /**
     * Value for cache-control header in Blob/File Service SAS.
     */
    d(this, "cacheControl");
    /**
     * Value for content-disposition header in Blob/File Service SAS.
     */
    d(this, "contentDisposition");
    /**
     * Value for content-encoding header in Blob/File Service SAS.
     */
    d(this, "contentEncoding");
    /**
     * Value for content-length header in Blob/File Service SAS.
     */
    d(this, "contentLanguage");
    /**
     * Value for content-type header in Blob/File Service SAS.
     */
    d(this, "contentType");
    /**
     * Inner value of getter ipRange.
     */
    d(this, "ipRangeInner");
    /**
     * The Azure Active Directory object ID in GUID format.
     * Property of user delegation key.
     */
    d(this, "signedOid");
    /**
     * The Azure Active Directory tenant ID in GUID format.
     * Property of user delegation key.
     */
    d(this, "signedTenantId");
    /**
     * The date-time the key is active.
     * Property of user delegation key.
     */
    d(this, "signedStartsOn");
    /**
     * The date-time the key expires.
     * Property of user delegation key.
     */
    d(this, "signedExpiresOn");
    /**
     * Abbreviation of the Azure Storage service that accepts the user delegation key.
     * Property of user delegation key.
     */
    d(this, "signedService");
    /**
     * The service version that created the user delegation key.
     * Property of user delegation key.
     */
    d(this, "signedVersion");
    /**
     * The delegated user tenant id in Azure AD.
     * Property of user delegation key.
     */
    d(this, "signedDelegatedUserTid");
    /**
     * Authorized AAD Object ID in GUID format. The AAD Object ID of a user authorized by the owner of the User Delegation Key
     * to perform the action granted by the SAS. The Azure Storage service will ensure that the owner of the user delegation key
     * has the required permissions before granting access but no additional permission check for the user specified in
     * this value will be performed. This is only used for User Delegation SAS.
     */
    d(this, "preauthorizedAgentObjectId");
    /**
     * A GUID value that will be logged in the storage diagnostic logs and can be used to correlate SAS generation with storage resource access.
     * This is only used for User Delegation SAS.
     */
    d(this, "correlationId");
    /**
     * Keys for request headers required in the SAS token
     */
    d(this, "requestHeaderKeys");
    /**
     * Keys for request query parameters required in the SAS token
     */
    d(this, "requestQueryParameterKeys");
    this.version = r, this.signature = e, a !== void 0 && typeof a != "string" ? (this.permissions = a.permissions, this.services = a.services, this.resourceTypes = a.resourceTypes, this.protocol = a.protocol, this.startsOn = a.startsOn, this.expiresOn = a.expiresOn, this.ipRangeInner = a.ipRange, this.identifier = a.identifier, this.delegatedUserObjectId = a.delegatedUserObjectId, this.encryptionScope = a.encryptionScope, this.resource = a.resource, this.cacheControl = a.cacheControl, this.contentDisposition = a.contentDisposition, this.contentEncoding = a.contentEncoding, this.contentLanguage = a.contentLanguage, this.contentType = a.contentType, this.requestHeaderKeys = a.requestHeaderKeys, this.requestQueryParameterKeys = a.requestQueryParameterKeys, a.userDelegationKey && (this.signedOid = a.userDelegationKey.signedObjectId, this.signedTenantId = a.userDelegationKey.signedTenantId, this.signedStartsOn = a.userDelegationKey.signedStartsOn, this.signedExpiresOn = a.userDelegationKey.signedExpiresOn, this.signedService = a.userDelegationKey.signedService, this.signedVersion = a.userDelegationKey.signedVersion, this.signedDelegatedUserTid = a.userDelegationKey.signedDelegatedUserTenantId, this.preauthorizedAgentObjectId = a.preauthorizedAgentObjectId, this.correlationId = a.correlationId)) : (this.services = n, this.resourceTypes = i, this.expiresOn = m, this.permissions = a, this.protocol = s, this.startsOn = o, this.ipRangeInner = c, this.delegatedUserObjectId = N, this.encryptionScope = f, this.identifier = l, this.resource = u, this.cacheControl = y, this.contentDisposition = A, this.contentEncoding = g, this.contentLanguage = C, this.contentType = R, this.requestHeaderKeys = h, this.requestQueryParameterKeys = z, D && (this.signedOid = D.signedObjectId, this.signedTenantId = D.signedTenantId, this.signedStartsOn = D.signedStartsOn, this.signedExpiresOn = D.signedExpiresOn, this.signedService = D.signedService, this.signedVersion = D.signedVersion, this.signedDelegatedUserTid = D.signedDelegatedUserTenantId, this.preauthorizedAgentObjectId = T, this.correlationId = v));
  }
  /**
   * Optional. IP range allowed for this SAS.
   *
   * @readonly
   */
  get ipRange() {
    if (this.ipRangeInner)
      return {
        end: this.ipRangeInner.end,
        start: this.ipRangeInner.start
      };
  }
  /**
   * Encodes all SAS query parameters into a string that can be appended to a URL.
   *
   */
  toString() {
    const r = [
      "sv",
      "ss",
      "srt",
      "spr",
      "st",
      "se",
      "sip",
      "si",
      "ses",
      "skoid",
      // Signed object ID
      "sktid",
      // Signed tenant ID
      "skt",
      // Signed key start time
      "ske",
      // Signed key expiry time
      "sks",
      // Signed key service
      "skv",
      // Signed key version
      "sr",
      "sp",
      "rscc",
      "rscd",
      "rsce",
      "rscl",
      "rsct",
      "saoid",
      "scid",
      "sduoid",
      // Signed key user delegation object ID
      "skdutid",
      // Signed key user delegation tenant ID
      "srh",
      // Request Headers
      "srq",
      // Request QueryParameters
      "sig"
    ], e = [];
    for (const a of r)
      switch (a) {
        case "sv":
          this.tryAppendQueryParameter(e, a, this.version);
          break;
        case "ss":
          this.tryAppendQueryParameter(e, a, this.services);
          break;
        case "srt":
          this.tryAppendQueryParameter(e, a, this.resourceTypes);
          break;
        case "spr":
          this.tryAppendQueryParameter(e, a, this.protocol);
          break;
        case "st":
          this.tryAppendQueryParameter(e, a, this.startsOn ? L(this.startsOn, !1) : void 0);
          break;
        case "se":
          this.tryAppendQueryParameter(e, a, this.expiresOn ? L(this.expiresOn, !1) : void 0);
          break;
        case "sip":
          this.tryAppendQueryParameter(e, a, this.ipRange ? we(this.ipRange) : void 0);
          break;
        case "si":
          this.tryAppendQueryParameter(e, a, this.identifier);
          break;
        case "ses":
          this.tryAppendQueryParameter(e, a, this.encryptionScope);
          break;
        case "skoid":
          this.tryAppendQueryParameter(e, a, this.signedOid);
          break;
        case "sktid":
          this.tryAppendQueryParameter(e, a, this.signedTenantId);
          break;
        case "skt":
          this.tryAppendQueryParameter(e, a, this.signedStartsOn ? L(this.signedStartsOn, !1) : void 0);
          break;
        case "ske":
          this.tryAppendQueryParameter(e, a, this.signedExpiresOn ? L(this.signedExpiresOn, !1) : void 0);
          break;
        case "sks":
          this.tryAppendQueryParameter(e, a, this.signedService);
          break;
        case "skv":
          this.tryAppendQueryParameter(e, a, this.signedVersion);
          break;
        case "skdutid":
          this.tryAppendQueryParameter(e, a, this.signedDelegatedUserTid);
          break;
        case "sr":
          this.tryAppendQueryParameter(e, a, this.resource);
          break;
        case "sp":
          this.tryAppendQueryParameter(e, a, this.permissions);
          break;
        case "sig":
          this.tryAppendQueryParameter(e, a, this.signature);
          break;
        case "rscc":
          this.tryAppendQueryParameter(e, a, this.cacheControl);
          break;
        case "rscd":
          this.tryAppendQueryParameter(e, a, this.contentDisposition);
          break;
        case "rsce":
          this.tryAppendQueryParameter(e, a, this.contentEncoding);
          break;
        case "rscl":
          this.tryAppendQueryParameter(e, a, this.contentLanguage);
          break;
        case "rsct":
          this.tryAppendQueryParameter(e, a, this.contentType);
          break;
        case "saoid":
          this.tryAppendQueryParameter(e, a, this.preauthorizedAgentObjectId);
          break;
        case "scid":
          this.tryAppendQueryParameter(e, a, this.correlationId);
          break;
        case "sduoid":
          this.tryAppendQueryParameter(e, a, this.delegatedUserObjectId);
          break;
        case "srh":
          this.tryAppendQueryParameter(e, a, this.requestHeaderKeys);
          break;
        case "srq":
          this.tryAppendQueryParameter(e, a, this.requestQueryParameterKeys);
          break;
      }
    return e.join("&");
  }
  /**
   * A private helper method used to filter and append query key/value pairs into an array.
   *
   * @param queries -
   * @param key -
   * @param value -
   */
  tryAppendQueryParameter(r, e, a) {
    a && (e = encodeURIComponent(e), a = encodeURIComponent(a), e.length > 0 && a.length > 0 && r.push(`${e}=${a}`));
  }
}
function Tr(t, r, e) {
  return mr(t, r, e).sasQueryParameters;
}
function mr(t, r, e) {
  const a = t.version ? t.version : _a, n = r instanceof Me ? r : void 0;
  let i;
  if (n === void 0 && e !== void 0 && (i = new Tg(e, r)), n === void 0 && i === void 0)
    throw TypeError("Invalid sharedKeyCredential, userDelegationKey or accountName.");
  if (a >= "2020-12-06")
    return n !== void 0 ? tA(t, n) : a >= "2026-04-06" ? sA(t, i) : a >= "2025-07-05" ? iA(t, i) : nA(t, i);
  if (a >= "2018-11-09")
    return n !== void 0 ? eA(t, n) : a >= "2020-02-10" ? aA(t, i) : rA(t, i);
  if (a >= "2015-04-05") {
    if (n !== void 0)
      return $f(t, n);
    throw new RangeError("'version' must be >= '2018-11-09' when generating user delegation SAS using user delegation key.");
  }
  throw new RangeError("'version' must be >= '2015-04-05'.");
}
function $f(t, r) {
  if (t = je(t), !t.identifier && !(t.permissions && t.expiresOn))
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when 'identifier' is not provided.");
  let e = "c";
  t.blobName && (e = "b");
  let a;
  t.permissions && (t.blobName ? a = Ee.parse(t.permissions.toString()).toString() : a = Pe.parse(t.permissions.toString()).toString());
  const n = [
    a || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    t.identifier,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    t.cacheControl ? t.cacheControl : "",
    t.contentDisposition ? t.contentDisposition : "",
    t.contentEncoding ? t.contentEncoding : "",
    t.contentLanguage ? t.contentLanguage : "",
    t.contentType ? t.contentType : ""
  ].join(`
`), i = r.computeHMACSHA256(n);
  return {
    sasQueryParameters: new ke(t.version, i, a, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType),
    stringToSign: n
  };
}
function eA(t, r) {
  if (t = je(t), !t.identifier && !(t.permissions && t.expiresOn))
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when 'identifier' is not provided.");
  let e = "c", a = t.snapshotTime;
  t.blobName && (e = "b", t.snapshotTime ? e = "bs" : t.versionId && (e = "bv", a = t.versionId));
  let n;
  t.permissions && (t.blobName ? n = Ee.parse(t.permissions.toString()).toString() : n = Pe.parse(t.permissions.toString()).toString());
  const i = [
    n || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    t.identifier,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    e,
    a,
    t.cacheControl ? t.cacheControl : "",
    t.contentDisposition ? t.contentDisposition : "",
    t.contentEncoding ? t.contentEncoding : "",
    t.contentLanguage ? t.contentLanguage : "",
    t.contentType ? t.contentType : ""
  ].join(`
`), s = r.computeHMACSHA256(i);
  return {
    sasQueryParameters: new ke(t.version, s, n, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType),
    stringToSign: i
  };
}
function tA(t, r) {
  if (t = je(t), !t.identifier && !(t.permissions && t.expiresOn))
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when 'identifier' is not provided.");
  let e = "c", a = t.snapshotTime;
  t.blobName && (e = "b", t.snapshotTime ? e = "bs" : t.versionId && (e = "bv", a = t.versionId));
  let n;
  t.permissions && (t.blobName ? n = Ee.parse(t.permissions.toString()).toString() : n = Pe.parse(t.permissions.toString()).toString());
  const i = [
    n || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    t.identifier,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    e,
    a,
    t.encryptionScope,
    t.cacheControl ? t.cacheControl : "",
    t.contentDisposition ? t.contentDisposition : "",
    t.contentEncoding ? t.contentEncoding : "",
    t.contentLanguage ? t.contentLanguage : "",
    t.contentType ? t.contentType : ""
  ].join(`
`), s = r.computeHMACSHA256(i);
  return {
    sasQueryParameters: new ke(t.version, s, n, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType, void 0, void 0, void 0, t.encryptionScope),
    stringToSign: i
  };
}
function rA(t, r) {
  if (t = je(t), !t.permissions || !t.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let e = "c", a = t.snapshotTime;
  t.blobName && (e = "b", t.snapshotTime ? e = "bs" : t.versionId && (e = "bv", a = t.versionId));
  let n;
  t.permissions && (t.blobName ? n = Ee.parse(t.permissions.toString()).toString() : n = Pe.parse(t.permissions.toString()).toString());
  const i = [
    n || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    r.userDelegationKey.signedObjectId,
    r.userDelegationKey.signedTenantId,
    r.userDelegationKey.signedStartsOn ? L(r.userDelegationKey.signedStartsOn, !1) : "",
    r.userDelegationKey.signedExpiresOn ? L(r.userDelegationKey.signedExpiresOn, !1) : "",
    r.userDelegationKey.signedService,
    r.userDelegationKey.signedVersion,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    e,
    a,
    t.cacheControl,
    t.contentDisposition,
    t.contentEncoding,
    t.contentLanguage,
    t.contentType
  ].join(`
`), s = r.computeHMACSHA256(i);
  return {
    sasQueryParameters: new ke(t.version, s, n, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType, r.userDelegationKey),
    stringToSign: i
  };
}
function aA(t, r) {
  if (t = je(t), !t.permissions || !t.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let e = "c", a = t.snapshotTime;
  t.blobName && (e = "b", t.snapshotTime ? e = "bs" : t.versionId && (e = "bv", a = t.versionId));
  let n;
  t.permissions && (t.blobName ? n = Ee.parse(t.permissions.toString()).toString() : n = Pe.parse(t.permissions.toString()).toString());
  const i = [
    n || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    r.userDelegationKey.signedObjectId,
    r.userDelegationKey.signedTenantId,
    r.userDelegationKey.signedStartsOn ? L(r.userDelegationKey.signedStartsOn, !1) : "",
    r.userDelegationKey.signedExpiresOn ? L(r.userDelegationKey.signedExpiresOn, !1) : "",
    r.userDelegationKey.signedService,
    r.userDelegationKey.signedVersion,
    t.preauthorizedAgentObjectId,
    void 0,
    // agentObjectId
    t.correlationId,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    e,
    a,
    t.cacheControl,
    t.contentDisposition,
    t.contentEncoding,
    t.contentLanguage,
    t.contentType
  ].join(`
`), s = r.computeHMACSHA256(i);
  return {
    sasQueryParameters: new ke(t.version, s, n, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType, r.userDelegationKey, t.preauthorizedAgentObjectId, t.correlationId),
    stringToSign: i
  };
}
function nA(t, r) {
  if (t = je(t), !t.permissions || !t.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let e = "c", a = t.snapshotTime;
  t.blobName && (e = "b", t.snapshotTime ? e = "bs" : t.versionId && (e = "bv", a = t.versionId));
  let n;
  t.permissions && (t.blobName ? n = Ee.parse(t.permissions.toString()).toString() : n = Pe.parse(t.permissions.toString()).toString());
  const i = [
    n || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    r.userDelegationKey.signedObjectId,
    r.userDelegationKey.signedTenantId,
    r.userDelegationKey.signedStartsOn ? L(r.userDelegationKey.signedStartsOn, !1) : "",
    r.userDelegationKey.signedExpiresOn ? L(r.userDelegationKey.signedExpiresOn, !1) : "",
    r.userDelegationKey.signedService,
    r.userDelegationKey.signedVersion,
    t.preauthorizedAgentObjectId,
    void 0,
    // agentObjectId
    t.correlationId,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    e,
    a,
    t.encryptionScope,
    t.cacheControl,
    t.contentDisposition,
    t.contentEncoding,
    t.contentLanguage,
    t.contentType
  ].join(`
`), s = r.computeHMACSHA256(i);
  return {
    sasQueryParameters: new ke(t.version, s, n, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType, r.userDelegationKey, t.preauthorizedAgentObjectId, t.correlationId, t.encryptionScope),
    stringToSign: i
  };
}
function iA(t, r) {
  if (t = je(t), !t.permissions || !t.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let e = "c", a = t.snapshotTime;
  t.blobName && (e = "b", t.snapshotTime ? e = "bs" : t.versionId && (e = "bv", a = t.versionId));
  let n;
  t.permissions && (t.blobName ? n = Ee.parse(t.permissions.toString()).toString() : n = Pe.parse(t.permissions.toString()).toString());
  const i = [
    n || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    r.userDelegationKey.signedObjectId,
    r.userDelegationKey.signedTenantId,
    r.userDelegationKey.signedStartsOn ? L(r.userDelegationKey.signedStartsOn, !1) : "",
    r.userDelegationKey.signedExpiresOn ? L(r.userDelegationKey.signedExpiresOn, !1) : "",
    r.userDelegationKey.signedService,
    r.userDelegationKey.signedVersion,
    t.preauthorizedAgentObjectId,
    void 0,
    // agentObjectId
    t.correlationId,
    r.userDelegationKey.signedDelegatedUserTenantId,
    // SignedKeyDelegatedUserTenantId, will be added in a future release.
    t.delegatedUserObjectId,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    e,
    a,
    t.encryptionScope,
    t.cacheControl,
    t.contentDisposition,
    t.contentEncoding,
    t.contentLanguage,
    t.contentType
  ].join(`
`), s = r.computeHMACSHA256(i);
  return {
    sasQueryParameters: new ke(t.version, s, n, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType, r.userDelegationKey, t.preauthorizedAgentObjectId, t.correlationId, t.encryptionScope, t.delegatedUserObjectId),
    stringToSign: i
  };
}
function sA(t, r) {
  if (t = je(t), !t.permissions || !t.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let e = "c", a = t.snapshotTime;
  t.blobName && (e = "b", t.snapshotTime ? e = "bs" : t.versionId && (e = "bv", a = t.versionId));
  let n;
  t.permissions && (t.blobName ? n = Ee.parse(t.permissions.toString()).toString() : n = Pe.parse(t.permissions.toString()).toString());
  const i = [
    n || "",
    t.startsOn ? L(t.startsOn, !1) : "",
    t.expiresOn ? L(t.expiresOn, !1) : "",
    We(r.accountName, t.containerName, t.blobName),
    r.userDelegationKey.signedObjectId,
    r.userDelegationKey.signedTenantId,
    r.userDelegationKey.signedStartsOn ? L(r.userDelegationKey.signedStartsOn, !1) : "",
    r.userDelegationKey.signedExpiresOn ? L(r.userDelegationKey.signedExpiresOn, !1) : "",
    r.userDelegationKey.signedService,
    r.userDelegationKey.signedVersion,
    t.preauthorizedAgentObjectId,
    void 0,
    // agentObjectId
    t.correlationId,
    r.userDelegationKey.signedDelegatedUserTenantId,
    // SignedKeyDelegatedUserTenantId, will be added in a future release.
    t.delegatedUserObjectId,
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    t.version,
    e,
    a,
    t.encryptionScope,
    oA(t.requestHeaders),
    mA(t.requestQueryParameters),
    t.cacheControl,
    t.contentDisposition,
    t.contentEncoding,
    t.contentLanguage,
    t.contentType
  ].join(`
`), s = r.computeHMACSHA256(i);
  return {
    sasQueryParameters: new ke(t.version, s, n, void 0, void 0, t.protocol, t.startsOn, t.expiresOn, t.ipRange, t.identifier, e, t.cacheControl, t.contentDisposition, t.contentEncoding, t.contentLanguage, t.contentType, r.userDelegationKey, t.preauthorizedAgentObjectId, t.correlationId, t.encryptionScope, t.delegatedUserObjectId, Wn(t.requestHeaders), Wn(t.requestQueryParameters)),
    stringToSign: i
  };
}
function oA(t) {
  if (t === void 0)
    return;
  let r = "";
  return Object.keys(t).forEach(function(e) {
    r = r + e + ":" + t[e] + `
`;
  }), r;
}
function mA(t) {
  if (t === void 0)
    return;
  let r = "";
  return Object.keys(t).forEach(function(e) {
    r = r + `
` + e + ":" + t[e];
  }), r;
}
function Wn(t) {
  if (t === void 0)
    return;
  let r = "", e = 0;
  return Object.keys(t).forEach(function(a) {
    e !== 0 && (r = r + ","), r = r + a, ++e;
  }), r;
}
function We(t, r, e) {
  const a = [`/blob/${t}/${r}`];
  return e && a.push(`/${e}`), a.join("");
}
function je(t) {
  const r = t.version ? t.version : _a;
  if (t.snapshotTime && r < "2018-11-09")
    throw RangeError("'version' must be >= '2018-11-09' when providing 'snapshotTime'.");
  if (t.blobName === void 0 && t.snapshotTime)
    throw RangeError("Must provide 'blobName' when providing 'snapshotTime'.");
  if (t.versionId && r < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when providing 'versionId'.");
  if (t.blobName === void 0 && t.versionId)
    throw RangeError("Must provide 'blobName' when providing 'versionId'.");
  if (t.permissions && t.permissions.setImmutabilityPolicy && r < "2020-08-04")
    throw RangeError("'version' must be >= '2020-08-04' when provided 'i' permission.");
  if (t.permissions && t.permissions.deleteVersion && r < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when providing 'x' permission.");
  if (t.permissions && t.permissions.permanentDelete && r < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when providing 'y' permission.");
  if (t.permissions && t.permissions.tag && r < "2019-12-12")
    throw RangeError("'version' must be >= '2019-12-12' when providing 't' permission.");
  if (r < "2020-02-10" && t.permissions && (t.permissions.move || t.permissions.execute))
    throw RangeError("'version' must be >= '2020-02-10' when providing the 'm' or 'e' permission.");
  if (r < "2021-04-10" && t.permissions && t.permissions.filterByTags)
    throw RangeError("'version' must be >= '2021-04-10' when providing the 'f' permission.");
  if (r < "2020-02-10" && (t.preauthorizedAgentObjectId || t.correlationId))
    throw RangeError("'version' must be >= '2020-02-10' when providing 'preauthorizedAgentObjectId' or 'correlationId'.");
  if (t.encryptionScope && r < "2020-12-06")
    throw RangeError("'version' must be >= '2020-12-06' when provided 'encryptionScope' in SAS.");
  return t.version = r, t;
}
class Rc {
  /**
   * Creates an instance of BlobLeaseClient.
   * @param client - The client to make the lease operation requests.
   * @param leaseId - Initial proposed lease id.
   */
  constructor(r, e) {
    d(this, "_leaseId");
    d(this, "_url");
    d(this, "_containerOrBlobOperation");
    d(this, "_isContainer");
    const a = r.storageClientContext;
    this._url = r.url, r.name === void 0 ? (this._isContainer = !0, this._containerOrBlobOperation = a.container) : (this._isContainer = !1, this._containerOrBlobOperation = a.blob), e || (e = zr()), this._leaseId = e;
  }
  /**
   * Gets the lease Id.
   *
   * @readonly
   */
  get leaseId() {
    return this._leaseId;
  }
  /**
   * Gets the url.
   *
   * @readonly
   */
  get url() {
    return this._url;
  }
  /**
   * Establishes and manages a lock on a container for delete operations, or on a blob
   * for write and delete operations.
   * The lock duration can be 15 to 60 seconds, or can be infinite.
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-blob
   *
   * @param duration - Must be between 15 to 60 seconds, or infinite (-1)
   * @param options - option to configure lease management operations.
   * @returns Response data for acquire lease operation.
   */
  async acquireLease(r, e = {}) {
    var a, n, i, s, o;
    if (this._isContainer && ((a = e.conditions) != null && a.ifMatch && ((n = e.conditions) == null ? void 0 : n.ifMatch) !== Re || (i = e.conditions) != null && i.ifNoneMatch && ((s = e.conditions) == null ? void 0 : s.ifNoneMatch) !== Re || (o = e.conditions) != null && o.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return I.withSpan("BlobLeaseClient-acquireLease", e, async (m) => {
      var c;
      return S(await this._containerOrBlobOperation.acquireLease({
        abortSignal: e.abortSignal,
        duration: r,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (c = e.conditions) == null ? void 0 : c.tagConditions
        },
        proposedLeaseId: this._leaseId,
        tracingOptions: m.tracingOptions
      }));
    });
  }
  /**
   * To change the ID of the lease.
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-blob
   *
   * @param proposedLeaseId - the proposed new lease Id.
   * @param options - option to configure lease management operations.
   * @returns Response data for change lease operation.
   */
  async changeLease(r, e = {}) {
    var a, n, i, s, o;
    if (this._isContainer && ((a = e.conditions) != null && a.ifMatch && ((n = e.conditions) == null ? void 0 : n.ifMatch) !== Re || (i = e.conditions) != null && i.ifNoneMatch && ((s = e.conditions) == null ? void 0 : s.ifNoneMatch) !== Re || (o = e.conditions) != null && o.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return I.withSpan("BlobLeaseClient-changeLease", e, async (m) => {
      var l;
      const c = S(await this._containerOrBlobOperation.changeLease(this._leaseId, r, {
        abortSignal: e.abortSignal,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (l = e.conditions) == null ? void 0 : l.tagConditions
        },
        tracingOptions: m.tracingOptions
      }));
      return this._leaseId = r, c;
    });
  }
  /**
   * To free the lease if it is no longer needed so that another client may
   * immediately acquire a lease against the container or the blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-blob
   *
   * @param options - option to configure lease management operations.
   * @returns Response data for release lease operation.
   */
  async releaseLease(r = {}) {
    var e, a, n, i, s;
    if (this._isContainer && ((e = r.conditions) != null && e.ifMatch && ((a = r.conditions) == null ? void 0 : a.ifMatch) !== Re || (n = r.conditions) != null && n.ifNoneMatch && ((i = r.conditions) == null ? void 0 : i.ifNoneMatch) !== Re || (s = r.conditions) != null && s.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return I.withSpan("BlobLeaseClient-releaseLease", r, async (o) => {
      var m;
      return S(await this._containerOrBlobOperation.releaseLease(this._leaseId, {
        abortSignal: r.abortSignal,
        modifiedAccessConditions: {
          ...r.conditions,
          ifTags: (m = r.conditions) == null ? void 0 : m.tagConditions
        },
        tracingOptions: o.tracingOptions
      }));
    });
  }
  /**
   * To renew the lease.
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-blob
   *
   * @param options - Optional option to configure lease management operations.
   * @returns Response data for renew lease operation.
   */
  async renewLease(r = {}) {
    var e, a, n, i, s;
    if (this._isContainer && ((e = r.conditions) != null && e.ifMatch && ((a = r.conditions) == null ? void 0 : a.ifMatch) !== Re || (n = r.conditions) != null && n.ifNoneMatch && ((i = r.conditions) == null ? void 0 : i.ifNoneMatch) !== Re || (s = r.conditions) != null && s.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return I.withSpan("BlobLeaseClient-renewLease", r, async (o) => {
      var m;
      return this._containerOrBlobOperation.renewLease(this._leaseId, {
        abortSignal: r.abortSignal,
        modifiedAccessConditions: {
          ...r.conditions,
          ifTags: (m = r.conditions) == null ? void 0 : m.tagConditions
        },
        tracingOptions: o.tracingOptions
      });
    });
  }
  /**
   * To end the lease but ensure that another client cannot acquire a new lease
   * until the current lease period has expired.
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/rest/api/storageservices/lease-blob
   *
   * @param breakPeriod - Break period
   * @param options - Optional options to configure lease management operations.
   * @returns Response data for break lease operation.
   */
  async breakLease(r, e = {}) {
    var a, n, i, s, o;
    if (this._isContainer && ((a = e.conditions) != null && a.ifMatch && ((n = e.conditions) == null ? void 0 : n.ifMatch) !== Re || (i = e.conditions) != null && i.ifNoneMatch && ((s = e.conditions) == null ? void 0 : s.ifNoneMatch) !== Re || (o = e.conditions) != null && o.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return I.withSpan("BlobLeaseClient-breakLease", e, async (m) => {
      var l;
      const c = {
        abortSignal: e.abortSignal,
        breakPeriod: r,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (l = e.conditions) == null ? void 0 : l.tagConditions
        },
        tracingOptions: m.tracingOptions
      };
      return S(await this._containerOrBlobOperation.breakLease(c));
    });
  }
}
var Sa;
(function(t) {
  t.Hot = "Hot", t.Cool = "Cool", t.Cold = "Cold", t.Archive = "Archive";
})(Sa || (Sa = {}));
var jn;
(function(t) {
  t.P4 = "P4", t.P6 = "P6", t.P10 = "P10", t.P15 = "P15", t.P20 = "P20", t.P30 = "P30", t.P40 = "P40", t.P50 = "P50", t.P60 = "P60", t.P70 = "P70", t.P80 = "P80";
})(jn || (jn = {}));
function at(t) {
  if (t !== void 0)
    return t;
}
function $(t, r) {
  if (t && !r)
    throw new RangeError("Customer-provided encryption key must be used over HTTPS.");
  t && !t.encryptionAlgorithm && (t.encryptionAlgorithm = kg);
}
var Zn;
(function(t) {
  t.StorageOAuthScopes = "https://storage.azure.com/.default", t.DiskComputeOAuthScopes = "https://disk.compute.azure.com/.default";
})(Zn || (Zn = {}));
function ga(t) {
  const r = (t._response.parsedBody.pageRange || []).map((a) => ({
    offset: a.start,
    count: a.end - a.start
  })), e = (t._response.parsedBody.clearRange || []).map((a) => ({
    offset: a.start,
    count: a.end - a.start
  }));
  return {
    ...t,
    pageRange: r,
    clearRange: e,
    _response: {
      ...t._response,
      parsedBody: {
        pageRange: r,
        clearRange: e
      }
    }
  };
}
class on extends Error {
  constructor(r) {
    super(r), this.name = "PollerStoppedError", Object.setPrototypeOf(this, on.prototype);
  }
}
class mn extends Error {
  constructor(r) {
    super(r), this.name = "PollerCancelledError", Object.setPrototypeOf(this, mn.prototype);
  }
}
class cA {
  /**
   * A poller needs to be initialized by passing in at least the basic properties of the `PollOperation<TState, TResult>`.
   *
   * When writing an implementation of a Poller, this implementation needs to deal with the initialization
   * of any custom state beyond the basic definition of the poller. The basic poller assumes that the poller's
   * operation has already been defined, at least its basic properties. The code below shows how to approach
   * the definition of the constructor of a new custom poller.
   *
   * ```ts
   * export class MyPoller extends Poller<MyOperationState, string> {
   *   constructor({
   *     // Anything you might need outside of the basics
   *   }) {
   *     let state: MyOperationState = {
   *       privateProperty: private,
   *       publicProperty: public,
   *     };
   *
   *     const operation = {
   *       state,
   *       update,
   *       cancel,
   *       toString
   *     }
   *
   *     // Sending the operation to the parent's constructor.
   *     super(operation);
   *
   *     // You can assign more local properties here.
   *   }
   * }
   * ```
   *
   * Inside of this constructor, a new promise is created. This will be used to
   * tell the user when the poller finishes (see `pollUntilDone()`). The promise's
   * resolve and reject methods are also used internally to control when to resolve
   * or reject anyone waiting for the poller to finish.
   *
   * The constructor of a custom implementation of a poller is where any serialized version of
   * a previous poller's operation should be deserialized into the operation sent to the
   * base constructor. For example:
   *
   * ```ts
   * export class MyPoller extends Poller<MyOperationState, string> {
   *   constructor(
   *     baseOperation: string | undefined
   *   ) {
   *     let state: MyOperationState = {};
   *     if (baseOperation) {
   *       state = {
   *         ...JSON.parse(baseOperation).state,
   *         ...state
   *       };
   *     }
   *     const operation = {
   *       state,
   *       // ...
   *     }
   *     super(operation);
   *   }
   * }
   * ```
   *
   * @param operation - Must contain the basic properties of `PollOperation<State, TResult>`.
   */
  constructor(r) {
    this.resolveOnUnsuccessful = !1, this.stopped = !0, this.pollProgressCallbacks = [], this.operation = r, this.promise = new Promise((e, a) => {
      this.resolve = e, this.reject = a;
    }), this.promise.catch(() => {
    });
  }
  /**
   * Starts a loop that will break only if the poller is done
   * or if the poller is stopped.
   */
  async startPolling(r = {}) {
    for (this.stopped && (this.stopped = !1); !this.isStopped() && !this.isDone(); )
      await this.poll(r), await this.delay();
  }
  /**
   * pollOnce does one polling, by calling to the update method of the underlying
   * poll operation to make any relevant change effective.
   *
   * It only optionally receives an object with an abortSignal property, from \@azure/abort-controller's AbortSignalLike.
   *
   * @param options - Optional properties passed to the operation's update method.
   */
  async pollOnce(r = {}) {
    this.isDone() || (this.operation = await this.operation.update({
      abortSignal: r.abortSignal,
      fireProgress: this.fireProgress.bind(this)
    })), this.processUpdatedState();
  }
  /**
   * fireProgress calls the functions passed in via onProgress the method of the poller.
   *
   * It loops over all of the callbacks received from onProgress, and executes them, sending them
   * the current operation state.
   *
   * @param state - The current operation state.
   */
  fireProgress(r) {
    for (const e of this.pollProgressCallbacks)
      e(r);
  }
  /**
   * Invokes the underlying operation's cancel method.
   */
  async cancelOnce(r = {}) {
    this.operation = await this.operation.cancel(r);
  }
  /**
   * Returns a promise that will resolve once a single polling request finishes.
   * It does this by calling the update method of the Poller's operation.
   *
   * It only optionally receives an object with an abortSignal property, from \@azure/abort-controller's AbortSignalLike.
   *
   * @param options - Optional properties passed to the operation's update method.
   */
  poll(r = {}) {
    if (!this.pollOncePromise) {
      this.pollOncePromise = this.pollOnce(r);
      const e = () => {
        this.pollOncePromise = void 0;
      };
      this.pollOncePromise.then(e, e).catch(this.reject);
    }
    return this.pollOncePromise;
  }
  processUpdatedState() {
    if (this.operation.state.error && (this.stopped = !0, !this.resolveOnUnsuccessful))
      throw this.reject(this.operation.state.error), this.operation.state.error;
    if (this.operation.state.isCancelled && (this.stopped = !0, !this.resolveOnUnsuccessful)) {
      const r = new mn("Operation was canceled");
      throw this.reject(r), r;
    }
    this.isDone() && this.resolve && this.resolve(this.getResult());
  }
  /**
   * Returns a promise that will resolve once the underlying operation is completed.
   */
  async pollUntilDone(r = {}) {
    return this.stopped && this.startPolling(r).catch(this.reject), this.processUpdatedState(), this.promise;
  }
  /**
   * Invokes the provided callback after each polling is completed,
   * sending the current state of the poller's operation.
   *
   * It returns a method that can be used to stop receiving updates on the given callback function.
   */
  onProgress(r) {
    return this.pollProgressCallbacks.push(r), () => {
      this.pollProgressCallbacks = this.pollProgressCallbacks.filter((e) => e !== r);
    };
  }
  /**
   * Returns true if the poller has finished polling.
   */
  isDone() {
    const r = this.operation.state;
    return !!(r.isCompleted || r.isCancelled || r.error);
  }
  /**
   * Stops the poller from continuing to poll.
   */
  stopPolling() {
    this.stopped || (this.stopped = !0, this.reject && this.reject(new on("This poller is already stopped")));
  }
  /**
   * Returns true if the poller is stopped.
   */
  isStopped() {
    return this.stopped;
  }
  /**
   * Attempts to cancel the underlying operation.
   *
   * It only optionally receives an object with an abortSignal property, from \@azure/abort-controller's AbortSignalLike.
   *
   * If it's called again before it finishes, it will throw an error.
   *
   * @param options - Optional properties passed to the operation's update method.
   */
  cancelOperation(r = {}) {
    if (!this.cancelPromise)
      this.cancelPromise = this.cancelOnce(r);
    else if (r.abortSignal)
      throw new Error("A cancel request is currently pending");
    return this.cancelPromise;
  }
  /**
   * Returns the state of the operation.
   *
   * Even though TState will be the same type inside any of the methods of any extension of the Poller class,
   * implementations of the pollers can customize what's shared with the public by writing their own
   * version of the `getOperationState` method, and by defining two types, one representing the internal state of the poller
   * and a public type representing a safe to share subset of the properties of the internal state.
   * Their definition of getOperationState can then return their public type.
   *
   * Example:
   *
   * ```ts
   * // Let's say we have our poller's operation state defined as:
   * interface MyOperationState extends PollOperationState<ResultType> {
   *   privateProperty?: string;
   *   publicProperty?: string;
   * }
   *
   * // To allow us to have a true separation of public and private state, we have to define another interface:
   * interface PublicState extends PollOperationState<ResultType> {
   *   publicProperty?: string;
   * }
   *
   * // Then, we define our Poller as follows:
   * export class MyPoller extends Poller<MyOperationState, ResultType> {
   *   // ... More content is needed here ...
   *
   *   public getOperationState(): PublicState {
   *     const state: PublicState = this.operation.state;
   *     return {
   *       // Properties from PollOperationState<TResult>
   *       isStarted: state.isStarted,
   *       isCompleted: state.isCompleted,
   *       isCancelled: state.isCancelled,
   *       error: state.error,
   *       result: state.result,
   *
   *       // The only other property needed by PublicState.
   *       publicProperty: state.publicProperty
   *     }
   *   }
   * }
   * ```
   *
   * You can see this in the tests of this repository, go to the file:
   * `../test/utils/testPoller.ts`
   * and look for the getOperationState implementation.
   */
  getOperationState() {
    return this.operation.state;
  }
  /**
   * Returns the result value of the operation,
   * regardless of the state of the poller.
   * It can return undefined or an incomplete form of the final TResult value
   * depending on the implementation.
   */
  getResult() {
    return this.operation.state.result;
  }
  /**
   * Returns a serialized version of the poller's operation
   * by invoking the operation's toString method.
   */
  toString() {
    return this.operation.toString();
  }
}
class lA extends cA {
  constructor(e) {
    const { blobClient: a, copySource: n, intervalInMs: i = 15e3, onProgress: s, resumeFrom: o, startCopyFromURLOptions: m } = e;
    let c;
    o && (c = JSON.parse(o).state);
    const l = er({
      ...c,
      blobClient: a,
      copySource: n,
      startCopyFromURLOptions: m
    });
    super(l);
    d(this, "intervalInMs");
    typeof s == "function" && this.onProgress(s), this.intervalInMs = i;
  }
  delay() {
    return Ni(this.intervalInMs);
  }
}
const dA = async function(r = {}) {
  const e = this.state, { copyId: a } = e;
  return e.isCompleted ? er(e) : a ? (await e.blobClient.abortCopyFromURL(a, {
    abortSignal: r.abortSignal
  }), e.isCancelled = !0, er(e)) : (e.isCancelled = !0, er(e));
}, pA = async function(r = {}) {
  const e = this.state, { blobClient: a, copySource: n, startCopyFromURLOptions: i } = e;
  if (e.isStarted) {
    if (!e.isCompleted)
      try {
        const s = await e.blobClient.getProperties({ abortSignal: r.abortSignal }), { copyStatus: o, copyProgress: m } = s, c = e.copyProgress;
        m && (e.copyProgress = m), o === "pending" && m !== c && typeof r.fireProgress == "function" ? r.fireProgress(e) : o === "success" ? (e.result = s, e.isCompleted = !0) : o === "failed" && (e.error = new Error(`Blob copy failed with reason: "${s.copyStatusDescription || "unknown"}"`), e.isCompleted = !0);
      } catch (s) {
        e.error = s, e.isCompleted = !0;
      }
  } else {
    e.isStarted = !0;
    const s = await a.startCopyFromURL(n, i);
    e.copyId = s.copyId, s.copyStatus === "success" && (e.result = s, e.isCompleted = !0);
  }
  return er(e);
}, uA = function() {
  return JSON.stringify({ state: this.state }, (r, e) => {
    if (r !== "blobClient")
      return e;
  });
};
function er(t) {
  return {
    state: { ...t },
    cancel: dA,
    toString: uA,
    update: pA
  };
}
function xe(t) {
  if (t.offset < 0)
    throw new RangeError("Range.offset cannot be smaller than 0.");
  if (t.count && t.count <= 0)
    throw new RangeError("Range.count must be larger than 0. Leave it undefined if you want a range from offset to the end.");
  return t.count ? `bytes=${t.offset}-${t.offset + t.count - 1}` : `bytes=${t.offset}-`;
}
var br = { exports: {} }, Vn;
function gA() {
  if (Vn) return br.exports;
  Vn = 1;
  var t = typeof Reflect == "object" ? Reflect : null, r = t && typeof t.apply == "function" ? t.apply : function(N, h, z) {
    return Function.prototype.apply.call(N, h, z);
  }, e;
  t && typeof t.ownKeys == "function" ? e = t.ownKeys : Object.getOwnPropertySymbols ? e = function(N) {
    return Object.getOwnPropertyNames(N).concat(Object.getOwnPropertySymbols(N));
  } : e = function(N) {
    return Object.getOwnPropertyNames(N);
  };
  function a(f) {
    console && console.warn && console.warn(f);
  }
  var n = Number.isNaN || function(N) {
    return N !== N;
  };
  function i() {
    i.init.call(this);
  }
  br.exports = i, br.exports.once = D, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var s = 10;
  function o(f) {
    if (typeof f != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof f);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(f) {
      if (typeof f != "number" || f < 0 || n(f))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + f + ".");
      s = f;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(N) {
    if (typeof N != "number" || N < 0 || n(N))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + N + ".");
    return this._maxListeners = N, this;
  };
  function m(f) {
    return f._maxListeners === void 0 ? i.defaultMaxListeners : f._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return m(this);
  }, i.prototype.emit = function(N) {
    for (var h = [], z = 1; z < arguments.length; z++) h.push(arguments[z]);
    var Q = N === "error", _ = this._events;
    if (_ !== void 0)
      Q = Q && _.error === void 0;
    else if (!Q)
      return !1;
    if (Q) {
      var k;
      if (h.length > 0 && (k = h[0]), k instanceof Error)
        throw k;
      var W = new Error("Unhandled error." + (k ? " (" + k.message + ")" : ""));
      throw W.context = k, W;
    }
    var Le = _[N];
    if (Le === void 0)
      return !1;
    if (typeof Le == "function")
      r(Le, this, h);
    else
      for (var lt = Le.length, Gt = g(Le, lt), z = 0; z < lt; ++z)
        r(Gt[z], this, h);
    return !0;
  };
  function c(f, N, h, z) {
    var Q, _, k;
    if (o(h), _ = f._events, _ === void 0 ? (_ = f._events = /* @__PURE__ */ Object.create(null), f._eventsCount = 0) : (_.newListener !== void 0 && (f.emit(
      "newListener",
      N,
      h.listener ? h.listener : h
    ), _ = f._events), k = _[N]), k === void 0)
      k = _[N] = h, ++f._eventsCount;
    else if (typeof k == "function" ? k = _[N] = z ? [h, k] : [k, h] : z ? k.unshift(h) : k.push(h), Q = m(f), Q > 0 && k.length > Q && !k.warned) {
      k.warned = !0;
      var W = new Error("Possible EventEmitter memory leak detected. " + k.length + " " + String(N) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      W.name = "MaxListenersExceededWarning", W.emitter = f, W.type = N, W.count = k.length, a(W);
    }
    return f;
  }
  i.prototype.addListener = function(N, h) {
    return c(this, N, h, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(N, h) {
    return c(this, N, h, !0);
  };
  function l() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function u(f, N, h) {
    var z = { fired: !1, wrapFn: void 0, target: f, type: N, listener: h }, Q = l.bind(z);
    return Q.listener = h, z.wrapFn = Q, Q;
  }
  i.prototype.once = function(N, h) {
    return o(h), this.on(N, u(this, N, h)), this;
  }, i.prototype.prependOnceListener = function(N, h) {
    return o(h), this.prependListener(N, u(this, N, h)), this;
  }, i.prototype.removeListener = function(N, h) {
    var z, Q, _, k, W;
    if (o(h), Q = this._events, Q === void 0)
      return this;
    if (z = Q[N], z === void 0)
      return this;
    if (z === h || z.listener === h)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[N], Q.removeListener && this.emit("removeListener", N, z.listener || h));
    else if (typeof z != "function") {
      for (_ = -1, k = z.length - 1; k >= 0; k--)
        if (z[k] === h || z[k].listener === h) {
          W = z[k].listener, _ = k;
          break;
        }
      if (_ < 0)
        return this;
      _ === 0 ? z.shift() : C(z, _), z.length === 1 && (Q[N] = z[0]), Q.removeListener !== void 0 && this.emit("removeListener", N, W || h);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(N) {
    var h, z, Q;
    if (z = this._events, z === void 0)
      return this;
    if (z.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : z[N] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete z[N]), this;
    if (arguments.length === 0) {
      var _ = Object.keys(z), k;
      for (Q = 0; Q < _.length; ++Q)
        k = _[Q], k !== "removeListener" && this.removeAllListeners(k);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (h = z[N], typeof h == "function")
      this.removeListener(N, h);
    else if (h !== void 0)
      for (Q = h.length - 1; Q >= 0; Q--)
        this.removeListener(N, h[Q]);
    return this;
  };
  function y(f, N, h) {
    var z = f._events;
    if (z === void 0)
      return [];
    var Q = z[N];
    return Q === void 0 ? [] : typeof Q == "function" ? h ? [Q.listener || Q] : [Q] : h ? R(Q) : g(Q, Q.length);
  }
  i.prototype.listeners = function(N) {
    return y(this, N, !0);
  }, i.prototype.rawListeners = function(N) {
    return y(this, N, !1);
  }, i.listenerCount = function(f, N) {
    return typeof f.listenerCount == "function" ? f.listenerCount(N) : A.call(f, N);
  }, i.prototype.listenerCount = A;
  function A(f) {
    var N = this._events;
    if (N !== void 0) {
      var h = N[f];
      if (typeof h == "function")
        return 1;
      if (h !== void 0)
        return h.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? e(this._events) : [];
  };
  function g(f, N) {
    for (var h = new Array(N), z = 0; z < N; ++z)
      h[z] = f[z];
    return h;
  }
  function C(f, N) {
    for (; N + 1 < f.length; N++)
      f[N] = f[N + 1];
    f.pop();
  }
  function R(f) {
    for (var N = new Array(f.length), h = 0; h < N.length; ++h)
      N[h] = f[h].listener || f[h];
    return N;
  }
  function D(f, N) {
    return new Promise(function(h, z) {
      function Q(k) {
        f.removeListener(N, _), z(k);
      }
      function _() {
        typeof f.removeListener == "function" && f.removeListener("error", Q), h([].slice.call(arguments));
      }
      v(f, N, _, { once: !0 }), N !== "error" && T(f, Q, { once: !0 });
    });
  }
  function T(f, N, h) {
    typeof f.on == "function" && v(f, "error", N, h);
  }
  function v(f, N, h, z) {
    if (typeof f.on == "function")
      z.once ? f.once(N, h) : f.on(N, h);
    else if (typeof f.addEventListener == "function")
      f.addEventListener(N, function Q(_) {
        z.once && f.removeEventListener(N, Q), h(_);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof f);
  }
  return br.exports;
}
var yA = gA(), tr;
(function(t) {
  t[t.Good = 0] = "Good", t[t.Error = 1] = "Error";
})(tr || (tr = {}));
class zc {
  /**
   * Creates an instance of Batch.
   * @param concurrency -
   */
  constructor(r = 5) {
    /**
     * Concurrency. Must be lager than 0.
     */
    d(this, "concurrency");
    /**
     * Number of active operations under execution.
     */
    d(this, "actives", 0);
    /**
     * Number of completed operations under execution.
     */
    d(this, "completed", 0);
    /**
     * Offset of next operation to be executed.
     */
    d(this, "offset", 0);
    /**
     * Operation array to be executed.
     */
    d(this, "operations", []);
    /**
     * States of Batch. When an error happens, state will turn into error.
     * Batch will stop execute left operations.
     */
    d(this, "state", tr.Good);
    /**
     * A private emitter used to pass events inside this class.
     */
    d(this, "emitter");
    if (r < 1)
      throw new RangeError("concurrency must be larger than 0");
    this.concurrency = r, this.emitter = new yA.EventEmitter();
  }
  /**
   * Add a operation into queue.
   *
   * @param operation -
   */
  addOperation(r) {
    this.operations.push(async () => {
      try {
        this.actives++, await r(), this.actives--, this.completed++, this.parallelExecute();
      } catch (e) {
        this.emitter.emit("error", e);
      }
    });
  }
  /**
   * Start execute operations in the queue.
   *
   */
  async do() {
    return this.operations.length === 0 ? Promise.resolve() : (this.parallelExecute(), new Promise((r, e) => {
      this.emitter.on("finish", r), this.emitter.on("error", (a) => {
        this.state = tr.Error, e(a);
      });
    }));
  }
  /**
   * Get next operation to be executed. Return null when reaching ends.
   *
   */
  nextOperation() {
    return this.offset < this.operations.length ? this.operations[this.offset++] : null;
  }
  /**
   * Start execute operations. One one the most important difference between
   * this method with do() is that do() wraps as an sync method.
   *
   */
  parallelExecute() {
    if (this.state !== tr.Error) {
      if (this.completed >= this.operations.length) {
        this.emitter.emit("finish");
        return;
      }
      for (; this.actives < this.concurrency; ) {
        const r = this.nextOperation();
        if (r)
          r();
        else
          return;
      }
    }
  }
}
async function hA(t, r, e, a, n) {
  throw new Error("streamToBuffer is not supported in the browser.");
}
async function fA(t, r) {
  throw new Error("readStreamToLocalFile is not supported in the browser.");
}
const AA = async function(r) {
  throw new Error("fsStat is not supported in the browser.");
}, NA = function(r, e) {
  throw new Error("fsCreateReadStream is not supported in the browser.");
};
class be extends sn {
  constructor(e, a, n, i) {
    i = i || {};
    let s, o;
    if (nt(a))
      o = e, s = a, i = n;
    else if (a instanceof K || Ie(a))
      o = e, i = n, s = V(a, i);
    else if (!a && typeof a != "string")
      o = e, n && typeof n != "string" && (i = n), s = V(new K(), i);
    else if (a && typeof a == "string" && n && typeof n == "string") {
      const m = a, c = n, l = _t(e);
      if (l.kind === "AccountConnString")
        throw new Error("Account connection string is only supported in Node.js environment");
      if (l.kind === "SASConnString")
        o = ye(ye(l.url, encodeURIComponent(m)), encodeURIComponent(c)) + "?" + l.accountSas, s = V(new K(), i);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(o, s);
    /**
     * blobContext provided by protocol layer.
     */
    d(this, "blobContext");
    d(this, "_name");
    d(this, "_containerName");
    d(this, "_versionId");
    d(this, "_snapshot");
    /**
     * Config used in creating blob client instances.
     */
    d(this, "blobClientConfig");
    ({ blobName: this._name, containerName: this._containerName } = this.getBlobAndContainerNamesFromUrl()), this.blobContext = this.storageClientContext.blob, this._snapshot = Yn(this.url, et.Parameters.SNAPSHOT), this._versionId = Yn(this.url, et.Parameters.VERSIONID), this.blobClientConfig = i;
  }
  /**
   * The name of the blob.
   */
  get name() {
    return this._name;
  }
  /**
   * The name of the storage container the blob is associated with.
   */
  get containerName() {
    return this._containerName;
  }
  /**
   * Creates a new BlobClient object identical to the source but with the specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a Client to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new BlobClient object identical to the source but with the specified snapshot timestamp
   */
  withSnapshot(e) {
    return new be(ir(this.url, et.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a new BlobClient object pointing to a version of this blob.
   * Provide "" will remove the versionId and return a Client to the base blob.
   *
   * @param versionId - The versionId.
   * @returns A new BlobClient object pointing to the version of this blob.
   */
  withVersion(e) {
    return new be(ir(this.url, et.Parameters.VERSIONID, e.length === 0 ? void 0 : e), this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a AppendBlobClient object.
   *
   */
  getAppendBlobClient() {
    return new Zr(this.url, this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a BlockBlobClient object.
   *
   */
  getBlockBlobClient() {
    return new Vr(this.url, this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a PageBlobClient object.
   *
   */
  getPageBlobClient() {
    return new $r(this.url, this.pipeline, this.blobClientConfig);
  }
  /**
   * Reads or downloads a blob from the system, including its metadata and properties.
   * You can also call Get Blob to read a snapshot.
   *
   * * In Node.js, data returns in a Readable stream readableStreamBody
   * * In browsers, data returns in a promise blobBody
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/get-blob
   *
   * @param offset - From which position of the blob to download, greater than or equal to 0
   * @param count - How much data to be downloaded, greater than 0. Will download to the end when undefined
   * @param options - Optional options to Blob Download operation.
   *
   *
   * Example usage (Node.js):
   *
   * ```ts snippet:ReadmeSampleDownloadBlob_Node
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blobClient = containerClient.getBlobClient(blobName);
   *
   * // Get blob content from position 0 to the end
   * // In Node.js, get downloaded data by accessing downloadBlockBlobResponse.readableStreamBody
   * const downloadBlockBlobResponse = await blobClient.download();
   * if (downloadBlockBlobResponse.readableStreamBody) {
   *   const downloaded = await streamToString(downloadBlockBlobResponse.readableStreamBody);
   *   console.log(`Downloaded blob content: ${downloaded}`);
   * }
   *
   * async function streamToString(stream: NodeJS.ReadableStream): Promise<string> {
   *   const result = await new Promise<Buffer<ArrayBuffer>>((resolve, reject) => {
   *     const chunks: Buffer[] = [];
   *     stream.on("data", (data) => {
   *       chunks.push(Buffer.isBuffer(data) ? data : Buffer.from(data));
   *     });
   *     stream.on("end", () => {
   *       resolve(Buffer.concat(chunks));
   *     });
   *     stream.on("error", reject);
   *   });
   *   return result.toString();
   * }
   * ```
   *
   * Example usage (browser):
   *
   * ```ts snippet:ReadmeSampleDownloadBlob_Browser
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blobClient = containerClient.getBlobClient(blobName);
   *
   * // Get blob content from position 0 to the end
   * // In browsers, get downloaded data by accessing downloadBlockBlobResponse.blobBody
   * const downloadBlockBlobResponse = await blobClient.download();
   * const blobBody = await downloadBlockBlobResponse.blobBody;
   * if (blobBody) {
   *   const downloaded = await blobBody.text();
   *   console.log(`Downloaded blob content: ${downloaded}`);
   * }
   * ```
   */
  async download(e = 0, a, n = {}) {
    return n.conditions = n.conditions || {}, n.conditions = n.conditions || {}, $(n.customerProvidedKey, this.isHttps), I.withSpan("BlobClient-download", n, async (i) => {
      var c, l;
      let s = n.contentChecksumAlgorithm ?? ((c = this.blobClientConfig) == null ? void 0 : c.downloadContentChecksumAlgorithm);
      s === void 0 ? s = "Customized" : s === "Auto" && (s = "StorageCrc64"), s === "StorageCrc64" && await ze.init();
      const o = S(await this.blobContext.download({
        abortSignal: n.abortSignal,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: {
          ...n.conditions,
          ifTags: (l = n.conditions) == null ? void 0 : l.tagConditions
        },
        requestOptions: {
          onDownloadProgress: n.onProgress
          // for Node.js, progress is reported by RetriableReadableStream
        },
        range: e === 0 && !a ? void 0 : xe({ offset: e, count: a }),
        rangeGetContentMD5: n.rangeGetContentMD5,
        rangeGetContentCRC64: n.rangeGetContentCrc64,
        snapshot: n.snapshot,
        cpkInfo: n.customerProvidedKey,
        tracingOptions: i.tracingOptions,
        structuredBodyType: s === "StorageCrc64" ? "XSM/1.0; properties=crc64" : void 0
      })), m = {
        ...o,
        _response: o._response,
        // _response is made non-enumerable
        objectReplicationDestinationPolicyId: o.objectReplicationPolicyId,
        objectReplicationSourceProperties: Dr(o.objectReplicationRules)
      };
      return s === "StorageCrc64" && (m.blobBody = gg(await m.blobBody)), m;
    });
  }
  /**
   * Returns true if the Azure blob resource represented by this client exists; false otherwise.
   *
   * NOTE: use this function with care since an existing blob might be deleted by other clients or
   * applications. Vice versa new blobs might be added by other clients or applications after this
   * function completes.
   *
   * @param options - options to Exists operation.
   */
  async exists(e = {}) {
    return I.withSpan("BlobClient-exists", e, async (a) => {
      try {
        return $(e.customerProvidedKey, this.isHttps), await this.getProperties({
          abortSignal: e.abortSignal,
          customerProvidedKey: e.customerProvidedKey,
          conditions: e.conditions,
          tracingOptions: a.tracingOptions
        }), !0;
      } catch (n) {
        if (n.statusCode === 404)
          return !1;
        if (n.statusCode === 409 && (n.details.errorCode === Og || n.details.errorCode === Fg))
          return !0;
        throw n;
      }
    });
  }
  /**
   * Returns all user-defined metadata, standard HTTP properties, and system properties
   * for the blob. It does not return the content of the blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-blob-properties
   *
   * WARNING: The `metadata` object returned in the response will have its keys in lowercase, even if
   * they originally contained uppercase characters. This differs from the metadata keys returned by
   * the methods of {@link ContainerClient} that list blobs using the `includeMetadata` option, which
   * will retain their original casing.
   *
   * @param options - Optional options to Get Properties operation.
   */
  async getProperties(e = {}) {
    return e.conditions = e.conditions || {}, $(e.customerProvidedKey, this.isHttps), I.withSpan("BlobClient-getProperties", e, async (a) => {
      var i;
      const n = S(await this.blobContext.getProperties({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (i = e.conditions) == null ? void 0 : i.tagConditions
        },
        cpkInfo: e.customerProvidedKey,
        tracingOptions: a.tracingOptions
      }));
      return {
        ...n,
        _response: n._response,
        // _response is made non-enumerable
        objectReplicationDestinationPolicyId: n.objectReplicationPolicyId,
        objectReplicationSourceProperties: Dr(n.objectReplicationRules)
      };
    });
  }
  /**
   * Marks the specified blob or snapshot for deletion. The blob is later deleted
   * during garbage collection. Note that in order to delete a blob, you must delete
   * all of its snapshots. You can delete both at the same time with the Delete
   * Blob operation.
   * @see https://learn.microsoft.com/rest/api/storageservices/delete-blob
   *
   * @param options - Optional options to Blob Delete operation.
   */
  async delete(e = {}) {
    return e.conditions = e.conditions || {}, I.withSpan("BlobClient-delete", e, async (a) => {
      var n, i, s;
      return S(await this.blobContext.delete({
        abortSignal: e.abortSignal,
        deleteSnapshots: e.deleteSnapshots,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (n = e.conditions) == null ? void 0 : n.tagConditions
        },
        tracingOptions: a.tracingOptions,
        accessTierIfModifiedSince: (i = e.conditions) == null ? void 0 : i.accessTierIfModifiedSince,
        accessTierIfUnmodifiedSince: (s = e.conditions) == null ? void 0 : s.accessTierIfUnmodifiedSince
      }));
    });
  }
  /**
   * Marks the specified blob or snapshot for deletion if it exists. The blob is later deleted
   * during garbage collection. Note that in order to delete a blob, you must delete
   * all of its snapshots. You can delete both at the same time with the Delete
   * Blob operation.
   * @see https://learn.microsoft.com/rest/api/storageservices/delete-blob
   *
   * @param options - Optional options to Blob Delete operation.
   */
  async deleteIfExists(e = {}) {
    return I.withSpan("BlobClient-deleteIfExists", e, async (a) => {
      var n, i;
      try {
        const s = S(await this.delete(a));
        return {
          succeeded: !0,
          ...s,
          _response: s._response
          // _response is made non-enumerable
        };
      } catch (s) {
        if (((n = s.details) == null ? void 0 : n.errorCode) === "BlobNotFound")
          return {
            succeeded: !1,
            ...(i = s.response) == null ? void 0 : i.parsedHeaders,
            _response: s.response
          };
        throw s;
      }
    });
  }
  /**
   * Restores the contents and metadata of soft deleted blob and any associated
   * soft deleted snapshots. Undelete Blob is supported only on version 2017-07-29
   * or later.
   * @see https://learn.microsoft.com/rest/api/storageservices/undelete-blob
   *
   * @param options - Optional options to Blob Undelete operation.
   */
  async undelete(e = {}) {
    return I.withSpan("BlobClient-undelete", e, async (a) => S(await this.blobContext.undelete({
      abortSignal: e.abortSignal,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Sets system properties on the blob.
   *
   * If no value provided, or no value provided for the specified blob HTTP headers,
   * these blob HTTP headers without a value will be cleared.
   * @see https://learn.microsoft.com/rest/api/storageservices/set-blob-properties
   *
   * @param blobHTTPHeaders - If no value provided, or no value provided for
   *                                                   the specified blob HTTP headers, these blob HTTP
   *                                                   headers without a value will be cleared.
   *                                                   A common header to set is `blobContentType`
   *                                                   enabling the browser to provide functionality
   *                                                   based on file type.
   * @param options - Optional options to Blob Set HTTP Headers operation.
   */
  async setHTTPHeaders(e, a = {}) {
    return a.conditions = a.conditions || {}, $(a.customerProvidedKey, this.isHttps), I.withSpan("BlobClient-setHTTPHeaders", a, async (n) => {
      var i;
      return S(await this.blobContext.setHttpHeaders({
        abortSignal: a.abortSignal,
        blobHttpHeaders: e,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        // cpkInfo: options.customerProvidedKey, // CPK is not included in Swagger, should change this back when this issue is fixed in Swagger.
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Sets user-defined metadata for the specified blob as one or more name-value pairs.
   *
   * If no option provided, or no metadata defined in the parameter, the blob
   * metadata will be removed.
   * @see https://learn.microsoft.com/rest/api/storageservices/set-blob-metadata
   *
   * @param metadata - Replace existing metadata with this value.
   *                               If no value provided the existing metadata will be removed.
   * @param options - Optional options to Set Metadata operation.
   */
  async setMetadata(e, a = {}) {
    return a.conditions = a.conditions || {}, $(a.customerProvidedKey, this.isHttps), I.withSpan("BlobClient-setMetadata", a, async (n) => {
      var i;
      return S(await this.blobContext.setMetadata({
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        metadata: e,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        cpkInfo: a.customerProvidedKey,
        encryptionScope: a.encryptionScope,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Sets tags on the underlying blob.
   * A blob can have up to 10 tags. Tag keys must be between 1 and 128 characters.  Tag values must be between 0 and 256 characters.
   * Valid tag key and value characters include lower and upper case letters, digits (0-9),
   * space (' '), plus ('+'), minus ('-'), period ('.'), foward slash ('/'), colon (':'), equals ('='), and underscore ('_').
   *
   * @param tags -
   * @param options -
   */
  async setTags(e, a = {}) {
    return I.withSpan("BlobClient-setTags", a, async (n) => {
      var i;
      return S(await this.blobContext.setTags({
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        blobModifiedAccessConditions: a.conditions,
        tracingOptions: n.tracingOptions,
        tags: jf(e)
      }));
    });
  }
  /**
   * Gets the tags associated with the underlying blob.
   *
   * @param options -
   */
  async getTags(e = {}) {
    return I.withSpan("BlobClient-getTags", e, async (a) => {
      var s;
      const n = S(await this.blobContext.getTags({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (s = e.conditions) == null ? void 0 : s.tagConditions
        },
        blobModifiedAccessConditions: e.conditions,
        tracingOptions: a.tracingOptions
      }));
      return {
        ...n,
        _response: n._response,
        // _response is made non-enumerable
        tags: $t({ blobTagSet: n.blobTagSet }) || {}
      };
    });
  }
  /**
   * Get a {@link BlobLeaseClient} that manages leases on the blob.
   *
   * @param proposeLeaseId - Initial proposed lease Id.
   * @returns A new BlobLeaseClient object for managing leases on the blob.
   */
  getBlobLeaseClient(e) {
    return new Rc(this, e);
  }
  /**
   * Creates a read-only snapshot of a blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/snapshot-blob
   *
   * @param options - Optional options to the Blob Create Snapshot operation.
   */
  async createSnapshot(e = {}) {
    return e.conditions = e.conditions || {}, $(e.customerProvidedKey, this.isHttps), I.withSpan("BlobClient-createSnapshot", e, async (a) => {
      var n;
      return S(await this.blobContext.createSnapshot({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        metadata: e.metadata,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (n = e.conditions) == null ? void 0 : n.tagConditions
        },
        cpkInfo: e.customerProvidedKey,
        encryptionScope: e.encryptionScope,
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Asynchronously copies a blob to a destination within the storage account.
   * This method returns a long running operation poller that allows you to wait
   * indefinitely until the copy is completed.
   * You can also cancel a copy before it is completed by calling `cancelOperation` on the poller.
   * Note that the onProgress callback will not be invoked if the operation completes in the first
   * request, and attempting to cancel a completed copy will result in an error being thrown.
   *
   * In version 2012-02-12 and later, the source for a Copy Blob operation can be
   * a committed blob in any Azure storage account.
   * Beginning with version 2015-02-21, the source for a Copy Blob operation can be
   * an Azure file in any Azure storage account.
   * Only storage accounts created on or after June 7th, 2012 allow the Copy Blob
   * operation to copy from another storage account.
   * @see https://learn.microsoft.com/rest/api/storageservices/copy-blob
   *
   * ```ts snippet:ClientsBeginCopyFromURL
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blobClient = containerClient.getBlobClient(blobName);
   *
   * // Example using automatic polling
   * const automaticCopyPoller = await blobClient.beginCopyFromURL("url");
   * const automaticResult = await automaticCopyPoller.pollUntilDone();
   *
   * // Example using manual polling
   * const manualCopyPoller = await blobClient.beginCopyFromURL("url");
   * while (!manualCopyPoller.isDone()) {
   *   await manualCopyPoller.poll();
   * }
   * const manualResult = manualCopyPoller.getResult();
   *
   * // Example using progress updates
   * const progressUpdatesCopyPoller = await blobClient.beginCopyFromURL("url", {
   *   onProgress(state) {
   *     console.log(`Progress: ${state.copyProgress}`);
   *   },
   * });
   * const progressUpdatesResult = await progressUpdatesCopyPoller.pollUntilDone();
   *
   * // Example using a changing polling interval (default 15 seconds)
   * const pollingIntervalCopyPoller = await blobClient.beginCopyFromURL("url", {
   *   intervalInMs: 1000, // poll blob every 1 second for copy progress
   * });
   * const pollingIntervalResult = await pollingIntervalCopyPoller.pollUntilDone();
   *
   * // Example using copy cancellation:
   * const cancelCopyPoller = await blobClient.beginCopyFromURL("url");
   * // cancel operation after starting it.
   * try {
   *   await cancelCopyPoller.cancelOperation();
   *   // calls to get the result now throw PollerCancelledError
   *   cancelCopyPoller.getResult();
   * } catch (err: any) {
   *   if (err.name === "PollerCancelledError") {
   *     console.log("The copy was cancelled.");
   *   }
   * }
   * ```
   *
   * @param copySource - url to the source Azure Blob/File.
   * @param options - Optional options to the Blob Start Copy From URL operation.
   */
  async beginCopyFromURL(e, a = {}) {
    const n = {
      abortCopyFromURL: (...s) => this.abortCopyFromURL(...s),
      getProperties: (...s) => this.getProperties(...s),
      startCopyFromURL: (...s) => this.startCopyFromURL(...s)
    }, i = new lA({
      blobClient: n,
      copySource: e,
      intervalInMs: a.intervalInMs,
      onProgress: a.onProgress,
      resumeFrom: a.resumeFrom,
      startCopyFromURLOptions: a
    });
    return await i.poll(), i;
  }
  /**
   * Aborts a pending asynchronous Copy Blob operation, and leaves a destination blob with zero
   * length and full metadata. Version 2012-02-12 and newer.
   * @see https://learn.microsoft.com/rest/api/storageservices/abort-copy-blob
   *
   * @param copyId - Id of the Copy From URL operation.
   * @param options - Optional options to the Blob Abort Copy From URL operation.
   */
  async abortCopyFromURL(e, a = {}) {
    return I.withSpan("BlobClient-abortCopyFromURL", a, async (n) => S(await this.blobContext.abortCopyFromURL(e, {
      abortSignal: a.abortSignal,
      leaseAccessConditions: a.conditions,
      tracingOptions: n.tracingOptions
    })));
  }
  /**
   * The synchronous Copy From URL operation copies a blob or an internet resource to a new blob. It will not
   * return a response until the copy is complete.
   * @see https://learn.microsoft.com/rest/api/storageservices/copy-blob-from-url
   *
   * @param copySource - The source URL to copy from, Shared Access Signature(SAS) maybe needed for authentication
   * @param options -
   */
  async syncCopyFromURL(e, a = {}) {
    return a.conditions = a.conditions || {}, a.sourceConditions = a.sourceConditions || {}, I.withSpan("BlobClient-syncCopyFromURL", a, async (n) => {
      var i, s, o, m, c, l, u;
      return S(await this.blobContext.copyFromURL(e, {
        abortSignal: a.abortSignal,
        metadata: a.metadata,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        sourceModifiedAccessConditions: {
          sourceIfMatch: (s = a.sourceConditions) == null ? void 0 : s.ifMatch,
          sourceIfModifiedSince: (o = a.sourceConditions) == null ? void 0 : o.ifModifiedSince,
          sourceIfNoneMatch: (m = a.sourceConditions) == null ? void 0 : m.ifNoneMatch,
          sourceIfUnmodifiedSince: (c = a.sourceConditions) == null ? void 0 : c.ifUnmodifiedSince
        },
        sourceContentMD5: a.sourceContentMD5,
        copySourceAuthorization: or(a.sourceAuthorization),
        tier: at(a.tier),
        blobTagsString: rt(a.tags),
        immutabilityPolicyExpiry: (l = a.immutabilityPolicy) == null ? void 0 : l.expiriesOn,
        immutabilityPolicyMode: (u = a.immutabilityPolicy) == null ? void 0 : u.policyMode,
        legalHold: a.legalHold,
        encryptionScope: a.encryptionScope,
        copySourceTags: a.copySourceTags,
        fileRequestIntent: a.sourceShareTokenIntent,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Sets the tier on a blob. The operation is allowed on a page blob in a premium
   * storage account and on a block blob in a blob storage account (locally redundant
   * storage only). A premium page blob's tier determines the allowed size, IOPS,
   * and bandwidth of the blob. A block blob's tier determines Hot/Cool/Archive
   * storage type. This operation does not update the blob's ETag.
   * @see https://learn.microsoft.com/rest/api/storageservices/set-blob-tier
   *
   * @param tier - The tier to be set on the blob. Valid values are Hot, Cool, or Archive.
   * @param options - Optional options to the Blob Set Tier operation.
   */
  async setAccessTier(e, a = {}) {
    return I.withSpan("BlobClient-setAccessTier", a, async (n) => {
      var i;
      return S(await this.blobContext.setTier(at(e), {
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        rehydratePriority: a.rehydratePriority,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  async downloadToBuffer(e, a, n, i = {}) {
    let s, o = 0, m = 0, c = i;
    e instanceof Buffer ? (s = e, o = a || 0, m = typeof n == "number" ? n : 0) : (o = typeof e == "number" ? e : 0, m = typeof a == "number" ? a : 0, c = n || {});
    let l = c.blockSize ?? 0;
    if (l < 0)
      throw new RangeError("blockSize option must be >= 0");
    if (l === 0 && (l = ba), o < 0)
      throw new RangeError("offset option must be >= 0");
    if (m && m <= 0)
      throw new RangeError("count option must be greater than 0");
    return c.conditions || (c.conditions = {}), I.withSpan("BlobClient-downloadToBuffer", c, async (u) => {
      if (!m) {
        const g = await this.getProperties({
          ...c,
          tracingOptions: u.tracingOptions
        });
        if (m = g.contentLength - o, m < 0)
          throw new RangeError(`offset ${o} shouldn't be larger than blob size ${g.contentLength}`);
      }
      if (!s)
        try {
          s = Buffer.alloc(m);
        } catch (g) {
          throw new Error(`Unable to allocate the buffer of size: ${m}(in bytes). Please try passing your own buffer to the "downloadToBuffer" method or try using other methods like "download" or "downloadToFile".	 ${g.message}`);
        }
      if (s.length < m)
        throw new RangeError(`The buffer's size should be equal to or larger than the request count of bytes: ${m}`);
      let y = 0;
      const A = new zc(c.concurrency);
      for (let g = o; g < o + m; g = g + l)
        A.addOperation(async () => {
          let C = o + m;
          g + l < C && (C = g + l), (await this.download(g, C - g, {
            abortSignal: c.abortSignal,
            conditions: c.conditions,
            maxRetryRequests: c.maxRetryRequestsPerBlock,
            customerProvidedKey: c.customerProvidedKey,
            contentChecksumAlgorithm: c.contentChecksumAlgorithm,
            tracingOptions: u.tracingOptions
          })).readableStreamBody, await hA(), y += C - g, c.onProgress && c.onProgress({ loadedBytes: y });
        });
      return await A.do(), s;
    });
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Downloads an Azure Blob to a local file.
   * Fails if the the given file path already exits.
   * Offset and count are optional, pass 0 and undefined respectively to download the entire blob.
   *
   * @param filePath -
   * @param offset - From which position of the block blob to download.
   * @param count - How much data to be downloaded. Will download to the end when passing undefined.
   * @param options - Options to Blob download options.
   * @returns The response data for blob download operation,
   *                                                 but with readableStreamBody set to undefined since its
   *                                                 content is already read and written into a local file
   *                                                 at the specified path.
   */
  async downloadToFile(e, a = 0, n, i = {}) {
    return I.withSpan("BlobClient-downloadToFile", i, async (s) => {
      const o = await this.download(a, n, {
        ...i,
        tracingOptions: s.tracingOptions
      });
      return o.readableStreamBody && await fA(o.readableStreamBody), o.blobDownloadStream = void 0, o;
    });
  }
  getBlobAndContainerNamesFromUrl() {
    let e, a;
    try {
      const n = new URL(this.url);
      if (n.host.split(".")[1] === "blob") {
        const i = n.pathname.match("/([^/]*)(/(.*))?");
        e = i[1], a = i[3];
      } else if (nn(n)) {
        const i = n.pathname.match("/([^/]*)/([^/]*)(/(.*))?");
        e = i[2], a = i[4];
      } else {
        const i = n.pathname.match("/([^/]*)(/(.*))?");
        e = i[1], a = i[3];
      }
      if (e = decodeURIComponent(e), a = decodeURIComponent(a), a = a.replace(/\\/g, "/"), !e)
        throw new Error("Provided containerName is invalid.");
      return { blobName: a, containerName: e };
    } catch {
      throw new Error("Unable to extract blobName and containerName with provided information.");
    }
  }
  /**
   * Asynchronously copies a blob to a destination within the storage account.
   * In version 2012-02-12 and later, the source for a Copy Blob operation can be
   * a committed blob in any Azure storage account.
   * Beginning with version 2015-02-21, the source for a Copy Blob operation can be
   * an Azure file in any Azure storage account.
   * Only storage accounts created on or after June 7th, 2012 allow the Copy Blob
   * operation to copy from another storage account.
   * @see https://learn.microsoft.com/rest/api/storageservices/copy-blob
   *
   * @param copySource - url to the source Azure Blob/File.
   * @param options - Optional options to the Blob Start Copy From URL operation.
   */
  async startCopyFromURL(e, a = {}) {
    return I.withSpan("BlobClient-startCopyFromURL", a, async (n) => {
      var i, s, o;
      return a.conditions = a.conditions || {}, a.sourceConditions = a.sourceConditions || {}, S(await this.blobContext.startCopyFromURL(e, {
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        metadata: a.metadata,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        sourceModifiedAccessConditions: {
          sourceIfMatch: a.sourceConditions.ifMatch,
          sourceIfModifiedSince: a.sourceConditions.ifModifiedSince,
          sourceIfNoneMatch: a.sourceConditions.ifNoneMatch,
          sourceIfUnmodifiedSince: a.sourceConditions.ifUnmodifiedSince,
          sourceIfTags: a.sourceConditions.tagConditions
        },
        immutabilityPolicyExpiry: (s = a.immutabilityPolicy) == null ? void 0 : s.expiriesOn,
        immutabilityPolicyMode: (o = a.immutabilityPolicy) == null ? void 0 : o.policyMode,
        legalHold: a.legalHold,
        rehydratePriority: a.rehydratePriority,
        tier: at(a.tier),
        blobTagsString: rt(a.tags),
        sealBlob: a.sealBlob,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Only available for BlobClient constructed with a shared key credential.
   *
   * Generates a Blob Service Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateSasUrl(e) {
    return new Promise((a) => {
      if (!(this.credential instanceof Me))
        throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
      const n = Tr({
        containerName: this._containerName,
        blobName: this._name,
        snapshotTime: this._snapshot,
        versionId: this._versionId,
        ...e
      }, this.credential).toString();
      a(sr(this.url, n));
    });
  }
  /**
   * Only available for BlobClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob Service Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  /* eslint-disable-next-line @azure/azure-sdk/ts-naming-options*/
  generateSasStringToSign(e) {
    if (!(this.credential instanceof Me))
      throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
    return mr({
      containerName: this._containerName,
      blobName: this._name,
      snapshotTime: this._snapshot,
      versionId: this._versionId,
      ...e
    }, this.credential).stringToSign;
  }
  /**
   *
   * Generates a Blob Service Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasUrl(e, a) {
    return new Promise((n) => {
      const i = Tr({
        containerName: this._containerName,
        blobName: this._name,
        snapshotTime: this._snapshot,
        versionId: this._versionId,
        ...e
      }, a, this.accountName).toString();
      n(sr(this.url, i));
    });
  }
  /**
   * Only available for BlobClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob Service Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasStringToSign(e, a) {
    return mr({
      containerName: this._containerName,
      blobName: this._name,
      snapshotTime: this._snapshot,
      versionId: this._versionId,
      ...e
    }, a, this.accountName).stringToSign;
  }
  /**
   * Delete the immutablility policy on the blob.
   *
   * @param options - Optional options to delete immutability policy on the blob.
   */
  async deleteImmutabilityPolicy(e = {}) {
    return I.withSpan("BlobClient-deleteImmutabilityPolicy", e, async (a) => S(await this.blobContext.deleteImmutabilityPolicy({
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Set immutability policy on the blob.
   *
   * @param options - Optional options to set immutability policy on the blob.
   */
  async setImmutabilityPolicy(e, a = {}) {
    return I.withSpan("BlobClient-setImmutabilityPolicy", a, async (n) => S(await this.blobContext.setImmutabilityPolicy({
      immutabilityPolicyExpiry: e.expiriesOn,
      immutabilityPolicyMode: e.policyMode,
      tracingOptions: n.tracingOptions
    })));
  }
  /**
   * Set legal hold on the blob.
   *
   * @param options - Optional options to set legal hold on the blob.
   */
  async setLegalHold(e, a = {}) {
    return I.withSpan("BlobClient-setLegalHold", a, async (n) => S(await this.blobContext.setLegalHold(e, {
      tracingOptions: n.tracingOptions
    })));
  }
  /**
   * The Get Account Information operation returns the sku name and account kind
   * for the specified account.
   * The Get Account Information operation is available on service versions beginning
   * with version 2018-03-28.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-account-information
   *
   * @param options - Options to the Service Get Account Info operation.
   * @returns Response data for the Service Get Account Info operation.
   */
  async getAccountInfo(e = {}) {
    return I.withSpan("BlobClient-getAccountInfo", e, async (a) => S(await this.blobContext.getAccountInfo({
      abortSignal: e.abortSignal,
      tracingOptions: a.tracingOptions
    })));
  }
}
class Zr extends be {
  constructor(e, a, n, i) {
    let s, o;
    if (i = i || {}, nt(a))
      o = e, s = a, i = n;
    else if (a instanceof K || Ie(a))
      o = e, i = n, s = V(a, i);
    else if (!a && typeof a != "string")
      o = e, i = n, s = V(new K(), i);
    else if (a && typeof a == "string" && n && typeof n == "string") {
      const m = a, c = n, l = _t(e);
      if (l.kind === "AccountConnString")
        throw new Error("Account connection string is only supported in Node.js environment");
      if (l.kind === "SASConnString")
        o = ye(ye(l.url, encodeURIComponent(m)), encodeURIComponent(c)) + "?" + l.accountSas, s = V(new K(), i);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(o, s);
    /**
     * appendBlobsContext provided by protocol layer.
     */
    d(this, "appendBlobContext");
    this.appendBlobContext = this.storageClientContext.appendBlob, this.blobClientConfig = i;
  }
  /**
   * Creates a new AppendBlobClient object identical to the source but with the
   * specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a Client to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new AppendBlobClient object identical to the source but with the specified snapshot timestamp.
   */
  withSnapshot(e) {
    return new Zr(ir(this.url, et.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a 0-length append blob. Call AppendBlock to append data to an append blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param options - Options to the Append Block Create operation.
   *
   *
   * Example usage:
   *
   * ```ts snippet:ClientsCreateAppendBlob
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   *
   * const appendBlobClient = containerClient.getAppendBlobClient(blobName);
   * await appendBlobClient.create();
   * ```
   */
  async create(e = {}) {
    return e.conditions = e.conditions || {}, $(e.customerProvidedKey, this.isHttps), I.withSpan("AppendBlobClient-create", e, async (a) => {
      var n, i, s;
      return S(await this.appendBlobContext.create(0, {
        abortSignal: e.abortSignal,
        blobHttpHeaders: e.blobHTTPHeaders,
        leaseAccessConditions: e.conditions,
        metadata: e.metadata,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (n = e.conditions) == null ? void 0 : n.tagConditions
        },
        cpkInfo: e.customerProvidedKey,
        encryptionScope: e.encryptionScope,
        immutabilityPolicyExpiry: (i = e.immutabilityPolicy) == null ? void 0 : i.expiriesOn,
        immutabilityPolicyMode: (s = e.immutabilityPolicy) == null ? void 0 : s.policyMode,
        legalHold: e.legalHold,
        blobTagsString: rt(e.tags),
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Creates a 0-length append blob. Call AppendBlock to append data to an append blob.
   * If the blob with the same name already exists, the content of the existing blob will remain unchanged.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param options -
   */
  async createIfNotExists(e = {}) {
    const a = { ifNoneMatch: ji };
    return I.withSpan("AppendBlobClient-createIfNotExists", e, async (n) => {
      var i, s;
      try {
        const o = S(await this.create({
          ...n,
          conditions: a
        }));
        return {
          succeeded: !0,
          ...o,
          _response: o._response
          // _response is made non-enumerable
        };
      } catch (o) {
        if (((i = o.details) == null ? void 0 : i.errorCode) === "BlobAlreadyExists")
          return {
            succeeded: !1,
            ...(s = o.response) == null ? void 0 : s.parsedHeaders,
            _response: o.response
          };
        throw o;
      }
    });
  }
  /**
   * Seals the append blob, making it read only.
   *
   * @param options -
   */
  async seal(e = {}) {
    return e.conditions = e.conditions || {}, I.withSpan("AppendBlobClient-seal", e, async (a) => {
      var n;
      return S(await this.appendBlobContext.seal({
        abortSignal: e.abortSignal,
        appendPositionAccessConditions: e.conditions,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: {
          ...e.conditions,
          ifTags: (n = e.conditions) == null ? void 0 : n.tagConditions
        },
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Commits a new block of data to the end of the existing append blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/append-block
   *
   * @param body - Data to be appended.
   * @param contentLength - Length of the body in bytes.
   * @param options - Options to the Append Block operation.
   *
   *
   * Example usage:
   *
   * ```ts snippet:ClientsAppendBlock
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   *
   * const content = "Hello World!";
   *
   * // Create a new append blob and append data to the blob.
   * const newAppendBlobClient = containerClient.getAppendBlobClient(blobName);
   * await newAppendBlobClient.create();
   * await newAppendBlobClient.appendBlock(content, content.length);
   *
   * // Append data to an existing append blob.
   * const existingAppendBlobClient = containerClient.getAppendBlobClient(blobName);
   * await existingAppendBlobClient.appendBlock(content, content.length);
   * ```
   */
  async appendBlock(e, a, n = {}) {
    return n.conditions = n.conditions || {}, $(n.customerProvidedKey, this.isHttps), I.withSpan("AppendBlobClient-appendBlock", n, async (i) => {
      var m, c;
      const s = {
        abortSignal: n.abortSignal,
        appendPositionAccessConditions: n.conditions,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: {
          ...n.conditions,
          ifTags: (m = n.conditions) == null ? void 0 : m.tagConditions
        },
        requestOptions: {
          onUploadProgress: n.onProgress
        },
        cpkInfo: n.customerProvidedKey,
        encryptionScope: n.encryptionScope,
        tracingOptions: i.tracingOptions
      }, o = await Qr(e, a, s, n, (c = this.blobClientConfig) == null ? void 0 : c.uploadContentChecksumAlgorithm);
      return S(await this.appendBlobContext.appendBlock(o.contentLength, o.body, s));
    });
  }
  /**
   * The Append Block operation commits a new block of data to the end of an existing append blob
   * where the contents are read from a source url.
   * @see https://learn.microsoft.com/rest/api/storageservices/append-block-from-url
   *
   * @param sourceURL -
   *                 The url to the blob that will be the source of the copy. A source blob in the same storage account can
   *                 be authenticated via Shared Key. However, if the source is a blob in another account, the source blob
   *                 must either be public or must be authenticated via a shared access signature. If the source blob is
   *                 public, no authentication is required to perform the operation.
   * @param sourceOffset - Offset in source to be appended
   * @param count - Number of bytes to be appended as a block
   * @param options -
   */
  async appendBlockFromURL(e, a, n, i = {}) {
    return i.conditions = i.conditions || {}, i.sourceConditions = i.sourceConditions || {}, $(i.customerProvidedKey, this.isHttps), I.withSpan("AppendBlobClient-appendBlockFromURL", i, async (s) => {
      var o, m, c, l, u, y, A, g;
      return S(await this.appendBlobContext.appendBlockFromUrl(e, 0, {
        abortSignal: i.abortSignal,
        sourceRange: xe({ offset: a, count: n }),
        sourceContentMD5: i.sourceContentMD5,
        sourceContentCrc64: i.sourceContentCrc64,
        leaseAccessConditions: i.conditions,
        appendPositionAccessConditions: i.conditions,
        modifiedAccessConditions: {
          ...i.conditions,
          ifTags: (o = i.conditions) == null ? void 0 : o.tagConditions
        },
        sourceModifiedAccessConditions: {
          sourceIfMatch: (m = i.sourceConditions) == null ? void 0 : m.ifMatch,
          sourceIfModifiedSince: (c = i.sourceConditions) == null ? void 0 : c.ifModifiedSince,
          sourceIfNoneMatch: (l = i.sourceConditions) == null ? void 0 : l.ifNoneMatch,
          sourceIfUnmodifiedSince: (u = i.sourceConditions) == null ? void 0 : u.ifUnmodifiedSince
        },
        copySourceAuthorization: or(i.sourceAuthorization),
        cpkInfo: i.customerProvidedKey,
        encryptionScope: i.encryptionScope,
        fileRequestIntent: i.sourceShareTokenIntent,
        tracingOptions: s.tracingOptions,
        sourceCpkInfo: {
          sourceEncryptionKey: (y = i.sourceCustomerProvidedKey) == null ? void 0 : y.encryptionKey,
          sourceEncryptionAlgorithm: (A = i.sourceCustomerProvidedKey) == null ? void 0 : A.encryptionAlgorithm,
          sourceEncryptionKeySha256: (g = i.sourceCustomerProvidedKey) == null ? void 0 : g.encryptionKeySha256
        }
      }));
    });
  }
}
class Vr extends be {
  constructor(e, a, n, i) {
    let s, o;
    if (i = i || {}, nt(a))
      o = e, s = a, i = n;
    else if (a instanceof K || Ie(a))
      o = e, i = n, s = V(a, i);
    else if (!a && typeof a != "string")
      o = e, n && typeof n != "string" && (i = n), s = V(new K(), i);
    else if (a && typeof a == "string" && n && typeof n == "string") {
      const m = a, c = n, l = _t(e);
      if (l.kind === "AccountConnString")
        throw new Error("Account connection string is only supported in Node.js environment");
      if (l.kind === "SASConnString")
        o = ye(ye(l.url, encodeURIComponent(m)), encodeURIComponent(c)) + "?" + l.accountSas, s = V(new K(), i);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(o, s);
    /**
     * blobContext provided by protocol layer.
     *
     * Note. Ideally BlobClient should set BlobClient.blobContext to protected. However, API
     * extractor has issue blocking that. Here we redecelare _blobContext in BlockBlobClient.
     */
    d(this, "_blobContext");
    /**
     * blockBlobContext provided by protocol layer.
     */
    d(this, "blockBlobContext");
    this.blockBlobContext = this.storageClientContext.blockBlob, this._blobContext = this.storageClientContext.blob, this.blobClientConfig = i;
  }
  /**
   * Creates a new BlockBlobClient object identical to the source but with the
   * specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a URL to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new BlockBlobClient object identical to the source but with the specified snapshot timestamp.
   */
  withSnapshot(e) {
    return new Vr(ir(this.url, et.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline, this.blobClientConfig);
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Quick query for a JSON or CSV formatted blob.
   *
   * Example usage (Node.js):
   *
   * ```ts snippet:ClientsQuery
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blockBlobClient = containerClient.getBlockBlobClient(blobName);
   *
   * // Query and convert a blob to a string
   * const queryBlockBlobResponse = await blockBlobClient.query("select from BlobStorage");
   * if (queryBlockBlobResponse.readableStreamBody) {
   *   const downloadedBuffer = await streamToBuffer(queryBlockBlobResponse.readableStreamBody);
   *   const downloaded = downloadedBuffer.toString();
   *   console.log(`Query blob content: ${downloaded}`);
   * }
   *
   * async function streamToBuffer(readableStream: NodeJS.ReadableStream): Promise<Buffer> {
   *   return new Promise((resolve, reject) => {
   *     const chunks: Buffer[] = [];
   *     readableStream.on("data", (data) => {
   *       chunks.push(data instanceof Buffer ? data : Buffer.from(data));
   *     });
   *     readableStream.on("end", () => {
   *       resolve(Buffer.concat(chunks));
   *     });
   *     readableStream.on("error", reject);
   *   });
   * }
   * ```
   *
   * @param query -
   * @param options -
   */
  async query(e, a = {}) {
    throw $(a.customerProvidedKey, this.isHttps), new Error("This operation currently is only supported in Node.js.");
  }
  /**
   * Creates a new block blob, or updates the content of an existing block blob.
   * Updating an existing block blob overwrites any existing metadata on the blob.
   * Partial updates are not supported; the content of the existing blob is
   * overwritten with the new content. To perform a partial update of a block blob's,
   * use {@link stageBlock} and {@link commitBlockList}.
   *
   * This is a non-parallel uploading method, please use {@link uploadFile},
   * {@link uploadStream} or {@link uploadBrowserData} for better performance
   * with concurrency uploading.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param body - Blob, string, ArrayBuffer, ArrayBufferView or a function
   *                               which returns a new Readable stream whose offset is from data source beginning.
   * @param contentLength - Length of body in bytes. Use Buffer.byteLength() to calculate body length for a
   *                               string including non non-Base64/Hex-encoded characters.
   * @param options - Options to the Block Blob Upload operation.
   * @returns Response data for the Block Blob Upload operation.
   *
   * Example usage:
   *
   * ```ts snippet:ClientsUpload
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blockBlobClient = containerClient.getBlockBlobClient(blobName);
   *
   * const content = "Hello world!";
   * const uploadBlobResponse = await blockBlobClient.upload(content, content.length);
   * ```
   */
  async upload(e, a, n = {}) {
    return n.conditions = n.conditions || {}, $(n.customerProvidedKey, this.isHttps), I.withSpan("BlockBlobClient-upload", n, async (i) => {
      var m, c, l, u;
      const s = {
        abortSignal: n.abortSignal,
        blobHttpHeaders: n.blobHTTPHeaders,
        leaseAccessConditions: n.conditions,
        metadata: n.metadata,
        modifiedAccessConditions: {
          ...n.conditions,
          ifTags: (m = n.conditions) == null ? void 0 : m.tagConditions
        },
        requestOptions: {
          onUploadProgress: n.onProgress
        },
        cpkInfo: n.customerProvidedKey,
        encryptionScope: n.encryptionScope,
        immutabilityPolicyExpiry: (c = n.immutabilityPolicy) == null ? void 0 : c.expiriesOn,
        immutabilityPolicyMode: (l = n.immutabilityPolicy) == null ? void 0 : l.policyMode,
        legalHold: n.legalHold,
        tier: at(n.tier),
        blobTagsString: rt(n.tags),
        tracingOptions: i.tracingOptions
      }, o = await Qr(e, a, s, n, (u = this.blobClientConfig) == null ? void 0 : u.uploadContentChecksumAlgorithm);
      return S(await this.blockBlobContext.upload(o.contentLength, o.body, s));
    });
  }
  /**
   * Creates a new Block Blob where the contents of the blob are read from a given URL.
   * This API is supported beginning with the 2020-04-08 version. Partial updates
   * are not supported with Put Blob from URL; the content of an existing blob is overwritten with
   * the content of the new blob.  To perform partial updates to a block blob’s contents using a
   * source URL, use {@link stageBlockFromURL} and {@link commitBlockList}.
   *
   * @param sourceURL - Specifies the URL of the blob. The value
   *                           may be a URL of up to 2 KB in length that specifies a blob.
   *                           The value should be URL-encoded as it would appear
   *                           in a request URI. The source blob must either be public
   *                           or must be authenticated via a shared access signature.
   *                           If the source blob is public, no authentication is required
   *                           to perform the operation. Here are some examples of source object URLs:
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob?snapshot=<DateTime>
   * @param options - Optional parameters.
   */
  async syncUploadFromURL(e, a = {}) {
    return a.conditions = a.conditions || {}, $(a.customerProvidedKey, this.isHttps), I.withSpan("BlockBlobClient-syncUploadFromURL", a, async (n) => {
      var i, s, o, m, c, l, u, y, A;
      return S(await this.blockBlobContext.putBlobFromUrl(0, e, {
        ...a,
        blobHttpHeaders: a.blobHTTPHeaders,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        sourceModifiedAccessConditions: {
          sourceIfMatch: (s = a.sourceConditions) == null ? void 0 : s.ifMatch,
          sourceIfModifiedSince: (o = a.sourceConditions) == null ? void 0 : o.ifModifiedSince,
          sourceIfNoneMatch: (m = a.sourceConditions) == null ? void 0 : m.ifNoneMatch,
          sourceIfUnmodifiedSince: (c = a.sourceConditions) == null ? void 0 : c.ifUnmodifiedSince,
          sourceIfTags: (l = a.sourceConditions) == null ? void 0 : l.tagConditions
        },
        cpkInfo: a.customerProvidedKey,
        copySourceAuthorization: or(a.sourceAuthorization),
        tier: at(a.tier),
        blobTagsString: rt(a.tags),
        copySourceTags: a.copySourceTags,
        fileRequestIntent: a.sourceShareTokenIntent,
        tracingOptions: n.tracingOptions,
        sourceCpkInfo: {
          sourceEncryptionKey: (u = a.sourceCustomerProvidedKey) == null ? void 0 : u.encryptionKey,
          sourceEncryptionAlgorithm: (y = a.sourceCustomerProvidedKey) == null ? void 0 : y.encryptionAlgorithm,
          sourceEncryptionKeySha256: (A = a.sourceCustomerProvidedKey) == null ? void 0 : A.encryptionKeySha256
        }
      }));
    });
  }
  /**
   * Uploads the specified block to the block blob's "staging area" to be later
   * committed by a call to commitBlockList.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-block
   *
   * @param blockId - A 64-byte value that is base64-encoded
   * @param body - Data to upload to the staging area.
   * @param contentLength - Number of bytes to upload.
   * @param options - Options to the Block Blob Stage Block operation.
   * @returns Response data for the Block Blob Stage Block operation.
   */
  async stageBlock(e, a, n, i = {}) {
    return $(i.customerProvidedKey, this.isHttps), I.withSpan("BlockBlobClient-stageBlock", i, async (s) => {
      var c;
      const o = {
        abortSignal: i.abortSignal,
        leaseAccessConditions: i.conditions,
        requestOptions: {
          onUploadProgress: i.onProgress
        },
        cpkInfo: i.customerProvidedKey,
        encryptionScope: i.encryptionScope,
        tracingOptions: s.tracingOptions
      }, m = await Qr(a, n, o, i, (c = this.blobClientConfig) == null ? void 0 : c.uploadContentChecksumAlgorithm);
      return S(await this.blockBlobContext.stageBlock(e, m.contentLength, m.body, o));
    });
  }
  /**
   * The Stage Block From URL operation creates a new block to be committed as part
   * of a blob where the contents are read from a URL.
   * This API is available starting in version 2018-03-28.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-block-from-url
   *
   * @param blockId - A 64-byte value that is base64-encoded
   * @param sourceURL - Specifies the URL of the blob. The value
   *                           may be a URL of up to 2 KB in length that specifies a blob.
   *                           The value should be URL-encoded as it would appear
   *                           in a request URI. The source blob must either be public
   *                           or must be authenticated via a shared access signature.
   *                           If the source blob is public, no authentication is required
   *                           to perform the operation. Here are some examples of source object URLs:
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob?snapshot=<DateTime>
   * @param offset - From which position of the blob to download, greater than or equal to 0
   * @param count - How much data to be downloaded, greater than 0. Will download to the end when undefined
   * @param options - Options to the Block Blob Stage Block From URL operation.
   * @returns Response data for the Block Blob Stage Block From URL operation.
   */
  async stageBlockFromURL(e, a, n = 0, i, s = {}) {
    return $(s.customerProvidedKey, this.isHttps), I.withSpan("BlockBlobClient-stageBlockFromURL", s, async (o) => {
      var m, c, l;
      return S(await this.blockBlobContext.stageBlockFromURL(e, 0, a, {
        abortSignal: s.abortSignal,
        leaseAccessConditions: s.conditions,
        sourceContentMD5: s.sourceContentMD5,
        sourceContentCrc64: s.sourceContentCrc64,
        sourceRange: n === 0 && !i ? void 0 : xe({ offset: n, count: i }),
        cpkInfo: s.customerProvidedKey,
        encryptionScope: s.encryptionScope,
        copySourceAuthorization: or(s.sourceAuthorization),
        fileRequestIntent: s.sourceShareTokenIntent,
        tracingOptions: o.tracingOptions,
        sourceCpkInfo: {
          sourceEncryptionKey: (m = s.sourceCustomerProvidedKey) == null ? void 0 : m.encryptionKey,
          sourceEncryptionAlgorithm: (c = s.sourceCustomerProvidedKey) == null ? void 0 : c.encryptionAlgorithm,
          sourceEncryptionKeySha256: (l = s.sourceCustomerProvidedKey) == null ? void 0 : l.encryptionKeySha256
        }
      }));
    });
  }
  /**
   * Writes a blob by specifying the list of block IDs that make up the blob.
   * In order to be written as part of a blob, a block must have been successfully written
   * to the server in a prior {@link stageBlock} operation. You can call {@link commitBlockList} to
   * update a blob by uploading only those blocks that have changed, then committing the new and existing
   * blocks together. Any blocks not specified in the block list and permanently deleted.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-block-list
   *
   * @param blocks -  Array of 64-byte value that is base64-encoded
   * @param options - Options to the Block Blob Commit Block List operation.
   * @returns Response data for the Block Blob Commit Block List operation.
   */
  async commitBlockList(e, a = {}) {
    return a.conditions = a.conditions || {}, $(a.customerProvidedKey, this.isHttps), I.withSpan("BlockBlobClient-commitBlockList", a, async (n) => {
      var i, s, o;
      return S(await this.blockBlobContext.commitBlockList({ latest: e }, {
        abortSignal: a.abortSignal,
        blobHttpHeaders: a.blobHTTPHeaders,
        leaseAccessConditions: a.conditions,
        metadata: a.metadata,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        cpkInfo: a.customerProvidedKey,
        encryptionScope: a.encryptionScope,
        immutabilityPolicyExpiry: (s = a.immutabilityPolicy) == null ? void 0 : s.expiriesOn,
        immutabilityPolicyMode: (o = a.immutabilityPolicy) == null ? void 0 : o.policyMode,
        legalHold: a.legalHold,
        tier: at(a.tier),
        blobTagsString: rt(a.tags),
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Returns the list of blocks that have been uploaded as part of a block blob
   * using the specified block list filter.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-block-list
   *
   * @param listType - Specifies whether to return the list of committed blocks,
   *                                        the list of uncommitted blocks, or both lists together.
   * @param options - Options to the Block Blob Get Block List operation.
   * @returns Response data for the Block Blob Get Block List operation.
   */
  async getBlockList(e, a = {}) {
    return I.withSpan("BlockBlobClient-getBlockList", a, async (n) => {
      var s;
      const i = S(await this.blockBlobContext.getBlockList(e, {
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (s = a.conditions) == null ? void 0 : s.tagConditions
        },
        tracingOptions: n.tracingOptions
      }));
      return i.committedBlocks || (i.committedBlocks = []), i.uncommittedBlocks || (i.uncommittedBlocks = []), i;
    });
  }
  // High level functions
  /**
   * Uploads a Buffer(Node.js)/Blob(browsers)/ArrayBuffer/ArrayBufferView object to a BlockBlob.
   *
   * When data length is no more than the specifiled {@link BlockBlobParallelUploadOptions.maxSingleShotSize} (default is
   * {@link BLOCK_BLOB_MAX_UPLOAD_BLOB_BYTES}), this method will use 1 {@link upload} call to finish the upload.
   * Otherwise, this method will call {@link stageBlock} to upload blocks, and finally call {@link commitBlockList}
   * to commit the block list.
   *
   * A common {@link BlockBlobParallelUploadOptions.blobHTTPHeaders} option to set is
   * `blobContentType`, enabling the browser to provide
   * functionality based on file type.
   *
   * @param data - Buffer(Node.js), Blob, ArrayBuffer or ArrayBufferView
   * @param options -
   */
  async uploadData(e, a = {}) {
    return I.withSpan("BlockBlobClient-uploadData", a, async (n) => {
      {
        const i = new Blob([e]);
        return this.uploadSeekableInternal((s, o) => i.slice(s, s + o), i.size, n);
      }
    });
  }
  /**
   * ONLY AVAILABLE IN BROWSERS.
   *
   * Uploads a browser Blob/File/ArrayBuffer/ArrayBufferView object to block blob.
   *
   * When buffer length lesser than or equal to 256MB, this method will use 1 upload call to finish the upload.
   * Otherwise, this method will call {@link stageBlock} to upload blocks, and finally call
   * {@link commitBlockList} to commit the block list.
   *
   * A common {@link BlockBlobParallelUploadOptions.blobHTTPHeaders} option to set is
   * `blobContentType`, enabling the browser to provide
   * functionality based on file type.
   *
   * @deprecated Use {@link uploadData} instead.
   *
   * @param browserData - Blob, File, ArrayBuffer or ArrayBufferView
   * @param options - Options to upload browser data.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadBrowserData(e, a = {}) {
    return I.withSpan("BlockBlobClient-uploadBrowserData", a, async (n) => {
      const i = new Blob([e]);
      return this.uploadSeekableInternal((s, o) => i.slice(s, s + o), i.size, n);
    });
  }
  /**
   *
   * Uploads data to block blob. Requires a bodyFactory as the data source,
   * which need to return a {@link HttpRequestBody} object with the offset and size provided.
   *
   * When data length is no more than the specified {@link BlockBlobParallelUploadOptions.maxSingleShotSize} (default is
   * {@link BLOCK_BLOB_MAX_UPLOAD_BLOB_BYTES}), this method will use 1 {@link upload} call to finish the upload.
   * Otherwise, this method will call {@link stageBlock} to upload blocks, and finally call {@link commitBlockList}
   * to commit the block list.
   *
   * @param bodyFactory -
   * @param size - size of the data to upload.
   * @param options - Options to Upload to Block Blob operation.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadSeekableInternal(e, a, n = {}) {
    let i = n.blockSize ?? 0;
    if (i < 0 || i > ua)
      throw new RangeError(`blockSize option must be >= 0 and <= ${ua}`);
    const s = n.maxSingleShotSize ?? pa;
    if (s < 0 || s > pa)
      throw new RangeError(`maxSingleShotSize option must be >= 0 and <= ${pa}`);
    if (i === 0) {
      if (a > ua * Ir)
        throw new RangeError(`${a} is too larger to upload to a block blob.`);
      a > s && (i = Math.ceil(a / Ir), i < ba && (i = ba));
    }
    return n.blobHTTPHeaders || (n.blobHTTPHeaders = {}), n.conditions || (n.conditions = {}), I.withSpan("BlockBlobClient-uploadSeekableInternal", n, async (o) => {
      if (a <= s)
        return S(await this.upload(e(0, a), a, o));
      const m = Math.floor((a - 1) / i) + 1;
      if (m > Ir)
        throw new RangeError(`The buffer's size is too big or the BlockSize is too small;the number of blocks must be <= ${Ir}`);
      const c = [], l = zr();
      let u = 0;
      const y = new zc(n.concurrency);
      for (let A = 0; A < m; A++)
        y.addOperation(async () => {
          const g = Kn(l, A), C = i * A, D = (A === m - 1 ? a : C + i) - C;
          c.push(g), await this.stageBlock(g, e(C, D), D, {
            abortSignal: n.abortSignal,
            conditions: n.conditions,
            encryptionScope: n.encryptionScope,
            tracingOptions: o.tracingOptions,
            contentChecksumAlgorithm: n.contentChecksumAlgorithm
          }), u += D, n.onProgress && n.onProgress({
            loadedBytes: u
          });
        });
      return await y.do(), this.commitBlockList(c, o);
    });
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Uploads a local file in blocks to a block blob.
   *
   * When file size lesser than or equal to 256MB, this method will use 1 upload call to finish the upload.
   * Otherwise, this method will call stageBlock to upload blocks, and finally call commitBlockList
   * to commit the block list.
   *
   * @param filePath - Full path of local file
   * @param options - Options to Upload to Block Blob operation.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadFile(e, a = {}) {
    return I.withSpan("BlockBlobClient-uploadFile", a, async (n) => {
      const i = (await AA()).size;
      return this.uploadSeekableInternal((s, o) => () => NA(), i, {
        ...a,
        tracingOptions: n.tracingOptions
      });
    });
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Uploads a Node.js Readable stream into block blob.
   *
   * PERFORMANCE IMPROVEMENT TIPS:
   * * Input stream highWaterMark is better to set a same value with bufferSize
   *    parameter, which will avoid Buffer.concat() operations.
   *
   * @param stream - Node.js Readable stream
   * @param bufferSize - Size of every buffer allocated, also the block size in the uploaded block blob. Default value is 8MB
   * @param maxConcurrency -  Max concurrency indicates the max number of buffers that can be allocated,
   *                                 positive correlation with max uploading concurrency. Default value is 5
   * @param options - Options to Upload Stream to Block Blob operation.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadStream(e, a = vg, n = 5, i = {}) {
    return i.blobHTTPHeaders || (i.blobHTTPHeaders = {}), i.conditions || (i.conditions = {}), I.withSpan("BlockBlobClient-uploadStream", i, async (s) => {
      let o = 0;
      const m = zr();
      let c = 0;
      const l = [];
      return await new ig(
        e,
        a,
        n,
        async (y, A) => {
          const g = Kn(m, o);
          l.push(g), o++, await this.stageBlock(g, y, A, {
            customerProvidedKey: i.customerProvidedKey,
            conditions: i.conditions,
            encryptionScope: i.encryptionScope,
            tracingOptions: s.tracingOptions,
            contentChecksumAlgorithm: i.contentChecksumAlgorithm
          }), c += A, i.onProgress && i.onProgress({ loadedBytes: c });
        },
        // concurrency should set a smaller value than maxConcurrency, which is helpful to
        // reduce the possibility when a outgoing handler waits for stream data, in
        // this situation, outgoing handlers are blocked.
        // Outgoing queue shouldn't be empty.
        Math.ceil(n / 4 * 3)
      ).do(), S(await this.commitBlockList(l, {
        ...i,
        tracingOptions: s.tracingOptions
      }));
    });
  }
}
class $r extends be {
  constructor(e, a, n, i) {
    let s, o;
    if (i = i || {}, nt(a))
      o = e, s = a, i = n;
    else if (a instanceof K || Ie(a))
      o = e, i = n, s = V(a, i);
    else if (!a && typeof a != "string")
      o = e, i = n, s = V(new K(), i);
    else if (a && typeof a == "string" && n && typeof n == "string") {
      const m = a, c = n, l = _t(e);
      if (l.kind === "AccountConnString")
        throw new Error("Account connection string is only supported in Node.js environment");
      if (l.kind === "SASConnString")
        o = ye(ye(l.url, encodeURIComponent(m)), encodeURIComponent(c)) + "?" + l.accountSas, s = V(new K(), i);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(o, s);
    /**
     * pageBlobsContext provided by protocol layer.
     */
    d(this, "pageBlobContext");
    this.pageBlobContext = this.storageClientContext.pageBlob, this.blobClientConfig = i;
  }
  /**
   * Creates a new PageBlobClient object identical to the source but with the
   * specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a Client to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new PageBlobClient object identical to the source but with the specified snapshot timestamp.
   */
  withSnapshot(e) {
    return new $r(ir(this.url, et.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a page blob of the specified length. Call uploadPages to upload data
   * data to a page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param size - size of the page blob.
   * @param options - Options to the Page Blob Create operation.
   * @returns Response data for the Page Blob Create operation.
   */
  async create(e, a = {}) {
    return a.conditions = a.conditions || {}, $(a.customerProvidedKey, this.isHttps), I.withSpan("PageBlobClient-create", a, async (n) => {
      var i, s, o;
      return S(await this.pageBlobContext.create(0, e, {
        abortSignal: a.abortSignal,
        blobHttpHeaders: a.blobHTTPHeaders,
        blobSequenceNumber: a.blobSequenceNumber,
        leaseAccessConditions: a.conditions,
        metadata: a.metadata,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        cpkInfo: a.customerProvidedKey,
        encryptionScope: a.encryptionScope,
        immutabilityPolicyExpiry: (s = a.immutabilityPolicy) == null ? void 0 : s.expiriesOn,
        immutabilityPolicyMode: (o = a.immutabilityPolicy) == null ? void 0 : o.policyMode,
        legalHold: a.legalHold,
        tier: at(a.tier),
        blobTagsString: rt(a.tags),
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Creates a page blob of the specified length. Call uploadPages to upload data
   * data to a page blob. If the blob with the same name already exists, the content
   * of the existing blob will remain unchanged.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param size - size of the page blob.
   * @param options -
   */
  async createIfNotExists(e, a = {}) {
    return I.withSpan("PageBlobClient-createIfNotExists", a, async (n) => {
      var i, s;
      try {
        const o = { ifNoneMatch: ji }, m = S(await this.create(e, {
          ...a,
          conditions: o,
          tracingOptions: n.tracingOptions
        }));
        return {
          succeeded: !0,
          ...m,
          _response: m._response
          // _response is made non-enumerable
        };
      } catch (o) {
        if (((i = o.details) == null ? void 0 : i.errorCode) === "BlobAlreadyExists")
          return {
            succeeded: !1,
            ...(s = o.response) == null ? void 0 : s.parsedHeaders,
            _response: o.response
          };
        throw o;
      }
    });
  }
  /**
   * Writes 1 or more pages to the page blob. The start and end offsets must be a multiple of 512.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-page
   *
   * @param body - Data to upload
   * @param offset - Offset of destination page blob
   * @param count - Content length of the body, also number of bytes to be uploaded
   * @param options - Options to the Page Blob Upload Pages operation.
   * @returns Response data for the Page Blob Upload Pages operation.
   */
  async uploadPages(e, a, n, i = {}) {
    return i.conditions = i.conditions || {}, $(i.customerProvidedKey, this.isHttps), I.withSpan("PageBlobClient-uploadPages", i, async (s) => {
      var c, l;
      const o = {
        abortSignal: i.abortSignal,
        leaseAccessConditions: i.conditions,
        modifiedAccessConditions: {
          ...i.conditions,
          ifTags: (c = i.conditions) == null ? void 0 : c.tagConditions
        },
        requestOptions: {
          onUploadProgress: i.onProgress
        },
        range: xe({ offset: a, count: n }),
        sequenceNumberAccessConditions: i.conditions,
        cpkInfo: i.customerProvidedKey,
        encryptionScope: i.encryptionScope,
        tracingOptions: s.tracingOptions
      }, m = await Qr(e, n, o, i, (l = this.blobClientConfig) == null ? void 0 : l.uploadContentChecksumAlgorithm);
      return S(await this.pageBlobContext.uploadPages(m.contentLength, m.body, o));
    });
  }
  /**
   * The Upload Pages operation writes a range of pages to a page blob where the
   * contents are read from a URL.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-page-from-url
   *
   * @param sourceURL - Specify a URL to the copy source, Shared Access Signature(SAS) maybe needed for authentication
   * @param sourceOffset - The source offset to copy from. Pass 0 to copy from the beginning of source page blob
   * @param destOffset - Offset of destination page blob
   * @param count - Number of bytes to be uploaded from source page blob
   * @param options -
   */
  async uploadPagesFromURL(e, a, n, i, s = {}) {
    return s.conditions = s.conditions || {}, s.sourceConditions = s.sourceConditions || {}, $(s.customerProvidedKey, this.isHttps), I.withSpan("PageBlobClient-uploadPagesFromURL", s, async (o) => {
      var m, c, l, u, y, A, g, C;
      return S(await this.pageBlobContext.uploadPagesFromURL(e, xe({ offset: a, count: i }), 0, xe({ offset: n, count: i }), {
        abortSignal: s.abortSignal,
        sourceContentMD5: s.sourceContentMD5,
        sourceContentCrc64: s.sourceContentCrc64,
        leaseAccessConditions: s.conditions,
        sequenceNumberAccessConditions: s.conditions,
        modifiedAccessConditions: {
          ...s.conditions,
          ifTags: (m = s.conditions) == null ? void 0 : m.tagConditions
        },
        sourceModifiedAccessConditions: {
          sourceIfMatch: (c = s.sourceConditions) == null ? void 0 : c.ifMatch,
          sourceIfModifiedSince: (l = s.sourceConditions) == null ? void 0 : l.ifModifiedSince,
          sourceIfNoneMatch: (u = s.sourceConditions) == null ? void 0 : u.ifNoneMatch,
          sourceIfUnmodifiedSince: (y = s.sourceConditions) == null ? void 0 : y.ifUnmodifiedSince
        },
        cpkInfo: s.customerProvidedKey,
        encryptionScope: s.encryptionScope,
        copySourceAuthorization: or(s.sourceAuthorization),
        fileRequestIntent: s.sourceShareTokenIntent,
        tracingOptions: o.tracingOptions,
        sourceCpkInfo: {
          sourceEncryptionKey: (A = s.sourceCustomerProvidedKey) == null ? void 0 : A.encryptionKey,
          sourceEncryptionAlgorithm: (g = s.sourceCustomerProvidedKey) == null ? void 0 : g.encryptionAlgorithm,
          sourceEncryptionKeySha256: (C = s.sourceCustomerProvidedKey) == null ? void 0 : C.encryptionKeySha256
        }
      }));
    });
  }
  /**
   * Frees the specified pages from the page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-page
   *
   * @param offset - Starting byte position of the pages to clear.
   * @param count - Number of bytes to clear.
   * @param options - Options to the Page Blob Clear Pages operation.
   * @returns Response data for the Page Blob Clear Pages operation.
   */
  async clearPages(e = 0, a, n = {}) {
    return n.conditions = n.conditions || {}, I.withSpan("PageBlobClient-clearPages", n, async (i) => {
      var s;
      return S(await this.pageBlobContext.clearPages(0, {
        abortSignal: n.abortSignal,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: {
          ...n.conditions,
          ifTags: (s = n.conditions) == null ? void 0 : s.tagConditions
        },
        range: xe({ offset: e, count: a }),
        sequenceNumberAccessConditions: n.conditions,
        cpkInfo: n.customerProvidedKey,
        encryptionScope: n.encryptionScope,
        tracingOptions: i.tracingOptions
      }));
    });
  }
  /**
   * Returns the list of valid page ranges for a page blob or snapshot of a page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param options - Options to the Page Blob Get Ranges operation.
   * @returns Response data for the Page Blob Get Ranges operation.
   */
  async getPageRanges(e = 0, a, n = {}) {
    return n.conditions = n.conditions || {}, I.withSpan("PageBlobClient-getPageRanges", n, async (i) => {
      var o;
      const s = S(await this.pageBlobContext.getPageRanges({
        abortSignal: n.abortSignal,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: {
          ...n.conditions,
          ifTags: (o = n.conditions) == null ? void 0 : o.tagConditions
        },
        range: xe({ offset: e, count: a }),
        tracingOptions: i.tracingOptions
      }));
      return ga(s);
    });
  }
  /**
   * getPageRangesSegment returns a single segment of page ranges starting from the
   * specified Marker. Use an empty Marker to start enumeration from the beginning.
   * After getting a segment, process it, and then call getPageRangesSegment again
   * (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param marker - A string value that identifies the portion of the list to be returned with the next list operation.
   * @param options - Options to PageBlob Get Page Ranges Segment operation.
   */
  async listPageRangesSegment(e = 0, a, n, i = {}) {
    return I.withSpan("PageBlobClient-getPageRangesSegment", i, async (s) => {
      var o;
      return S(await this.pageBlobContext.getPageRanges({
        abortSignal: i.abortSignal,
        leaseAccessConditions: i.conditions,
        modifiedAccessConditions: {
          ...i.conditions,
          ifTags: (o = i.conditions) == null ? void 0 : o.tagConditions
        },
        range: xe({ offset: e, count: a }),
        marker: n,
        maxPageSize: i.maxPageSize,
        tracingOptions: s.tracingOptions
      }));
    });
  }
  /**
   * Returns an AsyncIterableIterator for {@link PageBlobGetPageRangesResponseModel}
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param marker - A string value that identifies the portion of
   *                          the get of page ranges to be returned with the next getting operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          getting operation did not return all page ranges remaining within the current page.
   *                          The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of get
   *                          items. The marker value is opaque to the client.
   * @param options - Options to List Page Ranges operation.
   */
  async *listPageRangeItemSegments(e = 0, a, n, i = {}) {
    let s;
    if (n || n === void 0)
      do
        s = await this.listPageRangesSegment(e, a, n, i), n = s.continuationToken, yield await s;
      while (n);
  }
  /**
   * Returns an AsyncIterableIterator of {@link PageRangeInfo} objects
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param options - Options to List Page Ranges operation.
   */
  async *listPageRangeItems(e = 0, a, n = {}) {
    let i;
    for await (const s of this.listPageRangeItemSegments(e, a, i, n))
      yield* Jn(s);
  }
  /**
   * Returns an async iterable iterator to list of page ranges for a page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   *  .byPage() returns an async iterable iterator to list of page ranges for a page blob.
   *
   * ```ts snippet:ClientsListPageBlobs
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const pageBlobClient = containerClient.getPageBlobClient(blobName);
   *
   * // Example using `for await` syntax
   * let i = 1;
   * for await (const pageRange of pageBlobClient.listPageRanges()) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   *
   * // Example using `iter.next()` syntax
   * i = 1;
   * const iter = pageBlobClient.listPageRanges();
   * let { value, done } = await iter.next();
   * while (!done) {
   *   console.log(`Page range ${i++}: ${value.start} - ${value.end}`);
   *   ({ value, done } = await iter.next());
   * }
   *
   * // Example using `byPage()` syntax
   * i = 1;
   * for await (const page of pageBlobClient.listPageRanges().byPage({ maxPageSize: 20 })) {
   *   for (const pageRange of page.pageRange || []) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   *
   * // Example using paging with a marker
   * i = 1;
   * let iterator = pageBlobClient.listPageRanges().byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   * // Prints 2 page ranges
   * if (response.pageRange) {
   *   for (const pageRange of response.pageRange) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = pageBlobClient.listPageRanges().byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   * // Prints 10 page ranges
   * if (response.pageRange) {
   *   for (const pageRange of response.pageRange) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   * ```
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param options - Options to the Page Blob Get Ranges operation.
   * @returns An asyncIterableIterator that supports paging.
   */
  listPageRanges(e = 0, a, n = {}) {
    n.conditions = n.conditions || {};
    const i = this.listPageRangeItems(e, a, n);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return i.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (s = {}) => this.listPageRangeItemSegments(e, a, s.continuationToken, {
        maxPageSize: s.maxPageSize,
        ...n
      })
    };
  }
  /**
   * Gets the collection of page ranges that differ between a specified snapshot and this page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page blob
   * @param count - Number of bytes to get ranges diff.
   * @param prevSnapshot - Timestamp of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   * @returns Response data for the Page Blob Get Page Range Diff operation.
   */
  async getPageRangesDiff(e, a, n, i = {}) {
    return i.conditions = i.conditions || {}, I.withSpan("PageBlobClient-getPageRangesDiff", i, async (s) => {
      var m;
      const o = S(await this.pageBlobContext.getPageRangesDiff({
        abortSignal: i.abortSignal,
        leaseAccessConditions: i.conditions,
        modifiedAccessConditions: {
          ...i.conditions,
          ifTags: (m = i.conditions) == null ? void 0 : m.tagConditions
        },
        prevsnapshot: n,
        range: xe({ offset: e, count: a }),
        tracingOptions: s.tracingOptions
      }));
      return ga(o);
    });
  }
  /**
   * getPageRangesDiffSegment returns a single segment of page ranges starting from the
   * specified Marker for difference between previous snapshot and the target page blob.
   * Use an empty Marker to start enumeration from the beginning.
   * After getting a segment, process it, and then call getPageRangesDiffSegment again
   * (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshotOrUrl - Timestamp of snapshot to retrieve the difference or URL of snapshot to retrieve the difference.
   * @param marker - A string value that identifies the portion of the get to be returned with the next get operation.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   */
  async listPageRangesDiffSegment(e, a, n, i, s = {}) {
    return I.withSpan("PageBlobClient-getPageRangesDiffSegment", s, async (o) => {
      var m;
      return S(await this.pageBlobContext.getPageRangesDiff({
        abortSignal: s == null ? void 0 : s.abortSignal,
        leaseAccessConditions: s == null ? void 0 : s.conditions,
        modifiedAccessConditions: {
          ...s == null ? void 0 : s.conditions,
          ifTags: (m = s == null ? void 0 : s.conditions) == null ? void 0 : m.tagConditions
        },
        prevsnapshot: n,
        range: xe({
          offset: e,
          count: a
        }),
        marker: i,
        maxPageSize: s == null ? void 0 : s.maxPageSize,
        tracingOptions: o.tracingOptions
      }));
    });
  }
  /**
   * Returns an AsyncIterableIterator for {@link PageBlobGetPageRangesDiffResponseModel}
   *
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshotOrUrl - Timestamp of snapshot to retrieve the difference or URL of snapshot to retrieve the difference.
   * @param marker - A string value that identifies the portion of
   *                          the get of page ranges to be returned with the next getting operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          getting operation did not return all page ranges remaining within the current page.
   *                          The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of get
   *                          items. The marker value is opaque to the client.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   */
  async *listPageRangeDiffItemSegments(e, a, n, i, s) {
    let o;
    if (i || i === void 0)
      do
        o = await this.listPageRangesDiffSegment(e, a, n, i, s), i = o.continuationToken, yield await o;
      while (i);
  }
  /**
   * Returns an AsyncIterableIterator of {@link PageRangeInfo} objects
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshotOrUrl - Timestamp of snapshot to retrieve the difference or URL of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   */
  async *listPageRangeDiffItems(e, a, n, i) {
    let s;
    for await (const o of this.listPageRangeDiffItemSegments(e, a, n, s, i))
      yield* Jn(o);
  }
  /**
   * Returns an async iterable iterator to list of page ranges that differ between a specified snapshot and this page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   *  .byPage() returns an async iterable iterator to list of page ranges that differ between a specified snapshot and this page blob.
   *
   * ```ts snippet:ClientsListPageBlobsDiff
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const pageBlobClient = containerClient.getPageBlobClient(blobName);
   *
   * const offset = 0;
   * const count = 1024;
   * const previousSnapshot = "<previous snapshot>";
   * // Example using `for await` syntax
   * let i = 1;
   * for await (const pageRange of pageBlobClient.listPageRangesDiff(offset, count, previousSnapshot)) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   *
   * // Example using `iter.next()` syntax
   * i = 1;
   * const iter = pageBlobClient.listPageRangesDiff(offset, count, previousSnapshot);
   * let { value, done } = await iter.next();
   * while (!done) {
   *   console.log(`Page range ${i++}: ${value.start} - ${value.end}`);
   *   ({ value, done } = await iter.next());
   * }
   *
   * // Example using `byPage()` syntax
   * i = 1;
   * for await (const page of pageBlobClient
   *   .listPageRangesDiff(offset, count, previousSnapshot)
   *   .byPage({ maxPageSize: 20 })) {
   *   for (const pageRange of page.pageRange || []) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   *
   * // Example using paging with a marker
   * i = 1;
   * let iterator = pageBlobClient
   *   .listPageRangesDiff(offset, count, previousSnapshot)
   *   .byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   * // Prints 2 page ranges
   * if (response.pageRange) {
   *   for (const pageRange of response.pageRange) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = pageBlobClient
   *   .listPageRangesDiff(offset, count, previousSnapshot)
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   * // Prints 10 page ranges
   * if (response.pageRange) {
   *   for (const pageRange of response.pageRange) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   * ```
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshot - Timestamp of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Ranges operation.
   * @returns An asyncIterableIterator that supports paging.
   */
  listPageRangesDiff(e, a, n, i = {}) {
    i.conditions = i.conditions || {};
    const s = this.listPageRangeDiffItems(e, a, n, {
      ...i
    });
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return s.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (o = {}) => this.listPageRangeDiffItemSegments(e, a, n, o.continuationToken, {
        maxPageSize: o.maxPageSize,
        ...i
      })
    };
  }
  /**
   * Gets the collection of page ranges that differ between a specified snapshot and this page blob for managed disks.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page blob
   * @param count - Number of bytes to get ranges diff.
   * @param prevSnapshotUrl - URL of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   * @returns Response data for the Page Blob Get Page Range Diff operation.
   */
  async getPageRangesDiffForManagedDisks(e, a, n, i = {}) {
    return i.conditions = i.conditions || {}, I.withSpan("PageBlobClient-GetPageRangesDiffForManagedDisks", i, async (s) => {
      var m;
      const o = S(await this.pageBlobContext.getPageRangesDiff({
        abortSignal: i.abortSignal,
        leaseAccessConditions: i.conditions,
        modifiedAccessConditions: {
          ...i.conditions,
          ifTags: (m = i.conditions) == null ? void 0 : m.tagConditions
        },
        prevSnapshotUrl: n,
        range: xe({ offset: e, count: a }),
        tracingOptions: s.tracingOptions
      }));
      return ga(o);
    });
  }
  /**
   * Resizes the page blob to the specified size (which must be a multiple of 512).
   * @see https://learn.microsoft.com/rest/api/storageservices/set-blob-properties
   *
   * @param size - Target size
   * @param options - Options to the Page Blob Resize operation.
   * @returns Response data for the Page Blob Resize operation.
   */
  async resize(e, a = {}) {
    return a.conditions = a.conditions || {}, I.withSpan("PageBlobClient-resize", a, async (n) => {
      var i;
      return S(await this.pageBlobContext.resize(e, {
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        encryptionScope: a.encryptionScope,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Sets a page blob's sequence number.
   * @see https://learn.microsoft.com/rest/api/storageservices/set-blob-properties
   *
   * @param sequenceNumberAction - Indicates how the service should modify the blob's sequence number.
   * @param sequenceNumber - Required if sequenceNumberAction is max or update
   * @param options - Options to the Page Blob Update Sequence Number operation.
   * @returns Response data for the Page Blob Update Sequence Number operation.
   */
  async updateSequenceNumber(e, a, n = {}) {
    return n.conditions = n.conditions || {}, I.withSpan("PageBlobClient-updateSequenceNumber", n, async (i) => {
      var s;
      return S(await this.pageBlobContext.updateSequenceNumber(e, {
        abortSignal: n.abortSignal,
        blobSequenceNumber: a,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: {
          ...n.conditions,
          ifTags: (s = n.conditions) == null ? void 0 : s.tagConditions
        },
        tracingOptions: i.tracingOptions
      }));
    });
  }
  /**
   * Begins an operation to start an incremental copy from one page blob's snapshot to this page blob.
   * The snapshot is copied such that only the differential changes between the previously
   * copied snapshot are transferred to the destination.
   * The copied snapshots are complete copies of the original snapshot and can be read or copied from as usual.
   * @see https://learn.microsoft.com/rest/api/storageservices/incremental-copy-blob
   * @see https://learn.microsoft.com/azure/virtual-machines/windows/incremental-snapshots
   *
   * @param copySource - Specifies the name of the source page blob snapshot. For example,
   *                            https://myaccount.blob.core.windows.net/mycontainer/myblob?snapshot=<DateTime>
   * @param options - Options to the Page Blob Copy Incremental operation.
   * @returns Response data for the Page Blob Copy Incremental operation.
   */
  async startCopyIncremental(e, a = {}) {
    return I.withSpan("PageBlobClient-startCopyIncremental", a, async (n) => {
      var i;
      return S(await this.pageBlobContext.copyIncremental(e, {
        abortSignal: a.abortSignal,
        modifiedAccessConditions: {
          ...a.conditions,
          ifTags: (i = a.conditions) == null ? void 0 : i.tagConditions
        },
        tracingOptions: n.tracingOptions
      }));
    });
  }
}
async function CA(t) {
  const r = await t.blobBody;
  return r ? await r.text() : "";
}
function xA(t) {
  return new Blob([t]).size;
}
const Er = ": ", $n = " ", ei = -1;
class IA {
  constructor(r, e) {
    d(this, "batchResponse");
    d(this, "responseBatchBoundary");
    d(this, "perResponsePrefix");
    d(this, "batchResponseEnding");
    d(this, "subRequests");
    if (!r || !r.contentType)
      throw new RangeError("batchResponse is malformed or doesn't contain valid content-type.");
    if (!e || e.size === 0)
      throw new RangeError("Invalid state: subRequests is not provided or size is 0.");
    this.batchResponse = r, this.subRequests = e, this.responseBatchBoundary = this.batchResponse.contentType.split("=")[1], this.perResponsePrefix = `--${this.responseBatchBoundary}${Te}`, this.batchResponseEnding = `--${this.responseBatchBoundary}--`;
  }
  // For example of response, please refer to https://learn.microsoft.com/rest/api/storageservices/blob-batch#response
  async parseBatchResponse() {
    if (this.batchResponse._response.status !== Hg.HTTP_ACCEPTED)
      throw new Error(`Invalid state: batch request failed with status: '${this.batchResponse._response.status}'.`);
    const e = (await CA(this.batchResponse)).split(this.batchResponseEnding)[0].split(this.perResponsePrefix).slice(1), a = e.length;
    if (a !== this.subRequests.size && a !== 1)
      throw new Error("Invalid state: sub responses' count is not equal to sub requests' count.");
    const n = new Array(a);
    let i = 0, s = 0;
    for (let o = 0; o < a; o++) {
      const m = e[o], c = {};
      c.headers = qa(kr());
      const l = m.split(`${Te}`);
      let u = !1, y = !1, A = !1, g = ei;
      for (const C of l) {
        if (!u) {
          if (C.startsWith(At.CONTENT_ID) && (g = parseInt(C.split(Er)[1])), C.startsWith(Zi)) {
            u = !0;
            const R = C.split($n);
            c.status = parseInt(R[1]), c.statusMessage = R.slice(2).join($n);
          }
          continue;
        }
        if (C.trim() === "") {
          y || (y = !0);
          continue;
        }
        if (y)
          c.bodyAsText || (c.bodyAsText = ""), c.bodyAsText += C;
        else {
          if (C.indexOf(Er) === -1)
            throw new Error(`Invalid state: find non-empty line '${C}' without HTTP header delimiter '${Er}'.`);
          const R = C.split(Er);
          c.headers.set(R[0], R[1]), R[0] === At.X_MS_ERROR_CODE && (c.errorCode = R[1], A = !0);
        }
      }
      g !== ei && Number.isInteger(g) && g >= 0 && g < this.subRequests.size && n[g] === void 0 ? (c._request = this.subRequests.get(g), n[g] = c) : _i.error(`subResponses[${o}] is dropped as the Content-ID is not found or invalid, Content-ID: ${g}`), A ? s++ : i++;
    }
    return {
      subResponses: n,
      subResponsesSucceededCount: i,
      subResponsesFailedCount: s
    };
  }
}
var ht;
(function(t) {
  t[t.LOCKED = 0] = "LOCKED", t[t.UNLOCKED = 1] = "UNLOCKED";
})(ht || (ht = {}));
class vr {
  /**
   * Lock for a specific key. If the lock has been acquired by another customer, then
   * will wait until getting the lock.
   *
   * @param key - lock key
   */
  static async lock(r) {
    return new Promise((e) => {
      this.keys[r] === void 0 || this.keys[r] === ht.UNLOCKED ? (this.keys[r] = ht.LOCKED, e()) : this.onUnlockEvent(r, () => {
        this.keys[r] = ht.LOCKED, e();
      });
    });
  }
  /**
   * Unlock a key.
   *
   * @param key -
   */
  static async unlock(r) {
    return new Promise((e) => {
      this.keys[r] === ht.LOCKED && this.emitUnlockEvent(r), delete this.keys[r], e();
    });
  }
  static onUnlockEvent(r, e) {
    this.listeners[r] === void 0 ? this.listeners[r] = [e] : this.listeners[r].push(e);
  }
  static emitUnlockEvent(r) {
    if (this.listeners[r] !== void 0 && this.listeners[r].length > 0) {
      const e = this.listeners[r].shift();
      setImmediate(() => {
        e.call(this);
      });
    }
  }
}
d(vr, "keys", {}), d(vr, "listeners", {});
class ya {
  constructor() {
    d(this, "batchRequest");
    d(this, "batch", "batch");
    d(this, "batchType");
    this.batchRequest = new BA();
  }
  /**
   * Get the value of Content-Type for a batch request.
   * The value must be multipart/mixed with a batch boundary.
   * Example: multipart/mixed; boundary=batch_a81786c8-e301-4e42-a729-a32ca24ae252
   */
  getMultiPartContentType() {
    return this.batchRequest.getMultipartContentType();
  }
  /**
   * Get assembled HTTP request body for sub requests.
   */
  getHttpRequestBody() {
    return this.batchRequest.getHttpRequestBody();
  }
  /**
   * Get sub requests that are added into the batch request.
   */
  getSubRequests() {
    return this.batchRequest.getSubRequests();
  }
  async addSubRequestInternal(r, e) {
    await vr.lock(this.batch);
    try {
      this.batchRequest.preAddSubRequest(r), await e(), this.batchRequest.postAddSubRequest(r);
    } finally {
      await vr.unlock(this.batch);
    }
  }
  setBatchType(r) {
    if (this.batchType || (this.batchType = r), this.batchType !== r)
      throw new RangeError(`BlobBatch only supports one operation type per batch and it already is being used for ${this.batchType} operations.`);
  }
  async deleteBlob(r, e, a) {
    let n, i;
    if (typeof r == "string" && (e instanceof K || Ie(e)))
      n = r, i = e;
    else if (r instanceof be)
      n = r.url, i = r.credential, a = e;
    else
      throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");
    return a || (a = {}), I.withSpan("BatchDeleteRequest-addSubRequest", a, async (s) => {
      this.setBatchType("delete"), await this.addSubRequestInternal({
        url: n,
        credential: i
      }, async () => {
        await new be(n, this.batchRequest.createPipeline(i)).delete(s);
      });
    });
  }
  async setBlobAccessTier(r, e, a, n) {
    let i, s, o;
    if (typeof r == "string" && (e instanceof K || Ie(e)))
      i = r, s = e, o = a;
    else if (r instanceof be)
      i = r.url, s = r.credential, o = e, n = a;
    else
      throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");
    return n || (n = {}), I.withSpan("BatchSetTierRequest-addSubRequest", n, async (m) => {
      this.setBatchType("setAccessTier"), await this.addSubRequestInternal({
        url: i,
        credential: s
      }, async () => {
        await new be(i, this.batchRequest.createPipeline(s)).setAccessTier(o, m);
      });
    });
  }
}
class BA {
  constructor() {
    d(this, "operationCount");
    d(this, "body");
    d(this, "subRequests");
    d(this, "boundary");
    d(this, "subRequestPrefix");
    d(this, "multipartContentType");
    d(this, "batchRequestEnding");
    this.operationCount = 0, this.body = "";
    const r = zr();
    this.boundary = `batch_${r}`, this.subRequestPrefix = `--${this.boundary}${Te}${At.CONTENT_TYPE}: application/http${Te}${At.CONTENT_TRANSFER_ENCODING}: binary`, this.multipartContentType = `multipart/mixed; boundary=${this.boundary}`, this.batchRequestEnding = `--${this.boundary}--`, this.subRequests = /* @__PURE__ */ new Map();
  }
  /**
   * Create pipeline to assemble sub requests. The idea here is to use existing
   * credential and serialization/deserialization components, with additional policies to
   * filter unnecessary headers, assemble sub requests into request's body
   * and intercept request from going to wire.
   * @param credential -  Such as AnonymousCredential, StorageSharedKeyCredential or any credential from the `@azure/identity` package to authenticate requests to the service. You can also provide an object that implements the TokenCredential interface. If not specified, AnonymousCredential is used.
   */
  createPipeline(r) {
    const e = ui();
    e.addPolicy(Di({
      stringifyXML: Fi
    }), { phase: "Serialize" }), e.addPolicy(EA()), e.addPolicy(bA(this), { afterPhase: "Sign" }), Ie(r) ? e.addPolicy(La({
      credential: r,
      scopes: Wi,
      challengeCallbacks: { authorizeRequestOnChallenge: vi }
    }), { phase: "Sign" }) : r instanceof Me && e.addPolicy(Ji({
      accountName: r.accountName,
      accountKey: r.accountKey
    }), { phase: "Sign" });
    const a = new Vi([]);
    return a._credential = r, a._corePipeline = e, a;
  }
  appendSubRequestToBody(r) {
    this.body += [
      this.subRequestPrefix,
      // sub request constant prefix
      `${At.CONTENT_ID}: ${this.operationCount}`,
      // sub request's content ID
      "",
      // empty line after sub request's content ID
      `${r.method.toString()} ${Jf(r.url)} ${Zi}${Te}`
      // sub request start line with method
    ].join(Te);
    for (const [e, a] of r.headers)
      this.body += `${e}: ${a}${Te}`;
    this.body += Te;
  }
  preAddSubRequest(r) {
    if (this.operationCount >= qn)
      throw new RangeError(`Cannot exceed ${qn} sub requests in a single batch`);
    const e = Pc(r.url);
    if (!e || e === "")
      throw new RangeError(`Invalid url for sub request: '${r.url}'`);
  }
  postAddSubRequest(r) {
    this.subRequests.set(this.operationCount, r), this.operationCount++;
  }
  // Return the http request body with assembling the ending line to the sub request body.
  getHttpRequestBody() {
    return `${this.body}${this.batchRequestEnding}${Te}`;
  }
  getMultipartContentType() {
    return this.multipartContentType;
  }
  getSubRequests() {
    return this.subRequests;
  }
}
function bA(t) {
  return {
    name: "batchRequestAssemblePolicy",
    async sendRequest(r) {
      return t.appendSubRequestToBody(r), {
        request: r,
        status: 200,
        headers: kr()
      };
    }
  };
}
function EA() {
  return {
    name: "batchHeaderFilterPolicy",
    async sendRequest(t, r) {
      let e = "";
      for (const [a] of t.headers)
        wc(a, At.X_MS_VERSION) && (e = a);
      return e !== "" && t.headers.delete(e), r(t);
    }
  };
}
class Mc {
  constructor(r, e, a) {
    d(this, "serviceOrContainerContext");
    let n;
    nt(e) ? n = e : e ? n = V(e, a) : n = V(new K(), a);
    const i = new Ec(r, $i(n)), s = Pc(r);
    s && s !== "/" ? this.serviceOrContainerContext = i.container : this.serviceOrContainerContext = i.service;
  }
  /**
   * Creates a {@link BlobBatch}.
   * A BlobBatch represents an aggregated set of operations on blobs.
   */
  createBatch() {
    return new ya();
  }
  async deleteBlobs(r, e, a) {
    const n = new ya();
    for (const i of r)
      typeof i == "string" ? await n.deleteBlob(i, e, a) : await n.deleteBlob(i, e);
    return this.submitBatch(n);
  }
  async setBlobsAccessTier(r, e, a, n) {
    const i = new ya();
    for (const s of r)
      typeof s == "string" ? await i.setBlobAccessTier(s, e, a, n) : await i.setBlobAccessTier(s, e, a);
    return this.submitBatch(i);
  }
  /**
   * Submit batch request which consists of multiple subrequests.
   *
   * Get `blobBatchClient` and other details before running the snippets.
   * `blobServiceClient.getBlobBatchClient()` gives the `blobBatchClient`
   *
   * Example usage:
   *
   * ```ts snippet:BlobBatchClientSubmitBatch
   * import { DefaultAzureCredential } from "@azure/identity";
   * import { BlobServiceClient, BlobBatch } from "@azure/storage-blob";
   *
   * const account = "<account>";
   * const credential = new DefaultAzureCredential();
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   credential,
   * );
   *
   * const containerName = "<container name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blobBatchClient = containerClient.getBlobBatchClient();
   *
   * const batchRequest = new BlobBatch();
   * await batchRequest.deleteBlob("<blob-url-1>", credential);
   * await batchRequest.deleteBlob("<blob-url-2>", credential, {
   *   deleteSnapshots: "include",
   * });
   * const batchResp = await blobBatchClient.submitBatch(batchRequest);
   * console.log(batchResp.subResponsesSucceededCount);
   * ```
   *
   * Example using a lease:
   *
   * ```ts snippet:BlobBatchClientSubmitBatchWithLease
   * import { DefaultAzureCredential } from "@azure/identity";
   * import { BlobServiceClient, BlobBatch } from "@azure/storage-blob";
   *
   * const account = "<account>";
   * const credential = new DefaultAzureCredential();
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   credential,
   * );
   *
   * const containerName = "<container name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blobBatchClient = containerClient.getBlobBatchClient();
   * const blobClient = containerClient.getBlobClient("<blob name>");
   *
   * const batchRequest = new BlobBatch();
   * await batchRequest.setBlobAccessTier(blobClient, "Cool");
   * await batchRequest.setBlobAccessTier(blobClient, "Cool", {
   *   conditions: { leaseId: "<lease-id>" },
   * });
   * const batchResp = await blobBatchClient.submitBatch(batchRequest);
   * console.log(batchResp.subResponsesSucceededCount);
   * ```
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/blob-batch
   *
   * @param batchRequest - A set of Delete or SetTier operations.
   * @param options -
   */
  async submitBatch(r, e = {}) {
    if (!r || r.getSubRequests().size === 0)
      throw new RangeError("Batch request should contain one or more sub requests.");
    return I.withSpan("BlobBatchClient-submitBatch", e, async (a) => {
      const n = r.getHttpRequestBody(), i = S(await this.serviceOrContainerContext.submitBatch(xA(n), r.getMultiPartContentType(), n, {
        ...a
      })), o = await new IA(i, r.getSubRequests()).parseBatchResponse();
      return {
        _response: i._response,
        contentType: i.contentType,
        errorCode: i.errorCode,
        requestId: i.requestId,
        clientRequestId: i.clientRequestId,
        version: i.version,
        subResponses: o.subResponses,
        subResponsesSucceededCount: o.subResponsesSucceededCount,
        subResponsesFailedCount: o.subResponsesFailedCount
      };
    });
  }
}
class PA extends sn {
  constructor(e, a, n) {
    let i, s;
    if (n = n || {}, nt(a))
      s = e, i = a;
    else if (a instanceof K || Ie(a))
      s = e, i = V(a, n);
    else if (!a && typeof a != "string")
      s = e, i = V(new K(), n);
    else if (a && typeof a == "string") {
      const o = a, m = _t(e);
      if (m.kind === "AccountConnString")
        throw new Error("Account connection string is only supported in Node.js environment");
      if (m.kind === "SASConnString")
        s = ye(m.url, encodeURIComponent(o)) + "?" + m.accountSas, i = V(new K(), n);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName parameter");
    super(s, i);
    /**
     * containerContext provided by protocol layer.
     */
    d(this, "containerContext");
    d(this, "_containerName");
    d(this, "blobClientConfig");
    this._containerName = this.getContainerNameFromUrl(), this.containerContext = this.storageClientContext.container, this.blobClientConfig = n;
  }
  /**
   * The name of the container.
   */
  get containerName() {
    return this._containerName;
  }
  /**
   * Creates a new container under the specified account. If the container with
   * the same name already exists, the operation fails.
   * @see https://learn.microsoft.com/rest/api/storageservices/create-container
   * Naming rules: @see https://learn.microsoft.com/rest/api/storageservices/naming-and-referencing-containers--blobs--and-metadata
   *
   * @param options - Options to Container Create operation.
   *
   *
   * Example usage:
   *
   * ```ts snippet:ContainerClientCreate
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const createContainerResponse = await containerClient.create();
   * console.log("Container was created successfully", createContainerResponse.requestId);
   * ```
   */
  async create(e = {}) {
    return I.withSpan("ContainerClient-create", e, async (a) => S(await this.containerContext.create(a)));
  }
  /**
   * Creates a new container under the specified account. If the container with
   * the same name already exists, it is not changed.
   * @see https://learn.microsoft.com/rest/api/storageservices/create-container
   * Naming rules: @see https://learn.microsoft.com/rest/api/storageservices/naming-and-referencing-containers--blobs--and-metadata
   *
   * @param options -
   */
  async createIfNotExists(e = {}) {
    return I.withSpan("ContainerClient-createIfNotExists", e, async (a) => {
      var n, i;
      try {
        const s = await this.create(a);
        return {
          succeeded: !0,
          ...s,
          _response: s._response
          // _response is made non-enumerable
        };
      } catch (s) {
        if (((n = s.details) == null ? void 0 : n.errorCode) === "ContainerAlreadyExists")
          return {
            succeeded: !1,
            ...(i = s.response) == null ? void 0 : i.parsedHeaders,
            _response: s.response
          };
        throw s;
      }
    });
  }
  /**
   * Returns true if the Azure container resource represented by this client exists; false otherwise.
   *
   * NOTE: use this function with care since an existing container might be deleted by other clients or
   * applications. Vice versa new containers with the same name might be added by other clients or
   * applications after this function completes.
   *
   * @param options -
   */
  async exists(e = {}) {
    return I.withSpan("ContainerClient-exists", e, async (a) => {
      try {
        return await this.getProperties({
          abortSignal: e.abortSignal,
          tracingOptions: a.tracingOptions
        }), !0;
      } catch (n) {
        if (n.statusCode === 404)
          return !1;
        throw n;
      }
    });
  }
  /**
   * Creates a {@link BlobClient}
   *
   * @param blobName - A blob name
   * @returns A new BlobClient object for the given blob name.
   */
  getBlobClient(e) {
    return new be(ye(this.url, Br(e)), this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates an {@link AppendBlobClient}
   *
   * @param blobName - An append blob name
   */
  getAppendBlobClient(e) {
    return new Zr(ye(this.url, Br(e)), this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a {@link BlockBlobClient}
   *
   * @param blobName - A block blob name
   *
   *
   * Example usage:
   *
   * ```ts snippet:ClientsUpload
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const blobName = "<blob name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   * const blockBlobClient = containerClient.getBlockBlobClient(blobName);
   *
   * const content = "Hello world!";
   * const uploadBlobResponse = await blockBlobClient.upload(content, content.length);
   * ```
   */
  getBlockBlobClient(e) {
    return new Vr(ye(this.url, Br(e)), this.pipeline, this.blobClientConfig);
  }
  /**
   * Creates a {@link PageBlobClient}
   *
   * @param blobName - A page blob name
   */
  getPageBlobClient(e) {
    return new $r(ye(this.url, Br(e)), this.pipeline, this.blobClientConfig);
  }
  /**
   * Returns all user-defined metadata and system properties for the specified
   * container. The data returned does not include the container's list of blobs.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-container-properties
   *
   * WARNING: The `metadata` object returned in the response will have its keys in lowercase, even if
   * they originally contained uppercase characters. This differs from the metadata keys returned by
   * the `listContainers` method of {@link BlobServiceClient} using the `includeMetadata` option, which
   * will retain their original casing.
   *
   * @param options - Options to Container Get Properties operation.
   */
  async getProperties(e = {}) {
    return e.conditions || (e.conditions = {}), I.withSpan("ContainerClient-getProperties", e, async (a) => S(await this.containerContext.getProperties({
      abortSignal: e.abortSignal,
      ...e.conditions,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Marks the specified container for deletion. The container and any blobs
   * contained within it are later deleted during garbage collection.
   * @see https://learn.microsoft.com/rest/api/storageservices/delete-container
   *
   * @param options - Options to Container Delete operation.
   */
  async delete(e = {}) {
    return e.conditions || (e.conditions = {}), I.withSpan("ContainerClient-delete", e, async (a) => S(await this.containerContext.delete({
      abortSignal: e.abortSignal,
      leaseAccessConditions: e.conditions,
      modifiedAccessConditions: e.conditions,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Marks the specified container for deletion if it exists. The container and any blobs
   * contained within it are later deleted during garbage collection.
   * @see https://learn.microsoft.com/rest/api/storageservices/delete-container
   *
   * @param options - Options to Container Delete operation.
   */
  async deleteIfExists(e = {}) {
    return I.withSpan("ContainerClient-deleteIfExists", e, async (a) => {
      var n, i;
      try {
        const s = await this.delete(a);
        return {
          succeeded: !0,
          ...s,
          _response: s._response
        };
      } catch (s) {
        if (((n = s.details) == null ? void 0 : n.errorCode) === "ContainerNotFound")
          return {
            succeeded: !1,
            ...(i = s.response) == null ? void 0 : i.parsedHeaders,
            _response: s.response
          };
        throw s;
      }
    });
  }
  /**
   * Sets one or more user-defined name-value pairs for the specified container.
   *
   * If no option provided, or no metadata defined in the parameter, the container
   * metadata will be removed.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/set-container-metadata
   *
   * @param metadata - Replace existing metadata with this value.
   *                            If no value provided the existing metadata will be removed.
   * @param options - Options to Container Set Metadata operation.
   */
  async setMetadata(e, a = {}) {
    if (a.conditions || (a.conditions = {}), a.conditions.ifUnmodifiedSince)
      throw new RangeError("the IfUnmodifiedSince must have their default values because they are ignored by the blob service");
    return I.withSpan("ContainerClient-setMetadata", a, async (n) => S(await this.containerContext.setMetadata({
      abortSignal: a.abortSignal,
      leaseAccessConditions: a.conditions,
      metadata: e,
      modifiedAccessConditions: a.conditions,
      tracingOptions: n.tracingOptions
    })));
  }
  /**
   * Gets the permissions for the specified container. The permissions indicate
   * whether container data may be accessed publicly.
   *
   * WARNING: JavaScript Date will potentially lose precision when parsing startsOn and expiresOn strings.
   * For example, new Date("2018-12-31T03:44:23.8827891Z").toISOString() will get "2018-12-31T03:44:23.882Z".
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/get-container-acl
   *
   * @param options - Options to Container Get Access Policy operation.
   */
  async getAccessPolicy(e = {}) {
    return e.conditions || (e.conditions = {}), I.withSpan("ContainerClient-getAccessPolicy", e, async (a) => {
      const n = S(await this.containerContext.getAccessPolicy({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        tracingOptions: a.tracingOptions
      })), i = {
        _response: n._response,
        blobPublicAccess: n.blobPublicAccess,
        date: n.date,
        etag: n.etag,
        errorCode: n.errorCode,
        lastModified: n.lastModified,
        requestId: n.requestId,
        clientRequestId: n.clientRequestId,
        signedIdentifiers: [],
        version: n.version
      };
      for (const s of n) {
        let o;
        s.accessPolicy && (o = {
          permissions: s.accessPolicy.permissions
        }, s.accessPolicy.expiresOn && (o.expiresOn = new Date(s.accessPolicy.expiresOn)), s.accessPolicy.startsOn && (o.startsOn = new Date(s.accessPolicy.startsOn))), i.signedIdentifiers.push({
          accessPolicy: o,
          id: s.id
        });
      }
      return i;
    });
  }
  /**
   * Sets the permissions for the specified container. The permissions indicate
   * whether blobs in a container may be accessed publicly.
   *
   * When you set permissions for a container, the existing permissions are replaced.
   * If no access or containerAcl provided, the existing container ACL will be
   * removed.
   *
   * When you establish a stored access policy on a container, it may take up to 30 seconds to take effect.
   * During this interval, a shared access signature that is associated with the stored access policy will
   * fail with status code 403 (Forbidden), until the access policy becomes active.
   * @see https://learn.microsoft.com/rest/api/storageservices/set-container-acl
   *
   * @param access - The level of public access to data in the container.
   * @param containerAcl - Array of elements each having a unique Id and details of the access policy.
   * @param options - Options to Container Set Access Policy operation.
   */
  async setAccessPolicy(e, a, n = {}) {
    return n.conditions = n.conditions || {}, I.withSpan("ContainerClient-setAccessPolicy", n, async (i) => {
      const s = [];
      for (const o of a || [])
        s.push({
          accessPolicy: {
            expiresOn: o.accessPolicy.expiresOn ? L(o.accessPolicy.expiresOn) : "",
            permissions: o.accessPolicy.permissions,
            startsOn: o.accessPolicy.startsOn ? L(o.accessPolicy.startsOn) : ""
          },
          id: o.id
        });
      return S(await this.containerContext.setAccessPolicy({
        abortSignal: n.abortSignal,
        access: e,
        containerAcl: s,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: n.conditions,
        tracingOptions: i.tracingOptions
      }));
    });
  }
  /**
   * Get a {@link BlobLeaseClient} that manages leases on the container.
   *
   * @param proposeLeaseId - Initial proposed lease Id.
   * @returns A new BlobLeaseClient object for managing leases on the container.
   */
  getBlobLeaseClient(e) {
    return new Rc(this, e);
  }
  /**
   * Creates a new block blob, or updates the content of an existing block blob.
   *
   * Updating an existing block blob overwrites any existing metadata on the blob.
   * Partial updates are not supported; the content of the existing blob is
   * overwritten with the new content. To perform a partial update of a block blob's,
   * use {@link BlockBlobClient.stageBlock} and {@link BlockBlobClient.commitBlockList}.
   *
   * This is a non-parallel uploading method, please use {@link BlockBlobClient.uploadFile},
   * {@link BlockBlobClient.uploadStream} or {@link BlockBlobClient.uploadBrowserData} for better
   * performance with concurrency uploading.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param blobName - Name of the block blob to create or update.
   * @param body - Blob, string, ArrayBuffer, ArrayBufferView or a function
   *                               which returns a new Readable stream whose offset is from data source beginning.
   * @param contentLength - Length of body in bytes. Use Buffer.byteLength() to calculate body length for a
   *                               string including non non-Base64/Hex-encoded characters.
   * @param options - Options to configure the Block Blob Upload operation.
   * @returns Block Blob upload response data and the corresponding BlockBlobClient instance.
   */
  async uploadBlockBlob(e, a, n, i = {}) {
    return I.withSpan("ContainerClient-uploadBlockBlob", i, async (s) => {
      const o = this.getBlockBlobClient(e), m = await o.upload(a, n, s);
      return {
        blockBlobClient: o,
        response: m
      };
    });
  }
  /**
   * Marks the specified blob or snapshot for deletion. The blob is later deleted
   * during garbage collection. Note that in order to delete a blob, you must delete
   * all of its snapshots. You can delete both at the same time with the Delete
   * Blob operation.
   * @see https://learn.microsoft.com/rest/api/storageservices/delete-blob
   *
   * @param blobName -
   * @param options - Options to Blob Delete operation.
   * @returns Block blob deletion response data.
   */
  async deleteBlob(e, a = {}) {
    return I.withSpan("ContainerClient-deleteBlob", a, async (n) => {
      let i = this.getBlobClient(e);
      return a.versionId && (i = i.withVersion(a.versionId)), i.delete(n);
    });
  }
  /**
   * listBlobFlatSegment returns a single segment of blobs starting from the
   * specified Marker. Use an empty Marker to start enumeration from the beginning.
   * After getting a segment, process it, and then call listBlobsFlatSegment again
   * (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/list-blobs
   *
   * @param marker - A string value that identifies the portion of the list to be returned with the next list operation.
   * @param options - Options to Container List Blob Flat Segment operation.
   */
  async listBlobFlatSegment(e, a = {}) {
    return I.withSpan("ContainerClient-listBlobFlatSegment", a, async (n) => {
      const i = S(await this.containerContext.listBlobFlatSegment({
        marker: e,
        ...a,
        tracingOptions: n.tracingOptions
      }));
      return {
        ...i,
        _response: {
          ...i._response,
          parsedBody: Zf(i._response.parsedBody)
        },
        // _response is made non-enumerable
        segment: {
          ...i.segment,
          blobItems: i.segment.blobItems.map((o) => ({
            ...o,
            name: Nt(o.name),
            tags: $t(o.blobTags),
            objectReplicationSourceProperties: Dr(o.objectReplicationMetadata)
          }))
        }
      };
    });
  }
  /**
   * listBlobHierarchySegment returns a single segment of blobs starting from
   * the specified Marker. Use an empty Marker to start enumeration from the
   * beginning. After getting a segment, process it, and then call listBlobsHierarchicalSegment
   * again (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/list-blobs
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param marker - A string value that identifies the portion of the list to be returned with the next list operation.
   * @param options - Options to Container List Blob Hierarchy Segment operation.
   */
  async listBlobHierarchySegment(e, a, n = {}) {
    return I.withSpan("ContainerClient-listBlobHierarchySegment", n, async (i) => {
      var m;
      const s = S(await this.containerContext.listBlobHierarchySegment(e, {
        marker: a,
        ...n,
        tracingOptions: i.tracingOptions
      }));
      return {
        ...s,
        _response: {
          ...s._response,
          parsedBody: Vf(s._response.parsedBody)
        },
        // _response is made non-enumerable
        segment: {
          ...s.segment,
          blobItems: s.segment.blobItems.map((c) => ({
            ...c,
            name: Nt(c.name),
            tags: $t(c.blobTags),
            objectReplicationSourceProperties: Dr(c.objectReplicationMetadata)
          })),
          blobPrefixes: (m = s.segment.blobPrefixes) == null ? void 0 : m.map((c) => ({
            ...c,
            name: Nt(c.name)
          }))
        }
      };
    });
  }
  /**
   * Returns an AsyncIterableIterator for ContainerListBlobFlatSegmentResponse
   *
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to list blobs operation.
   */
  async *listSegments(e, a = {}) {
    let n;
    if (e || e === void 0)
      do
        n = await this.listBlobFlatSegment(e, a), e = n.continuationToken, yield await n;
      while (e);
  }
  /**
   * Returns an AsyncIterableIterator of {@link BlobItem} objects
   *
   * @param options - Options to list blobs operation.
   */
  async *listItems(e = {}) {
    let a;
    for await (const n of this.listSegments(a, e))
      yield* n.segment.blobItems;
  }
  /**
   * Returns an async iterable iterator to list all the blobs
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the blobs in pages.
   *
   * ```ts snippet:ReadmeSampleListBlobs_Multiple
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   *
   * // Example using `for await` syntax
   * let i = 1;
   * const blobs = containerClient.listBlobsFlat();
   * for await (const blob of blobs) {
   *   console.log(`Blob ${i++}: ${blob.name}`);
   * }
   *
   * // Example using `iter.next()` syntax
   * i = 1;
   * const iter = containerClient.listBlobsFlat();
   * let { value, done } = await iter.next();
   * while (!done) {
   *   console.log(`Blob ${i++}: ${value.name}`);
   *   ({ value, done } = await iter.next());
   * }
   *
   * // Example using `byPage()` syntax
   * i = 1;
   * for await (const page of containerClient.listBlobsFlat().byPage({ maxPageSize: 20 })) {
   *   for (const blob of page.segment.blobItems) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   *
   * // Example using paging with a marker
   * i = 1;
   * let iterator = containerClient.listBlobsFlat().byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   * // Prints 2 blob names
   * if (response.segment.blobItems) {
   *   for (const blob of response.segment.blobItems) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = containerClient.listBlobsFlat().byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   * // Prints 10 blob names
   * if (response.segment.blobItems) {
   *   for (const blob of response.segment.blobItems) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * ```
   *
   * @param options - Options to list blobs.
   * @returns An asyncIterableIterator that supports paging.
   */
  listBlobsFlat(e = {}) {
    const a = [];
    e.includeCopy && a.push("copy"), e.includeDeleted && a.push("deleted"), e.includeMetadata && a.push("metadata"), e.includeSnapshots && a.push("snapshots"), e.includeVersions && a.push("versions"), e.includeUncommitedBlobs && a.push("uncommittedblobs"), e.includeTags && a.push("tags"), e.includeDeletedWithVersions && a.push("deletedwithversions"), e.includeImmutabilityPolicy && a.push("immutabilitypolicy"), e.includeLegalHold && a.push("legalhold"), e.prefix === "" && (e.prefix = void 0);
    const n = {
      ...e,
      ...a.length > 0 ? { include: a } : {}
    }, i = this.listItems(n);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return i.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (s = {}) => this.listSegments(s.continuationToken, {
        maxPageSize: s.maxPageSize,
        ...n
      })
    };
  }
  /**
   * Returns an AsyncIterableIterator for ContainerListBlobHierarchySegmentResponse
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to list blobs operation.
   */
  async *listHierarchySegments(e, a, n = {}) {
    let i;
    if (a || a === void 0)
      do
        i = await this.listBlobHierarchySegment(e, a, n), a = i.continuationToken, yield await i;
      while (a);
  }
  /**
   * Returns an AsyncIterableIterator for {@link BlobPrefix} and {@link BlobItem} objects.
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param options - Options to list blobs operation.
   */
  async *listItemsByHierarchy(e, a = {}) {
    let n;
    for await (const i of this.listHierarchySegments(e, n, a)) {
      const s = i.segment;
      if (s.blobPrefixes)
        for (const o of s.blobPrefixes)
          yield {
            kind: "prefix",
            ...o
          };
      for (const o of s.blobItems)
        yield { kind: "blob", ...o };
    }
  }
  /**
   * Returns an async iterable iterator to list all the blobs by hierarchy.
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the blobs by hierarchy in pages.
   *
   * ```ts snippet:ReadmeSampleListBlobsByHierarchy
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   *
   * // Example using `for await` syntax
   * let i = 1;
   * const blobs = containerClient.listBlobsByHierarchy("/");
   * for await (const blob of blobs) {
   *   if (blob.kind === "prefix") {
   *     console.log(`\tBlobPrefix: ${blob.name}`);
   *   } else {
   *     console.log(`\tBlobItem: name - ${blob.name}`);
   *   }
   * }
   *
   * // Example using `iter.next()` syntax
   * i = 1;
   * const iter = containerClient.listBlobsByHierarchy("/");
   * let { value, done } = await iter.next();
   * while (!done) {
   *   if (value.kind === "prefix") {
   *     console.log(`\tBlobPrefix: ${value.name}`);
   *   } else {
   *     console.log(`\tBlobItem: name - ${value.name}`);
   *   }
   *   ({ value, done } = await iter.next());
   * }
   *
   * // Example using `byPage()` syntax
   * i = 1;
   * for await (const page of containerClient.listBlobsByHierarchy("/").byPage({ maxPageSize: 20 })) {
   *   const segment = page.segment;
   *   if (segment.blobPrefixes) {
   *     for (const prefix of segment.blobPrefixes) {
   *       console.log(`\tBlobPrefix: ${prefix.name}`);
   *     }
   *   }
   *   for (const blob of page.segment.blobItems) {
   *     console.log(`\tBlobItem: name - ${blob.name}`);
   *   }
   * }
   *
   * // Example using paging with a marker
   * i = 1;
   * let iterator = containerClient.listBlobsByHierarchy("/").byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   * // Prints 2 blob names
   * if (response.blobPrefixes) {
   *   for (const prefix of response.blobPrefixes) {
   *     console.log(`\tBlobPrefix: ${prefix.name}`);
   *   }
   * }
   * if (response.segment.blobItems) {
   *   for (const blob of response.segment.blobItems) {
   *     console.log(`\tBlobItem: name - ${blob.name}`);
   *   }
   * }
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = containerClient
   *   .listBlobsByHierarchy("/")
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   * // Prints 10 blob names
   * if (response.blobPrefixes) {
   *   for (const prefix of response.blobPrefixes) {
   *     console.log(`\tBlobPrefix: ${prefix.name}`);
   *   }
   * }
   * if (response.segment.blobItems) {
   *   for (const blob of response.segment.blobItems) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * ```
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param options - Options to list blobs operation.
   */
  listBlobsByHierarchy(e, a = {}) {
    if (e === "")
      throw new RangeError("delimiter should contain one or more characters");
    const n = [];
    a.includeCopy && n.push("copy"), a.includeDeleted && n.push("deleted"), a.includeMetadata && n.push("metadata"), a.includeSnapshots && n.push("snapshots"), a.includeVersions && n.push("versions"), a.includeUncommitedBlobs && n.push("uncommittedblobs"), a.includeTags && n.push("tags"), a.includeDeletedWithVersions && n.push("deletedwithversions"), a.includeImmutabilityPolicy && n.push("immutabilitypolicy"), a.includeLegalHold && n.push("legalhold"), a.prefix === "" && (a.prefix = void 0);
    const i = {
      ...a,
      ...n.length > 0 ? { include: n } : {}
    }, s = this.listItemsByHierarchy(e, i);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      async next() {
        return s.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (o = {}) => this.listHierarchySegments(e, o.continuationToken, {
        maxPageSize: o.maxPageSize,
        ...i
      })
    };
  }
  /**
   * The Filter Blobs operation enables callers to list blobs in the container whose tags
   * match a given search expression.
   *
   * @param tagFilterSqlExpression - The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                        The given expression must evaluate to true for a blob to be returned in the results.
   *                                        The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                        however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  async findBlobsByTagsSegment(e, a, n = {}) {
    return I.withSpan("ContainerClient-findBlobsByTagsSegment", n, async (i) => {
      const s = S(await this.containerContext.filterBlobs({
        abortSignal: n.abortSignal,
        where: e,
        marker: a,
        maxPageSize: n.maxPageSize,
        tracingOptions: i.tracingOptions
      }));
      return {
        ...s,
        _response: s._response,
        // _response is made non-enumerable
        blobs: s.blobs.map((m) => {
          var l;
          let c = "";
          return ((l = m.tags) == null ? void 0 : l.blobTagSet.length) === 1 && (c = m.tags.blobTagSet[0].value), { ...m, tags: $t(m.tags), tagValue: c };
        })
      };
    });
  }
  /**
   * Returns an AsyncIterableIterator for ContainerFindBlobsByTagsSegmentResponse.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  async *findBlobsByTagsSegments(e, a, n = {}) {
    let i;
    if (a || a === void 0)
      do
        i = await this.findBlobsByTagsSegment(e, a, n), i.blobs = i.blobs || [], a = i.continuationToken, yield i;
      while (a);
  }
  /**
   * Returns an AsyncIterableIterator for blobs.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to findBlobsByTagsItems.
   */
  async *findBlobsByTagsItems(e, a = {}) {
    let n;
    for await (const i of this.findBlobsByTagsSegments(e, n, a))
      yield* i.blobs;
  }
  /**
   * Returns an async iterable iterator to find all blobs with specified tag
   * under the specified container.
   *
   * .byPage() returns an async iterable iterator to list the blobs in pages.
   *
   * Example using `for await` syntax:
   *
   * ```ts snippet:ReadmeSampleFindBlobsByTags
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerName = "<container name>";
   * const containerClient = blobServiceClient.getContainerClient(containerName);
   *
   * // Example using `for await` syntax
   * let i = 1;
   * for await (const blob of containerClient.findBlobsByTags("tagkey='tagvalue'")) {
   *   console.log(`Blob ${i++}: ${blob.name}`);
   * }
   *
   * // Example using `iter.next()` syntax
   * i = 1;
   * const iter = containerClient.findBlobsByTags("tagkey='tagvalue'");
   * let { value, done } = await iter.next();
   * while (!done) {
   *   console.log(`Blob ${i++}: ${value.name}`);
   *   ({ value, done } = await iter.next());
   * }
   *
   * // Example using `byPage()` syntax
   * i = 1;
   * for await (const page of containerClient
   *   .findBlobsByTags("tagkey='tagvalue'")
   *   .byPage({ maxPageSize: 20 })) {
   *   for (const blob of page.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   *
   * // Example using paging with a marker
   * i = 1;
   * let iterator = containerClient.findBlobsByTags("tagkey='tagvalue'").byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   * // Prints 2 blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = containerClient
   *   .findBlobsByTags("tagkey='tagvalue'")
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   * // Prints 10 blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * ```
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to find blobs by tags.
   */
  findBlobsByTags(e, a = {}) {
    const n = {
      ...a
    }, i = this.findBlobsByTagsItems(e, n);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return i.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (s = {}) => this.findBlobsByTagsSegments(e, s.continuationToken, {
        maxPageSize: s.maxPageSize,
        ...n
      })
    };
  }
  /**
   * The Get Account Information operation returns the sku name and account kind
   * for the specified account.
   * The Get Account Information operation is available on service versions beginning
   * with version 2018-03-28.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-account-information
   *
   * @param options - Options to the Service Get Account Info operation.
   * @returns Response data for the Service Get Account Info operation.
   */
  async getAccountInfo(e = {}) {
    return I.withSpan("ContainerClient-getAccountInfo", e, async (a) => S(await this.containerContext.getAccountInfo({
      abortSignal: e.abortSignal,
      tracingOptions: a.tracingOptions
    })));
  }
  getContainerNameFromUrl() {
    let e;
    try {
      const a = new URL(this.url);
      if (a.hostname.split(".")[1] === "blob" ? e = a.pathname.split("/")[1] : nn(a) ? e = a.pathname.split("/")[2] : e = a.pathname.split("/")[1], e = decodeURIComponent(e), !e)
        throw new Error("Provided containerName is invalid.");
      return e;
    } catch {
      throw new Error("Unable to extract containerName with provided information.");
    }
  }
  /**
   * Only available for ContainerClient constructed with a shared key credential.
   *
   * Generates a Blob Container Service Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateSasUrl(e) {
    return new Promise((a) => {
      if (!(this.credential instanceof Me))
        throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
      const n = Tr({
        containerName: this._containerName,
        ...e
      }, this.credential).toString();
      a(sr(this.url, n));
    });
  }
  /**
   * Only available for ContainerClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob Container Service Shared Access Signature (SAS) URI
   * based on the client properties and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  /* eslint-disable-next-line @azure/azure-sdk/ts-naming-options*/
  generateSasStringToSign(e) {
    if (!(this.credential instanceof Me))
      throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
    return mr({
      containerName: this._containerName,
      ...e
    }, this.credential).stringToSign;
  }
  /**
   * Generates a Blob Container Service Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasUrl(e, a) {
    return new Promise((n) => {
      const i = Tr({
        containerName: this._containerName,
        ...e
      }, a, this.accountName).toString();
      n(sr(this.url, i));
    });
  }
  /**
   * Generates string to sign for a Blob Container Service Shared Access Signature (SAS) URI
   * based on the client properties and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasStringToSign(e, a) {
    return mr({
      containerName: this._containerName,
      ...e
    }, a, this.accountName).stringToSign;
  }
  /**
   * Creates a BlobBatchClient object to conduct batch operations.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/blob-batch
   *
   * @returns A new BlobBatchClient object for this container.
   */
  getBlobBatchClient() {
    return new Mc(this.url, this.pipeline);
  }
}
class It {
  constructor() {
    /**
     * Permission to read resources and list queues and tables granted.
     */
    d(this, "read", !1);
    /**
     * Permission to write resources granted.
     */
    d(this, "write", !1);
    /**
     * Permission to delete blobs and files granted.
     */
    d(this, "delete", !1);
    /**
     * Permission to delete versions granted.
     */
    d(this, "deleteVersion", !1);
    /**
     * Permission to list blob containers, blobs, shares, directories, and files granted.
     */
    d(this, "list", !1);
    /**
     * Permission to add messages, table entities, and append to blobs granted.
     */
    d(this, "add", !1);
    /**
     * Permission to create blobs and files granted.
     */
    d(this, "create", !1);
    /**
     * Permissions to update messages and table entities granted.
     */
    d(this, "update", !1);
    /**
     * Permission to get and delete messages granted.
     */
    d(this, "process", !1);
    /**
     * Specfies Tag access granted.
     */
    d(this, "tag", !1);
    /**
     * Permission to filter blobs.
     */
    d(this, "filter", !1);
    /**
     * Permission to set immutability policy.
     */
    d(this, "setImmutabilityPolicy", !1);
    /**
     * Specifies that Permanent Delete is permitted.
     */
    d(this, "permanentDelete", !1);
  }
  /**
   * Parse initializes the AccountSASPermissions fields from a string.
   *
   * @param permissions -
   */
  static parse(r) {
    const e = new It();
    for (const a of r)
      switch (a) {
        case "r":
          e.read = !0;
          break;
        case "w":
          e.write = !0;
          break;
        case "d":
          e.delete = !0;
          break;
        case "x":
          e.deleteVersion = !0;
          break;
        case "l":
          e.list = !0;
          break;
        case "a":
          e.add = !0;
          break;
        case "c":
          e.create = !0;
          break;
        case "u":
          e.update = !0;
          break;
        case "p":
          e.process = !0;
          break;
        case "t":
          e.tag = !0;
          break;
        case "f":
          e.filter = !0;
          break;
        case "i":
          e.setImmutabilityPolicy = !0;
          break;
        case "y":
          e.permanentDelete = !0;
          break;
        default:
          throw new RangeError(`Invalid permission character: ${a}`);
      }
    return e;
  }
  /**
   * Creates a {@link AccountSASPermissions} from a raw object which contains same keys as it
   * and boolean values for them.
   *
   * @param permissionLike -
   */
  static from(r) {
    const e = new It();
    return r.read && (e.read = !0), r.write && (e.write = !0), r.delete && (e.delete = !0), r.deleteVersion && (e.deleteVersion = !0), r.filter && (e.filter = !0), r.tag && (e.tag = !0), r.list && (e.list = !0), r.add && (e.add = !0), r.create && (e.create = !0), r.update && (e.update = !0), r.process && (e.process = !0), r.setImmutabilityPolicy && (e.setImmutabilityPolicy = !0), r.permanentDelete && (e.permanentDelete = !0), e;
  }
  /**
   * Produces the SAS permissions string for an Azure Storage account.
   * Call this method to set AccountSASSignatureValues Permissions field.
   *
   * Using this method will guarantee the resource types are in
   * an order accepted by the service.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-an-account-sas
   *
   */
  toString() {
    const r = [];
    return this.read && r.push("r"), this.write && r.push("w"), this.delete && r.push("d"), this.deleteVersion && r.push("x"), this.filter && r.push("f"), this.tag && r.push("t"), this.list && r.push("l"), this.add && r.push("a"), this.create && r.push("c"), this.update && r.push("u"), this.process && r.push("p"), this.setImmutabilityPolicy && r.push("i"), this.permanentDelete && r.push("y"), r.join("");
  }
}
class cn {
  constructor() {
    /**
     * Permission to access service level APIs granted.
     */
    d(this, "service", !1);
    /**
     * Permission to access container level APIs (Blob Containers, Tables, Queues, File Shares) granted.
     */
    d(this, "container", !1);
    /**
     * Permission to access object level APIs (Blobs, Table Entities, Queue Messages, Files) granted.
     */
    d(this, "object", !1);
  }
  /**
   * Creates an {@link AccountSASResourceTypes} from the specified resource types string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid resource type.
   *
   * @param resourceTypes -
   */
  static parse(r) {
    const e = new cn();
    for (const a of r)
      switch (a) {
        case "s":
          e.service = !0;
          break;
        case "c":
          e.container = !0;
          break;
        case "o":
          e.object = !0;
          break;
        default:
          throw new RangeError(`Invalid resource type: ${a}`);
      }
    return e;
  }
  /**
   * Converts the given resource types to a string.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/constructing-an-account-sas
   *
   */
  toString() {
    const r = [];
    return this.service && r.push("s"), this.container && r.push("c"), this.object && r.push("o"), r.join("");
  }
}
class cr {
  constructor() {
    /**
     * Permission to access blob resources granted.
     */
    d(this, "blob", !1);
    /**
     * Permission to access file resources granted.
     */
    d(this, "file", !1);
    /**
     * Permission to access queue resources granted.
     */
    d(this, "queue", !1);
    /**
     * Permission to access table resources granted.
     */
    d(this, "table", !1);
  }
  /**
   * Creates an {@link AccountSASServices} from the specified services string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid service.
   *
   * @param services -
   */
  static parse(r) {
    const e = new cr();
    for (const a of r)
      switch (a) {
        case "b":
          e.blob = !0;
          break;
        case "f":
          e.file = !0;
          break;
        case "q":
          e.queue = !0;
          break;
        case "t":
          e.table = !0;
          break;
        default:
          throw new RangeError(`Invalid service character: ${a}`);
      }
    return e;
  }
  /**
   * Converts the given services to a string.
   *
   */
  toString() {
    const r = [];
    return this.blob && r.push("b"), this.table && r.push("t"), this.queue && r.push("q"), this.file && r.push("f"), r.join("");
  }
}
function wA(t, r) {
  return Dc(t, r).sasQueryParameters;
}
function Dc(t, r) {
  const e = t.version ? t.version : _a;
  if (t.permissions && t.permissions.setImmutabilityPolicy && e < "2020-08-04")
    throw RangeError("'version' must be >= '2020-08-04' when provided 'i' permission.");
  if (t.permissions && t.permissions.deleteVersion && e < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when provided 'x' permission.");
  if (t.permissions && t.permissions.permanentDelete && e < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when provided 'y' permission.");
  if (t.permissions && t.permissions.tag && e < "2019-12-12")
    throw RangeError("'version' must be >= '2019-12-12' when provided 't' permission.");
  if (t.permissions && t.permissions.filter && e < "2019-12-12")
    throw RangeError("'version' must be >= '2019-12-12' when provided 'f' permission.");
  if (t.encryptionScope && e < "2020-12-06")
    throw RangeError("'version' must be >= '2020-12-06' when provided 'encryptionScope' in SAS.");
  const a = It.parse(t.permissions.toString()), n = cr.parse(t.services).toString(), i = cn.parse(t.resourceTypes).toString();
  let s;
  e >= "2020-12-06" ? s = [
    r.accountName,
    a,
    n,
    i,
    t.startsOn ? L(t.startsOn, !1) : "",
    L(t.expiresOn, !1),
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    e,
    t.encryptionScope ? t.encryptionScope : "",
    ""
    // Account SAS requires an additional newline character
  ].join(`
`) : s = [
    r.accountName,
    a,
    n,
    i,
    t.startsOn ? L(t.startsOn, !1) : "",
    L(t.expiresOn, !1),
    t.ipRange ? we(t.ipRange) : "",
    t.protocol ? t.protocol : "",
    e,
    ""
    // Account SAS requires an additional newline character
  ].join(`
`);
  const o = r.computeHMACSHA256(s);
  return {
    sasQueryParameters: new ke(e, o, a.toString(), n, i, t.protocol, t.startsOn, t.expiresOn, t.ipRange, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, t.encryptionScope),
    stringToSign: s
  };
}
function SA(t) {
  return !t || typeof t != "object" ? !1 : t.expiresOn instanceof Date;
}
class ln extends sn {
  constructor(e, a, n) {
    n = n ?? {};
    let i;
    nt(a) ? i = a : a instanceof K || Ie(a) ? i = V(a, n) : i = V(new K(), n);
    super(e, i);
    /**
     * serviceContext provided by protocol layer.
     */
    d(this, "serviceContext");
    d(this, "blobClientConfig");
    this.serviceContext = this.storageClientContext.service, this.blobClientConfig = n;
  }
  /**
   *
   * Creates an instance of BlobServiceClient from connection string.
   *
   * @param connectionString - Account connection string or a SAS connection string of an Azure storage account.
   *                                  [ Note - Account connection string can only be used in NODE.JS runtime. ]
   *                                  Account connection string example -
   *                                  `DefaultEndpointsProtocol=https;AccountName=myaccount;AccountKey=accountKey;EndpointSuffix=core.windows.net`
   *                                  SAS connection string example -
   *                                  `BlobEndpoint=https://myaccount.blob.core.windows.net/;QueueEndpoint=https://myaccount.queue.core.windows.net/;FileEndpoint=https://myaccount.file.core.windows.net/;TableEndpoint=https://myaccount.table.core.windows.net/;SharedAccessSignature=sasString`
   * @param options - Optional. Options to configure the HTTP pipeline.
   */
  static fromConnectionString(e, a) {
    a = a || {};
    const n = _t(e);
    if (n.kind === "AccountConnString")
      throw new Error("Account connection string is only supported in Node.js environment");
    if (n.kind === "SASConnString") {
      const i = V(new K(), a);
      return new ln(n.url + "?" + n.accountSas, i, a);
    } else
      throw new Error("Connection string must be either an Account connection string or a SAS connection string");
  }
  /**
   * Creates a {@link ContainerClient} object
   *
   * @param containerName - A container name
   * @returns A new ContainerClient object for the given container name.
   *
   * Example usage:
   *
   * ```ts snippet:BlobServiceClientGetContainerClient
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * const containerClient = blobServiceClient.getContainerClient("<container name>");
   * ```
   */
  getContainerClient(e) {
    return new PA(ye(this.url, encodeURIComponent(e)), this.pipeline, this.blobClientConfig);
  }
  /**
   * Create a Blob container. @see https://learn.microsoft.com/rest/api/storageservices/create-container
   *
   * @param containerName - Name of the container to create.
   * @param options - Options to configure Container Create operation.
   * @returns Container creation response and the corresponding container client.
   */
  async createContainer(e, a = {}) {
    return I.withSpan("BlobServiceClient-createContainer", a, async (n) => {
      const i = this.getContainerClient(e), s = await i.create(n);
      return {
        containerClient: i,
        containerCreateResponse: s
      };
    });
  }
  /**
   * Deletes a Blob container.
   *
   * @param containerName - Name of the container to delete.
   * @param options - Options to configure Container Delete operation.
   * @returns Container deletion response.
   */
  async deleteContainer(e, a = {}) {
    return I.withSpan("BlobServiceClient-deleteContainer", a, async (n) => this.getContainerClient(e).delete(n));
  }
  /**
   * Restore a previously deleted Blob container.
   * This API is only functional if Container Soft Delete is enabled for the storage account associated with the container.
   *
   * @param deletedContainerName - Name of the previously deleted container.
   * @param deletedContainerVersion - Version of the previously deleted container, used to uniquely identify the deleted container.
   * @param options - Options to configure Container Restore operation.
   * @returns Container deletion response.
   */
  async undeleteContainer(e, a, n = {}) {
    return I.withSpan("BlobServiceClient-undeleteContainer", n, async (i) => {
      const s = this.getContainerClient(n.destinationContainerName || e), o = s.storageClientContext.container, m = S(await o.restore({
        deletedContainerName: e,
        deletedContainerVersion: a,
        tracingOptions: i.tracingOptions
      }));
      return { containerClient: s, containerUndeleteResponse: m };
    });
  }
  /**
   * Gets the properties of a storage account’s Blob service, including properties
   * for Storage Analytics and CORS (Cross-Origin Resource Sharing) rules.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-blob-service-properties
   *
   * @param options - Options to the Service Get Properties operation.
   * @returns Response data for the Service Get Properties operation.
   */
  async getProperties(e = {}) {
    return I.withSpan("BlobServiceClient-getProperties", e, async (a) => S(await this.serviceContext.getProperties({
      abortSignal: e.abortSignal,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Sets properties for a storage account’s Blob service endpoint, including properties
   * for Storage Analytics, CORS (Cross-Origin Resource Sharing) rules and soft delete settings.
   * @see https://learn.microsoft.com/rest/api/storageservices/set-blob-service-properties
   *
   * @param properties -
   * @param options - Options to the Service Set Properties operation.
   * @returns Response data for the Service Set Properties operation.
   */
  async setProperties(e, a = {}) {
    return I.withSpan("BlobServiceClient-setProperties", a, async (n) => S(await this.serviceContext.setProperties(e, {
      abortSignal: a.abortSignal,
      tracingOptions: n.tracingOptions
    })));
  }
  /**
   * Retrieves statistics related to replication for the Blob service. It is only
   * available on the secondary location endpoint when read-access geo-redundant
   * replication is enabled for the storage account.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-blob-service-stats
   *
   * @param options - Options to the Service Get Statistics operation.
   * @returns Response data for the Service Get Statistics operation.
   */
  async getStatistics(e = {}) {
    return I.withSpan("BlobServiceClient-getStatistics", e, async (a) => S(await this.serviceContext.getStatistics({
      abortSignal: e.abortSignal,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * The Get Account Information operation returns the sku name and account kind
   * for the specified account.
   * The Get Account Information operation is available on service versions beginning
   * with version 2018-03-28.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-account-information
   *
   * @param options - Options to the Service Get Account Info operation.
   * @returns Response data for the Service Get Account Info operation.
   */
  async getAccountInfo(e = {}) {
    return I.withSpan("BlobServiceClient-getAccountInfo", e, async (a) => S(await this.serviceContext.getAccountInfo({
      abortSignal: e.abortSignal,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Returns a list of the containers under the specified account.
   * @see https://learn.microsoft.com/rest/api/storageservices/list-containers2
   *
   * @param marker - A string value that identifies the portion of
   *                        the list of containers to be returned with the next listing operation. The
   *                        operation returns the continuationToken value within the response body if the
   *                        listing operation did not return all containers remaining to be listed
   *                        with the current page. The continuationToken value can be used as the value for
   *                        the marker parameter in a subsequent call to request the next page of list
   *                        items. The marker value is opaque to the client.
   * @param options - Options to the Service List Container Segment operation.
   * @returns Response data for the Service List Container Segment operation.
   */
  async listContainersSegment(e, a = {}) {
    return I.withSpan("BlobServiceClient-listContainersSegment", a, async (n) => S(await this.serviceContext.listContainersSegment({
      abortSignal: a.abortSignal,
      marker: e,
      ...a,
      include: typeof a.include == "string" ? [a.include] : a.include,
      tracingOptions: n.tracingOptions
    })));
  }
  /**
   * The Filter Blobs operation enables callers to list blobs across all containers whose tags
   * match a given search expression. Filter blobs searches across all containers within a
   * storage account but can be scoped within the expression to a single container.
   *
   * @param tagFilterSqlExpression - The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                        The given expression must evaluate to true for a blob to be returned in the results.
   *                                        The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                        however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  async findBlobsByTagsSegment(e, a, n = {}) {
    return I.withSpan("BlobServiceClient-findBlobsByTagsSegment", n, async (i) => {
      const s = S(await this.serviceContext.filterBlobs({
        abortSignal: n.abortSignal,
        where: e,
        marker: a,
        maxPageSize: n.maxPageSize,
        tracingOptions: i.tracingOptions
      }));
      return {
        ...s,
        _response: s._response,
        // _response is made non-enumerable
        blobs: s.blobs.map((m) => {
          var l;
          let c = "";
          return ((l = m.tags) == null ? void 0 : l.blobTagSet.length) === 1 && (c = m.tags.blobTagSet[0].value), { ...m, tags: $t(m.tags), tagValue: c };
        })
      };
    });
  }
  /**
   * Returns an AsyncIterableIterator for ServiceFindBlobsByTagsSegmentResponse.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  async *findBlobsByTagsSegments(e, a, n = {}) {
    let i;
    if (a || a === void 0)
      do
        i = await this.findBlobsByTagsSegment(e, a, n), i.blobs = i.blobs || [], a = i.continuationToken, yield i;
      while (a);
  }
  /**
   * Returns an AsyncIterableIterator for blobs.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to findBlobsByTagsItems.
   */
  async *findBlobsByTagsItems(e, a = {}) {
    let n;
    for await (const i of this.findBlobsByTagsSegments(e, n, a))
      yield* i.blobs;
  }
  /**
   * Returns an async iterable iterator to find all blobs with specified tag
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the blobs in pages.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/get-blob-service-properties
   *
   * ```ts snippet:BlobServiceClientFindBlobsByTags
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * // Use for await to iterate the blobs
   * let i = 1;
   * for await (const blob of blobServiceClient.findBlobsByTags("tagkey='tagvalue'")) {
   *   console.log(`Blob ${i++}: ${blob.name}`);
   * }
   *
   * // Use iter.next() to iterate the blobs
   * i = 1;
   * const iter = blobServiceClient.findBlobsByTags("tagkey='tagvalue'");
   * let { value, done } = await iter.next();
   * while (!done) {
   *   console.log(`Blob ${i++}: ${value.name}`);
   *   ({ value, done } = await iter.next());
   * }
   *
   * // Use byPage() to iterate the blobs
   * i = 1;
   * for await (const page of blobServiceClient
   *   .findBlobsByTags("tagkey='tagvalue'")
   *   .byPage({ maxPageSize: 20 })) {
   *   for (const blob of page.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   *
   * // Use paging with a marker
   * i = 1;
   * let iterator = blobServiceClient.findBlobsByTags("tagkey='tagvalue'").byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   * // Prints 2 blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = blobServiceClient
   *   .findBlobsByTags("tagkey='tagvalue'")
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * ```
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to find blobs by tags.
   */
  findBlobsByTags(e, a = {}) {
    const n = {
      ...a
    }, i = this.findBlobsByTagsItems(e, n);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return i.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (s = {}) => this.findBlobsByTagsSegments(e, s.continuationToken, {
        maxPageSize: s.maxPageSize,
        ...n
      })
    };
  }
  /**
   * Returns an AsyncIterableIterator for ServiceListContainersSegmentResponses
   *
   * @param marker - A string value that identifies the portion of
   *                        the list of containers to be returned with the next listing operation. The
   *                        operation returns the continuationToken value within the response body if the
   *                        listing operation did not return all containers remaining to be listed
   *                        with the current page. The continuationToken value can be used as the value for
   *                        the marker parameter in a subsequent call to request the next page of list
   *                        items. The marker value is opaque to the client.
   * @param options - Options to list containers operation.
   */
  async *listSegments(e, a = {}) {
    let n;
    if (e || e === void 0)
      do
        n = await this.listContainersSegment(e, a), n.containerItems = n.containerItems || [], e = n.continuationToken, yield await n;
      while (e);
  }
  /**
   * Returns an AsyncIterableIterator for Container Items
   *
   * @param options - Options to list containers operation.
   */
  async *listItems(e = {}) {
    let a;
    for await (const n of this.listSegments(a, e))
      yield* n.containerItems;
  }
  /**
   * Returns an async iterable iterator to list all the containers
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the containers in pages.
   *
   * ```ts snippet:BlobServiceClientListContainers
   * import { BlobServiceClient } from "@azure/storage-blob";
   * import { DefaultAzureCredential } from "@azure/identity";
   *
   * const account = "<account>";
   * const blobServiceClient = new BlobServiceClient(
   *   `https://${account}.blob.core.windows.net`,
   *   new DefaultAzureCredential(),
   * );
   *
   * // Use for await to iterate the containers
   * let i = 1;
   * for await (const container of blobServiceClient.listContainers()) {
   *   console.log(`Container ${i++}: ${container.name}`);
   * }
   *
   * // Use iter.next() to iterate the containers
   * i = 1;
   * const iter = blobServiceClient.listContainers();
   * let { value, done } = await iter.next();
   * while (!done) {
   *   console.log(`Container ${i++}: ${value.name}`);
   *   ({ value, done } = await iter.next());
   * }
   *
   * // Use byPage() to iterate the containers
   * i = 1;
   * for await (const page of blobServiceClient.listContainers().byPage({ maxPageSize: 20 })) {
   *   for (const container of page.containerItems) {
   *     console.log(`Container ${i++}: ${container.name}`);
   *   }
   * }
   *
   * // Use paging with a marker
   * i = 1;
   * let iterator = blobServiceClient.listContainers().byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   *
   * // Prints 2 container names
   * if (response.containerItems) {
   *   for (const container of response.containerItems) {
   *     console.log(`Container ${i++}: ${container.name}`);
   *   }
   * }
   *
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = blobServiceClient
   *   .listContainers()
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints 10 container names
   * if (response.containerItems) {
   *   for (const container of response.containerItems) {
   *     console.log(`Container ${i++}: ${container.name}`);
   *   }
   * }
   * ```
   *
   * @param options - Options to list containers.
   * @returns An asyncIterableIterator that supports paging.
   */
  listContainers(e = {}) {
    e.prefix === "" && (e.prefix = void 0);
    const a = [];
    e.includeDeleted && a.push("deleted"), e.includeMetadata && a.push("metadata"), e.includeSystem && a.push("system");
    const n = {
      ...e,
      ...a.length > 0 ? { include: a } : {}
    }, i = this.listItems(n);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return i.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (s = {}) => this.listSegments(s.continuationToken, {
        maxPageSize: s.maxPageSize,
        ...n
      })
    };
  }
  async getUserDelegationKey(e, a, n = {}) {
    let i = e, s = a, o, m = n;
    return SA(e) && (i = e.startsOn, s = e.expiresOn, o = e.delegatedUserTenantId, m = a, m = m ?? {}), I.withSpan("BlobServiceClient-getUserDelegationKey", m, async (c) => {
      const l = S(await this.serviceContext.getUserDelegationKey({
        startsOn: L(i, !1),
        expiresOn: L(s, !1),
        delegatedUserTid: o
      }, {
        abortSignal: m.abortSignal,
        tracingOptions: c.tracingOptions
      })), u = {
        signedObjectId: l.signedObjectId,
        signedTenantId: l.signedTenantId,
        signedStartsOn: new Date(l.signedStartsOn),
        signedExpiresOn: new Date(l.signedExpiresOn),
        signedService: l.signedService,
        signedVersion: l.signedVersion,
        signedDelegatedUserTenantId: l.signedDelegatedUserTenantId,
        value: l.value
      };
      return {
        _response: l._response,
        requestId: l.requestId,
        clientRequestId: l.clientRequestId,
        version: l.version,
        date: l.date,
        errorCode: l.errorCode,
        ...u
      };
    });
  }
  /**
   * Creates a BlobBatchClient object to conduct batch operations.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/blob-batch
   *
   * @returns A new BlobBatchClient object for this service.
   */
  getBlobBatchClient() {
    return new Mc(this.url, this.pipeline);
  }
  /**
   * Only available for BlobServiceClient constructed with a shared key credential.
   *
   * Generates a Blob account Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/create-account-sas
   *
   * @param expiresOn - Optional. The time at which the shared access signature becomes invalid. Default to an hour later if not provided.
   * @param permissions - Specifies the list of permissions to be associated with the SAS.
   * @param resourceTypes - Specifies the resource types associated with the shared access signature.
   * @param options - Optional parameters.
   * @returns An account SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateAccountSasUrl(e, a = It.parse("r"), n = "sco", i = {}) {
    if (!(this.credential instanceof Me))
      throw RangeError("Can only generate the account SAS when the client is initialized with a shared key credential");
    if (e === void 0) {
      const o = /* @__PURE__ */ new Date();
      e = new Date(o.getTime() + 3600 * 1e3);
    }
    const s = wA({
      permissions: a,
      expiresOn: e,
      resourceTypes: n,
      services: cr.parse("b").toString(),
      ...i
    }, this.credential).toString();
    return sr(this.url, s);
  }
  /**
   * Only available for BlobServiceClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob account Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/create-account-sas
   *
   * @param expiresOn - Optional. The time at which the shared access signature becomes invalid. Default to an hour later if not provided.
   * @param permissions - Specifies the list of permissions to be associated with the SAS.
   * @param resourceTypes - Specifies the resource types associated with the shared access signature.
   * @param options - Optional parameters.
   * @returns An account SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateSasStringToSign(e, a = It.parse("r"), n = "sco", i = {}) {
    if (!(this.credential instanceof Me))
      throw RangeError("Can only generate the account SAS when the client is initialized with a shared key credential");
    if (e === void 0) {
      const s = /* @__PURE__ */ new Date();
      e = new Date(s.getTime() + 3600 * 1e3);
    }
    return Dc({
      permissions: a,
      expiresOn: e,
      resourceTypes: n,
      services: cr.parse("b").toString(),
      ...i
    }, this.credential).stringToSign;
  }
}
class DA {
  constructor(r) {
    d(this, "sas");
    this.sas = r;
  }
  /** Upload file to azure directly through sas, returns any errors as string */
  async uploadAsync(r, e, a, n, i) {
    var c;
    let s = "", o = 0;
    const m = this.getBlockClient();
    if (!m)
      return "Unable to get client for azure upload";
    try {
      const l = await m.uploadData(
        r,
        {
          blockSize: 4194304,
          //10MB block size
          concurrency: 20,
          onProgress: (u) => {
            o = u.loadedBytes / e * 100, i && typeof i == "function" && i(o);
          },
          blobHTTPHeaders: { blobContentType: a },
          metadata: n,
          tier: Sa.Cold
        }
      );
      (((c = l.errorCode) == null ? void 0 : c.length) || 0) > 0 && (s = "Upload failed with an error code of " + l.errorCode);
    } catch (l) {
      console.log(l), s = l.message;
    }
    return s;
  }
  async uploadFileAsync(r, e) {
    return await this.uploadAsync(r, r.size, r.type, { name: r.name }, e);
  }
  getBlockClient() {
    return this.getContainerClient().getBlockBlobClient(this.sas.storagePath ?? "");
  }
  getContainerClient() {
    const r = V(new K(), {
      retryOptions: { maxTries: 4 },
      // Retry options
      userAgentOptions: { userAgentPrefix: "Daymap" },
      keepAliveOptions: { enable: !1 }
    });
    return new ln(`https://${this.sas.account}.blob.core.windows.net?${this.sas.token}`, r).getContainerClient(this.sas.container ?? "");
  }
}
export {
  DA as AzureBlobs
};
//# sourceMappingURL=azureblobs.js.map
